export const doctorWhoValidGuesses: {
  [word: string]: {
    count: number
    firstSaidSeasonIndex: number
    firstSaidStoryIndex: number
    firstSaidBy: string
    firstSaidQuote: string
  }
} = {
  night: {
    count: 747,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GIRL',
    firstSaidQuote: 'Night, Miss Wright.',
  },
  susan: {
    count: 480,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "Wait in here, please, Susan. I won't be long.",
  },
  right: {
    count: 9952,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Right, ask a silly question.',
  },
  silly: {
    count: 176,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Right, ask a silly question.',
  },
  sorry: {
    count: 2696,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "I'm sorry.",
  },
  girls: {
    count: 135,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "Oh, it's one of the girls, Susan Foreman.",
  },
  about: {
    count: 6904,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Fifteen. She lets her knowledge out a bit at a time so as not to embarrass me. That's what I feel about her. She knows more science than I'll ever know. She's a genius. Is that what she's doing with history?",
  },
  knows: {
    count: 545,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Fifteen. She lets her knowledge out a bit at a time so as not to embarrass me. That's what I feel about her. She knows more science than I'll ever know. She's a genius. Is that what she's doing with history?",
  },
  doing: {
    count: 2356,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Fifteen. She lets her knowledge out a bit at a time so as not to embarrass me. That's what I feel about her. She knows more science than I'll ever know. She's a genius. Is that what she's doing with history?",
  },
  class: {
    count: 112,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'So your problem is whether to stay in business or to hand over the class to her.',
  },
  quite: {
    count: 1683,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'No, not quite.',
  },
  going: {
    count: 7105,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Ian, I must talk to someone about this, but I don't want to get the girl into trouble. And I know you're going to tell me I'm imagining things.",
  },
  ought: {
    count: 181,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Well, I told you how good she is at history. I had a talk with her and told her she ought to specialise. Well, she seemed quite interested until I said I'd be willing to work with her at her home. Then she said that would be absolutely impossible as her grandfather didn't like strangers.",
  },
  until: {
    count: 867,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Well, I told you how good she is at history. I had a talk with her and told her she ought to specialise. Well, she seemed quite interested until I said I'd be willing to work with her at her home. Then she said that would be absolutely impossible as her grandfather didn't like strangers.",
  },
  would: {
    count: 4392,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Well, I told you how good she is at history. I had a talk with her and told her she ought to specialise. Well, she seemed quite interested until I said I'd be willing to work with her at her home. Then she said that would be absolutely impossible as her grandfather didn't like strangers.",
  },
  point: {
    count: 1032,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Well, I didn't pursue the point but then recently her homework's been so bad.",
  },
  along: {
    count: 856,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Well, that's just it. I got her address from the secretary, 76 Totter's Lane, and I went along there one evening. Oh Ian, do pay attention.",
  },
  there: {
    count: 11610,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Well, that's just it. I got her address from the secretary, 76 Totter's Lane, and I went along there one evening. Oh Ian, do pay attention.",
  },
  wrong: {
    count: 1466,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'You must have gone to the wrong place.',
  },
  place: {
    count: 1931,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'You must have gone to the wrong place.',
  },
  other: {
    count: 1861,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "No. I checked. There's a big wall on one side, houses on the other and nothing in the middle. And this nothing in the middle is number 76 Totter's Lane.",
  },
  thank: {
    count: 2382,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Thank you for the we. She's waiting in one of the classrooms. I'm lending her a book on the French Revolution.",
  },
  blank: {
    count: 36,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "What's she going to do, rewrite it? Oh, all right. What do we do? Ask her point-blank?",
  },
  could: {
    count: 4533,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'No, I thought we could drive there, wait till she arrives and see where she goes.',
  },
  drive: {
    count: 256,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'No, I thought we could drive there, wait till she arrives and see where she goes.',
  },
  where: {
    count: 5623,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'No, I thought we could drive there, wait till she arrives and see where she goes.',
  },
  after: {
    count: 1619,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "No, I'm not. After you.",
  },
  smith: {
    count: 299,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "It's John Smith and the Common Men. They've gone from nineteen to two.",
  },
  stage: {
    count: 138,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "John Smith is the stage name of the Honourable Aubrey Waites. He started his career as Chris Waites and the Carollers, didn't he, Susan?",
  },
  chris: {
    count: 20,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "John Smith is the stage name of the Honourable Aubrey Waites. He started his career as Chris Waites and the Carollers, didn't he, Susan?",
  },
  again: {
    count: 2301,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Be careful, Susan, there'll probably be fog again tonight.",
  },
  lucky: {
    count: 293,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "We're lucky there was no fog. I'd never have found this.",
  },
  never: {
    count: 3519,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "We're lucky there was no fog. I'd never have found this.",
  },
  found: {
    count: 1352,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "We're lucky there was no fog. I'd never have found this.",
  },
  thing: {
    count: 2917,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Well, she doesn't seem to have arrived yet. I suppose we are doing the right thing, aren't we?",
  },
  worse: {
    count: 276,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "A bit of an excuse, really, isn't it? I've seen far worse. The truth is, we're both curious about Susan and we won't be happy until we know some of the answers.",
  },
  truth: {
    count: 504,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "A bit of an excuse, really, isn't it? I've seen far worse. The truth is, we're both curious about Susan and we won't be happy until we know some of the answers.",
  },
  happy: {
    count: 361,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "A bit of an excuse, really, isn't it? I've seen far worse. The truth is, we're both curious about Susan and we won't be happy until we know some of the answers.",
  },
  being: {
    count: 1386,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "You can't just pass it off like that. If I thought I was just being a busybody, I'd go straight home. I thought you agreed she was a bit of a mystery.",
  },
  think: {
    count: 7443,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Yes, but I think you'll find there's a very simple explanation to all this.",
  },
  pound: {
    count: 21,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Well, I don't know how you explain the fact that a fifteen year old girl does not know how many shillings there are in a pound.",
  },
  sense: {
    count: 474,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I suppose she couldn't be a foreigner? No, doesn't make sense. Nothing about this girl makes sense. For instance, the other day I talking about chemical changes. I'd given out the litmus paper to show cause and effect",
  },
  makes: {
    count: 420,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I suppose she couldn't be a foreigner? No, doesn't make sense. Nothing about this girl makes sense. For instance, the other day I talking about chemical changes. I'd given out the litmus paper to show cause and effect",
  },
  given: {
    count: 404,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I suppose she couldn't be a foreigner? No, doesn't make sense. Nothing about this girl makes sense. For instance, the other day I talking about chemical changes. I'd given out the litmus paper to show cause and effect",
  },
  paper: {
    count: 125,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I suppose she couldn't be a foreigner? No, doesn't make sense. Nothing about this girl makes sense. For instance, the other day I talking about chemical changes. I'd given out the litmus paper to show cause and effect",
  },
  cause: {
    count: 262,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I suppose she couldn't be a foreigner? No, doesn't make sense. Nothing about this girl makes sense. For instance, the other day I talking about chemical changes. I'd given out the litmus paper to show cause and effect",
  },
  turns: {
    count: 98,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Yes, I can see red turns to blue, Mister Chesterton, but that's because we're dealing with two inactive chemicals. They only act in relation to each other.",
  },
  whole: {
    count: 1193,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "But that's the whole point of the experiment, Susan.",
  },
  means: {
    count: 741,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "She means it. These simple experiments are child's play to her.",
  },
  these: {
    count: 3014,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "She means it. These simple experiments are child's play to her.",
  },
  three: {
    count: 1847,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Yes. Something like that happened the other day. I'd set the class a problem with A, B and C as the three dimensions.",
  },
  fifth: {
    count: 52,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Three of them? Oh, time being the fourth dimension, I suppose? Then what do you need E for? What do you make the fifth dimension?',
  },
  space: {
    count: 1355,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Space.',
  },
  alone: {
    count: 701,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'Look, can we go in now? I hate to think of her alone in that place.',
  },
  might: {
    count: 1877,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "If she is alone. Look, she is fifteen. She might be meeting a boy. Didn't that occur to you?",
  },
  occur: {
    count: 33,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "If she is alone. Look, she is fifteen. She might be meeting a boy. Didn't that occur to you?",
  },
  stuff: {
    count: 467,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "What a mess. We're not turning over any of this stuff to find her..",
  },
  blast: {
    count: 197,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "Blast. I've dropped it.",
  },
  torch: {
    count: 61,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'The torch.',
  },
  match: {
    count: 67,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Well, use a match.',
  },
  faint: {
    count: 40,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "It's a faint vibration.",
  },
  alive: {
    count: 836,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "It's alive!",
  },
  floor: {
    count: 224,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "It's not connected to anything, unless it's through the floor.",
  },
  quick: {
    count: 731,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "That's not her. Quick.",
  },
  shush: {
    count: 570,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Shush!',
  },
  young: {
    count: 741,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "We're looking for a young girl.",
  },
  their: {
    count: 2555,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: ' One of their pupils, not the police, then.',
  },
  heard: {
    count: 938,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "We heard a young girl's voice call out to you.",
  },
  voice: {
    count: 303,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "We heard a young girl's voice call out to you.",
  },
  acute: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Your hearing must be very acute. I didn't hear anything.",
  },
  dirty: {
    count: 48,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I wonder why I've never seen that before. Now isn't that strange. Very damp and dirty.",
  },
  leave: {
    count: 1975,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Won't you help us? We're two of her teachers from the Coal Hill School. We saw her come in and we haven't seen her leave. Naturally, we're worried.",
  },
  yours: {
    count: 608,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Yours leaves a lot to be desired.',
  },
  fetch: {
    count: 169,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "I think we'd better go and fetch a policeman.",
  },
  force: {
    count: 533,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "We can't force him.",
  },
  enter: {
    count: 180,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Don't you think you're being rather high-handed, young man? You thought you saw a young girl enter the yard. You imagine you heard her voice. You believe she might be inside there. It's not very substantial, is it?",
  },
  fools: {
    count: 122,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I'm not hindering you. If you both want to make fools of yourselves, I suggest you do what you said you'd do. Go and find a policeman.",
  },
  while: {
    count: 795,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'While you nip off quietly in the other direction.',
  },
  shall: {
    count: 2539,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Insulting. There's only one way in and out of this yard. I shall be here when you get back. I want to see your faces when you try to explain away your behaviour to a policeman.",
  },
  faces: {
    count: 76,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Insulting. There's only one way in and out of this yard. I shall be here when you get back. I want to see your faces when you try to explain away your behaviour to a policeman.",
  },
  close: {
    count: 682,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Close the door!',
  },
  known: {
    count: 431,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Close the door, Susan. I believe these people are known to you.',
  },
  round: {
    count: 639,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'I walked all round it.',
  },
  tried: {
    count: 498,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's stopped again, you know, and I've tried hmm? Oh, you wouldn't understand.",
  },
  serve: {
    count: 179,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, yes, yes, yes, yes, yes. By the way, Susan, I managed to find a replacement for that faulty filament. It's an amateur job, but I think it'll serve.",
  },
  rooms: {
    count: 66,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You don't understand, so you find excuses. Illusions, indeed? You say you can't fit an enormous building into one of your smaller sitting rooms.",
  },
  still: {
    count: 3004,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "Well, yes, but I still don't know",
  },
  clear: {
    count: 588,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Not quite clear, is it. I can see by your face that you're not certain. You don't understand. And I knew you wouldn't. Never mind. Now then, which switch was it? No. No, no. Ah yes, that is it. The point is not whether you understand. What is going to happen to you, hmm? They'll tell everybody about the ship now.",
  },
  which: {
    count: 1451,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Not quite clear, is it. I can see by your face that you're not certain. You don't understand. And I knew you wouldn't. Never mind. Now then, which switch was it? No. No, no. Ah yes, that is it. The point is not whether you understand. What is going to happen to you, hmm? They'll tell everybody about the ship now.",
  },
  moves: {
    count: 80,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'You mean it moves?',
  },
  those: {
    count: 2328,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Well, I made up the name Tardis from the initials, Time And Relative Dimension In Space. I thought you'd both understand when you saw the different dimensions inside from those outside.",
  },
  looks: {
    count: 664,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Just let me get this straight. A thing that looks like a police box, standing in a junkyard, it can move anywhere in time and space?',
  },
  first: {
    count: 1974,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Now, now, don't get exasperated, Susan. Remember the Red Indian. When he saw the first steam train, his savage mind thought it an illusion, too.",
  },
  steam: {
    count: 35,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Now, now, don't get exasperated, Susan. Remember the Red Indian. When he saw the first steam train, his savage mind thought it an illusion, too.",
  },
  train: {
    count: 75,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Now, now, don't get exasperated, Susan. Remember the Red Indian. When he saw the first steam train, his savage mind thought it an illusion, too.",
  },
  enjoy: {
    count: 150,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, my civilisation. I tolerate this century, but I don't enjoy it. Have you ever thought what it's like to be wanderers in the fourth dimension? Have you? To be exiles? Susan and I are cut off from our own planet, without friends or protection. But one day we shall get back. Yes, one day. One day.",
  },
  every: {
    count: 1322,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "It's true. Every word of it's true. You don't know what you've done coming in here. Grandfather, let them go now, please. Look, if they don't understand, they can't, they can't hurt us at all. I understand these people better than you. Their minds reject things they don't understand.",
  },
  minds: {
    count: 192,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "It's true. Every word of it's true. You don't know what you've done coming in here. Grandfather, let them go now, please. Look, if they don't understand, they can't, they can't hurt us at all. I understand these people better than you. Their minds reject things they don't understand.",
  },
  loved: {
    count: 72,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "It's not! Look, I love your school. I loved England in the twentieth century. The last five months have been the happiest of my life.",
  },
  sound: {
    count: 396,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'But you are one of us. You look like us, you sound like us.',
  },
  world: {
    count: 1419,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'I was born in another time, another world.',
  },
  doors: {
    count: 318,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'He closed the doors from over there. I saw him. Now, which is it? Which is it? Which control operates the door?',
  },
  dream: {
    count: 280,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I know that free movement time and space is a scientific dream I don't expect to find solved in a junkyard.",
  },
  great: {
    count: 1549,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Your arrogance is nearly as great as your ignorance.',
  },
  touch: {
    count: 516,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: "Don't touch it! It's live!",
  },
  earth: {
    count: 2177,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "Ian! What on earth do you think you're doing?",
  },
  child: {
    count: 644,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'My dear child, of course they will. Put yourself in their place. They are bound to make some sort of a complaint to the authorities, or at the very least talk to their friends. If I do let them go, Susan, you realise of course we must go, too.',
  },
  bound: {
    count: 148,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'My dear child, of course they will. Put yourself in their place. They are bound to make some sort of a complaint to the authorities, or at the very least talk to their friends. If I do let them go, Susan, you realise of course we must go, too.',
  },
  least: {
    count: 635,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'My dear child, of course they will. Put yourself in their place. They are bound to make some sort of a complaint to the authorities, or at the very least talk to their friends. If I do let them go, Susan, you realise of course we must go, too.',
  },
  trust: {
    count: 664,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "I want to stay! But they're both kind people. Why won't you trust them? All you've got to do is ask them to promise to keep our secret",
  },
  hands: {
    count: 511,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HUR',
    firstSaidQuote: ' In his hands. We are not going to the wood.',
  },
  tiger: {
    count: 28,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'He showed me how to sharpen the stones and trap the bear and the tiger. He should have shown me this, too.',
  },
  shown: {
    count: 49,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'He showed me how to sharpen the stones and trap the bear and the tiger. He should have shown me this, too.',
  },
  sight: {
    count: 211,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'Out of my sight, old woman. You should have died with him.',
  },
  woman: {
    count: 513,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'Out of my sight, old woman. You should have died with him.',
  },
  layer: {
    count: 22,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Layer of sand, rock formation. Good.',
  },
  proof: {
    count: 173,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "All right, show me some proof. Give me some concrete evidence. I'm sorry, Susan, I don't want to hurt you, but it's time you were brought back to reality.",
  },
  prove: {
    count: 203,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Well, just open the doors and prove your point.',
  },
  alien: {
    count: 533,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'If you could touch the alien sand and hear the cries of strange birds and watch them wheel in another sky, would that satisfy you?',
  },
  cries: {
    count: 17,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'If you could touch the alien sand and hear the cries of strange birds and watch them wheel in another sky, would that satisfy you?',
  },
  birds: {
    count: 64,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'If you could touch the alien sand and hear the cries of strange birds and watch them wheel in another sky, would that satisfy you?',
  },
  watch: {
    count: 622,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'If you could touch the alien sand and hear the cries of strange birds and watch them wheel in another sky, would that satisfy you?',
  },
  wheel: {
    count: 100,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'If you could touch the alien sand and hear the cries of strange birds and watch them wheel in another sky, would that satisfy you?',
  },
  argue: {
    count: 100,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well I've no more time to argue with you. I must get some samples, Susan.",
  },
  horns: {
    count: 10,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I don't know. It hasn't got any horns or antlers. Could be a horse. Could be anything. Incredible. A police box in the midst of. Oh, it just doesn't make sense.",
  },
  horse: {
    count: 108,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I don't know. It hasn't got any horns or antlers. Could be a horse. Could be anything. Incredible. A police box in the midst of. Oh, it just doesn't make sense.",
  },
  midst: {
    count: 9,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I don't know. It hasn't got any horns or antlers. Could be a horse. Could be anything. Incredible. A police box in the midst of. Oh, it just doesn't make sense.",
  },
  ionic: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: "Yes, it's been an Ionic column and a sedan chair.",
  },
  sedan: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: "Yes, it's been an Ionic column and a sedan chair.",
  },
  chair: {
    count: 87,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: "Yes, it's been an Ionic column and a sedan chair.",
  },
  quiet: {
    count: 411,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "You're very quiet.",
  },
  panic: {
    count: 120,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "Susan, don't panic.",
  },
  maybe: {
    count: 1019,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Well, maybe he saw something and went off to investigate.',
  },
  taken: {
    count: 753,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I don't know. Perhaps he was excited and went off to investigate something as you suggest, but. He may have been taken.",
  },
  worry: {
    count: 879,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "Susan, don't worry. What's the matter?",
  },
  notes: {
    count: 44,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "It's his notes. He'd never leave his notebook. It's too important to him. It's got the key codes of all the machines in the ship. It's got notes of everywhere we've been to. Something terrible has happened to him, I know it has. We must find him.",
  },
  codes: {
    count: 52,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "It's his notes. He'd never leave his notebook. It's too important to him. It's got the key codes of all the machines in the ship. It's got notes of everywhere we've been to. Something terrible has happened to him, I know it has. We must find him.",
  },
  rocks: {
    count: 70,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "What's on the other side of those rocks?",
  },
  trees: {
    count: 118,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "There's a line of trees. There's a gap in them. There might be a path on the other side.",
  },
  comes: {
    count: 414,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HORG',
    firstSaidQuote:
      "Kal says, where he comes from, he's often seen men make fire.",
  },
  often: {
    count: 138,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HORG',
    firstSaidQuote:
      "Kal says, where he comes from, he's often seen men make fire.",
  },
  tribe: {
    count: 77,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'All his tribe died in the last cold. If he had not found us, he would have died too.',
  },
  shows: {
    count: 65,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HORG',
    firstSaidQuote: 'He says Orb only shows the secret to the leader.',
  },
  sleep: {
    count: 334,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'I am leader. Orb will show me. I am the son of the great firemaker, but he does not show me how to put flames into the sticks. Kal comes. I do not kill him. I let him eat with us and sleep in our caves. I will have to spill some blood and make people bow to me.',
  },
  caves: {
    count: 110,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'I am leader. Orb will show me. I am the son of the great firemaker, but he does not show me how to put flames into the sticks. Kal comes. I do not kill him. I let him eat with us and sleep in our caves. I will have to spill some blood and make people bow to me.',
  },
  spill: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'I am leader. Orb will show me. I am the son of the great firemaker, but he does not show me how to put flames into the sticks. Kal comes. I do not kill him. I let him eat with us and sleep in our caves. I will have to spill some blood and make people bow to me.',
  },
  blood: {
    count: 351,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'I am leader. Orb will show me. I am the son of the great firemaker, but he does not show me how to put flames into the sticks. Kal comes. I do not kill him. I let him eat with us and sleep in our caves. I will have to spill some blood and make people bow to me.',
  },
  smoke: {
    count: 68,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KAL',
    firstSaidQuote:
      "Orb is for strong men. Orb has sent me this creature to make fire come from his fingers. I have seen it. Inside, he's full of fire. The smoke comes from his mouth.",
  },
  mouth: {
    count: 93,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KAL',
    firstSaidQuote:
      "Orb is for strong men. Orb has sent me this creature to make fire come from his fingers. I have seen it. Inside, he's full of fire. The smoke comes from his mouth.",
  },
  wears: {
    count: 21,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote: 'As lies come out of yours. He wears strange skins.',
  },
  skins: {
    count: 20,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote: 'As lies come out of yours. He wears strange skins.',
  },
  bears: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote: 'Tomorrow, I kill many bears. You all have warm skins.',
  },
  carry: {
    count: 294,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KAL',
    firstSaidQuote:
      'The firemaker is dead. You all carry dry sticks with you. But tonight, I make them burn. I am leader.',
  },
  waits: {
    count: 19,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KAL',
    firstSaidQuote:
      "When it's cold, the tiger comes to our caves again at night. Za will give you to the tiger. Za will give you to the cold. Za rubs his hands and waits for Orb to remember him. My creature can make fire come from his fingers. I have seen it. But I, Kal, brought him here. The creature is mine.",
  },
  women: {
    count: 116,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote: 'I say what is to be done here, not old men and women.',
  },
  tries: {
    count: 37,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KAL',
    firstSaidQuote:
      'Za tries to talk like his father, the firemaker. Za does not want to see fire made. But I, Kal, am not afraid of fire. I will make my creature make fire.',
  },
  fight: {
    count: 572,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'You want to be strong like Za, son of the great firemaker. You all heard him say that there would be fire. There is no fire. Za does not tell you lies. He does not say, I will do this thing, and then not do it. He does not say, I will make you warm, and then leave you to the dark. He does not say, I will fight away the tiger with fire, and then let him come to you in the dark. Do you want a liar for your chief?',
  },
  chief: {
    count: 246,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'You want to be strong like Za, son of the great firemaker. You all heard him say that there would be fire. There is no fire. Za does not tell you lies. He does not say, I will do this thing, and then not do it. He does not say, I will make you warm, and then leave you to the dark. He does not say, I will fight away the tiger with fire, and then let him come to you in the dark. Do you want a liar for your chief?',
  },
  kills: {
    count: 49,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      "Let the old man die. And we'll watch the great Kal as he kills his strong enemy.",
  },
  enemy: {
    count: 311,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      "Let the old man die. And we'll watch the great Kal as he kills his strong enemy.",
  },
  laugh: {
    count: 89,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      "Or we'll keep them and make them hunt for us. It's good to have someone to laugh at!",
  },
  gives: {
    count: 121,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'Wait. You cannot kill all our enemies. When Orb gives fire back to the sky, let him look down on them. Then that is when they die, and Orb will give us fire again. Take them to the Cave of Skulls.',
  },
  fault: {
    count: 423,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "We should use our cunning. I hope you can get yourself free, Chesterton. I can't. The stench in here. The stench. I'm sorry. It's all my fault. I'm desperately sorry.",
  },
  blame: {
    count: 120,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: "Don't blame yourself, Grandfather.",
  },
  split: {
    count: 93,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "They're all the same. They've been split open.",
  },
  piece: {
    count: 257,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: "I've found another piece with a rough edge.",
  },
  rough: {
    count: 66,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: "I've found another piece with a rough edge.",
  },
  keeps: {
    count: 129,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "It's no good, it keeps crumbling.",
  },
  stone: {
    count: 196,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, it's hopeless, hopeless. Even if we do get free, we shall never move that stone.",
  },
  small: {
    count: 389,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "It may only be a small opening. Don't count on it.",
  },
  count: {
    count: 234,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "It may only be a small opening. Don't count on it.",
  },
  waste: {
    count: 261,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, no, don't waste time. Try those bones, they may be. They're sharper, perhaps.",
  },
  bones: {
    count: 78,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, no, don't waste time. Try those bones, they may be. They're sharper, perhaps.",
  },
  tired: {
    count: 144,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Susan, you have a go. My arms are tired.',
  },
  lives: {
    count: 484,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Fear is with all of us, and always will be. Just like that other sensation that lives with it.',
  },
  knife: {
    count: 69,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HUR',
    firstSaidQuote: 'I saw the old woman take your knife.',
  },
  awake: {
    count: 69,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HUR',
    firstSaidQuote:
      'Kal was in the cave. Leaders are awake when others sleep. The strange tribe will not be able to show you how to make fire if the old woman kills them.',
  },
  bring: {
    count: 961,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MOTHER',
    firstSaidQuote:
      'I will set you free if you will go away and not make fire. Fire will bring trouble and death to the tribe.',
  },
  death: {
    count: 944,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MOTHER',
    firstSaidQuote:
      'I will set you free if you will go away and not make fire. Fire will bring trouble and death to the tribe.',
  },
  hurry: {
    count: 616,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MOTHER',
    firstSaidQuote:
      'Hurry, hurry. You must go across the tuft and into the trees.',
  },
  trail: {
    count: 45,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Yes, there was a sort of trail.',
  },
  party: {
    count: 258,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I'm all right. Don't keep on looking upon me as the weakest link of the party.",
  },
  moved: {
    count: 197,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "The bushes moved. I saw them. I saw them! Oh, we're never going to get out of this awful place! Never! Never! Never!",
  },
  awful: {
    count: 104,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "The bushes moved. I saw them. I saw them! Oh, we're never going to get out of this awful place! Never! Never! Never!",
  },
  sheer: {
    count: 37,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Oh, sheer nonsense, child. Imagination.',
  },
  order: {
    count: 624,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "No. We'll change the order. You and Susan go in front, Barbara and I'll bring up the rear. Susan seems to remember the way better than any of us.",
  },
  front: {
    count: 244,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "No. We'll change the order. You and Susan go in front, Barbara and I'll bring up the rear. Susan seems to remember the way better than any of us.",
  },
  seems: {
    count: 714,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "No. We'll change the order. You and Susan go in front, Barbara and I'll bring up the rear. Susan seems to remember the way better than any of us.",
  },
  allow: {
    count: 248,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I won't allow myself to be frightened out of my wits by mere shadows, that's all.",
  },
  marks: {
    count: 58,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote: 'There are marks here.',
  },
  water: {
    count: 514,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'I want water.',
  },
  stray: {
    count: 15,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Well, we've lost our chance of getting away. Your flat must be littered with stray cats and dogs.",
  },
  human: {
    count: 1261,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'These are human beings, Ian.',
  },
  treat: {
    count: 77,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'Why? You treat everybody and everything as something less important than yourself.',
  },
  bonds: {
    count: 8,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'And what about the old woman who cut our bonds? You understand?',
  },
  poles: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Take your coat off, Barbara. Susan, try and find me two poles. Long ones, fairly straight.',
  },
  logic: {
    count: 81,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Do you think so? These people have logic and reason, have they? Can't you see their minds change as rapidly as night and day? She's probably telling the whole tribe at this very moment.",
  },
  teach: {
    count: 76,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'We will make him well again. We will teach you how to make fire. In return, you show us the way back to our cave.',
  },
  ready: {
    count: 1123,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "We've been too long as it is. Is the stretcher ready?",
  },
  takes: {
    count: 243,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KAL',
    firstSaidQuote:
      'Za has gone with them, taking them to their cave. Za takes away fire. Now I, Kal, lead. Go!',
  },
  saved: {
    count: 303,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HUR',
    firstSaidQuote: 'They saved Za from death near the stream.',
  },
  speak: {
    count: 681,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KAL',
    firstSaidQuote:
      'The old woman does not speak. She does not say she did this or did that. The old woman is dead. Za killed the old woman.',
  },
  finer: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'It is a finer knife than yours.',
  },
  stand: {
    count: 1017,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'The great stone will close one place, and you will stand by another I will show you. Take them.',
  },
  beast: {
    count: 94,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'Tell me what happened after I fought the beast in the forest.',
  },
  whose: {
    count: 118,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'They are a new tribe. Not like us. Not like Kal. The young one, whose name is Friend, spoke to me.',
  },
  spoke: {
    count: 115,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'They are a new tribe. Not like us. Not like Kal. The young one, whose name is Friend, spoke to me.',
  },
  drove: {
    count: 20,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'The whole tribe drove Kal away with the stones. The whole tribe can collect more fruit than one. The whole tribe can kill a beast where one of the tribe would die.',
  },
  fruit: {
    count: 38,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'The whole tribe drove Kal away with the stones. The whole tribe can collect more fruit than one. The whole tribe can kill a beast where one of the tribe would die.',
  },
  grass: {
    count: 26,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Here are some leaves, and some dead grass.',
  },
  smell: {
    count: 162,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'I can smell something.',
  },
  dying: {
    count: 335,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'I think you are from the other side of the mountains. If you show me how to make fire, I will take you back to the foot of the mountains. If you do not show me, I cannot stop you dying on the old stone.',
  },
  roots: {
    count: 19,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HORG',
    firstSaidQuote:
      'Orb strikes the old stone and Za does not bring them out. We have no meat, and no fruit from the trees, and no roots. Za is no leader.',
  },
  guard: {
    count: 516,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HUR',
    firstSaidQuote:
      'Za told one of them to watch and guard them until he came out of the Cave of Skulls.',
  },
  above: {
    count: 189,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HORG',
    firstSaidQuote:
      'Orb is above us and there is no fire. Bring them out from the Cave of Skulls and Za as well. Come on.',
  },
  later: {
    count: 443,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HUR',
    firstSaidQuote:
      'Za has gone into the forest to find meat. There will be more food later.',
  },
  stick: {
    count: 157,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZA',
    firstSaidQuote:
      'You will stay here. I have the meat and I have the stick, and a piece of skin. I can make fire now. Your tribe and my tribe will join together.',
  },
  asked: {
    count: 297,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: "That isn't what I asked you.",
  },
  clean: {
    count: 100,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It could be anywhere. Dear, dear, dear, dear. It's no help to us at all. Well, I suggest before we go outside and explore, let us clean ourselves up.",
  },
  white: {
    count: 146,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "There's been a forest fire. Everything's sort of white and ashen.",
  },
  ashen: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "There's been a forest fire. Everything's sort of white and ashen.",
  },
  funny: {
    count: 439,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Funny mist.',
  },
  ashes: {
    count: 17,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The heat must have been indescribable. Look at this soil here. Look at it. It's all turn to sand and ashes. Extraordinary. How can shrubs or trees grow in soil like that, hmm?",
  },
  decay: {
    count: 20,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's petrified. How fascinating, a petrified jungle. Hm. Extraordinary. Yes, I must really investigate that. Couldn't have been heat, then, and age would merely decay.",
  },
  knack: {
    count: 14,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "The ship's no good without him. We'd better keep an eye on him. He seems to have a knack of getting himself into trouble.",
  },
  break: {
    count: 411,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Yes. Well, I suppose we'd better make sure he doesn't fall down and break a leg. Don't you ever think he deserves something to happen to him?",
  },
  glass: {
    count: 136,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'going to put it into a glass and',
  },
  solid: {
    count: 100,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "It's all right. Like everything else in this place, solid stone.",
  },
  metal: {
    count: 265,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, it's certainly alien to anything on your planet. But you're wrong about one thing, Chesterfield. This isn't like everything else. The animal is solidified, certainly, but it's not crumbly stone. It's metal. Yes, it always was.",
  },
  flesh: {
    count: 142,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Why? Can't you imagine an animal unless it's flesh, blood and bone, hmm? No, I tell you this is an entirely different formation. I should say originally it was some pliable metal held together by a magnetic field, or an inner magnetic field, rather, and it may have had the ability to attract it's victims towards it, if they were metal too.",
  },
  field: {
    count: 338,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Why? Can't you imagine an animal unless it's flesh, blood and bone, hmm? No, I tell you this is an entirely different formation. I should say originally it was some pliable metal held together by a magnetic field, or an inner magnetic field, rather, and it may have had the ability to attract it's victims towards it, if they were metal too.",
  },
  inner: {
    count: 42,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Why? Can't you imagine an animal unless it's flesh, blood and bone, hmm? No, I tell you this is an entirely different formation. I should say originally it was some pliable metal held together by a magnetic field, or an inner magnetic field, rather, and it may have had the ability to attract it's victims towards it, if they were metal too.",
  },
  upset: {
    count: 74,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Try not to be too upset.',
  },
  stars: {
    count: 227,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Grandfather's talking about fixing our position by the stars.",
  },
  meter: {
    count: 15,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Oh, yes. There's a meter fixed to a great big bank of computers. If you feed it with the right sort of information, it can take over the controls of the ship and deliver you to any place you want to go.",
  },
  fixed: {
    count: 135,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Oh, yes. There's a meter fixed to a great big bank of computers. If you feed it with the right sort of information, it can take over the controls of the ship and deliver you to any place you want to go.",
  },
  likes: {
    count: 95,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Well, it's a question of the right information, you see. I don't say that Grandfather doesn't know how to work the ship, but he's so forgetful, and then he will go off and. Well, he likes to work on his own.",
  },
  light: {
    count: 685,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I don't know, I don't know. Whatever it was destroyed the vegetation here certainly hasn't damaged the city. But there's no sign of life. No movement, no light, no. No, I shall know more about it when I've been down there.",
  },
  study: {
    count: 78,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Now, don't be ridiculous. That city down there is a magnificent subject for study, and I don't intend to leave here until I've thoroughly investigated it.",
  },
  hello: {
    count: 1441,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Hello.',
  },
  finds: {
    count: 49,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Oh, Susan, it isn't that he doesn't believe you. It's just that he finds it difficult to go against his scientific facts.",
  },
  facts: {
    count: 99,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Oh, Susan, it isn't that he doesn't believe you. It's just that he finds it difficult to go against his scientific facts.",
  },
  admit: {
    count: 164,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'All right, all right, I admit it. A small part of the blame is ours.',
  },
  bacon: {
    count: 16,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "I'd like some bacon and eggs.",
  },
  fully: {
    count: 158,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'This is fully automatic.',
  },
  taste: {
    count: 92,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: "I hope mine doesn't taste of engine grease.",
  },
  salty: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: "My bacon's a bit salty.",
  },
  parts: {
    count: 117,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Food has component parts, dear boy. Flavours are rather like primary colours, you know, you blend two to achieve a third, a fourth, etc, etc.',
  },
  blend: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Food has component parts, dear boy. Flavours are rather like primary colours, you know, you blend two to achieve a third, a fourth, etc, etc.',
  },
  third: {
    count: 165,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Food has component parts, dear boy. Flavours are rather like primary colours, you know, you blend two to achieve a third, a fourth, etc, etc.',
  },
  noise: {
    count: 289,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'But something must have made that noise.',
  },
  power: {
    count: 1930,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "I don't know. The power take-up was rising normally and",
  },
  trace: {
    count: 137,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Shall I trace it on the fault locator, Grandfather?',
  },
  fluid: {
    count: 58,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'K7? Ah, yes, of course, the fluid link. Yes, yes, yes. Yes.',
  },
  spare: {
    count: 161,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Have you got a spare?',
  },
  tests: {
    count: 57,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, I'd like to run a few tests on those. Susan, would you take these into the ship, please?",
  },
  ample: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Yes, ample, ample.',
  },
  hours: {
    count: 448,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I trust we won't be more than a couple of hours. You ready, Susan?",
  },
  level: {
    count: 319,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, I'm afraid so. The atmosphere here is polluted with a very high level of fallout, and we've been walking around in it completely unprotected.",
  },
  badly: {
    count: 86,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'What? But how much radiation, and how badly?',
  },
  drugs: {
    count: 44,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'We need, we need drugs to be treated.',
  },
  cured: {
    count: 25,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      'The Tardis will have to take us to another time and place where we can be cured.',
  },
  avoid: {
    count: 73,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "For the fluid link, yes. Yes, I'm afraid I cheated a little on that. I was determined to see the city, but everybody wanted to go on and, well, to avoid arguments, in short, there's nothing wrong with the fluid link.",
  },
  short: {
    count: 230,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "For the fluid link, yes. Yes, I'm afraid I cheated a little on that. I was determined to see the city, but everybody wanted to go on and, well, to avoid arguments, in short, there's nothing wrong with the fluid link.",
  },
  abuse: {
    count: 10,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Abuse me as much as you like, Chesterton. The point is we need an immediate return to the ship, and I suggest we leave at once.',
  },
  faced: {
    count: 39,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "No! It's time you faced up to your responsibilities. You got us here. Now I'm going to make sure that you get us back.",
  },
  adult: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Child, if only you'd think as an adult sometimes. Oh, very well. Let's go then. Let's go.",
  },
  ahead: {
    count: 290,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK',
    firstSaidQuote:
      'You will move ahead of us and follow my directions. This way. Immediately.',
  },
  lifts: {
    count: 23,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "No, nothing much. They moved me from floor to floor, always in lifts. Where we are now must be miles underground. Well, there wasn't any furniture now I come to think about it.",
  },
  miles: {
    count: 300,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "No, nothing much. They moved me from floor to floor, always in lifts. Where we are now must be miles underground. Well, there wasn't any furniture now I come to think about it.",
  },
  began: {
    count: 57,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "I tried to think of how I could get away from them, but then I began to feel so weak and giddy. It's getting worse now. I think they must have drugged me in some way.",
  },
  giddy: {
    count: 12,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "I tried to think of how I could get away from them, but then I began to feel so weak and giddy. It's getting worse now. I think they must have drugged me in some way.",
  },
  fifty: {
    count: 342,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote: 'It is now fifty eight. An impressive reduction.',
  },
  eight: {
    count: 444,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote: 'It is now fifty eight. An impressive reduction.',
  },
  thals: {
    count: 80,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote: 'We know the Thals are able to live on the surface.',
  },
  signs: {
    count: 88,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'Perhaps it is a drug. Is it failing them now? Why are these four showing signs of radiation sickness?',
  },
  aware: {
    count: 119,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Why? Because we were not aware of it until it was too late, that's why.",
  },
  words: {
    count: 327,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'Tardis? He is becoming delirious. I do not understand his words.',
  },
  under: {
    count: 932,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "My friends and I are travellers. We did find something in the forest near our encampment. They may be the drugs you're referring to. Why not let one of us go and bring the phials here? And under guard, if necessary.",
  },
  agree: {
    count: 293,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote: 'Then we agree.',
  },
  years: {
    count: 1482,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'Over five hundred years ago there were two races on this planet. We, the Daleks, and the Thals. After the neutronic war, our Dalek forefathers retired into the city, protected my our machines.',
  },
  races: {
    count: 37,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'Over five hundred years ago there were two races on this planet. We, the Daleks, and the Thals. After the neutronic war, our Dalek forefathers retired into the city, protected my our machines.',
  },
  dalek: {
    count: 751,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'Over five hundred years ago there were two races on this planet. We, the Daleks, and the Thals. After the neutronic war, our Dalek forefathers retired into the city, protected my our machines.',
  },
  tells: {
    count: 85,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'Most of them perished in the war, but we know that there are survivors. They must be disgustingly mutated, but the fact that they have survived tells us they must have a drug that preserves the life force.',
  },
  exist: {
    count: 246,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "And knowing that these mutated creatures exist outside the city, you're willing to send one of us in amongst them?",
  },
  phial: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'In a moment, child. The phial of drugs left outside the Tardis, remember?',
  },
  eager: {
    count: 14,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's possible that they may have been anti-radiation gloves. Drugs. I can't be certain, but it does give us a chance. The people here, whoever they may be, are very eager to get hold of them.",
  },
  shape: {
    count: 106,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'None of us are in very good shape to go and get them.',
  },
  built: {
    count: 278,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The Daleks, our captors here. Oh, if I didn't feel so. Oh. But I was right about the neutron bomb. The Daleks built this underground city as a kind of huge shelter.",
  },
  opens: {
    count: 42,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Susan, supposing these Daleks insist that only one of us goes. Then I'll have to take the key and I'll have to go on trying until the door opens.",
  },
  holes: {
    count: 29,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "No, you'd jam the lock. Look, it's a defence mechanism. There are twenty one different holes inside the lock. There's one right place and twenty wrong ones. If you make a mistake, you'll. Well, the whole inside of the lock will melt.",
  },
  plead: {
    count: 8,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "You can't let her go alone. She's just a child. Plead with them. Anything!",
  },
  value: {
    count: 137,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'No. They will die in time. There only value is in bringing us enough of the Thal drug to duplicate it for our own use.',
  },
  forty: {
    count: 268,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "How long did the Doctor say we'd last without treatment? Forty eight hours?",
  },
  crawl: {
    count: 16,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Wait. Yes. An hour ago I thought we might try and escape, watch their movements, make a plan. There's always a chance. Now we're too late. I think even if they left the doors wide open we wouldn't have the strength to crawl through them.",
  },
  fever: {
    count: 43,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "He's so hot. It's like a fever.",
  },
  outer: {
    count: 114,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ALYDON',
    firstSaidQuote:
      'I am Alydon of the Thal race. I shall go with you through the forest to the outer wall of the city, if you will allow me.',
  },
  cloak: {
    count: 36,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ALYDON',
    firstSaidQuote: "Here, take my cloak. You're cold.",
  },
  final: {
    count: 357,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ALYDON',
    firstSaidQuote:
      'We are the survivors of a final war. But the radiation still persists and that is why your friends are ill. I wonder if the Daleks have seen us.',
  },
  pulse: {
    count: 83,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Don't give him any more water, Susan. His pulse is steady now anyway.",
  },
  extra: {
    count: 107,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'This Alydon of yours seems to have kept his wits about him. Giving you that extra supply of drugs.',
  },
  plots: {
    count: 8,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "We must try and talk to the Daleks. Alydon says the Thals are going to starve unless they can find new supplies of food. You see, after the war, the Thals that survived managed to cultivate small plots of land. Well, that's how they've survived ever since. But they've always had to be very, very careful, because the crops have always been in danger. But, you see, they rely on a great rainfall that only happens about every four or five years. Well, it's two years overdue now, and all their crops are ruined. Well, that's why the whole Thal race had to leave their plateau and go in search of food.",
  },
  since: {
    count: 646,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "We must try and talk to the Daleks. Alydon says the Thals are going to starve unless they can find new supplies of food. You see, after the war, the Thals that survived managed to cultivate small plots of land. Well, that's how they've survived ever since. But they've always had to be very, very careful, because the crops have always been in danger. But, you see, they rely on a great rainfall that only happens about every four or five years. Well, it's two years overdue now, and all their crops are ruined. Well, that's why the whole Thal race had to leave their plateau and go in search of food.",
  },
  crops: {
    count: 22,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "We must try and talk to the Daleks. Alydon says the Thals are going to starve unless they can find new supplies of food. You see, after the war, the Thals that survived managed to cultivate small plots of land. Well, that's how they've survived ever since. But they've always had to be very, very careful, because the crops have always been in danger. But, you see, they rely on a great rainfall that only happens about every four or five years. Well, it's two years overdue now, and all their crops are ruined. Well, that's why the whole Thal race had to leave their plateau and go in search of food.",
  },
  wants: {
    count: 393,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      'Well, he wants to talk to the Daleks. He said if they agree to supply food for them, then one of us must take a message outside the city.',
  },
  begin: {
    count: 239,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote: 'Why not begin now?',
  },
  lapse: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'Because the lapse of time, the relaxation of sleep, the provision of food, all these things will give them a false sense of security.',
  },
  false: {
    count: 101,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'Because the lapse of time, the relaxation of sleep, the provision of food, all these things will give them a false sense of security.',
  },
  craft: {
    count: 125,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote:
      'This must be the craft in which the strangers arrived here. So, Alydon, we were right to believe the city inhabited.',
  },
  ideas: {
    count: 115,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote:
      "From the distance, the city looks as if they make science and invention their profession. It's a magical architecture. Perhaps we can exchange ideas with them, learn from them.",
  },
  learn: {
    count: 228,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote:
      "From the distance, the city looks as if they make science and invention their profession. It's a magical architecture. Perhaps we can exchange ideas with them, learn from them.",
  },
  weird: {
    count: 171,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote: 'And these others, they arrived here in this weird object?',
  },
  dyoni: {
    count: 8,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote:
      "I hope you're not too generous in your beliefs. What do you say, Dyoni?",
  },
  blind: {
    count: 106,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ALYDON',
    firstSaidQuote: "I'm not quite so blind.",
  },
  trick: {
    count: 236,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote: 'But how shall we know that it is not a trick?',
  },
  foods: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'Have liquid foods, water in abundance. We can also supply unlimited quantities of fresh vegetables which are forced in artificial sunlight.',
  },
  fresh: {
    count: 81,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'Have liquid foods, water in abundance. We can also supply unlimited quantities of fresh vegetables which are forced in artificial sunlight.',
  },
  write: {
    count: 92,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'Have you told the Thals that you would write this name on the message?',
  },
  shout: {
    count: 65,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Take your hands off me. How dare you shout',
  },
  cable: {
    count: 85,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'No, the cable is strong. They have broken it deliberately.',
  },
  holds: {
    count: 48,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'There is no escape from the room that holds them. They may well be useful again. We shall deal with the Thals.',
  },
  issue: {
    count: 33,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'The point is, how do we get out of here? Wait until the Daleks open the door, and force the issue?',
  },
  lasts: {
    count: 19,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, I know you don't know. I mean, why do they use metal? Is it because it lasts longer? Or because",
  },
  acrid: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, no, no, now listen. Let's concentrate on the Daleks. Have you noticed, for example, that when they move about there's a sort of acrid smell?",
  },
  apart: {
    count: 191,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Precisely. If I'm right, of course. Now, what do we know apart from guessing how they are powered?",
  },
  large: {
    count: 154,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Yes. Their eye is flexible, like a large camera lens.',
  },
  nylon: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "I don't know. It isn't plastic, I don't think it's nylon either.",
  },
  lived: {
    count: 168,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ALYDON',
    firstSaidQuote:
      "I wish I could be as objective as you. We've lived for so long a time.",
  },
  gates: {
    count: 48,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote: 'This was found at the city gates.',
  },
  build: {
    count: 223,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote:
      "They're going to help us! It's signed by the girl, Susan. She says the Dalek people have no malice towards us, and they hope that they can work with us to build a new and safe world, free from the fear of war. They have the ability to produce food by means of synthetic sunlight, and they have left a quantity of it in the entrance hall of their main building. We are to collect it tomorrow. So there is a future for us.",
  },
  cover: {
    count: 240,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'He seemed to be able to cover all of us.',
  },
  throw: {
    count: 170,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Yes. Perhaps we can throw a coat over the lens.',
  },
  shoes: {
    count: 44,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Now, wait a minute. Susan, throw me your shoes.',
  },
  nasty: {
    count: 128,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "It's very sticky and very nasty.",
  },
  swing: {
    count: 23,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I think I'm all right. Swing it round. Keep out of the way, Susan.",
  },
  catch: {
    count: 212,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Now, I think it's worked. Take your hand off the gun. It has! It's worked! Now, there must be a catch here somewhere. I've found one.",
  },
  clasp: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'The clasp is stuck.',
  },
  stuck: {
    count: 248,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'The clasp is stuck.',
  },
  shaft: {
    count: 146,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK',
    firstSaidQuote:
      'I have just passed the prisoners through into lift shaft seven.',
  },
  seven: {
    count: 786,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK',
    firstSaidQuote:
      'I have just passed the prisoners through into lift shaft seven.',
  },
  alarm: {
    count: 137,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK',
    firstSaidQuote: 'The door is locked. Emergency alarm.',
  },
  budge: {
    count: 12,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "I can't move it. It won't budge.",
  },
  reach: {
    count: 250,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "We should never have left him. It's so slow. It'll never reach him in time.",
  },
  empty: {
    count: 192,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote: 'It is empty.',
  },
  cross: {
    count: 176,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "There's someone down there. Look, by that sort of gateway thing beyond the low building. I saw someone cross that space.",
  },
  offer: {
    count: 196,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote:
      "You've been saying that ever since their message arrived. Perhaps their offer was coldly worded, but friendship grows with time. These Daleks must have believed that they were the only survivors on this planet.",
  },
  grows: {
    count: 41,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote:
      "You've been saying that ever since their message arrived. Perhaps their offer was coldly worded, but friendship grows with time. These Daleks must have believed that they were the only survivors on this planet.",
  },
  based: {
    count: 50,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote:
      "No, Alydon. And you must thrown off these suspicions. They're based on fear, and fear breeds hatred and war. I shall speak to them peacefully. They'll see that I'm unarmed. There's no better argument against war than that.",
  },
  yards: {
    count: 37,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "By the city wall, I think. Yes, there's a gateway about fifty yards away.",
  },
  peace: {
    count: 306,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote:
      "Daleks, can you hear me? Daleks, the Thal people wish to live in peace. If this is your wish too, then let us work together to rebuild our world. We need your help, and in return we'll make the soil live again, grow crops, build homes. The time for enmity is passed. If this is the kind of future that you want, then send for us and we shall talk.",
  },
  homes: {
    count: 25,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEMMOSUS',
    firstSaidQuote:
      "Daleks, can you hear me? Daleks, the Thal people wish to live in peace. If this is your wish too, then let us work together to rebuild our world. We need your help, and in return we'll make the soil live again, grow crops, build homes. The time for enmity is passed. If this is the kind of future that you want, then send for us and we shall talk.",
  },
  skaro: {
    count: 87,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DYONI',
    firstSaidQuote:
      'The complete history of our planet Skaro is here. It seems now that no one will survive to read it.',
  },
  solar: {
    count: 219,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, nonsense, young lady. Your survival is all here. What, er, is this a solar system?',
  },
  total: {
    count: 140,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DYONI',
    firstSaidQuote:
      'Each of these maps is a tiny section of another solar system, so the total picture can be built up.',
  },
  plans: {
    count: 210,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Yes, I see. I wonder if I could see the plans.',
  },
  burns: {
    count: 42,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DYONI',
    firstSaidQuote: "I'll get some ointment, and something to cover the burns.",
  },
  drink: {
    count: 247,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DYONI',
    firstSaidQuote: "I'll get some water for him to drink. Can you manage?",
  },
  hated: {
    count: 30,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ALYDON',
    firstSaidQuote:
      'Yes. Yes, I know. If only I knew why the Daleks hated us. If I knew that, I, I could alter our approach to them, perhaps.',
  },
  alter: {
    count: 33,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ALYDON',
    firstSaidQuote:
      'Yes. Yes, I know. If only I knew why the Daleks hated us. If I knew that, I, I could alter our approach to them, perhaps.',
  },
  worth: {
    count: 247,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Alydon, you can't go on running away. There are some things worth preserving.",
  },
  works: {
    count: 292,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Pacifism? Is that it? Pacifism only works when everybody feels the same.',
  },
  feels: {
    count: 95,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Pacifism? Is that it? Pacifism only works when everybody feels the same.',
  },
  hosts: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, yes. It took hundreds of years, of course. In the second example, our recent hosts, the mutation has not completed its full circle. Why, I don't know. But do you remember that monstrosity we took out of its machine?",
  },
  sword: {
    count: 96,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "Is this a sword the Thal's holding?",
  },
  start: {
    count: 741,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, please, come along. Oh, by the way, let me have the fluid link, will you? Oh, dear boy, now please, please, come along. You know I can't start the ship without it.",
  },
  elder: {
    count: 64,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote: 'It is the elder prisoner.',
  },
  beats: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'How you two can stand there wasting time with small talk beats me.',
  },
  faith: {
    count: 142,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Thank you, my dear. Your faith is something that I prize very highly. You all realise, of course, we cannot succeed against the Daleks alone?',
  },
  prize: {
    count: 44,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Thank you, my dear. Your faith is something that I prize very highly. You all realise, of course, we cannot succeed against the Daleks alone?',
  },
  steal: {
    count: 135,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'to have self- respect. At this moment, anyone could come in here. They could rob, they could steal.',
  },
  trade: {
    count: 39,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "You're not sorry. You stand here, mumbling a lot of words out of your history. But it means nothing, nothing at all. You carry this around with you. Your history records. Well, it must be valuable to you. Supposing I take it down to the city and try and trade with the Daleks? Perhaps they'd think it valuable enough to exchange for our fluid link.",
  },
  delay: {
    count: 124,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote: 'Then we cannot delay.',
  },
  angry: {
    count: 125,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DYONI',
    firstSaidQuote: 'Are you angry with yourself for striking the young man?',
  },
  swamp: {
    count: 39,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      "Yes. There's horror down there in the swamp. Five of us went there in search of food, and only my brother and I came back.",
  },
  sonic: {
    count: 237,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'Daleks in section two are to be brought to the sonic chamber.',
  },
  adapt: {
    count: 25,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'We do not have to adapt to the environment. We will change the environment to suit us.',
  },
  times: {
    count: 437,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ALYDON',
    firstSaidQuote:
      'You see, we cannot stand by and let these people die. If we do not help them, it would be the same as if we had killed them ourselves. Well, the way I have reasoned is this. The Daleks are strong and they hate us. And I am sure they will find a way to come out of their city and kill us. So it is not merely a question of whether we go off in a vain search for food and in all probability starve to death. We face death now. In the city is enough food for all of us and all of the Daleks, a hundred times over. My conclusion is this. There is no indignity in being afraid to die. But there is a terrible shame in being afraid to live. If none of you agree with my reasons, then let me go with these people, and I will help you elect a new chief.',
  },
  shame: {
    count: 76,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ALYDON',
    firstSaidQuote:
      'You see, we cannot stand by and let these people die. If we do not help them, it would be the same as if we had killed them ourselves. Well, the way I have reasoned is this. The Daleks are strong and they hate us. And I am sure they will find a way to come out of their city and kill us. So it is not merely a question of whether we go off in a vain search for food and in all probability starve to death. We face death now. In the city is enough food for all of us and all of the Daleks, a hundred times over. My conclusion is this. There is no indignity in being afraid to die. But there is a terrible shame in being afraid to live. If none of you agree with my reasons, then let me go with these people, and I will help you elect a new chief.',
  },
  elect: {
    count: 9,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ALYDON',
    firstSaidQuote:
      'You see, we cannot stand by and let these people die. If we do not help them, it would be the same as if we had killed them ourselves. Well, the way I have reasoned is this. The Daleks are strong and they hate us. And I am sure they will find a way to come out of their city and kill us. So it is not merely a question of whether we go off in a vain search for food and in all probability starve to death. We face death now. In the city is enough food for all of us and all of the Daleks, a hundred times over. My conclusion is this. There is no indignity in being afraid to die. But there is a terrible shame in being afraid to live. If none of you agree with my reasons, then let me go with these people, and I will help you elect a new chief.',
  },
  lakes: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      "The swamp. Here are the mountains. This is the far side of the city. I've been into the swamp. It's surrounded by lakes, here, as you see. The lakes are inhabited by all sorts of strange creatures.",
  },
  sorts: {
    count: 60,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      "The swamp. Here are the mountains. This is the far side of the city. I've been into the swamp. It's surrounded by lakes, here, as you see. The lakes are inhabited by all sorts of strange creatures.",
  },
  laser: {
    count: 124,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'The laser scope is transmitting. The quality is poor. What has happened? Has this group broken away? Is there a plan behind it? Why divide their forces?',
  },
  scope: {
    count: 38,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'The laser scope is transmitting. The quality is poor. What has happened? Has this group broken away? Is there a plan behind it? Why divide their forces?',
  },
  group: {
    count: 162,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'The laser scope is transmitting. The quality is poor. What has happened? Has this group broken away? Is there a plan behind it? Why divide their forces?',
  },
  stock: {
    count: 37,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'Essential. I want a complete survey of our stock of nuclear materials. I want an estimate of the amount of waste matter from the nuclear reactors.',
  },
  fears: {
    count: 42,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      "That's enough. We're going on, Antodus. You keep your fears to yourself. I don't want you upsetting the others. Is that clear?",
  },
  thick: {
    count: 69,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      "The ground's very uneven. Sometimes rock, sometimes thick mud. You'll have to watch how you walk. I think it'll be a wise plan to find a place to rest for the night.",
  },
  today: {
    count: 351,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ELYON',
    firstSaidQuote:
      'Most of today. If we could cross the lake we could reach it much quicker.',
  },
  pipes: {
    count: 51,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Barbara, we saw some pipes going into the lake.',
  },
  elyon: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "Where's Elyon?",
  },
  roads: {
    count: 16,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      'There are four roads that lead off from the main square, going north, south, east and west.',
  },
  north: {
    count: 167,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      'There are four roads that lead off from the main square, going north, south, east and west.',
  },
  south: {
    count: 133,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      'There are four roads that lead off from the main square, going north, south, east and west.',
  },
  radio: {
    count: 214,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, yes, yes. Now, the things we have to put out of action is the radio and television waves. They've obviously got complete coverage in and around the city.",
  },
  waves: {
    count: 53,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, yes, yes. Now, the things we have to put out of action is the radio and television waves. They've obviously got complete coverage in and around the city.",
  },
  speed: {
    count: 175,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Yes, we do have speed on our side.',
  },
  tails: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Oh, it's like all the other caves. Just tails off into a dead end.",
  },
  sixth: {
    count: 46,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      "Let's make sure this is impossible first. I must have had sixth sense. Look at that. Pity. Well, let's go back and try one of the other ways.",
  },
  alert: {
    count: 264,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote: 'We must keep alert.',
  },
  risky: {
    count: 30,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, I know it's risky, but, well, we mustn't diddle about here. Now, I want to get to the east side of that antennae.",
  },
  aside: {
    count: 56,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      'A rock hit him. It would have hit me, but he pushed me aside. He was very brave.',
  },
  brave: {
    count: 133,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      'A rock hit him. It would have hit me, but he pushed me aside. He was very brave.',
  },
  track: {
    count: 137,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'No. If we track them by their vibrations, we can take them by surprise.',
  },
  leads: {
    count: 88,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Well it leads up to the antennae.',
  },
  shock: {
    count: 120,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "The thing is, how are we going to cut the wire now it's exposed without getting a terrific shock?",
  },
  tools: {
    count: 33,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "But, my dear child, don't you realise what I've done? A few simple tools",
  },
  brain: {
    count: 429,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'A superior brain.',
  },
  ledge: {
    count: 12,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Yes, and deep. Well, you might as well take a rest while we sort this one out. No point in going that way, it widens out. There's no foothold at all on this side. There's a ledge over there, look. About two to three feet, would you say?",
  },
  cleft: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      'There seems to be some sort of cleft in the rock face there.',
  },
  climb: {
    count: 63,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      'How about going down this side on a rope, and trying to climb the other?',
  },
  shine: {
    count: 37,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Shine the torch on that ledge. Keep clear of me when I run, and give me plenty of rope.',
  },
  slack: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote: ' Take up the slack, will you?',
  },
  wider: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      "It's all right. There's a handhold just here. A little more rope. It goes wider. It seems to be some sort of a tunnel. I don't need the rope any more. Bring the others over.",
  },
  ended: {
    count: 81,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'Without radiation, the Dalek race is ended. We need it as you and the Thals need air.',
  },
  tight: {
    count: 113,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Move back from the edge and catch this rope. Ready? Coming now. Good. Now, tie it round yourself. Tight! Now give yourself a good long run and jump. I'm ready whenever you are.",
  },
  sweat: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Sweat on my hands.',
  },
  chasm: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KRISTAS',
    firstSaidQuote:
      "I don't know. Dirt's got into it, I expect. And if we're going back, we'll have to go back now. We can't cross the chasm without light.",
  },
  alike: {
    count: 26,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'I have no idea. I have some experience in these corridors. They all look alike.',
  },
  knock: {
    count: 96,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Barbara, first and foremost we must find the control room and knock it out.',
  },
  slide: {
    count: 19,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Quick. Wait a minute, I'll take the strain. Barbara, try and slide yourself out.",
  },
  doubt: {
    count: 346,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No doubt you will have other wars to fight. Chesterton, come along, my boy. We've got work to do. I want to look at the reactors and see if there's any radiation leakage.",
  },
  shell: {
    count: 89,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The whole of it. It's useless. Throw it away. Forget it. Unless you want to live in a shell like our dead friends.",
  },
  visit: {
    count: 132,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, I'm afraid it's out of the question. But I might visit your grandchildren to find if they've learned the secrets, and if they have, well, who knows, I might live with them.",
  },
  dress: {
    count: 77,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GANATUS',
    firstSaidQuote:
      "Well, Barbara. The dress you make from this won't be suitable for swamps and caverns.",
  },
  hurts: {
    count: 44,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "My neck hurts too. It's going away now. That's better. I couldn't think where I was",
  },
  dizzy: {
    count: 31,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Dizzy. Shouldn't we help him? His heart seems all right, and his breathing's quite regular. I don't think that cut's as deep as you think.",
  },
  heart: {
    count: 367,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Dizzy. Shouldn't we help him? His heart seems all right, and his breathing's quite regular. I don't think that cut's as deep as you think.",
  },
  crash: {
    count: 107,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "No, the ship can't crash. It's impossible. Grandfather. Grandfather!",
  },
  wound: {
    count: 42,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "The coloured part is the ointment. You'll find the colour disappearing. It goes into the wound. When the bandage is completely white, it means the wound is healed.",
  },
  check: {
    count: 586,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Where is not as important as why, young man. I must go and check the fault locator again.',
  },
  wiser: {
    count: 21,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, well, perhaps it would be wiser to check the fault locator first. I'm glad I thought of that. Yes, come along. Come along.",
  },
  madam: {
    count: 168,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'What is inside, madam, is most important at the moment.',
  },
  lying: {
    count: 234,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'And when we were lying helpless on the floor, you tampered with my controls.',
  },
  knees: {
    count: 19,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Accuse us? You ought to go down on your hands and knees and thank us. But gratitude's the last thing you'll ever have, or any sort of common sense either.",
  },
  relax: {
    count: 90,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'A little nightcap to help us relax and sleep.',
  },
  apply: {
    count: 28,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'You mean, to keep one jump ahead. That you will never be. You need my knowledge and ability to apply it, and then you need my experience to gain the fullest results.',
  },
  crime: {
    count: 70,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "One man's law is another man's crime. Sleep on it, Chesterton. Sleep on it.",
  },
  swear: {
    count: 143,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "But you're wrong. I swear we haven't done anything.",
  },
  panel: {
    count: 66,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'He went near the control panel.',
  },
  smart: {
    count: 64,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Oh, yes, I admit they were very smart.',
  },
  refer: {
    count: 12,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Hurry. Look. We must pull him round. You see that panel up there? You've heard me refer to it? The fault locator?",
  },
  fails: {
    count: 25,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "If one small piece of apparatus fails, a little bulb illuminates and tells me precisely where the fault is. Can you imagine what would happen if the whole of it lights up? Hmm? It means that the ship is on the point of disintegration. You're not to blame. All four of us are to blame!",
  },
  clock: {
    count: 146,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'But all the clock are',
  },
  brink: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "We're on the brink of destruction, so all four of us must work closely together. We must find out where we are and what is happening to my ship.",
  },
  token: {
    count: 14,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Precisely. We haven't crash-landed, otherwise I would have discovered that immediately. And I don't believe there's an evil intelligence in the ship. Just at the same token, I don't really believe that you, either of you, have been the cause of this trouble.",
  },
  rises: {
    count: 25,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'The source of power. You see, when the column rises, it proves the extent of the power thrust.',
  },
  stood: {
    count: 51,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, it's quite safe here. This is where I stood when I tried the scanner switch.",
  },
  clues: {
    count: 16,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "I think. I think, perhaps, we've been given nothing else but clues.",
  },
  blown: {
    count: 89,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, no, it couldn't. If you felt the power, dear boy, you wouldn't live to speak of it. You'd be blown to atoms in a split second.",
  },
  atoms: {
    count: 29,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, no, it couldn't. If you felt the power, dear boy, you wouldn't live to speak of it. You'd be blown to atoms in a split second.",
  },
  solve: {
    count: 34,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Yes, we must solve this problem, you know. We must.',
  },
  flash: {
    count: 39,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, then we have the sequence. A planet, a planet in the solar system, getting further away. Blinding flash. Destruction. Yes, of course. It's our journey.",
  },
  birth: {
    count: 48,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I know. I know. I said it would take the force of a total solar system to attract the power away from my ship. We're at the very beginning, the new start of a solar system. Outside, the atoms are rushing towards each other. Fusing, coagulating, until minute little collections of matter are created. And so the process goes on, and on until dust is formed. Dust then becomes solid entity. A new birth, of a sun and its planets.",
  },
  hoped: {
    count: 58,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'I, er, had hoped to reach your planet Earth. Skaro was in the future and I used the fast return switch.',
  },
  press: {
    count: 119,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, you merely press it down, and. It's stuck. It hasn't released itself!",
  },
  thumb: {
    count: 17,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, the switch hadn't broken down, therefore the fault locator couldn't give us any recognition. You see, let me give you a demonstration. Now, look, when I put my thumb on there, the light comes on. And it only stays on so long as my thumb is pressing that switch. As soon as I take if off, a little spring inside releases the switch here and out goes the light.",
  },
  stays: {
    count: 51,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, the switch hadn't broken down, therefore the fault locator couldn't give us any recognition. You see, let me give you a demonstration. Now, look, when I put my thumb on there, the light comes on. And it only stays on so long as my thumb is pressing that switch. As soon as I take if off, a little spring inside releases the switch here and out goes the light.",
  },
  proud: {
    count: 90,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Precisely. As simple as that. You know, my dear child, I think your old grandfather is going a tiny little bit around the bend. Well, I think you were very brave and I was proud of you.',
  },
  story: {
    count: 392,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Really? And I always thought that you were a young man without any recrimination in you. Well, as for you, young lady, well, you were absolutely right. It was your instinct and intuition against my logic, and you succeeded. I mean, the blackouts, and the still pictures and the clock. Well, you read a story into all these things and were determined to hold on to it. We all owe you our lives.',
  },
  suits: {
    count: 72,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, I think that's absolutely splendid, Chesterton. Yes, it suits you.",
  },
  giant: {
    count: 95,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      'Look at this huge footprint. It must have been made by a giant.',
  },
  edges: {
    count: 9,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Well, it could be a perfectly ordinary footprint, Susan, and the sun's melted the edges and made it look a bit bigger.",
  },
  andes: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Or it could be the Andes.',
  },
  added: {
    count: 22,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "All the lights in the ship have gone out. The whole circuit has burned itself to a cinder, and added to that it affected the water. We haven't got any.",
  },
  lower: {
    count: 96,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, yes, yes, but it's going to take such a long time. Time we don't have. Now the only chance is to try and get down to a lower altitude and, you know, before it gets cold and we",
  },
  print: {
    count: 43,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Well, I only saw a print.',
  },
  marco: {
    count: 175,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote: ' Yes, Messer Marco.',
  },
  flame: {
    count: 98,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "I'm afraid the liquid is not too warm, but the cold here is so intense, it even robs a flame of its heat.",
  },
  boils: {
    count: 3,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "The cold can't affect the heat of the flame, sir. The liquid boils at a lower temperature, because there's so little air up here.",
  },
  shang: {
    count: 28,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'My companions are the Lady Ping-Cho and the Warlord Tegana. We travel to Shang Tu.',
  },
  china: {
    count: 33,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "Shang Tu? That's in China, isn't it?",
  },
  share: {
    count: 110,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'Well, you must all be very tired. Ping-Cho, you will share your quarters with?',
  },
  plain: {
    count: 65,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'How long have you been travelling? It is twelve hundred and eighty nine and this is the Plain of Pamir, known to those who travel to Cathay as The Roof of the World.',
  },
  pamir: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'How long have you been travelling? It is twelve hundred and eighty nine and this is the Plain of Pamir, known to those who travel to Cathay as The Roof of the World.',
  },
  marry: {
    count: 49,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote:
      'Do you marry at our age in your land? Here it is the custom.',
  },
  fianc: {
    count: 10,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Is your fiancé handsome?',
  },
  calls: {
    count: 108,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Yes, the Doctor calls it the Tardis.',
  },
  court: {
    count: 140,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "Well, at the Khan's court in Peking, I have seen Buddhist monks make cups of wine fly through the air unaided and offer themselves to the Great Khan's lips. I do not understand it, but I have seen it. There is room for all of you inside here, Miss Wright?",
  },
  monks: {
    count: 112,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "Well, at the Khan's court in Peking, I have seen Buddhist monks make cups of wine fly through the air unaided and offer themselves to the Great Khan's lips. I do not understand it, but I have seen it. There is room for all of you inside here, Miss Wright?",
  },
  among: {
    count: 107,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote:
      "I wish to serve, my lord, although, among Messer Marco's retinue, there is a man who calls himself a cook.",
  },
  india: {
    count: 25,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'Doctor, I once transported an entire army and its equipment from Cathay to India, all without loss.',
  },
  route: {
    count: 107,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "Success. My plan has worked. The strangers and their unusual caravan accompany me to Lop. Our route takes us across the Roof of the World, down to the Kashgar Valley and southeast to Tarkand. Here we join the Old Silk Road, along which the commerce and culture of a thousand years has travelled to and from Cathay. I wonder what the strangers' reaction will be when I tell them what I propose to do?",
  },
  uncle: {
    count: 81,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "My home is Venice. I left there with my father and my uncle to come to Cathay in twelve seventy one. The journey to Peking took us three and a half years. When I arrived at the Khan's court, I was twenty one. I was an alert young man, good at languages, and willing to learn. The Khan liked me.",
  },
  liked: {
    count: 72,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "My home is Venice. I left there with my father and my uncle to come to Cathay in twelve seventy one. The journey to Peking took us three and a half years. When I arrived at the Khan's court, I was twenty one. I was an alert young man, good at languages, and willing to learn. The Khan liked me.",
  },
  flies: {
    count: 35,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'I told you about the Buddhist monks. They will discover its secret. A caravan that flies. Do you imagine what this will mean to the Khan? It will make him the most powerful ruler the world has ever known. Stronger than Hannibal. Mightier than Alexander the Great.',
  },
  ruler: {
    count: 53,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'I told you about the Buddhist monks. They will discover its secret. A caravan that flies. Do you imagine what this will mean to the Khan? It will make him the most powerful ruler the world has ever known. Stronger than Hannibal. Mightier than Alexander the Great.',
  },
  magic: {
    count: 138,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TEGANA',
    firstSaidQuote:
      "I will use it well, on all but the first of Marco Polo's water gourds, for tomorrow, the caravan sets out to cross the Gobi Desert. Now, you will follow us, and on the third night I will walk back to you. Then we will ride back here to Lop, wait for two days, and then return to the caravan to collect the thing of magic, and bring the mighty Kublai Khan to his knees!",
  },
  ocean: {
    count: 45,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "I have taken charge of the travellers' unusual caravan, and set out into the Gobi Desert. The journey across this vast ocean of sand is slow and hazardous. To make matters worse, the old Doctor continually shows his disapproval of my action by being both difficult and bad-tempered. For three days now, during which time we have covered no more than thirty miles, I have had to endure his insults.",
  },
  chess: {
    count: 51,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote: 'A game of chess, Ian?',
  },
  skies: {
    count: 30,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "One day we'll know all the mysteries of the skies, and we'll stop our wandering.",
  },
  venus: {
    count: 27,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'The metal seas of Venus.',
  },
  queen: {
    count: 260,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Like my Queen. Check.',
  },
  crazy: {
    count: 117,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Oh crazy. Hey, Ping-Cho.',
  },
  walks: {
    count: 28,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'He walks so quickly. Can you still see him?',
  },
  cloud: {
    count: 47,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'That cloud on the horizon.',
  },
  drums: {
    count: 16,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "Not always, Barbara. Sometimes, it sounds like musical instruments being played. The clashing of drums and cymbals. I've heard it sound like a great many people talking as they trekked across the desert. It can also be like a familiar voice calling your name. You're not the only one to be afraid. Travellers of the Gobi Desert have good reason to fear the singing sands, Barbara.",
  },
  sands: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "Not always, Barbara. Sometimes, it sounds like musical instruments being played. The clashing of drums and cymbals. I've heard it sound like a great many people talking as they trekked across the desert. It can also be like a familiar voice calling your name. You're not the only one to be afraid. Travellers of the Gobi Desert have good reason to fear the singing sands, Barbara.",
  },
  storm: {
    count: 136,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "We must wait until the storm calms down. There's nothing we can do now.",
  },
  calms: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "We must wait until the storm calms down. There's nothing we can do now.",
  },
  spend: {
    count: 89,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "This has been a terrible experience for us all, Marco. Couldn't we spend one more night here?",
  },
  repay: {
    count: 16,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'Progress today has been good, although we were all very tired after a sleepless night. How can I ever repay Tegana for saving Ping-Cho and Susan? We covered fifteen miles before I gave the order to set up camp for the night.',
  },
  blade: {
    count: 25,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TEGANA',
    firstSaidQuote:
      "That's excellent, excellent. But it's better a man keeps the blade of his sword clean, and it's edge sharp. You continue your writing, Marco. I'll see to the horses tonight. I'll give the guard his instructions.",
  },
  sharp: {
    count: 39,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TEGANA',
    firstSaidQuote:
      "That's excellent, excellent. But it's better a man keeps the blade of his sword clean, and it's edge sharp. You continue your writing, Marco. I'll see to the horses tonight. I'll give the guard his instructions.",
  },
  using: {
    count: 286,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote: "Yes, except for the one we're using.",
  },
  oasis: {
    count: 12,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "The nearest is a small oasis, but that's one weeks journey north from here.",
  },
  weeks: {
    count: 125,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "The nearest is a small oasis, but that's one weeks journey north from here.",
  },
  worst: {
    count: 88,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "The worst of the sun is nearly over. We must move on again as soon we've had this.",
  },
  wagon: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote: "We'll fix up a cot for him in the wagon.",
  },
  needs: {
    count: 382,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'To be jostled and bumped about? He needs to rest in comfort, Marco. What about the Tardis?',
  },
  rests: {
    count: 8,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'None of us are, Ian, without water. Our fate rests with Tegana.',
  },
  swept: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'What has happened to Tegana? Is he lost? Perhaps he never found the oasis. But in the hope he did, I inched our caravan forward through the night. What misery. A bitterly cold wind swept down from the north and set us shivering as we stumbled on. I fear the end is not far off.',
  },
  cloth: {
    count: 19,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Water! Susan, Susan, child. Susan, wake up. Wake up, quickly! Fetch some cloth and cups.',
  },
  walls: {
    count: 123,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "We must catch the water. We mustn't waste a drop! Come along, child, wake up, quickly! Look at it, streaming down the walls. Look. We must collect it. It's water!",
  },
  heats: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'We must. Quickly, quickly, before the ship heats up in the sun. Hurry, child. Hurry, please.',
  },
  state: {
    count: 246,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I haven't got any water, don't you understand. I wouldn't allow us to get into this state if I had water, young man. No, this was the water that was running off the walls. It's condensation. It's unbelievable. Condensation, do you understand?",
  },
  huang: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "My conscience pricks me. I was adamant despite the Doctor's protests, that the key and his caravan should be handed over to me. Now we journey on across this burning desert and I shall not rest until I see the temple spires of the city of Tun-Huang.",
  },
  sneak: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Don't you realise they will be much less vigilant? I shall be able to sneak into the Tardis, no worry at all.",
  },
  lords: {
    count: 394,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote:
      'Gracious maidens, gentle lords, pray attend me while I tell my tale of Ala-eddin, the Old Man of the Mountains, who by devious schemes, evil designs and foul murders ruled the land.',
  },
  eddin: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote:
      'Gracious maidens, gentle lords, pray attend me while I tell my tale of Ala-eddin, the Old Man of the Mountains, who by devious schemes, evil designs and foul murders ruled the land.',
  },
  ruled: {
    count: 24,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote:
      'Gracious maidens, gentle lords, pray attend me while I tell my tale of Ala-eddin, the Old Man of the Mountains, who by devious schemes, evil designs and foul murders ruled the land.',
  },
  mount: {
    count: 28,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote:
      'No, Susan. It was on a mountain called Mount Alumet in Persia.',
  },
  malik: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TEGANA',
    firstSaidQuote: 'Malik? Malik?',
  },
  await: {
    count: 44,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ACOMAT',
    firstSaidQuote: 'Where he will await news of your success.',
  },
  areas: {
    count: 59,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'Wait, Ian. We will search together. The city is divided into distinct areas. Tegana, you will take one, we will take another. We will meet back here in two hours time.',
  },
  veins: {
    count: 9,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "How extraordinary. Look. Yes, it's quartz. Yes, a mineral ore. Look, you see the veins going through the rock structure. And look how cleverly that face is carved so that at the eye the quartz is exposed. Now, isn't that interesting, hmm?",
  },
  crack: {
    count: 94,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I've just seen them move myself. Look. These eyes you see here have been set in from behind. There must be some sort of a room behind this rock face. Look, there's a crack. There's a door here.",
  },
  shaky: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Still bit shaky.',
  },
  banks: {
    count: 48,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'Poor Susan and Ping-Cho. Yet what alternative had I but to separate them? Now my caravan seethes with suspicion and discontent as we journey south-west. The route takes us to the ancient cities of Su-Chow and Kan-Chow, where the Great Wall of Cathay begins. Following the wall, we travel south to Lan-Chow, which lies on the banks of the Yellow River. Here, our route swings north, and with the river always in sight, we journey towards Shang-Tu.',
  },
  river: {
    count: 217,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'Poor Susan and Ping-Cho. Yet what alternative had I but to separate them? Now my caravan seethes with suspicion and discontent as we journey south-west. The route takes us to the ancient cities of Su-Chow and Kan-Chow, where the Great Wall of Cathay begins. Following the wall, we travel south to Lan-Chow, which lies on the banks of the Yellow River. Here, our route swings north, and with the river always in sight, we journey towards Shang-Tu.',
  },
  jolly: {
    count: 54,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Yes, and a jolly good riddance.',
  },
  spite: {
    count: 15,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote:
      'For me this journey, in spite of all the dangers, was the happiest time of my life, until Tun-Huang.',
  },
  cheer: {
    count: 42,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote: "Hey, this'll cheer you up.",
  },
  flows: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'For the past three days, I have followed the course of the Yellow River as it flows north to the small town of Sinju, which lies nestled against the Great Wall.',
  },
  sinju: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'For the past three days, I have followed the course of the Yellow River as it flows north to the small town of Sinju, which lies nestled against the Great Wall.',
  },
  reply: {
    count: 50,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote:
      "Messer Marco, do you remember Tegana's reply when Miss Wright said she had followed him to the Cave of Five Hundred Eyes?",
  },
  shake: {
    count: 40,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'And on these grounds you dare to call the War Lord Tegana a liar? You foolish child, how dare you make such a reckless accusation. Believe me, it will take much more than this to shake my confidence in Tegana.',
  },
  stake: {
    count: 52,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TEGANA',
    firstSaidQuote: 'With a stake through the heart.',
  },
  bluff: {
    count: 34,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Good. Now listen. Go and get the Doctor out of the ship, then hide. I'm going to try a bluff. If it works, we may be able to turn the tables on Tegana. Now, go quickly.",
  },
  wreck: {
    count: 34,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "No, understand? No! I'd let you wreck it first!",
  },
  seize: {
    count: 57,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'Bear witness. I wear the gold seal of Kublai Khan, and by the authority it invests in me, I do hereby seize and hold your caravan in his name. Be warned. Any resistance to this decree is instantly punishable by death.',
  },
  dealt: {
    count: 65,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "As soon as I've dealt with that guard, I'll come back for you.",
  },
  wakes: {
    count: 23,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'Now, she sleeps now, but if she wakes up, make sure she stays with you.',
  },
  bread: {
    count: 18,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, we're not going to get very far with this overgrown bread knife! We shall have to use more enterprise than this.",
  },
  sport: {
    count: 29,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ACOMAT',
    firstSaidQuote:
      "But not with stealth, as lord Tegana wished. We'll make sport of it.",
  },
  meant: {
    count: 243,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote: 'Even though failure might have meant death?',
  },
  broke: {
    count: 94,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, it wasn't the devils in the fire. Their leader was killed. That's why they broke up and ran.",
  },
  noble: {
    count: 120,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Huh. Very noble of you, I'm sure.",
  },
  house: {
    count: 659,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'LING-TAU',
    firstSaidQuote:
      "That's the reason we wear these, my lord To warn the post-house of our arrival. And when we get there a fresh horse is saddled and waiting, ready for the next three miles.",
  },
  sends: {
    count: 27,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'LING-TAU',
    firstSaidQuote:
      'The mighty Kublai Khan sends his greetings to his faithful servant.',
  },
  cheng: {
    count: 9,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      'Kublai Khan wishes to see me without delay. Six days hard riding from here is the city of Cheng-Ting, where we can take horses and ride on to Shang-Tu.',
  },
  silky: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Look at that one there. He's just like Wang-Lo, all fat, smooth and silky. And look at this one here. He's very solemn. He's just like Marco Polo. And look at this one dashing around all over the place. He's got Ian's energy. Ah, look, that one's all by itself. It's independent, like Barbara.",
  },
  price: {
    count: 128,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KUIJU',
    firstSaidQuote: 'Are you prepared to pay a good price?',
  },
  money: {
    count: 319,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KUIJU',
    firstSaidQuote: "We want gold, not Kublai Khan's paper money.",
  },
  guess: {
    count: 222,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote: "Can't you guess?",
  },
  grant: {
    count: 270,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLO',
    firstSaidQuote:
      "Well, I grant you England's a long way, but the journey's not impossible, Ian. The Crusaders did it.",
  },
  black: {
    count: 296,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote: "It's black, isn't it.",
  },
  wrath: {
    count: 23,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TEGANA',
    firstSaidQuote: "Well, you're the one who will face his wrath.",
  },
  cruel: {
    count: 34,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Oh, even you couldn't be so cruel as to want her to marry a man four times her age.",
  },
  tents: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote:
      'Karakorum was not a city of stone. It was just a collection of tents. When the Khan moved, the Mongols dispersed.',
  },
  kneel: {
    count: 28,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'VIZIER',
    firstSaidQuote:
      'Kow-tow. Kneel upon the ground and touch your forehead upon the floor three times.',
  },
  items: {
    count: 14,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, if it breaks my back, then he can take all of me. So why waste time on small items?',
  },
  pains: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'I am not a doctor of medicine, sire, otherwise I should be able to cure these pains.',
  },
  aches: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote:
      'We have healing waters here which relieve my gout. Come, let us observe their effects upon your aches and pains.',
  },
  trial: {
    count: 130,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote: 'Oh, what a trial old age is.',
  },
  borne: {
    count: 5,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'It must be borne with dignity, sir.',
  },
  pouch: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KUIJU',
    firstSaidQuote: 'In my pouch, lord.',
  },
  thief: {
    count: 45,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PING-CHO',
    firstSaidQuote: 'He is the thief. We caught him with that.',
  },
  judge: {
    count: 55,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'LING-TAU',
    firstSaidQuote:
      "Pardon me, my lady. I have not the authority to judge in this dispute. It's a matter for the great Khan.",
  },
  tooth: {
    count: 24,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'And the sacred tooth of Buddha which Polo brought over from India.',
  },
  burma: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I'm very much afraid all the commerce from Burma for one year, sire.",
  },
  loses: {
    count: 20,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote: 'One wins, one loses, my dear.',
  },
  brief: {
    count: 27,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote:
      'We are too busy for that, Marco. Be brief, please. Be brief.',
  },
  truly: {
    count: 82,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote:
      'Oh, he is a fortunate one. But our friend here made a truly royal gesture which we have accepted, although it might upset you.',
  },
  royal: {
    count: 88,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote:
      'Oh, he is a fortunate one. But our friend here made a truly royal gesture which we have accepted, although it might upset you.',
  },
  theft: {
    count: 14,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote:
      'The lady Ping-Cho has been excused of complicity in the theft.',
  },
  bribe: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote: 'You wanted to bribe us, Marco?',
  },
  terms: {
    count: 104,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote:
      "We are distressed and angered by your conduct, Marco. Please think about it. You'll also attend us after the banquet, Lord Tegana. We'll discuss the terms of our settlement with Noghai. But we be on guard against you.",
  },
  feast: {
    count: 44,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote:
      'Dead! And in the middle of the feast. How shall we tell her? Terrible! Horrible! Terrible and horrible! Horrible and terrible!',
  },
  table: {
    count: 77,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote:
      'Oh, here you are, my child. Come, we have something to tell you. A tragedy has occurred at the table tonight.',
  },
  drank: {
    count: 8,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote:
      'Your beloved husband-to-be, so anxious to be worthy of your love, drank a potion of quicksilver and sulphur, the elixir of life and eternal youth, and expired.',
  },
  youth: {
    count: 23,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KHAN',
    firstSaidQuote:
      'Your beloved husband-to-be, so anxious to be worthy of your love, drank a potion of quicksilver and sulphur, the elixir of life and eternal youth, and expired.',
  },
  grief: {
    count: 58,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'EMPRESS',
    firstSaidQuote: 'Come into my arms, child. Let me share your grief.',
  },
  scene: {
    count: 39,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It wasn't just my ship then. Whatever double-game Tegana is playing, he must have decided upon a long time before we appeared on the scene.",
  },
  chaos: {
    count: 46,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, but what you have to take into account where battles are concerned, dear boy, are its leaders. Kill the leader, and where are you? What happens? The whole army dissipates itself into chaos and utter confusion. It's happened throughout your history time and time again!",
  },
  utter: {
    count: 12,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, but what you have to take into account where battles are concerned, dear boy, are its leaders. Kill the leader, and where are you? What happens? The whole army dissipates itself into chaos and utter confusion. It's happened throughout your history time and time again!",
  },
  boots: {
    count: 31,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote: "Here, you'd better take my boots.",
  },
  corns: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote: "They'll give you lovely corns, those will.",
  },
  tidal: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Ian. This is a tidal pool.',
  },
  beach: {
    count: 72,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Yes, I agree. Rather ties up with the glass beach, doesn't it.",
  },
  devil: {
    count: 158,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'You mean the acid got in. Poor devil.',
  },
  ships: {
    count: 201,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Good! Now perhaps we might learn who it is that uses these strange ships. Anyway, lets get back to the ship and find Susan. Later, perhaps, a little visiting, I think.',
  },
  joins: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Look at the joins in the blocks, Ian.',
  },
  sworn: {
    count: 42,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'I could have sworn I heard her.',
  },
  habit: {
    count: 40,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, no. The man wearing the monk's habit lives in this building.",
  },
  voord: {
    count: 5,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ARBITAN',
    firstSaidQuote:
      'Safe. I saw your machine materialise. Until I knew otherwise I had to treat you as potential enemies. The Voord were trying to penetrate the walls.',
  },
  named: {
    count: 45,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ARBITAN',
    firstSaidQuote:
      'That is exactly what happened. Marinus was unique in the universe. Robbery, fear, hate, violence were unknown among us. Yes, yes, for seven centuries we prospered, and then a man named Yartek found a means of overcoming the power of the machine. He and his followers, the Voords, were able to rob, exploit, kill, cheat. Our people could not resist because violence is alien to them.',
  },
  cheat: {
    count: 28,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ARBITAN',
    firstSaidQuote:
      'That is exactly what happened. Marinus was unique in the universe. Robbery, fear, hate, violence were unknown among us. Yes, yes, for seven centuries we prospered, and then a man named Yartek found a means of overcoming the power of the machine. He and his followers, the Voords, were able to rob, exploit, kill, cheat. Our people could not resist because violence is alien to them.',
  },
  wrist: {
    count: 29,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ARBITAN',
    firstSaidQuote:
      'The principle is much the same as that of your ship. Place that around your wrist, please. You told me about, except this will enable you to cross space, not time.',
  },
  twist: {
    count: 22,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ARBITAN',
    firstSaidQuote:
      "They're all programmed to the same destination. You have only to twist the dial once.",
  },
  dials: {
    count: 17,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ARBITAN',
    firstSaidQuote:
      'You must not waste time. You must follow, quickly. One final word. If when you return, you find the Voord have taken this building, do not let them get the keys. You understand? Destroy them! Now, now, twist the dials.',
  },
  strap: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Doctor, there's blood on this strap. That means she's hurt, maybe badly. We can't argue now. Let's get inside.",
  },
  silks: {
    count: 12,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Oh, those silks. They're gorgeous. I'd love a dress made from one of these.",
  },
  spoil: {
    count: 33,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "Oh, now don't spoil it all for me.",
  },
  blink: {
    count: 60,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote: "He didn't blink once. Am I being ridiculous?",
  },
  juice: {
    count: 32,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Can I have some more orange juice, please?',
  },
  altos: {
    count: 26,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Ah, here comes Altos. Now perhaps he can convince you.',
  },
  discs: {
    count: 12,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MORPHO',
    firstSaidQuote: 'Who placed the discs?',
  },
  amuse: {
    count: 15,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "What? Oh, yes, yes, yes, yes. A simple toy. I'm sure that will amuse you. Ah, now this might be helpful.",
  },
  gangs: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MORPHO',
    firstSaidQuote:
      "The two men will join the working parties. We can use the younger one's strength with the haulage gangs. The old man is weaker, but intelligent. Isolate him and put him to work on the scheme for increasing my powers. As for the child, she must be trained rapidly. She will take the place of Sabetha, the one that failed us.",
  },
  erase: {
    count: 14,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MORPHO',
    firstSaidQuote:
      'No. You have seen the truth of our city. It is beyond our power to erase this from your memory. You must be destroyed. Kill her. Kill her.',
  },
  eprin: {
    count: 9,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ALTOS',
    firstSaidQuote:
      'I was sent by Arbitan. I and a friend called Eprin. Our plan was as follows. He would go ahead in search of key four, and I would come here for the first.',
  },
  adopt: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Ah, yes, the place you mentioned, yes. The highly civilised society. Now then, I've decided to adopt his plan.",
  },
  jumps: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'What? You mean go two jumps ahead and try and find the fourth key?',
  },
  rebel: {
    count: 40,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'You rebel.',
  },
  mixed: {
    count: 40,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Well, it was a sound. A noise like tapping, and whirring, all mixed up with a screeching. I've heard it before.",
  },
  dense: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "You know, I've never seen vegetation as dense as this before. It'll overrun the building in time.",
  },
  snake: {
    count: 41,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'It was alive! A snake crawling all over me!',
  },
  twine: {
    count: 3,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'It was trying to twine all round me.',
  },
  micro: {
    count: 56,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote: "Barbara's found the micro-key.",
  },
  pivot: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Barbara's disappeared. That idol thing was on some sort of a pivot.",
  },
  raise: {
    count: 102,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SABETHA',
    firstSaidQuote:
      "Thank you. Look, I don't want to raise false hopes, but perhaps things aren't as bad as they seem.",
  },
  hopes: {
    count: 26,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SABETHA',
    firstSaidQuote:
      "Thank you. Look, I don't want to raise false hopes, but perhaps things aren't as bad as they seem.",
  },
  chain: {
    count: 44,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Good luck. Here, you'd better put this on your chain with the other one. We don't want you losing it somewhere in outer space.",
  },
  booby: {
    count: 27,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "This whole place is one big booby-trap. It's full of things like that statue. I'd only been here a minute when part of the wall crashed down just where I'd been standing.",
  },
  vines: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'These vines are everywhere. They seem to be crawling all over the building.',
  },
  traps: {
    count: 40,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'DARRIUS',
    firstSaidQuote:
      'I know. A system of mirrors. When the false key was taken I put my traps in motion. Only those warned by Arbitan could avoid them.',
  },
  diary: {
    count: 21,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I don't know. I think he was rambling, he didn't mean anything. I'm hoping to find a lead in here. It's a diary of his experiments.",
  },
  tempo: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Yes. Last couple of entries are a bit strange. All about the balance of nature and increased destructive forces. Listen to this. Nature has a fixed tempo of destruction. Water dripping on a stone may take a thousand years to produce any sign of wear.',
  },
  below: {
    count: 122,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Oh, it must be far below zero.',
  },
  vasar: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VASAR',
    firstSaidQuote:
      "Last year I broke the back of a wolf with my bare hands. I'm Vasar. Most men fear me, so I have few visitors. There, see? The blood is beginning to return.",
  },
  eaten: {
    count: 52,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VASAR',
    firstSaidQuote: 'The wolves would have eaten you first.',
  },
  dozen: {
    count: 52,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VASAR',
    firstSaidQuote:
      "Yes, there are more than ever of them this winter. I've counted a dozen packs, twenty in each. They're hungry. They're even raiding the villages at night.",
  },
  packs: {
    count: 26,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VASAR',
    firstSaidQuote:
      "Yes, there are more than ever of them this winter. I've counted a dozen packs, twenty in each. They're hungry. They're even raiding the villages at night.",
  },
  early: {
    count: 165,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VASAR',
    firstSaidQuote:
      "A madman. Came in here early last night, raving and ranting. I couldn't talk to him. Gave him some clothes and went with him up the mountain. He was searching for a couple of girls.",
  },
  store: {
    count: 78,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VASAR',
    firstSaidQuote:
      "There's a cave on the mountain where I store my traps. I found the two girls hiding there.",
  },
  flint: {
    count: 5,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VASAR',
    firstSaidQuote:
      'They may be. That was yesterday. I gave them food and flint in return for these, and I left them there.',
  },
  stole: {
    count: 92,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "I don't believe you. You stole those things.",
  },
  scent: {
    count: 20,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ALTOS',
    firstSaidQuote:
      "There's your answer. Those beasts could scent meat a couple of miles away. Draw them like a magnet. Vasar's making certain you wouldn't get back.",
  },
  ridge: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VASAR',
    firstSaidQuote:
      "It's just beyond the next ridge. When we get there, can I go back?",
  },
  slope: {
    count: 5,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ALTOS',
    firstSaidQuote: 'Sabetha, keep close behind me. Look out for this slope.',
  },
  block: {
    count: 128,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Yes. Mind the slope. All right? Altos, look out! This rock's the only thing supporting this block of ice.",
  },
  valve: {
    count: 36,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "Ian, over here. It's a sort of valve, or something.",
  },
  vault: {
    count: 86,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TARRON',
    firstSaidQuote:
      "This is a maximum security vault. No one is admitted until they've undergone a complete probity check. There's no record of you ever having completed such a check.",
  },
  legal: {
    count: 32,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TARRON',
    firstSaidQuote: 'That is contrary to our legal system.',
  },
  rigid: {
    count: 3,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'CLERK',
    firstSaidQuote:
      "But I'm to tell you there must be no disturbances of any kind. The laws are very rigid. Offenders can be sent for one year to the glass factories in the desert, instantly and without trial.",
  },
  grave: {
    count: 86,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JUDGE',
    firstSaidQuote:
      'Representative for the defence, you have a grave duty. You have offered your services in this matter, which complies with the law of the city of Millenius, in that any person may speak on behalf of another. Are you acquainted with our laws?',
  },
  autho: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TARRON',
    firstSaidQuote:
      'No. every person that came in here was checked by the autho-ray scanner as they went out. If anyone had the key on them, the scanner would have detected it.',
  },
  error: {
    count: 82,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'You see, Tarron never doubted that Chesterton was guilty. A grave error. Yes, a very grave error.',
  },
  ayden: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'KALA',
    firstSaidQuote: 'Ayden.',
  },
  aydon: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JUDGE',
    firstSaidQuote:
      'It is clear that Aydon was involved in either the theft or the killing. It is also clear that he had an accomplice. Bearing in mind that the accused came here with the express purpose of recovering the micro-key, and remembering the evidence against him, his guilt becomes even more obvious. Will the prosecutor please summarise.',
  },
  guilt: {
    count: 32,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JUDGE',
    firstSaidQuote:
      'It is clear that Aydon was involved in either the theft or the killing. It is also clear that he had an accomplice. Bearing in mind that the accused came here with the express purpose of recovering the micro-key, and remembering the evidence against him, his guilt becomes even more obvious. Will the prosecutor please summarise.',
  },
  helps: {
    count: 49,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SABETHA',
    firstSaidQuote: "I don't see how that helps.",
  },
  crept: {
    count: 3,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Yes, then the three of them crept up behind her and pow!',
  },
  phone: {
    count: 280,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      'What about that man who called on the phone thing? I heard him tell her to kill me.',
  },
  owned: {
    count: 15,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TARRON',
    firstSaidQuote:
      "Oh, yes, they've owned up to everything. Kala and the Prosecutor had planned to steal the key and sell it, and Chesterton here just happened to walk right into the middle of it. They made him look so guilty I never doubted for a moment he was the one.",
  },
  asset: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'You should read Pyrrho, my boy. He founded Scepticism. A great asset to your business.',
  },
  loves: {
    count: 53,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SABETHA',
    firstSaidQuote: 'The man who loves me cannot betray me.',
  },
  untie: {
    count: 22,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SABETHA',
    firstSaidQuote:
      "It's no use. Even if we manage to untie ourselves, we'll never break the gates down.",
  },
  loose: {
    count: 81,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "There's not a moment to loose. Come on!",
  },
  chase: {
    count: 94,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Yes, my child. Chase the others up, will you?',
  },
  bless: {
    count: 49,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, no, I wouldn't say that. His work will go on, only not quite in the same way. But I don't believe that man was made to be controlled by machines. Machines can make laws, but they cannot preserve justice. Only human beings can do that. Now I only hope that you'll carry on his good work, please. Goodbye. Bless you, my child.",
  },
  aztec: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "It's an Aztec mask. He must have been a priest.",
  },
  tombs: {
    count: 15,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, you push from the other side. These tombs were designed to prevent grave robbers, not to aid and abet them.',
  },
  local: {
    count: 116,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'The local butcher by the look of him.',
  },
  rains: {
    count: 10,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TLOTOXL',
    firstSaidQuote:
      'At that moment shall I present her to the people. A vision is with us and shall stand before them. And I, in supplication to the Rain God, shall offer human blood. The rains will come. No more talk against us that the gods were against us and brought drought to the land. The rains will come and power shall again be ours.',
  },
  groan: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'AUTLOC',
    firstSaidQuote:
      'For many days the Rain God has looked away from us, and the land withers and the people groan.',
  },
  draws: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'AUTLOC',
    firstSaidQuote:
      "When the sun's fire first touches the horizon to the west, the people will stand before the temple in obedience to our commands. We humbly beg, Great Spirit, that at that time the people shall see you and know that their suffering draws to an end.",
  },
  rival: {
    count: 18,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TLOTOXL',
    firstSaidQuote: 'Your rival to command.',
  },
  greet: {
    count: 23,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote: 'I greet you, Tlotoxl. What manner of warrior is this?',
  },
  skill: {
    count: 43,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote:
      'I had heard that Yetaxa again guides us in wisdom and in strength. Would the High Priest care for me to demonstrate my skill?',
  },
  dwell: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote: 'Here dwell only warriors chosen to command.',
  },
  dwelt: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote:
      'Then I tell you, Ian, six warriors dwelt here. Only I remain. There is no fear of you in me. Rather I welcome you. For one day all men shall fear Ixta, the Aztec commander who killed the chosen servant of Yetaxa.',
  },
  souls: {
    count: 42,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Poor old souls, they must be bored to tears doing nothing.',
  },
  bored: {
    count: 53,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Poor old souls, they must be bored to tears doing nothing.',
  },
  tears: {
    count: 34,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Poor old souls, they must be bored to tears doing nothing.',
  },
  topau: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CAMECA',
    firstSaidQuote: 'The words of Topau.',
  },
  altar: {
    count: 8,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I must escort the victim to the altar and hold him down. Doctor, I can't",
  },
  sakes: {
    count: 26,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "There's no buts about it. If human sacrifice is essential here and it's their tradition, then let them get on with it. But for our sakes, don't interfere. Now promise me, please. Promise. I'll go and tell Barbara.",
  },
  ascot: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Just the thing for the Royal Enclosure at Ascot.',
  },
  lands: {
    count: 37,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Don't you see? If I could start the destruction of everything that's evil here, then everything that is good would survive when Cortes lands.",
  },
  forth: {
    count: 25,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'AUTLOC',
    firstSaidQuote:
      'A vision has come to us, my people. The High Priest Yetaxa has returned that you may look once more upon the sign of the coiled serpent. Great Spirit of Yetaxa, stand forth that we may honour you.',
  },
  spilt: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'Stop. I, Yetaxa, command you. There shall be no more blood spilt.',
  },
  cried: {
    count: 8,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TLOTOXL',
    firstSaidQuote:
      'Then let the handmaiden be punished. She cried out and desecrated sacred ground. She transgressed the law.',
  },
  harsh: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I'm sorry, my dear. I didn't mean to be so harsh with you.",
  },
  rogue: {
    count: 47,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "You're an old rogue.",
  },
  covet: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'Does Tlotoxl covet the mantle of the High Priest of Knowledge?',
  },
  grace: {
    count: 129,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TLOTOXL',
    firstSaidQuote:
      'You grace us here with your presence. Ixta. Here is one who would be Commander of our armies. His name is Ixta.',
  },
  oftla: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'VICTIM',
    firstSaidQuote:
      'You drive the man. How often have you and Oftla instructed me that small failings in a man may be his saving graces.',
  },
  dread: {
    count: 18,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TLOTOXL',
    firstSaidQuote:
      'But you, O Perfect Victim, are, as your name implies. When you meet the gods, you will be able to tell them of the Aztecs. A commander should be as pure, so that his name may be held in very awe and dread.',
  },
  glory: {
    count: 72,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TLOTOXL',
    firstSaidQuote:
      'This I promise you. All honour and glory shall be yours if you destroy him.',
  },
  seeks: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CAMECA',
    firstSaidQuote:
      'But you can be of service to him. He seeks an interview with you.',
  },
  pupil: {
    count: 3,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'AUTLOC',
    firstSaidQuote:
      'Susan is a good pupil. She uses her intelligence. Susan, this is Tonila, one of the Priests of Knowledge.',
  },
  drawn: {
    count: 42,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote: 'He has drawn it.',
  },
  spear: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote:
      'Only my hands. My strength lies in the use of a spear or a club.',
  },
  older: {
    count: 67,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote: 'I thank the older servant of Yetaxa.',
  },
  scorn: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Does the High Priest scorn my attempts to be worthy of command?',
  },
  cease: {
    count: 89,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'AUTLOC',
    firstSaidQuote:
      'I shall not oppose the gods if it is their will that such sacrifices cease.',
  },
  thorn: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote: 'The thorn of a cactus will give me victory?',
  },
  drain: {
    count: 50,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, it won't kill. It'll slowly drain away the strength of your opponent. And scratch here.",
  },
  avert: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TLOTOXL',
    firstSaidQuote: 'To avert her own. I tell you she is a false goddess.',
  },
  timed: {
    count: 14,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'The contest is ill-timed. Ixta has trained for many months.',
  },
  loyal: {
    count: 43,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'I am loyal to those who serve me.',
  },
  claim: {
    count: 83,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'VICTIM',
    firstSaidQuote: 'The contest is ended. Ixta may not claim the victory.',
  },
  plant: {
    count: 87,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TLOTOXL',
    firstSaidQuote:
      'It is not magic. It is the juice from a plant. Tonila will know. Why did he aid you?',
  },
  mercy: {
    count: 124,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote: 'Tlotoxl, what of Ian? He was at my mercy.',
  },
  cocoa: {
    count: 9,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'AUTLOC',
    firstSaidQuote:
      'Then I am grateful to him. You carry cocoa beans. For barter?',
  },
  beans: {
    count: 19,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'AUTLOC',
    firstSaidQuote:
      'Then I am grateful to him. You carry cocoa beans. For barter?',
  },
  daily: {
    count: 23,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CAMECA',
    firstSaidQuote: 'We use these to barter for our daily needs.',
  },
  risks: {
    count: 34,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Why do you take such risks?',
  },
  views: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "You've got it all wrong, Barbara. All the people here share Tlotoxl's views.",
  },
  deeds: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TLOTOXL',
    firstSaidQuote:
      'We have both spoken hot words and thought black deeds, and I must be the one to find a common ground.',
  },
  bliss: {
    count: 16,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CAMECA',
    firstSaidQuote:
      'The happiest of my life, dear heart. Was ever such a potion brewed? In bliss is quenched my thirsty heart.',
  },
  sweet: {
    count: 125,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CAMECA',
    firstSaidQuote:
      'Oh, sweet-favoured man, you have declared your love for me, and I acknowledge and accept your gentle proposal.',
  },
  chose: {
    count: 72,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TONILA',
    firstSaidQuote: 'Not unless she chose the man.',
  },
  bride: {
    count: 25,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'VICTIM',
    firstSaidQuote:
      'But it is a great honour for me to be chosen. I shall take her as my bride.',
  },
  talks: {
    count: 40,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TLOTOXL',
    firstSaidQuote:
      'What is the punishment for one who talks out against our teachings?',
  },
  hills: {
    count: 23,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote:
      'There is a tunnel. My father built it. A water course from a lake in the hills. Would you see the garden flooded?',
  },
  fills: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote:
      "There's a small gate near the entrance by the lake. It is opened and closed often. I must replace the stone before the tunnel fills with water.",
  },
  angle: {
    count: 38,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, we can pull, but I think we'd better do it at an angle. What we really need is a pulley.",
  },
  safer: {
    count: 74,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "That's it, it's safer.",
  },
  hates: {
    count: 28,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'AUTLOC',
    firstSaidQuote:
      'Tlotoxl hates you, I know that, and Ixta does his bidding. And I am bewildered by the things that happen. I have many doubts, but in this matter I must believe you. As for the others, I do not know if you are Yetaxa. I do not know what you are.',
  },
  hangs: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'AUTLOC',
    firstSaidQuote:
      'The same cloud hangs over us. The sunlight of the truth is darkened and I must know the reason for that darkness.',
  },
  title: {
    count: 58,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'AUTLOC',
    firstSaidQuote:
      "See this ornament? It proves the title to my dwelling house and all my wealth. You will take it to the one who guards Yetaxa's handmaiden. It will serve to turn his head away while you take the girl up to the temple.",
  },
  steps: {
    count: 42,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IXTA',
    firstSaidQuote:
      'When we have reached the temple steps, bring them on. We shall have one more meeting, Ian.',
  },
  motor: {
    count: 38,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'That could be caused by an unsuppressed motor.',
  },
  henry: {
    count: 48,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, and that extraordinary quarrel I had with that English king, Henry the Eighth. You know, he threw a parson's nose at me.",
  },
  threw: {
    count: 44,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, and that extraordinary quarrel I had with that English king, Henry the Eighth. You know, he threw a parson's nose at me.",
  },
  tower: {
    count: 167,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Threw it back, of course. Take them to the Tower, he said. That's why I did it.",
  },
  carol: {
    count: 24,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MAITLAND',
    firstSaidQuote: "Carol. Place this against Carol's chest.",
  },
  chest: {
    count: 34,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MAITLAND',
    firstSaidQuote: "Carol. Place this against Carol's chest.",
  },
  abbey: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "Well, it's a clock. Near Westminster Abbey.",
  },
  ounce: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No. No, Barbara. I learned not to meddle in other people's affairs years ago. Now, now, now, don't be absurd. There's not an ounce of curiosity in me, my dear boy. Tell me, why are you in danger?",
  },
  boost: {
    count: 65,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Boost engines. Forward thrust and lock.',
  },
  fancy: {
    count: 121,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, well, I rather fancy that's settled that little bit of solution. You know, I think these Sensorites have found a way to take control of your minds.",
  },
  carte: {
    count: 5,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Iron rations a la carte.',
  },
  locks: {
    count: 39,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MAITLAND',
    firstSaidQuote: 'Electro-magnectics. We should be to the locks very soon.',
  },
  whine: {
    count: 5,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'You mean that high-pitched whine? Is that it?',
  },
  scans: {
    count: 16,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CAROL',
    firstSaidQuote: 'Interference now on all our scans.',
  },
  tense: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: "He's so tense, Barbara. Can't we help him?",
  },
  newly: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SENSORITE 2',
    firstSaidQuote:
      ' The human creatures who are newly arrived seem to possess more intelligence than the others.',
  },
  graph: {
    count: 5,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Would you like to look at that graph for a moment?',
  },
  lines: {
    count: 106,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "It's a spectrograph, Susan. You see these lines? They represent the emission wavelengths.",
  },
  usual: {
    count: 98,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MAITLAND',
    firstSaidQuote:
      "I studied it whenever I could, but it didn't look like anything that would cause much excitement. The Sensphere is just an ordinary planet with a slightly bigger land mass than usual, but that's all.",
  },
  alloy: {
    count: 17,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes. It's used as an alloy in steel. In fact this machine would be useless without it. Now let me see. Iron melts at one thousand five hundred and thirty nine degrees centigrade, and molybdenum melts at two thousand six hundred and twenty two degrees centigrade. So, you know, we've some idea. Yes, I see now just what John found. I wonder if he was excited. Yes, that planet must be full of it. Full of it! It's a veritable gold mine!",
  },
  steel: {
    count: 50,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes. It's used as an alloy in steel. In fact this machine would be useless without it. Now let me see. Iron melts at one thousand five hundred and thirty nine degrees centigrade, and molybdenum melts at two thousand six hundred and twenty two degrees centigrade. So, you know, we've some idea. Yes, I see now just what John found. I wonder if he was excited. Yes, that planet must be full of it. Full of it! It's a veritable gold mine!",
  },
  melts: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes. It's used as an alloy in steel. In fact this machine would be useless without it. Now let me see. Iron melts at one thousand five hundred and thirty nine degrees centigrade, and molybdenum melts at two thousand six hundred and twenty two degrees centigrade. So, you know, we've some idea. Yes, I see now just what John found. I wonder if he was excited. Yes, that planet must be full of it. Full of it! It's a veritable gold mine!",
  },
  drift: {
    count: 23,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MAITLAND',
    firstSaidQuote: 'What do you expect us to do? Drift around for ever?',
  },
  exact: {
    count: 105,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, it's all perfectly simple, Chesterton. You see, the Sensorites eyes are the exact opposite to that of a cat. The Sensorites eyes were completely dilated, that is, enormous, in light.",
  },
  sided: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Do you think I don't understand? Trust is a two-sided affair.",
  },
  petty: {
    count: 28,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Dictated to by petty thieves and my own grandchild!',
  },
  timid: {
    count: 5,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Oh, look, Grandfather. I understand the Sensorites. They're timid little people. Because their minds and mine can communicate sometimes, they trust me.",
  },
  anger: {
    count: 43,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, and it's a good thing you can't read the anger in mine. In all the years my granddaughter and I have been travelling, we have never had an argument. And now you have caused one.",
  },
  woken: {
    count: 25,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CAROL',
    firstSaidQuote: "John's just woken up.",
  },
  rules: {
    count: 134,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ADMINISTRATOR',
    firstSaidQuote:
      "I am the city's administrator. It is my duty to protect the one who rules. Can you say that these Earth creatures will not use force? I am only guarding the First Elder. One suspicious act and the disintegrator will destroy them.",
  },
  cures: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It must be explained to them. The disease, if that's what it is, isn't anybody's fault. Besides, there's cures and preventives.",
  },
  caste: {
    count: 5,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SENSORITE 2',
    firstSaidQuote:
      'You mentioned explaining to the people. You must not speak to them. You are forbidden to talk to the lower caste.',
  },
  fatal: {
    count: 27,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ADMINISTRATOR',
    firstSaidQuote: 'And that will prove fatal?',
  },
  fleet: {
    count: 162,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote:
      'That is correct. He thought of a fleet of spaceships to come here and mine the metal and transport it back to his own planet. We saw the pictures he formed in his mind, and we saw that it was the end of our way of life. We had no alternative but to imprison him and his friends in orbit round the Sensphere.',
  },
  orbit: {
    count: 173,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote:
      'That is correct. He thought of a fleet of spaceships to come here and mine the metal and transport it back to his own planet. We saw the pictures he formed in his mind, and we saw that it was the end of our way of life. We had no alternative but to imprison him and his friends in orbit round the Sensphere.',
  },
  grown: {
    count: 79,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ADMINISTRATOR',
    firstSaidQuote:
      'We are being bound hand and foot and given to these people from Earth. Our leaders are grown weak.',
  },
  stamp: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote:
      'I intended to. We need help with this calamity. The disease is invisible, and resists all our attempts to stamp it out. It hits all manner of people, irrespective of their tasks.',
  },
  tasks: {
    count: 20,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote:
      'I intended to. We need help with this calamity. The disease is invisible, and resists all our attempts to stamp it out. It hits all manner of people, irrespective of their tasks.',
  },
  paint: {
    count: 23,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote:
      'This is a terrible picture you paint. Do you mistrust them as much as all that?',
  },
  weigh: {
    count: 19,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote: 'I will think of your advice, and weigh up the matter.',
  },
  names: {
    count: 128,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ADMINISTRATOR',
    firstSaidQuote:
      'These are absurd names they all have. None of them wear any signs of authority or badges of position. How are we to distinguish them? What is wrong with the other one?',
  },
  backs: {
    count: 16,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CAROL',
    firstSaidQuote:
      "Yes, I'm sorry, but when your backs are turned, it's very difficult to see. I don't know what we'd all do if you changed your badges and sashes. We wouldn't be able to tell you apart.",
  },
  nurse: {
    count: 86,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'I know we have no alternative, but such outrageous behaviour! Oh, forget it, child. Now, I want you to stay here and act as nurse. Watch his pulse rate, will you, and let me know immediately',
  },
  rapid: {
    count: 17,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, well, I have to say, very comprehensive. Now, gentlemen, time is not on our side. I believe your people have been dying because there is atropine poison in the aqueduct water. Now, allow me. I've made a few notes here which might interest you. Now these are the symptoms. Atropine causes dilation of the blood vessels. Temperature rises and pulse rate becomes very rapid. A rash may appear. The mouth and throat both become extremely dry. Now what we have to do is this, gentlemen. Isolate the poison and then prescribe the remedy.",
  },
  lucid: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I don't know. He might be more lucid, you know, than one should imagine. Now I'm going off on an expedition, and I want you to take note of what he says.",
  },
  meets: {
    count: 14,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "How very convenient. Yes. Noise and darkness. The two things the Sensorites dislike. There's more in this than meets the eye.",
  },
  stuns: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote:
      'You have no conception of what extreme sound does to us. It stuns the brain and paralyses the nerves.',
  },
  smile: {
    count: 88,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ADMINISTRATOR',
    firstSaidQuote:
      'These Earth creatures are working to destroy the Sensorite nation. Their pleasant smile conceals sharp teeth, their soft words hide deadly threats.',
  },
  teeth: {
    count: 72,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ADMINISTRATOR',
    firstSaidQuote:
      'These Earth creatures are working to destroy the Sensorite nation. Their pleasant smile conceals sharp teeth, their soft words hide deadly threats.',
  },
  pride: {
    count: 31,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote:
      'I cannot. I selected him for office, but it is not pride which makes me defend my choice. I know that Sensorite. I trust him.',
  },
  civil: {
    count: 61,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "My dear sir. That's most civil of you. I ruined my jacket down in the aqueduct, but of course I have others on my ship. Thank you.",
  },
  acted: {
    count: 27,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote: 'You acted correctly. What can have possessed my advisor?',
  },
  range: {
    count: 199,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WARRIOR',
    firstSaidQuote:
      'The range is considerable. The ray paralyses up to a distance of thirty yards.',
  },
  handy: {
    count: 40,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, yes, splendid. And remember, dear boy, that I shall be standing nearly next to you. I've never liked weapons at any time. However, they're handy little things. Tell me, how long does this paralysis last?",
  },
  juicy: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CAROL',
    firstSaidQuote:
      "Oh, won't it be wonderful when we get back to the Earth, John? How I long for a thick, juicy steak.",
  },
  steak: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CAROL',
    firstSaidQuote:
      "Oh, won't it be wonderful when we get back to the Earth, John? How I long for a thick, juicy steak.",
  },
  wrote: {
    count: 36,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Look, whatever she wrote this with wasn't dry. I put my thumb on it and smudged it.",
  },
  armed: {
    count: 147,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote:
      'They were given light and a good map. Also they were well armed. They can be in no danger.',
  },
  naive: {
    count: 9,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ENGINEER',
    firstSaidQuote:
      'But surely you did not think you would be released? All human creatures are naive. They live while they have a purpose. As soon as that purpose is achieved, then their life has no value left.',
  },
  guide: {
    count: 59,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Yes, then we can guide them both out.',
  },
  tuned: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote:
      'Your mind must be finely tuned. The frequencies covering the surface of the Sensphere are numerous. You must be able to break in on the major ones.',
  },
  major: {
    count: 241,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: '1ST ELDER',
    firstSaidQuote:
      'Your mind must be finely tuned. The frequencies covering the surface of the Sensphere are numerous. You must be able to break in on the major ones.',
  },
  trove: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'COMMANDER',
    firstSaidQuote:
      'Oh, you know about that, do you? You do realise this war has been fought by me and my men here. Any treasure trove is ours.',
  },
  spies: {
    count: 77,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'COMMANDER',
    firstSaidQuote:
      "No, Number One, not allies. Spies. The war isn't over at all, is it. I thought it was a bit too good to be true.",
  },
  ultra: {
    count: 13,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "I had a talk with the senior Scientist just before we left. It seems that the Sensphere has an extraordinary number of ultra high frequencies, so I won't be able to go on using thought transference.",
  },
  minor: {
    count: 70,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Entirely different circumstances! I'm rather tired of your insinuations that I am not master of this craft. Oh, I admit, it did develop a fault, a minor fault on one occasion, perhaps twice, but nothing I couldn't control.",
  },
  twice: {
    count: 103,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Entirely different circumstances! I'm rather tired of your insinuations that I am not master of this craft. Oh, I admit, it did develop a fault, a minor fault on one occasion, perhaps twice, but nothing I couldn't control.",
  },
  amiss: {
    count: 9,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes. Yes, well perhaps, since you put it that way, an hour or two won't come amiss. Susan, bring my stick will you?",
  },
  manor: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'Well those crops suggest a manor or farmhouse. It should be reasonably close.',
  },
  towns: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'Well, towns and villages can be well-spaced, even in England.',
  },
  jumpy: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Perhaps it was a rabbit. Do you know, Chesterton's getting quite jumpy these days. Young man like him shouldn't suffer from nerves.",
  },
  paris: {
    count: 134,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'France? Well, how far from Paris?',
  },
  woods: {
    count: 44,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Pity. Probably knows these woods like the back of his hand.',
  },
  sizes: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "You know, there's a whole wardrobe here. Look, they're all different sizes too.",
  },
  stale: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Look at these bundles. Bottles of wine. Bread. A bit stale.',
  },
  bunch: {
    count: 63,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "There's another bundle over here. Hey, look at all these maps. There's a whole bunch of daggers down here.",
  },
  reign: {
    count: 31,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Yes. The Reign of Terror.',
  },
  hears: {
    count: 23,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "We might not get back to the ship if Grandfather hears we're in the Reign of Terror.",
  },
  sides: {
    count: 59,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'ROUVRAY',
    firstSaidQuote:
      "In France now there are only two sides. You're either with us or against us. Our sympathies are obvious. We want to know yours.",
  },
  march: {
    count: 45,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'LIEUTENANT',
    firstSaidQuote:
      "No. No, let's let them rest. They've had a long march. We'll cover the back.",
  },
  nerve: {
    count: 56,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'ROUVRAY',
    firstSaidQuote: 'No. The intention is to break our nerve.',
  },
  shoot: {
    count: 289,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'LIEUTENANT',
    firstSaidQuote:
      'Silence! If any of them speak again without permission, shoot them.',
  },
  cells: {
    count: 116,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JUDGE',
    firstSaidQuote:
      'You have no rights! You will be guillotined as soon as it can be arranged. Take them to the cells!',
  },
  patch: {
    count: 41,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Hey, there's a damp patch in the wall here. Hmm. Maybe a sewer leading to the river.",
  },
  sewer: {
    count: 12,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Hey, there's a damp patch in the wall here. Hmm. Maybe a sewer leading to the river.",
  },
  lever: {
    count: 38,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'Crowbars. May not be necessary to dig our way out after all. I might be able to lever up one of those stones with this.',
  },
  nears: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'WEBSTER',
    firstSaidQuote:
      'I was sent to bring him home to England. The day nears that his information is important. Find him if you can. Try to escape. Try. Promise to find James Stirling, and home. Promise! Promise!',
  },
  james: {
    count: 81,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'WEBSTER',
    firstSaidQuote:
      'I was sent to bring him home to England. The day nears that his information is important. Find him if you can. Try to escape. Try. Promise to find James Stirling, and home. Promise! Promise!',
  },
  jules: {
    count: 46,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'WEBSTER',
    firstSaidQuote: 'Jules Renan.',
  },
  renan: {
    count: 5,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'WEBSTER',
    firstSaidQuote: 'Jules Renan.',
  },
  chien: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'WEBSTER',
    firstSaidQuote: 'The sign of Le Chien Gris.',
  },
  undue: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, without any undue modesty, yes! Now, would you mind standing aside?',
  },
  taxes: {
    count: 17,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'OVERSEER',
    firstSaidQuote:
      "I see. You can't prove your identity. Have you paid your taxes? No? Then perhaps you'd join the poor wretches and put your energy to better use. Give him a pick.",
  },
  smelt: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "They must have smelt the food. Barbara, there's rats down there.",
  },
  tenth: {
    count: 21,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "It's the tenth time he's counted his wealth.",
  },
  spade: {
    count: 5,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Catch his spade! Stop!',
  },
  sacre: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'PEASANT',
    firstSaidQuote: 'Sacre bleu!',
  },
  batch: {
    count: 16,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JAILER',
    firstSaidQuote:
      "Was that your friend? He was lucky. LeMaitre crossed him off the list. You're not so fortunate. This batch for the guillotine! Take them away!",
  },
  stead: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JULES',
    firstSaidQuote:
      'You must try and cultivate patience, my friend. It will stand you in good stead.',
  },
  heavy: {
    count: 103,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'TAILOR',
    firstSaidQuote:
      'It is a heavy material, I grant you, and perhaps with a few alterations. You are offering the entire outfit?',
  },
  lists: {
    count: 6,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'LEMAITRE',
    firstSaidQuote:
      "You see, I'm taking the execution lists to the first deputy's palace and, by a coincidence if you like, your province is going to be discussed. It would be a great help if you were on hand to answer any difficult questions that crop up.",
  },
  purge: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'ROBESPIERRE',
    firstSaidQuote:
      'I am only interested in your comments on your own territory. Recent memoranda from your province suggest that the purge of our enemies in your region is progressing very slowly.',
  },
  fewer: {
    count: 7,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, you've reached that conclusion. Hmm. Well, perhaps we have fewer enemies in our region, and it maybe that Paris can take an example from us, hmm?",
  },
  heads: {
    count: 104,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Do they? Or is it just their wish to keep their heads, hmm?',
  },
  chill: {
    count: 10,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'LEON',
    firstSaidQuote: "It's probably just a chill.",
  },
  necks: {
    count: 18,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'LEON',
    firstSaidQuote:
      'Well, we could call a physician, but it would be dangerous. They report almost everything to the militia these days, if only to save their own necks.',
  },
  guest: {
    count: 79,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'LEMAITRE',
    firstSaidQuote: 'Arrange suitable accommodation for our Citizen guest.',
  },
  tonic: {
    count: 4,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Don't know. We're hoping to see a doctor tomorrow. Although when she hears you're back, that should be tonic enough.",
  },
  alias: {
    count: 2,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JULES',
    firstSaidQuote:
      'But if as you say Stirling is a spy, to do his job properly he must be able to move around freely. That would mean an alias, a completely new identity.',
  },
  slept: {
    count: 36,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'LEMAITRE',
    firstSaidQuote: 'Good morning, Citizen. I hope you slept well?',
  },
  decoy: {
    count: 11,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'LEMAITRE',
    firstSaidQuote: "What if he's just a decoy?",
  },
  books: {
    count: 111,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'You check your history books, Ian, before you decide what people deserve.',
  },
  fairy: {
    count: 31,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Do you know that's the biggest fairy story I've ever heard in my life.",
  },
  ideal: {
    count: 18,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JULES',
    firstSaidQuote:
      "Just a moment. There's an inn called the Sinking Ship on the Calais Road. It would be ideal for a secret meeting.",
  },
  event: {
    count: 95,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'NAPOLEON',
    firstSaidQuote:
      "I accept, dependent on Robespierre's downfall. In the event of failure, I shall of course deny this meeting ever took place.",
  },
  flood: {
    count: 33,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The events will happen, just as they are written. I'm afraid so and we can't stem the tide. But at least we can stop being carried away with the flood! Now, Susan and the prison.",
  },
  score: {
    count: 28,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JAILER',
    firstSaidQuote:
      'No, but I am glad you came. I still have a score to settle with you.',
  },
  adage: {
    count: 1,
    firstSaidSeasonIndex: 1,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, unlike the old adage, my boy, our destiny is in the stars, so let's go and search for it.",
  },
  burnt: {
    count: 77,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "I've burnt myself. It's hot!",
  },
  frame: {
    count: 34,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Like something too big for it's frame.",
  },
  strip: {
    count: 24,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'What do we do now, Doctor? Take the scanner out and strip it down?',
  },
  types: {
    count: 15,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'There are two different types of rock. Doctor, look. This is ordinary stone up here, but this down here seems to be quite different.',
  },
  stiff: {
    count: 25,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Yes. It's dead, all right. Stiff as a poker. What a fantastic size.",
  },
  poker: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Yes. It's dead, all right. Stiff as a poker. What a fantastic size.",
  },
  scale: {
    count: 96,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Well, what else? Look at the scale of things.',
  },
  noted: {
    count: 28,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FORRESTER',
    firstSaidQuote:
      "You do realise what's at stake here, Mister Farrow? The early experiments were noted by the Ministry, welcomed in fact. I've already geared factories, advertising and all the rest of it to start pushing DN6.",
  },
  vital: {
    count: 125,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FARROW',
    firstSaidQuote:
      "I don't think I'm making myself quite clear. There are many insects which make a vital contribution to agriculture, and these insects must not die. Did you know that?",
  },
  sting: {
    count: 20,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'It could still sting.',
  },
  aroma: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "It's the same distinctive aroma.",
  },
  pests: {
    count: 6,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "What would kill insects in a perfectly ordinary garden. I mean, pests one can understand, but surely it's wrong to bees and worms and things, isn't it?",
  },
  worms: {
    count: 12,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "What would kill insects in a perfectly ordinary garden. I mean, pests one can understand, but surely it's wrong to bees and worms and things, isn't it?",
  },
  swipe: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Don't relax. One swipe of its paw would smash us to pieces.",
  },
  smash: {
    count: 57,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Don't relax. One swipe of its paw would smash us to pieces.",
  },
  growl: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Imagine a record played at the wrong speed, Susan. We'd sound like a little squeak to them and they'd sound like a low growl to us.",
  },
  ankle: {
    count: 30,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "It's a ceiling up there. That means we're indoors and the Doctor and Susan are outside. How's your ankle?",
  },
  tubes: {
    count: 13,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Look at those enormous test tubes.',
  },
  wheat: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'What do you suppose it is? Corn? Wheat?',
  },
  seeds: {
    count: 20,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I mean, look at the way these seeds are coated. They're obviously samples. Yes, I think they must be inventing a new insecticide and they've sprayed these seeds with it.",
  },
  sixty: {
    count: 100,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FORRESTER',
    firstSaidQuote:
      "The tests are very satisfactory. I'm sending in the report. Yes, it is a bad line, isn't it. Well, I would say that DN6, as they call it, is about sixty percent improvement on normal insecticide. Yes, I know I'm not usually so enthusiastic, but this is really extraordinary. Crossing over to France tonight. And I'll send in the report. Will you send in the authorisation? Good. I'll tell Forrester. Yes. Goodbye.",
  },
  hilda: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BERT',
    firstSaidQuote: "Hilda, come and answer this thing. It's driving me mad.",
  },
  ropey: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Oh, a bit ropey. Could do with a glass of water.',
  },
  hallo: {
    count: 8,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HILDA',
    firstSaidQuote: 'Hallo? Mister Farrow?',
  },
  spray: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, no, no, I've had a good look at this. This is pressurised. It's a spray can. Our problem will be to get away far enough when it explodes.",
  },
  scrub: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Completely, my dear. Now, before I get up and see where we are, I suggest you all go and have a good scrub, hmm? Off you go.',
  },
  boast: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, I don't want to boast, but we might be somewhere in London, hmm?",
  },
  docks: {
    count: 8,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Are we down by the docks?',
  },
  shift: {
    count: 129,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: "We're going to need help to shift this.",
  },
  whisk: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, my dear boy, you can't just whisk up men and material out of the thin air now, can you, hmm?",
  },
  brute: {
    count: 24,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You know, my dear boy, I never fail to be impressed by your optimism. You can't move that by sheer brute force. You were right, you need a cutting flame.",
  },
  bathe: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'We shall be as quick as we can. And you bathe that ankle. What you need is a jolly good smacked bottom! Come on.',
  },
  snoop: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Let's take a snoop.",
  },
  musty: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "What a musty smell. This place hasn't been used in years.",
  },
  skull: {
    count: 46,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I don't know. Do you think it could be some sort of medical aid? You know, if he'd fractured his skull, something to knit the bones together?",
  },
  pause: {
    count: 10,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Except you. I think we'd better pause in this search and get back to the others. Come along.",
  },
  tyler: {
    count: 150,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DAVID',
    firstSaidQuote: 'Tyler?',
  },
  cooks: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DAVID',
    firstSaidQuote: 'Good, we need some cooks.',
  },
  pairs: {
    count: 8,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DORTMUN',
    firstSaidQuote: 'Two more pairs of hands. Good, we need',
  },
  david: {
    count: 51,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DORTMUN',
    firstSaidQuote: 'David, where are you going?',
  },
  jenny: {
    count: 84,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TYLER',
    firstSaidQuote:
      'Jenny, see if you can find them some food, will you, and look after her ankle.',
  },
  faded: {
    count: 14,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MAN 2',
    firstSaidQuote: 'No. The Africa group have faded out completely.',
  },
  model: {
    count: 41,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DAVID',
    firstSaidQuote: "Oh, you're a model of charm and patience, aren't you.",
  },
  charm: {
    count: 33,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DAVID',
    firstSaidQuote: "Oh, you're a model of charm and patience, aren't you.",
  },
  robos: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DAVID',
    firstSaidQuote:
      "I've seen the Robos when they break down. They go insane. They smash their heads against walls, they throw themselves off buildings or into the river.",
  },
  board: {
    count: 291,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JENNY',
    firstSaidQuote:
      "Oh, yes. They keep up their numbers of Robomen. They got my brother last year. That's another reason why they saucers at the heliport. That's where the Daleks take the prisoners and operate on them. Once they've got you on board a saucer, there isn't a hope.",
  },
  bombs: {
    count: 86,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, that explains your poster, dear boy. Germ bombs, hmm?',
  },
  wiped: {
    count: 83,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CRADDOCK',
    firstSaidQuote:
      'Yes. The Daleks were up in the sky just waiting for Earth to get weaker. Whole continents of people were wiped out. Asia, Africa, South America. They used to say the Earth had a smell of death about it.',
  },
  razed: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DAVID',
    firstSaidQuote:
      "Hmm. About six months after the meteorite fall, that's when the saucers landed. Cities were razed to the ground, others were simply occupied. Anyone who resisted was destroyed. Some people were captured and were turned into Robomen, the slaves of the Daleks. They caught other human beings and many of them were shipped to the vast mining areas. No one escapes. The Robomen see to that.",
  },
  bands: {
    count: 8,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK',
    firstSaidQuote: 'All radio waves bands are open.',
  },
  males: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BLACK',
    firstSaidQuote:
      'Rebel against us and the Daleks will destroy London completely. You will all die, the males, the females and descendants. Rebels of London, come out of your hiding places. The Daleks offer you life.',
  },
  baker: {
    count: 41,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TYLER',
    firstSaidQuote: "All right, Baker, we know we'll have to get closer.",
  },
  gamma: {
    count: 29,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'My dear boy, if they had to deal with a man of your talents, they need hardly fear, need they. Now do sit down and rest, please. Oh, dear, now where were we? Ah, yes, of course, yes, yes, yes. Now, X equals gamma, that means roughly two and a half percent, so that should give us a curve of around about eighty degrees. Oh by the way, did you take three dimensional graph geometry at your school, hmm?',
  },
  curve: {
    count: 14,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'My dear boy, if they had to deal with a man of your talents, they need hardly fear, need they. Now do sit down and rest, please. Oh, dear, now where were we? Ah, yes, of course, yes, yes, yes. Now, X equals gamma, that means roughly two and a half percent, so that should give us a curve of around about eighty degrees. Oh by the way, did you take three dimensional graph geometry at your school, hmm?',
  },
  repel: {
    count: 7,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'I see what you mean. Like poles repel, eh?',
  },
  exits: {
    count: 37,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote: 'All exits to the square are blocked.',
  },
  civic: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JENNY',
    firstSaidQuote:
      'Well, Dortmun may be right. People may start collecting at the Civic Transport Museum.',
  },
  coast: {
    count: 27,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BAKER',
    firstSaidQuote:
      "A large group won't stand a chance. I thought I'd try on my own. I'll make for the Cornish coast. It's deserted down there. Not much for the Daleks.",
  },
  flask: {
    count: 10,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DAVID',
    firstSaidQuote: "Look, Baker, here, take this hip flask. It's full.",
  },
  sugar: {
    count: 39,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "He is. He's a very brilliant one. There's no sugar, I'm afraid.",
  },
  chute: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'LARRY',
    firstSaidQuote:
      "The disposal chute. Once we get through the outer door, make for the nearest cover. It's our only chance.",
  },
  loads: {
    count: 44,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote:
      "Grandfather, I think we should stay a bit longer, don't you? Because David looked just now and there were loads of Daleks.",
  },
  prise: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DAVID',
    firstSaidQuote:
      "That will be it. I'll have to take a chance. I'm going to try and prise the front off this thing.",
  },
  upper: {
    count: 29,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "It's a pity all the motor cars are on the upper floors.",
  },
  larry: {
    count: 15,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I don't know how you're going to find your brother here, Larry.",
  },
  costs: {
    count: 32,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Survive at all costs.',
  },
  ditch: {
    count: 6,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Yes, they're sure to radio ahead. We may have to ditch this at any moment.",
  },
  alpha: {
    count: 106,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'This is saucer Alpha Major. Am forty five miles south of mining area.',
  },
  wells: {
    count: 14,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'LARRY',
    firstSaidQuote: "Wells told us. We've come here looking specially for you.",
  },
  kinds: {
    count: 18,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ASHTON',
    firstSaidQuote: "People tell all kinds of lies when they're starving.",
  },
  chaps: {
    count: 36,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ASHTON',
    firstSaidQuote:
      'I see you managed to bring their character references just in time. Well, chaps, I suppose we ought to have something to eat.',
  },
  roams: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WELLS',
    firstSaidQuote:
      'Yes, well, in a way. Mainly it roams the mine area at night in search of food.',
  },
  slave: {
    count: 96,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WOMAN',
    firstSaidQuote:
      "Oh, they know all right. Yes, they know, but we can't harm them. Besides, we make clothes for the slave workers. We're more use to them doing that than we would be in the mine.",
  },
  truck: {
    count: 24,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'LARRY',
    firstSaidQuote: "It's my kneecap. I caught it on the truck as I fell.",
  },
  shops: {
    count: 18,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WOMAN',
    firstSaidQuote:
      'Destroyed? Well I never. Oh, when I went it was beautiful. There was the moving pavements, and the shops, and the astronaut fair I went to and it was in the Chelsea heliport.',
  },
  idiot: {
    count: 186,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'David, you idiot. You idiot.',
  },
  moles: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, quite, quite. Instead, there they are, burrowing like moles down and through the crust of the Earth.',
  },
  crust: {
    count: 24,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, quite, quite. Instead, there they are, burrowing like moles down and through the crust of the Earth.',
  },
  units: {
    count: 158,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK',
    firstSaidQuote:
      'Attention all units. Stand by for an announcement by the Supreme Controller.',
  },
  pilot: {
    count: 156,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BLACK',
    firstSaidQuote:
      'Once the core is removed, we can replace it with a power system that will enable us to pilot the planet anywhere in the universe.',
  },
  hatch: {
    count: 102,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALEK',
    firstSaidQuote: 'Hatch over control to closed position. Motor running.',
  },
  aural: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BLACK',
    firstSaidQuote:
      'Alter the command frequencies to aural control to all Robomen. They are to herd humans down to the lower galleries.',
  },
  sever: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, I want you and Susan to walk around the lip of the crater and sever it. Use the bombs. Detonate with your revolver, right?',
  },
  fired: {
    count: 66,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BLACK',
    firstSaidQuote:
      'Good. We shall have one hour to leave when the device is fired. Am firing now.',
  },
  cliff: {
    count: 44,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'And we must all meet back on the cliff, we were before. Now hurry up, all of you.',
  },
  vicki: {
    count: 194,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BENNETT',
    firstSaidQuote:
      'Look, Vicki. I know how badly you want to get off this planet. We both want to get away but its no good building up our hopes. Go and radio the rescue ship. You’ll find your mistake… And Vicki, watch out for Koquillion.',
  },
  haven: {
    count: 21,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VICKI',
    firstSaidQuote: 'I haven’t seen him today.',
  },
  rocky: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Very dark. Can’t really make out anything at all. It looks very rocky, whatever it is.',
  },
  doesn: {
    count: 26,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh. It doesn’t necessarily mean anything my dear Barbara. We can, of course, always travel through…solid matter in flight… and all, again, we can, we can take off again quite easily. No, I do think we ought to step outside and have a look. I will too. Susan, er',
  },
  claws: {
    count: 17,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'With hands and feet like claws?',
  },
  grand: {
    count: 63,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      'They, they killed all the crew. We, when we landed, we made contact here. Everyone on board was invited to a grand sort of meeting. I couldn’t go, I was ill, a fever or something. I stayed here that night. I remember waking up. A thunderstorm, I thought, but it was an explosion. Bennett. Bennett dragged himself back. I was ill for days, I didn’t know about it til later. I came around and…found Bennett. He can’t walk. We just wait, and then Koquillion.',
  },
  fires: {
    count: 38,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      'Mmm? Oh, he’s the only one we see. They live quite near here, I believe but, well, I don’t know. This fires a flare.',
  },
  flare: {
    count: 39,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      'Mmm? Oh, he’s the only one we see. They live quite near here, I believe but, well, I don’t know. This fires a flare.',
  },
  green: {
    count: 142,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Yes. It’s got eyes. I saw them. Green. Used to daylight. Must have come in from the outside.',
  },
  razor: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Doctor, they’re razor sharp!',
  },
  sandy: {
    count: 8,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VICKI',
    firstSaidQuote: 'You killed Sandy. Why? What made you?',
  },
  mustn: {
    count: 6,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      "You mustn’t, Ian. I keep telling you why we did what he said. You'll spoil it, you’ll spoil everything.",
  },
  miser: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'The Doctor gone to see Miser Bennett?',
  },
  daddy: {
    count: 68,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      '2493, of course. My mother had just died and Daddy wanted to get away so he took a job on the planet Astra.',
  },
  astra: {
    count: 79,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      '2493, of course. My mother had just died and Daddy wanted to get away so he took a job on the planet Astra.',
  },
  weren: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'Oh, we weren’t entirely ignorant, young lady. Even the Doctor thought it was worth paying us a visit. That’s how we got mixed up with him in the first place.',
  },
  masks: {
    count: 16,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'This used to be the Peoples’ Hall of Judgement. Fitting, in the present circumstances don’t you think, hmm? Mister Bennett, may I remind you that masks and robes such as you are wearing are only used on absolutely ceremonial occasions, hmm?',
  },
  robes: {
    count: 15,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'This used to be the Peoples’ Hall of Judgement. Fitting, in the present circumstances don’t you think, hmm? Mister Bennett, may I remind you that masks and robes such as you are wearing are only used on absolutely ceremonial occasions, hmm?',
  },
  grape: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Well, have a grape.',
  },
  month: {
    count: 79,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      "Well, the way you spoke I thought we were going to have adventures and see things. We've been here nearly a month and all everyone wants to do is sit around and rest.",
  },
  roman: {
    count: 65,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Oh, Vicki. Look, the adventures come without us looking for them. And you're finding out what it was like to live in Roman times.",
  },
  style: {
    count: 44,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Oh, I see. Well, what sort of style would you like?',
  },
  villa: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SELLER',
    firstSaidQuote:
      "Yes. They moved into a villa just north of the town about a month ago. The owner, Flavius Guiscard is away campaigning in Gaul. We reckon they're friends of his looking after the house.",
  },
  owner: {
    count: 25,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SELLER',
    firstSaidQuote:
      "Yes. They moved into a villa just north of the town about a month ago. The owner, Flavius Guiscard is away campaigning in Gaul. We reckon they're friends of his looking after the house.",
  },
  sauce: {
    count: 6,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'With an orange and juniper sauce.',
  },
  larks: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Garnished with larks tongues and baked pomegranates',
  },
  baked: {
    count: 6,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Garnished with larks tongues and baked pomegranates',
  },
  honey: {
    count: 48,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: "Ant's eggs in hibiscus honey.",
  },
  arise: {
    count: 21,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DIDIUS',
    firstSaidQuote: 'Before any local enquiries arise, is that the idea?',
  },
  mores: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'O tempora, o mores.',
  },
  music: {
    count: 81,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CENTURION',
    firstSaidQuote:
      "Caesar Nero's court. The Emperor of all Rome is very concerned for your safe arrival. He looks forward to discussing your music with you.",
  },
  lyres: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'The Emperor. Nero, eh? Ha, ha, yes, of course, I have heard that he that he plucks a string or two. Yes, yes. Oh, the child, she travels with me. She keeps her eye on all the lyres.',
  },
  goods: {
    count: 19,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SEVCHERIA',
    firstSaidQuote: "Come on, let's inspect the goods.",
  },
  hired: {
    count: 13,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, I'm not surprised. It was he who obviously hired the man to kill me. Or rather to kill this fellow, Maximus what is it? Er.",
  },
  cough: {
    count: 6,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'WOMAN',
    firstSaidQuote:
      "Much better. It's just this cough. It was a long march. Thirty four days it took us. Thirty four days. You said your friend would meet you here.",
  },
  delos: {
    count: 14,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'Five days, Delos. Five whole days.',
  },
  sales: {
    count: 11,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SEVCHERIA',
    firstSaidQuote:
      "I'm sorry, Tavius. No private sales. She's to be sold by auction.",
  },
  arena: {
    count: 13,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SEVCHERIA',
    firstSaidQuote:
      "She wouldn't fetch any price at all at the auction. She's to be taken to the circus and thrown in the arena.",
  },
  falls: {
    count: 44,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, I don't see why not, my child. For a while, anyway. Then we must present our credentials so to speak, before night falls.",
  },
  fiery: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SEVCHERIA',
    firstSaidQuote:
      'Take note gentlemen, of the fiery spirit. Think about your bids the double it.',
  },
  apodi: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'The apodi-what?',
  },
  stool: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'NERO',
    firstSaidQuote: 'Oh. A stool.',
  },
  plays: {
    count: 15,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'NERO',
    firstSaidQuote:
      'No, I was referring to my problem. Naturally, I appreciate the feelings of my fellow artists. When Maximus Pettulion plays for the court of Rome, he must have the centre of the stage. He will receive the same rapt and hushed attention that I do when I put on a recital. Well, nearly the same rapt attention as when I play.',
  },
  staff: {
    count: 182,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TAVIUS',
    firstSaidQuote: 'I have a new attendant for your staff, Madame.',
  },
  lions: {
    count: 8,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'NERO',
    firstSaidQuote:
      "Cornered at last. Tigilinus, if you don't leave me alone, you will be sent to feed the lions. Now go away!",
  },
  teeny: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'NERO',
    firstSaidQuote:
      "Got you! Now, young woman, surely you wouldn't refuse me, Claudius Nero, a teeny weeny kiss?",
  },
  weeny: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'NERO',
    firstSaidQuote:
      "Got you! Now, young woman, surely you wouldn't refuse me, Claudius Nero, a teeny weeny kiss?",
  },
  bravo: {
    count: 22,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ALL',
    firstSaidQuote: ' Bravo!',
  },
  earns: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SEVCHERIA',
    firstSaidQuote:
      "He'll have you killed. This way at least, one of you has a chance. A good winner sometimes earns his freedom.",
  },
  posts: {
    count: 24,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SEVCHERIA',
    firstSaidQuote: 'Back to your posts.',
  },
  dives: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Perhaps, but I've got a friend who specialises in trouble. He dives in and usually finds a way. I think I'll take a leaf out of his book for once. Come on.",
  },
  crowd: {
    count: 21,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SEVCHERIA',
    firstSaidQuote:
      "Yes. They may have got in with the crowd. If they did, they won't get out.",
  },
  jokes: {
    count: 34,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Oh, very funny! Instead of sitting there making stupid jokes, why don't you get yourself cleaned up? As a matter of fact, you can start with this.",
  },
  crags: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Crags and pools. Oh, it’s like a cemetery, it’s so quiet.',
  },
  pools: {
    count: 11,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote: 'Crags and pools. Oh, it’s like a cemetery, it’s so quiet.',
  },
  pills: {
    count: 21,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'Now, wait a minute. You can’t blame my generation for everything and those pills belong to the Doctor.',
  },
  dance: {
    count: 94,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      'After all, it would save me having to put make-up on and a mask and dance round a fire in order to get rid of the evil spirits.',
  },
  pants: {
    count: 13,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote: 'I hope my pants stay up.',
  },
  coats: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, it’s these ADJ coats are no use. After about an hour, they’re useless.',
  },
  diver: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      'You can certainly tell the difference, can’t you. Breathe slowly. Deeply, like a diver. Oh, it it’s possible. Okay?',
  },
  zarbi: {
    count: 53,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VRESTIN',
    firstSaidQuote:
      'The Zarbi will treat them as enemies. If we refuse to help them, they will not survive.',
  },
  taron: {
    count: 31,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VRESTIN',
    firstSaidQuote:
      'They will. They can echo their signals to us off satellite Taron. Menop spearhead, acknowledge reception.',
  },
  menop: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VRESTIN',
    firstSaidQuote:
      'They will. They can echo their signals to us off satellite Taron. Menop spearhead, acknowledge reception.',
  },
  plane: {
    count: 105,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'We are alone. We have strayed from our astral plane.',
  },
  yield: {
    count: 10,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ANIMUS',
    firstSaidQuote: 'You demand my secrets? Yield yours.',
  },
  heron: {
    count: 13,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VRESTIN',
    firstSaidQuote:
      'Heron? Do you still intend to go to the Crater of Needles?',
  },
  wings: {
    count: 28,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VRESTIN',
    firstSaidQuote:
      'Many of my friends are enslaved there. They tear off our wings so that we may not escape.',
  },
  moons: {
    count: 20,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VRESTIN',
    firstSaidQuote:
      'At that time, these strange moons appeared. One of them became our home, those of us who could reach it.',
  },
  hetra: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'NEMINI',
    firstSaidQuote: 'Hetra.',
  },
  align: {
    count: 15,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, it flew out of his hand just as he was about to give it to me. A gold pen. Now, we have got to find something to re-align this power.',
  },
  slugs: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VRESTIN',
    firstSaidQuote:
      'Your Gods? The Menoptra are your kinsmen. Your wings withered on your bodies while you crawled blindly underground, like slugs. You were born to the greatest freedom of all creatures. To peace, beauty and light!',
  },
  woven: {
    count: 8,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PRAPILLUS',
    firstSaidQuote:
      'So the legends say. Sewn into the craters and plateaus of Vortis, been slowly un-woven by the silence of time and their entrances long forgotten by our species. But our Gods have not forgotten us, Barbara. This was indeed deliverance.',
  },
  hilio: {
    count: 7,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HILIO',
    firstSaidQuote: 'Spearhead Leader Hilio.',
  },
  zombo: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VICKI',
    firstSaidQuote: 'You know, Doctor, I’m getting quite fond of Zombo.',
  },
  sucks: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HETRA',
    firstSaidQuote: 'Poidarac sucks goodness from our world.',
  },
  pluck: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ANIMUS',
    firstSaidQuote:
      'What I take from you will enable me to reach beyond this galaxy, into the solar system, to pluck from Earth its myriad techniques and take from man his mastery of space.',
  },
  aimed: {
    count: 16,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HILIO',
    firstSaidQuote:
      'Remember, the Destructor must be aimed at the dark side of the Animus.',
  },
  kings: {
    count: 19,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PRAPILLUS',
    firstSaidQuote:
      'Their deeds shall be sung in the Temples of Light. Pictos shall remind us of a time as it circles Vortis. Every time it points to the Needle of the Kings, as it does now, then we shall weave songs to praise the gods of light and thank them that they sent the Earth people to save us from the Animus. Now the Zarbi larvae feed the soil, the flower forest shall grow again across Vortis. But we must not allow the forest to conceal another lurking Animus. Welcome the main force.',
  },
  weave: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PRAPILLUS',
    firstSaidQuote:
      'Their deeds shall be sung in the Temples of Light. Pictos shall remind us of a time as it circles Vortis. Every time it points to the Needle of the Kings, as it does now, then we shall weave songs to praise the gods of light and thank them that they sent the Earth people to save us from the Animus. Now the Zarbi larvae feed the soil, the flower forest shall grow again across Vortis. But we must not allow the forest to conceal another lurking Animus. Welcome the main force.',
  },
  songs: {
    count: 21,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PRAPILLUS',
    firstSaidQuote:
      'Their deeds shall be sung in the Temples of Light. Pictos shall remind us of a time as it circles Vortis. Every time it points to the Needle of the Kings, as it does now, then we shall weave songs to praise the gods of light and thank them that they sent the Earth people to save us from the Animus. Now the Zarbi larvae feed the soil, the flower forest shall grow again across Vortis. But we must not allow the forest to conceal another lurking Animus. Welcome the main force.',
  },
  delta: {
    count: 82,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VRESTIN',
    firstSaidQuote:
      'The dark power is dead. Fly in Menoptra to the delta of lights. We are waiting.',
  },
  marun: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      "Now there's a subject for our troubadours and actors. Speak to the Chamberlain about it, I beg you, de Marun.",
  },
  weary: {
    count: 19,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      "Well, it'll help us to pass these weary waiting nights at Jaffa. Here's a man devoted to his work.",
  },
  jaffa: {
    count: 14,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      "Well, it'll help us to pass these weary waiting nights at Jaffa. Here's a man devoted to his work.",
  },
  etabe: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DE TORNEBU',
    firstSaidQuote:
      "I have put the brothers de L'Etabe with the horses, sire, and all is ready for the return to Jaffa. If your Majesty desires to go.",
  },
  malek: {
    count: 8,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DES PREAUX',
    firstSaidQuote: 'Saracens, I am the king! I am Malek Ric!',
  },
  obeys: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'EL AKIR',
    firstSaidQuote:
      'A king at liberty may give commands. A captured one obeys them. Take him! Find the others and kill them.',
  },
  coeur: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'That Saracen very nearly did for me. Of course. Did you hear what that man called him? Saracen. Malek Ric! Yes, that was the name the Saracens had for King Richard, Coeur de Lion. Malek Ric.',
  },
  sadly: {
    count: 17,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DES PREAUX',
    firstSaidQuote: 'We were sadly outnumbered and taken by surprise.',
  },
  yusef: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'EL AKIR',
    firstSaidQuote:
      'Yusef Salah ed-Din has commanded that all prisoners be treated with compassion. Would you say I have complied with his wishes?',
  },
  salah: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'EL AKIR',
    firstSaidQuote:
      'Yusef Salah ed-Din has commanded that all prisoners be treated with compassion. Would you say I have complied with his wishes?',
  },
  egypt: {
    count: 14,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DES PREAUX',
    firstSaidQuote:
      'The Sultan of Egypt and Syria would no doubt be pleased. But this lady, my sister',
  },
  syria: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DES PREAUX',
    firstSaidQuote:
      'The Sultan of Egypt and Syria would no doubt be pleased. But this lady, my sister',
  },
  bodes: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'EL AKIR',
    firstSaidQuote:
      "We shall call her a prisoner, then. Does that sound better? You have no rights, no privileges, nothing except the benevolence of our leader. That you are the King's sister bodes well for me. I can serve both the Sultan and Malek el Adil.",
  },
  basra: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DAHEER',
    firstSaidQuote:
      'Silks. Satins. Fine robes. Rich silks. Satins from Basra. Fine robes. Silks. Satins. The finest robes in Jaffa! Silks. Satins. Fine robes. Rich silks. Fine satins. The finest robes in Jaffa.',
  },
  genoa: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DAHEER',
    firstSaidQuote: 'Genoa, then?',
  },
  shorn: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THATCHER',
    firstSaidQuote:
      "Here, that's not enough. It was dangerous work getting them things. If I was caught, do you know what would happen? Do you know the King's punishment for thieves? I'd be shorn like a prizefighter and boiling pitch poured on me head. And as for you.",
  },
  pitch: {
    count: 21,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THATCHER',
    firstSaidQuote:
      "Here, that's not enough. It was dangerous work getting them things. If I was caught, do you know what would happen? Do you know the King's punishment for thieves? I'd be shorn like a prizefighter and boiling pitch poured on me head. And as for you.",
  },
  beset: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DAHEER',
    firstSaidQuote:
      "No, my beautiful clothes! Oh, they're ruined, all covered in mud. My silks and satins. My embroidery from India. Oh, I am beset by devils! Oh!",
  },
  loser: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, yes, you are, but I'm afraid I must leave you with your misfortune. But I shall return. Yes, I will return and you shall not be the loser by this business.",
  },
  rowdy: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SAPHADIN',
    firstSaidQuote:
      'Less then less! Who is this creature? This rowdy jackal that yaps at my feet with tales of fortune and success?',
  },
  tales: {
    count: 25,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SAPHADIN',
    firstSaidQuote:
      'Less then less! Who is this creature? This rowdy jackal that yaps at my feet with tales of fortune and success?',
  },
  coals: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'EL AKIR',
    firstSaidQuote:
      'Great Sultan, this woman can be made to entertain you. I can have her dance on hot coals, run a gauntlet of sharp tipped swords.',
  },
  roust: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      "Once again, I am in your debt. But I'd give this for de Marun and the others. My friends cut down about my ears or stolen. My armies roust about the streets and clutter up the streets of Jaffa with the garbage of their vices. And now I learn my brother John thirsts after power, drinking great draughts of it though it's not his to take. He's planning to usurp my crown, and trade with my enemy, Philip of France. Trade! A tragedy of fortunes and I am too much beset by them. A curse on this! A thousand curses!",
  },
  vices: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      "Once again, I am in your debt. But I'd give this for de Marun and the others. My friends cut down about my ears or stolen. My armies roust about the streets and clutter up the streets of Jaffa with the garbage of their vices. And now I learn my brother John thirsts after power, drinking great draughts of it though it's not his to take. He's planning to usurp my crown, and trade with my enemy, Philip of France. Trade! A tragedy of fortunes and I am too much beset by them. A curse on this! A thousand curses!",
  },
  usurp: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      "Once again, I am in your debt. But I'd give this for de Marun and the others. My friends cut down about my ears or stolen. My armies roust about the streets and clutter up the streets of Jaffa with the garbage of their vices. And now I learn my brother John thirsts after power, drinking great draughts of it though it's not his to take. He's planning to usurp my crown, and trade with my enemy, Philip of France. Trade! A tragedy of fortunes and I am too much beset by them. A curse on this! A thousand curses!",
  },
  crown: {
    count: 38,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      "Once again, I am in your debt. But I'd give this for de Marun and the others. My friends cut down about my ears or stolen. My armies roust about the streets and clutter up the streets of Jaffa with the garbage of their vices. And now I learn my brother John thirsts after power, drinking great draughts of it though it's not his to take. He's planning to usurp my crown, and trade with my enemy, Philip of France. Trade! A tragedy of fortunes and I am too much beset by them. A curse on this! A thousand curses!",
  },
  curse: {
    count: 61,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      "Once again, I am in your debt. But I'd give this for de Marun and the others. My friends cut down about my ears or stolen. My armies roust about the streets and clutter up the streets of Jaffa with the garbage of their vices. And now I learn my brother John thirsts after power, drinking great draughts of it though it's not his to take. He's planning to usurp my crown, and trade with my enemy, Philip of France. Trade! A tragedy of fortunes and I am too much beset by them. A curse on this! A thousand curses!",
  },
  moods: {
    count: 7,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'VICKI',
    firstSaidQuote: "No, he doesn't seem in the best of moods, does he?",
  },
  troop: {
    count: 12,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DE TORNEBU',
    firstSaidQuote:
      "Look on the brighter side, my lord. A troop of men to capture one of your knights? Why, he'd need an army by itself and more to take your horse, or every man he has or more to take you prisoner.",
  },
  jewel: {
    count: 17,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      'Good friends. And what is this? I have not seen this jewel before.',
  },
  lydda: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LUIGI',
    firstSaidQuote: 'Do you return to your palace at Lydda?',
  },
  heels: {
    count: 10,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LUIGI',
    firstSaidQuote:
      'Conrad of Tyre has sent an emissary here to make a treaty with your overlord. I come on his heels. Where there is a treaty there is a chance of profit. What lies unwanted on my ships at Tyre will find a home in Saladin. And from him I can buy and stock my ships again.',
  },
  romeo: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Escape? But how? A never-ending story. What am I going to do? Stories. Stories. Shakespeare! Yes, Romeo and Juliet. Hans Christian Andersen. Lilliput. Gulliver's Travels.",
  },
  luigi: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LUIGI',
    firstSaidQuote:
      'I am Luigi Ferrigo, merchant from Genoa. I have got a horse for you at the stables.',
  },
  saint: {
    count: 54,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      'In the name of God, Saint Michael, and Saint George, we dub you Sir Ian, Knight of Jaffa. Arise Sir Ian, and be valiant.',
  },
  ivory: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LUIGI',
    firstSaidQuote:
      'Perfumes, materials from Baghdad, ivory, gold, spices. All these, Prince Saphadin, are now but a trickle because of this war.',
  },
  flown: {
    count: 24,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SAPHADIN',
    firstSaidQuote:
      'Yes, your reputation has flown ahead of you. Where there are transactions to be made, there will one find Master Ferrigo.',
  },
  glove: {
    count: 12,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SHEYRAH',
    firstSaidQuote: 'On the table I found a glove.',
  },
  giver: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DAHEER',
    firstSaidQuote:
      'Joy to you, my lord! Giver of life to my father, provider!',
  },
  islam: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'GUARD 2',
    firstSaidQuote: 'I swear it to be the finest collection in Islam.',
  },
  harem: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DES PREAUX',
    firstSaidQuote:
      "El Akir has an evil reputation. It's my belief he captured your companion as revenge, and in his eyes she would make a fine addition to his harem.",
  },
  multi: {
    count: 20,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DAHEER',
    firstSaidQuote:
      'Marvellous indeed, my lord. The birds will envy you and the multi-coloured fish from the deeps are put to shame.',
  },
  deeps: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DAHEER',
    firstSaidQuote:
      'Marvellous indeed, my lord. The birds will envy you and the multi-coloured fish from the deeps are put to shame.',
  },
  belts: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DAHEER',
    firstSaidQuote:
      'Like yours, my lord? Then I can provide all the quality you need. Jewelled tunics with fur collars, ruby-studded belts, quilted sleeves, laced leather boots.',
  },
  laced: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DAHEER',
    firstSaidQuote:
      'Like yours, my lord? Then I can provide all the quality you need. Jewelled tunics with fur collars, ruby-studded belts, quilted sleeves, laced leather boots.',
  },
  purse: {
    count: 7,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'The household purse, hmm?',
  },
  allah: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SAFIYA',
    firstSaidQuote:
      "No. It is a strange mystery. They've gone away and we must simply wait for their return. It is the will of Allah. You will eat? My father's knife!",
  },
  arsuf: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LEICESTER',
    firstSaidQuote:
      'Tell me your plan, sire. A new demand of Saladin? A battle plan? A victory like Arsuf?',
  },
  horde: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LEICESTER',
    firstSaidQuote:
      "I speak as a soldier. Why are we here in this foreign land if not to fight? The Devil's horde, Saracen and Turk, posses Jerusalem and we will not wrest it from them with honeyed words.",
  },
  wrest: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LEICESTER',
    firstSaidQuote:
      "I speak as a soldier. Why are we here in this foreign land if not to fight? The Devil's horde, Saracen and Turk, posses Jerusalem and we will not wrest it from them with honeyed words.",
  },
  union: {
    count: 31,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SALADIN',
    firstSaidQuote:
      "Have England, France and all the rest come here to cheer a man and woman and a love match? No, this is a last appeal for peace from a weary man. So you write your letter and I'll alert the armies. Then on either day, the day of blissful union or the day of awful battle, we will be prepared.",
  },
  cared: {
    count: 15,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SALADIN',
    firstSaidQuote:
      'Sir William I cannot return. Not yet. But write that he is well cared for. As for the other, Sir Ian, he begged to be allowed to search for the lady Barbara. The brave deserve their favours. Go, brother, write your letter. This sincerity deserves our honest dealings. But caution, yes, caution insists that my armies are ready.',
  },
  flour: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JOANNA',
    firstSaidQuote:
      'This unconsulted partner has no wish to marry. I am no sack of flour to be given in exchange.',
  },
  spent: {
    count: 98,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'EL AKIR',
    firstSaidQuote:
      'Such a prize as you is worth rewarding these men for your recapture, would you not agree? I have spent time and trouble on you. Now you cost me gold as well.',
  },
  coins: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'EL AKIR',
    firstSaidQuote:
      'You are not here to like or dislike me. Such liberties are over for you. Look at these coins. Mere pieces of metal. No interest? You should have. These coins are going to change your laughter into tears, your joy to misery.',
  },
  drunk: {
    count: 24,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MAIMUNA',
    firstSaidQuote: 'What do you want in here? Are you both drunk? Or mad?',
  },
  hafsa: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MAIMUNA',
    firstSaidQuote:
      'Hafsa, run to the doors and let your ears warn us. We will hide you here. We all hate him.',
  },
  ropes: {
    count: 10,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IAN',
    firstSaidQuote: "I won't tell you anything until you undo these ropes.",
  },
  dates: {
    count: 18,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IBRAHIM',
    firstSaidQuote:
      'I am cursed with the affliction of disbelief, but I have another little scheme. A little pot of honey, made from pounded dates and very, very sweet. There, my lord, a little bit on your wrists and a little bit on your chest. Now, over there is a hungry home, full of ants that go wild for date honey. We must be generous to them. Lay a little trail across the sand, like this. And I will sit in the shade of the trees and dream of all the treasures I will get when the ants discover you. If you crane your neck around, my lord, you will soon see what you take to be a black line along the honey. Why, you will be able to see it getting closer and closer. My little ones! Such ecstasy!',
  },
  shade: {
    count: 13,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IBRAHIM',
    firstSaidQuote:
      'I am cursed with the affliction of disbelief, but I have another little scheme. A little pot of honey, made from pounded dates and very, very sweet. There, my lord, a little bit on your wrists and a little bit on your chest. Now, over there is a hungry home, full of ants that go wild for date honey. We must be generous to them. Lay a little trail across the sand, like this. And I will sit in the shade of the trees and dream of all the treasures I will get when the ants discover you. If you crane your neck around, my lord, you will soon see what you take to be a black line along the honey. Why, you will be able to see it getting closer and closer. My little ones! Such ecstasy!',
  },
  crane: {
    count: 26,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'IBRAHIM',
    firstSaidQuote:
      'I am cursed with the affliction of disbelief, but I have another little scheme. A little pot of honey, made from pounded dates and very, very sweet. There, my lord, a little bit on your wrists and a little bit on your chest. Now, over there is a hungry home, full of ants that go wild for date honey. We must be generous to them. Lay a little trail across the sand, like this. And I will sit in the shade of the trees and dream of all the treasures I will get when the ants discover you. If you crane your neck around, my lord, you will soon see what you take to be a black line along the honey. Why, you will be able to see it getting closer and closer. My little ones! Such ecstasy!',
  },
  knave: {
    count: 6,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LEICESTER',
    firstSaidQuote:
      'I have the right to civility from you. What are you, knave or commoner? Or are you perhaps a traitor?',
  },
  visor: {
    count: 6,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LEICESTER',
    firstSaidQuote:
      "Sire, I will. I'll turn them from a rabble into victors once again, and we shall set a noise of sharpening and polishing til the ground fare trembles with sound of axe and sword against the whetstone, and the sun shall find a glittering home in every visor.",
  },
  hardy: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      'We accept the impeachment. We are unjust to you to serve the greater good. You see, my Lord of Leicester is a hardy fighter, and a fight is near us now. When we meet the Saracen again, we shall need him at our elbow. But do not be discouraged. You have our favour.',
  },
  elbow: {
    count: 8,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RICHARD',
    firstSaidQuote:
      'We accept the impeachment. We are unjust to you to serve the greater good. You see, my Lord of Leicester is a hardy fighter, and a fight is near us now. When we meet the Saracen again, we shall need him at our elbow. But do not be discouraged. You have our favour.',
  },
  swore: {
    count: 18,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MAIMUNA',
    firstSaidQuote:
      'My tears are tears of joy. All this time I believed that my father and sister were dead. El Akir had swore that they were.',
  },
  witch: {
    count: 84,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LEICESTER',
    firstSaidQuote:
      "Take men and follow them discreetly. The old man tried to poison the King's mind. He may be in the pay of the infidel Saladin. He may be worse. Some devil in a human form, the girl a witch.",
  },
  haste: {
    count: 17,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HAROUN',
    firstSaidQuote: 'Quickly! Make haste. We must not stay here.',
  },
  liars: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LEICESTER',
    firstSaidQuote:
      "We will not speak of this. Let this story die here in this wood or we'll be branded idiots, or liars. Poor Sir Ian, brave fellow. Spirited away by fiends. What dreadful anguish and despair he must be suffering now.",
  },
  hence: {
    count: 24,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'No, I think there’s probably something in the atmosphere that, er, has a very slow destructive property, er, hence the lack of windows.',
  },
  cases: {
    count: 41,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      'And all the rooms are exactly the same, just cases and cabinets. I’m beginning to think the Doctor’s wrong.',
  },
  mists: {
    count: 12,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, I’m afraid it’s going to be a little more difficult than that. The mists are beginning to clear slightly. I’m just beginning to see reason. Where are we? Where are we?',
  },
  xeron: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LOBOS',
    firstSaidQuote:
      'Like everything on this planet, including us. Well, I’ve got two more mimmians before I can go home. Yes, I say it often enough, but it’s still two thousand Xeron days and it sounds more in days. Yeah, I know, I volunteered, you were ordered. If the truth were known, I was just as bored on Morok. Still it was home, and youth never appreciates what it has. Oh, I don’t know what I’m going to do now. Still, let’s get on with it, shall we? I have to sign these reports. I don’t know.',
  },
  morok: {
    count: 8,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LOBOS',
    firstSaidQuote:
      'Like everything on this planet, including us. Well, I’ve got two more mimmians before I can go home. Yes, I say it often enough, but it’s still two thousand Xeron days and it sounds more in days. Yeah, I know, I volunteered, you were ordered. If the truth were known, I was just as bored on Morok. Still it was home, and youth never appreciates what it has. Oh, I don’t know what I’m going to do now. Still, let’s get on with it, shall we? I have to sign these reports. I don’t know.',
  },
  xeros: {
    count: 13,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LOBOS',
    firstSaidQuote:
      'Alien? Well, this will indeed be a red letter day for the Xeros calendar. Have the crew been detained?',
  },
  lobos: {
    count: 26,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'TOR',
    firstSaidQuote:
      'No, I don’t think they will. They’ve had time to do that and they haven’t. Lobos is organising a search.',
  },
  sieve: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Your memory is like a sieve, dear boy. We turned right and then left.',
  },
  image: {
    count: 104,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LOBOS',
    firstSaidQuote:
      'A simple matter of thought selection. By asking a question, I plant an image in your mind. No matter what you say, as long as you’re seated in that chair, I will see your mental pictures reflected. You see, it is quite useless for you to lie to me. Now shall we return to the questioning? How did you get here?',
  },
  needn: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      'Well if it gets there, we needn’t bother. We won’t have changed what’s going to happen in the future.',
  },
  entry: {
    count: 84,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'COMMANDER',
    firstSaidQuote: 'We could not gain entry, sir.',
  },
  dodge: {
    count: 6,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'TOR',
    firstSaidQuote: 'Well, they need time to dodge the guards.',
  },
  beams: {
    count: 22,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VICKI',
    firstSaidQuote: 'These must be the light beams.',
  },
  tally: {
    count: 14,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'TOR',
    firstSaidQuote:
      'Withdrawal requisition numbers are fed in from headquarters. It has to tally with the number given. There’s no chance, Vicki.',
  },
  tolma: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'TOR',
    firstSaidQuote:
      'Oh good! Get as many as you can carry and give them to Sham for distribution. I’ll give mine to the Tolma Corrin and bring them back here for more.',
  },
  quote: {
    count: 12,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Very well then, I shall quote you Ven Der Haff's law. Mass is absorbed by light, therefore light has mass and energy.",
  },
  equal: {
    count: 32,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      'The energy radiated by a light neutron is equal to the energy of the mass it absorbed.',
  },
  gonna: {
    count: 110,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BEATLES',
    firstSaidQuote:
      "I think I'm gonna be sad, I think it's today, yeah! The girl that's driving me mad, Is going away.",
  },
  hedge: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      'Near where I lived there was a field, and in this field there was a ring, just like that, sticking out of the ground. You see, the point was, on the other side of the hedge, there was a castle, an enormous thing, with a drawbridge.',
  },
  dried: {
    count: 16,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'RYNIAN',
    firstSaidQuote:
      ' Then, then the seas dried up and all the creatures that lived within their waters perished.',
  },
  slime: {
    count: 17,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MALSAN',
    firstSaidQuote:
      'They lived in the slime, at the bottom of the ocean. When the waters were gone they invaded our cities.',
  },
  qualm: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'A momentary qualm, a momentary qualm. Nothing more, nothing more.',
  },
  guava: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'VICKI',
    firstSaidQuote: 'Guava.',
  },
  elude: {
    count: 3,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Ah, I'm afraid it's no good. I'm quite unable to elude them.",
  },
  rotor: {
    count: 8,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'VICKI',
    firstSaidQuote: "Doctor, the time rotor. Doctor, it's slowing down.",
  },
  wanna: {
    count: 30,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'GUIDE',
    firstSaidQuote:
      "Here on top of the Empire State Building, you're on the hundredth and second storey above the ground level. At a height of one thousand four hundred and seventy three feet. This is the tallest building, the tallest structure in the entire world. Now you'll note, when you come up in the elevator, it took you seven minutes. Well, this way down, you wanna get down in a hurry, it would take you thirty seconds.",
  },
  folks: {
    count: 33,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MORTON',
    firstSaidQuote:
      "Oh now, come on, wait a minute. I just bet you folks are from Hollywood. You're making some kind of motion picture. Now that's it, ain't it?",
  },
  sheds: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MORTON',
    firstSaidQuote:
      "Sure, I've seen this trick before. Great long police cars comin' outa tiny little wooden sheds. I saw you come outa there with ma own eyes! You just ain't gonna make it back it again.",
  },
  movie: {
    count: 16,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MORTON',
    firstSaidQuote:
      'Sure thing, Mister! I understand. Just wait til I tell the folks back home I met some real live movie pe Do you know Cheyenne Bodie? Look, just wait a minute, I want to get this thing on celluloid.',
  },
  bodie: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MORTON',
    firstSaidQuote:
      'Sure thing, Mister! I understand. Just wait til I tell the folks back home I met some real live movie pe Do you know Cheyenne Bodie? Look, just wait a minute, I want to get this thing on celluloid.',
  },
  howdy: {
    count: 7,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MORTON',
    firstSaidQuote:
      "Howdy, Mister! Say, you sure are an ugly looking friend. Wait, what's the name of this film, Mister? My, my, boy, you've come all over in blue spots. What's this thing here?",
  },
  spots: {
    count: 14,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MORTON',
    firstSaidQuote:
      "Howdy, Mister! Say, you sure are an ugly looking friend. Wait, what's the name of this film, Mister? My, my, boy, you've come all over in blue spots. What's this thing here?",
  },
  kinda: {
    count: 53,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MORTON',
    firstSaidQuote:
      "They just left. They was in some kind of beat-up old blue wooden box. It just kinda like vanished. Say, I thought they'd have been chasing you. Just hold it there, Mister. I want to get a picture of this.",
  },
  gotta: {
    count: 25,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MORTON',
    firstSaidQuote:
      "Well, dang me if they ain't gone and done it again. This is the greatest thing. It's gotta be around here somewhere. Just can't vanish into thin air. I know you're there somewhere, boy.",
  },
  santa: {
    count: 30,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BRIGGS',
    firstSaidQuote:
      " Aye, that'll be the island of Santa Maria. One of the Azores group. We're making poor time, Mister Richardson. And now it becalmed, after the storm.",
  },
  maria: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BRIGGS',
    firstSaidQuote:
      " Aye, that'll be the island of Santa Maria. One of the Azores group. We're making poor time, Mister Richardson. And now it becalmed, after the storm.",
  },
  sarah: {
    count: 459,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BRIGGS',
    firstSaidQuote:
      "I'm going below if you should want me. Sarah says our child has sickness.",
  },
  bosun: {
    count: 7,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BRIGGS',
    firstSaidQuote: "Mister Bosun! Pipe all hands amidships. We've a stowaway.",
  },
  youse: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BOSUN',
    firstSaidQuote:
      'Aye, aye, sir. The rest of youse men search the hold. Keep your hands off the cargo.',
  },
  cargo: {
    count: 88,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BOSUN',
    firstSaidQuote:
      'Aye, aye, sir. The rest of youse men search the hold. Keep your hands off the cargo.',
  },
  dared: {
    count: 13,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I altered the curve we were travelling on. For one moment, I dared hoped we'd lost them. They must have detected the change and followed. They're close on our track.",
  },
  stout: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "I don't know. Ideal place to fight Daleks, you know. Good stout walls, an upper storey, stairs. Daleks don't like stairs.",
  },
  tolls: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "And therefore never send to know, for whom the bell tolls. It tolls for thee. Vicki, I feel as though my hair's turned white.",
  },
  phago: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Oh, there's one thing about this place, Doctor. It certainly stimulates the phagocytes. The phago? You know, it's uncanny, strange and weird, but it is familiar.",
  },
  crude: {
    count: 44,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, necessarily crude, dear boy. I haven't time to perfect anything.",
  },
  photo: {
    count: 14,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'DALEK 3',
    firstSaidQuote:
      'All is in readiness. Photo images and relevant data are in the computer. The humanoid will be completed by the time we arrive at our destination.',
  },
  robot: {
    count: 226,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote: 'Is the humanoid robot complete?',
  },
  vocal: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'DALEK 4',
    firstSaidQuote:
      'Micro-units containing personality and vocal mannerisms are charged.',
  },
  forms: {
    count: 88,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote:
      'This is the planet Mechanus. All forms of life are to be treated as hostile.',
  },
  scare: {
    count: 53,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BARBARA',
    firstSaidQuote:
      "Ah, it's designed to scare off those fungoid things we saw in the swamp.",
  },
  tough: {
    count: 57,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'IAN',
    firstSaidQuote: "It's tough.",
  },
  input: {
    count: 21,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MECHONOID',
    firstSaidQuote: 'Eight hundred thirty Mechonoid. English input. Enter.',
  },
  perch: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'IAN',
    firstSaidQuote: "Ha, looks like a monkey's perch.",
  },
  sites: {
    count: 15,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      'Look, about fifty years ago Earth decided to colonise this planet. Well, it landed a rocket full of robots programmed to clear landing sites, get everything ready for the first immigrants.',
  },
  pulls: {
    count: 6,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'IAN',
    firstSaidQuote:
      "Well, there's a junction box over here. A few good pulls, this'd come away. Come on, let's get the others.",
  },
  fused: {
    count: 25,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'IAN',
    firstSaidQuote: "I think we've fused it.",
  },
  fares: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'CONDUCTOR',
    firstSaidQuote: 'Fares please.',
  },
  panda: {
    count: 7,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'That is the dematerialising control and that, over yonder, is the horizontal hold. Up there is the scanner, those are the doors, that is a chair with a panda on it. Sheer poetry, dear boy. Now please stop bothering me.',
  },
  brush: {
    count: 9,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I've checked up on all the readings. Now I think our guest will need a wash and brush up. So I think the best thing for you to do is go and find him some clothes and a cloak. Bring mine as well. We'll show him whether this is a time machine or not.",
  },
  hitch: {
    count: 7,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, yes, yes, but unfortunately, we have a slight technical hitch at the moment. Excuse me.',
  },
  winds: {
    count: 23,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'EDITH',
    firstSaidQuote:
      "No, it's not far from here. It's just at the top of the hill. And when the winds in the right direction, you can hear the monks much clearer, as though they're down in the village.",
  },
  balmy: {
    count: 2,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Now, if Harold is king, and Edward was laid to rest at the beginning of the year, then it must be 1066! Yes. Judging by the appearance of these leaves, late summer. And a balmy night, a balmy night.',
  },
  saxon: {
    count: 65,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "I've felt better. I dare say I'll get over it. It's pretty authentic Saxon, isn't it?",
  },
  edith: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'WULNOTH',
    firstSaidQuote:
      'You can go. Edith, take the girl inside and get some food for their journey.',
  },
  ragra: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'VIKING',
    firstSaidQuote:
      'Send Ragra and the others up. Then we can rejoin the fleet.',
  },
  siege: {
    count: 20,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      "Listen, they always have them in castles and monasteries and things in case of siege, or fire, or something. Well, don't just sit there. Help me look.",
  },
  trans: {
    count: 4,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'WULNOTH',
    firstSaidQuote: 'Blood trans fu sion?',
  },
  vinci: {
    count: 14,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      'A logbook. A sort of diary. Listen. Met Leonardo Da Vinci.',
  },
  swoop: {
    count: 1,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE MONK',
    firstSaidQuote: 'The whole course of history changed in one single swoop.',
  },
  hints: {
    count: 5,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE MONK',
    firstSaidQuote:
      "Well, for instance, Harold, King Harold, I know he'd be a good king. There wouldn't be all those wars in Europe, those claims over France went on for years and years. With peace the people'd be able to better themselves. With a few hints and tips from me they'd be able to have jet airliners by 1320! Shakespeare'd be able to put Hamlet on television.",
  },
  knots: {
    count: 10,
    firstSaidSeasonIndex: 2,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "I can't find a sharp enough stone anywhere. Those Vikings sure know how to tie knots.",
  },
  bolts: {
    count: 16,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'LOWERY',
    firstSaidQuote:
      "Oh, it's slow. Flare-back melted the retaining bolts. Just solid lumps of tarnium. Ah, some of it's free.",
  },
  lumps: {
    count: 14,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'LOWERY',
    firstSaidQuote:
      "Oh, it's slow. Flare-back melted the retaining bolts. Just solid lumps of tarnium. Ah, some of it's free.",
  },
  lousy: {
    count: 7,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'LOWERY',
    firstSaidQuote:
      "I'm doing the best I can. I didn't want to touch down on this lousy planet in the first place, remember?",
  },
  varga: {
    count: 22,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'CORY',
    firstSaidQuote: 'A Varga thorn.',
  },
  prick: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'CORY',
    firstSaidQuote:
      "Careful, don't prick yourself with it or you'll end up the way Garvey is. I'd have to kill you.",
  },
  ninth: {
    count: 38,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'CORY',
    firstSaidQuote:
      "That's right. Well, they haven't been active in our galaxy for some time now, but that doesn't mean they've exactly been sitting around. In the last five hundred years, they've gained control of over seventy planets in Ninth Galactic System and forty more in the Constellation of Miros.",
  },
  miros: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'CORY',
    firstSaidQuote:
      "That's right. Well, they haven't been active in our galaxy for some time now, but that doesn't mean they've exactly been sitting around. In the last five hundred years, they've gained control of over seventy planets in Ninth Galactic System and forty more in the Constellation of Miros.",
  },
  hunch: {
    count: 12,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'CORY',
    firstSaidQuote:
      "It could be. This is the most hostile planet in the universe. People from other civilisations avoid it. I suddenly had a hunch that this might make an ideal place for any secret preparations that the Daleks wanted to make. That's why we brought this ship down here.",
  },
  seeps: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'CORY',
    firstSaidQuote:
      'Because of this. A thorn from a Varga plant. A thing part animal, part vegetable. Looks like a cactus. The poison attacks the brain. Rational thought is replaced by an overwhelming desire to kill. Eventually the poison seeps through the system and the victim is gradually transformed into a Varga.',
  },
  relay: {
    count: 43,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'CORY',
    firstSaidQuote:
      'If our galaxy is to be saved, whoever receives this message must relay this information to Earth immediately. It is vital that defence mechanisms are put into operation at once! Message ends.',
  },
  roses: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      "Oh look, there's those flowers that I could smell. Hey, they're roses. No, they're not. Not quite roses, but almost.",
  },
  maaga: {
    count: 36,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DRAHVIN 2',
    firstSaidQuote: 'Maaga will tell you.',
  },
  rills: {
    count: 32,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DRAHVIN 1',
    firstSaidQuote:
      'If you stay here, more machines will come. They will capture you and take you to the Rills.',
  },
  dawns: {
    count: 19,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MAAGA',
    firstSaidQuote: 'In fourteen dawns time.',
  },
  tempt: {
    count: 11,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MAAGA',
    firstSaidQuote:
      'They were trying to tempt us on board their spaceship so that they may kill us.',
  },
  gross: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MAAGA',
    firstSaidQuote:
      'To lose the mesh was gross incompetence. It was our only weapon against the machines. If we lose to the Rills it will be because of you. You want that, do you?',
  },
  slimy: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MAAGA',
    firstSaidQuote:
      'You want to be captured by those creeping, revolting, green monsters? You want their slimy claws to close about your necks?',
  },
  wires: {
    count: 24,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'STEVEN',
    firstSaidQuote: "Doctor, I think it's holding a couple of wires. Look out!",
  },
  trash: {
    count: 7,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well of course they didn't. My ship's not made of tin like this old trash. Oh, good gracious me! Seems if I cough too loudly, the whole thing'd fall to pieces.",
  },
  limbs: {
    count: 11,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'I think I can drag my aged limbs in some sort of semblance of a run. Go on.',
  },
  drill: {
    count: 104,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'VICKI',
    firstSaidQuote: 'It looks like a drill rig.',
  },
  cored: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'First I will need some metal-cored cable.',
  },
  creep: {
    count: 16,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MAAGA',
    firstSaidQuote:
      "It is now dim light. Soon it will be night. The last night this planet will ever know. We must capture the Rill spaceship before then. When I give the order, you will steal silently through the forward hatch. You will then creep round behind the Rills' machine. Understood?",
  },
  snags: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "Well, it's all fixed up here, Doctor. Any snags at the Tardis?",
  },
  hades: {
    count: 13,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HECTOR',
    firstSaidQuote:
      'A boy? Well he died like a dog, whimpering after his master Achilles! How! Let me send you to him where he waits in Hades. Let me throw the dog a bone or two!',
  },
  beard: {
    count: 13,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HECTOR',
    firstSaidQuote:
      'You pretend that old Father Zeus will descend to Earth and take Troy for you. I guarantee to trim his beard for him if he dare attempt it!',
  },
  guise: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ACHILLES',
    firstSaidQuote:
      'To Europa, you appeared as a bull. To Leda, as a swan. To me, in the guise of an old beggar.',
  },
  raced: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ODYSSEUS',
    firstSaidQuote:
      'And raced him round the walls till down he fell exhausted. A famous victory.',
  },
  cower: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ODYSSEUS',
    firstSaidQuote:
      'What? You will to the Grecian camp. If indeed you be Zeus, we have need of your assistance. Now, do not cower there, lads. Zeus is on our side, so Agamemnon keeps insisting. Bear him up, and let us carry him in triumph to the camp.',
  },
  crave: {
    count: 6,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ODYSSEUS',
    firstSaidQuote:
      'You shall have honour enough, and maybe we shall have a little of the truth. Father Zeus, we await you. We crave the pleasure of your company at supper, and perhaps a tale or two of Aphrodite?',
  },
  helen: {
    count: 22,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'AGAMEMNON',
    firstSaidQuote:
      "You won't get any older if you talk to me like that, brother or no brother. What's the matter with you, man? Don't you want to get Helen back? Don't you don't you want to see your wife again?",
  },
  priam: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MENELAUS',
    firstSaidQuote:
      "It isn't enough for you that you control the Achaean League, is it? Now you want to take over Asia Minor as well, only King Priam of Troy stands in your way.",
  },
  dares: {
    count: 14,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ODYSSEUS',
    firstSaidQuote:
      "Who dares command Odysseus? Well, Agamemnon, is it you? Well, we will not quarrel when we have a guest of such importance. Here's this old man, claims to be our father Zeus.",
  },
  stain: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Do not mock me, my Lord Odysseus. Would you stain the tent of Agamemnon's with a Trojan's blood? I claim this man as a sacrifice to Olympus! Bring him to my temple in the plain, at sunrise in the morning, and I will show you a miracle.",
  },
  fling: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ODYSSEUS',
    firstSaidQuote:
      'Yes, fling a thunderbolt or some such to rise to the occasion.',
  },
  wager: {
    count: 15,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'PRIAM',
    firstSaidQuote:
      'Hmm, captured, you say? I wager they were glad to see the back of it. What is it?',
  },
  belly: {
    count: 7,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CASSANDRA',
    firstSaidQuote:
      'Thank you. I dreamed that out on the plain the Greeks had left a gift, and although what it was remained unclear, we brought it into Troy. Then at night, from out its belly, soldiers came and fell upon us as we slept.',
  },
  sized: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'PARIS',
    firstSaidQuote:
      "Yes, well I hardly think we need trouble to interpret that one. Oh really, Cassandra, have you looked at this thing, as you call it? I mean, just how many soldiers do you think you can get inside that? A whole regiment, perhaps? I mean, you'd be very lucky to get even two medium-sized soldiers out of that thing.",
  },
  unbar: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CASSANDRA',
    firstSaidQuote:
      "Fool! One soldier could unbar the gate and so admit an army. It's exactly the sort of scheme Odysseus would think of.",
  },
  blaze: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'PRIAM',
    firstSaidQuote: 'That should make quite a blaze.',
  },
  pagan: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CASSANDRA',
    firstSaidQuote:
      "How do you so? You're no Trojan goddess. Are you some puny pagan goddess of the Greeks?",
  },
  exams: {
    count: 7,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VICKI',
    firstSaidQuote:
      'Not that I know of. I mean, I never took any exams or anything.',
  },
  greek: {
    count: 41,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'PRIAM',
    firstSaidQuote:
      "I wish to question her. Come here, child. That's better. Now, are you a Greek?",
  },
  homer: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, my dear boy, I couldn't possibly suggest that. The whole story is obviously absurd. Probably invented by Homer as some good dramatic device. No, I think it would be completely impractical.",
  },
  mania: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'PARIS',
    firstSaidQuote:
      "All right then, get back to your temple before you give us all galloping religious mania. Oh, really, father. I can't tolerate another of her tedious tirades at the moment.",
  },
  ranks: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      'We fought. I lost. I am not ashamed. There is none in all our ranks who could stand against the wrath of Paris when he seeks revenge.',
  },
  annoy: {
    count: 11,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ODYSSEUS',
    firstSaidQuote:
      'Looks like a parchment dart to me. My boy makes these to annoy his tutors.',
  },
  arrow: {
    count: 38,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Never mind that. It shrinks. Now, allow me to demonstrate. You place the flying machine thus, as you would an arrow in a bow, and let it go.',
  },
  spell: {
    count: 27,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VICKI',
    firstSaidQuote: 'And you thought I might put a spell on you?',
  },
  scrap: {
    count: 35,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TROILUS',
    firstSaidQuote:
      "He won't starve. The guards will throw him a scrap or two later on.",
  },
  fried: {
    count: 17,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ODYSSEUS',
    firstSaidQuote:
      "Be happy that's all you have to worry about. Of all the undignified ways of entering a city this takes the fried phoenix.",
  },
  booty: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ODYSSEUS',
    firstSaidQuote:
      'No, die. Just a hope. One less finger in the pie. A greater share of the booty for me.',
  },
  cheap: {
    count: 54,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You had no right to bring me here at all. I'm utterly useless to you. You must let me out of here. You're selfish, greedy, corrupt, cheap, horrible. Your one thought is for yourself and what you can get out of it.",
  },
  couch: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You're sure it's just the shoulder? Right. Well, steady, steady. Hold tight. Hold on. Yes, careful. Just a minute. Careful, careful, Vicki. Oh, dear, dear. This business. There we are. Now, come on bring him in. Bring him in there. Gently and carefully. That's it. That's it. Put him on the couch.",
  },
  limbo: {
    count: 9,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KATARINA',
    firstSaidQuote: 'What help is there in limbo?',
  },
  games: {
    count: 142,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROALD',
    firstSaidQuote:
      "So it's checkmate, isn't it? I want to see the Venus-Mars games. You want to see your hero, Mavic Chen.",
  },
  mavic: {
    count: 48,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROALD',
    firstSaidQuote:
      "So it's checkmate, isn't it? I want to see the Venus-Mars games. You want to see your hero, Mavic Chen.",
  },
  agent: {
    count: 69,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROALD',
    firstSaidQuote:
      "Yes, the agent who disappeared near the planet Kembel. Probably crashed, so they think. Hey, bring up the sound! It's Mavic Chen on holiday.",
  },
  terra: {
    count: 16,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROALD',
    firstSaidQuote:
      "Well, become a galactic politician and who knows? Maybe one day you will. As far as I'm concerned, give me terra firma any day.",
  },
  firma: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROALD',
    firstSaidQuote:
      "Well, become a galactic politician and who knows? Maybe one day you will. As far as I'm concerned, give me terra firma any day.",
  },
  brash: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROALD',
    firstSaidQuote:
      "It's a trifle brash, isn't it? There are other space vessels, you know.",
  },
  cynic: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'LIZAN',
    firstSaidQuote: 'Cynic.',
  },
  phony: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'KURT',
    firstSaidQuote:
      "This is no time for phony heroics. I'll just slow you down, and then we'll both get it. Now without me you've got a chance. It's not a good one, but it's a chance. Just stay alive and get that message through.",
  },
  brawn: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "So, you'd use physical violence, would you? You don't know what you've let yourself in for. So you've left the key in the door! Well, well, that's the first big mistake, isn't it? Yes, very foolish. Very foolish indeed, young man. Well now, it's brain, or brawn rather, versus brain? I've got you beaten from the start, young man!",
  },
  fisar: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CHEN',
    firstSaidQuote:
      "Traitor? An archaic word for so advanced a man as yourself. Considering that the planet Fisar and the Embodiment Gris have both, at different times, tried to depose you, do you still maintain that you're the mouthpiece for your own galaxy?",
  },
  cares: {
    count: 30,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRET',
    firstSaidQuote: 'Who cares about history?',
  },
  beaus: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ZEPHON',
    firstSaidQuote:
      'The Daleks needed me. Without my help, they would never have got the co-operation of the masters of Celation and Beaus. We are on equal terms.',
  },
  quest: {
    count: 48,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ZEPHON',
    firstSaidQuote:
      'The quest for power. Perhaps you wanted to use the core for yourself!',
  },
  unity: {
    count: 11,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BLACK',
    firstSaidQuote: 'You threaten our unity.',
  },
  penal: {
    count: 7,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRET',
    firstSaidQuote: 'Desperus is the penal planet of the Solar System.',
  },
  garge: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BORS',
    firstSaidQuote:
      "And you can build up the fire. Kirksen, like the knife, would you? Then you'd be leader. You could tell Garge what to do, like I do. You can tell me what to do!",
  },
  lizan: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CHEN',
    firstSaidQuote:
      "You've done well. I want all Space Security agents called back to Earth. If the traitors are not caught at the landing zone, then Central City must be cordoned off until they are found. And Lizan! They will be killed on sight. Give out the instructions.",
  },
  begun: {
    count: 42,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'KARLTON',
    firstSaidQuote:
      "They won't. I've already insisted that all future operations shall be cleared with me before they're begun.",
  },
  oddly: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SARA',
    firstSaidQuote:
      'Three. Bret Vyon and two strangers. They look as though they could come from Earth but are oddly dressed. None of them can leave the plant.',
  },
  doers: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'You brainless idiot! How many times have I told you about taking lives? We have other ways and means of dealing with evil doers.',
  },
  risen: {
    count: 10,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'RHYNMAL',
    firstSaidQuote: 'Pressure count seems have risen again.',
  },
  ratio: {
    count: 11,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "It's a pity I blacked out. I mean, if I knew the ratio readings, we could use the same force again to protect us from the Daleks.",
  },
  bloke: {
    count: 95,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CONSTABLE 1',
    firstSaidQuote: "There's a bloke in there.",
  },
  holly: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, Christmas. Oh, is it? Of course. Yes, yes, yes, yes. That accounts for the holly in the hall.',
  },
  welsh: {
    count: 12,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'INSPECTOR',
    firstSaidQuote: 'Are you Welsh, then?',
  },
  ferry: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'INSPECTOR',
    firstSaidQuote: "No, no, of course it's not. It's the new Brighton ferry.",
  },
  boxes: {
    count: 39,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'INSPECTOR',
    firstSaidQuote:
      "Well didn't you check? There might be a whole army of them in there, living like gypsies in one of Her Majesty's police telephone boxes.",
  },
  queer: {
    count: 13,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SERGEANT',
    firstSaidQuote:
      'Aye. You seem to know all the queer people. Well, who is she?',
  },
  camel: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SHEIK',
    firstSaidQuote:
      'And then I will come to you on my camel, and sweep you away across the desert.',
  },
  sweep: {
    count: 25,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SHEIK',
    firstSaidQuote:
      'And then I will come to you on my camel, and sweep you away across the desert.',
  },
  harry: {
    count: 227,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ASSISTANT',
    firstSaidQuote: 'OK, Harry. Cut that at 23',
  },
  knopf: {
    count: 6,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'INGMAR',
    firstSaidQuote: 'Knopf. Ingmar Knopf.',
  },
  suave: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GREEN',
    firstSaidQuote:
      "You should have seen him! He was great! Bigger than Fairbanks! I've got to find a name for him! Something suave!",
  },
  actor: {
    count: 7,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SHEIK',
    firstSaidQuote: "Kenerve. You can't talk to me like that. I am an actor!",
  },
  arabs: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Now, come along. We must go back to the Tardis. This is a madhouse. It's all full of Arabs. Come along.",
  },
  dolly: {
    count: 10,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CAMERAMAN',
    firstSaidQuote:
      "Now we start in close, see? And then we'll dolly back down along there.",
  },
  paste: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CLOWN',
    firstSaidQuote:
      "They They won't even let me do the wallpaper and paste routine. You know why?",
  },
  toast: {
    count: 22,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Here's a toast. A Happy Christmas to all of us.",
  },
  hasty: {
    count: 15,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, a hasty conclusion, but possibly right. Although I don't understand how they could have tested that taranium so quickly.",
  },
  greed: {
    count: 24,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BLACK',
    firstSaidQuote:
      'Yes. Their greed for power is so great that they can be trusted. Activate the machine.',
  },
  scott: {
    count: 30,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'TREVOR',
    firstSaidQuote:
      'Well, the English batsmen are really fighting against the clock now, Scott.',
  },
  tigus: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE MONK',
    firstSaidQuote:
      "And all carried out as well. Oh, ho. Doctor, you remember you left me in 1066? Now I've marooned you on the planet Tigus. Look! Oh, it's funny this. Forgive me laughing, Doctor, but I don't seem to be able to control it. Well, goodbye, Doctor. Perhaps I'll come back one day and rescue you.",
  },
  reset: {
    count: 34,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Reset the lock mechanism. He probably used some kind of ray.',
  },
  guile: {
    count: 9,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CHEN',
    firstSaidQuote:
      'I welcome it. Guile and cunning will succeed where force would fail.',
  },
  speck: {
    count: 9,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CHEN',
    firstSaidQuote:
      'Three time machines in one infinitesimal speck of space and time. Of course, a coincidence is possible, but hardly likely. You would agree?',
  },
  prior: {
    count: 14,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE MONK',
    firstSaidQuote:
      "Yes, that's right. The enemy. I have an old score to settle with him, but I'm sure yours is the prior claim.",
  },
  audio: {
    count: 29,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'DALEK 1',
    firstSaidQuote: 'The voice audio has been adjusted.',
  },
  folly: {
    count: 18,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CELATION',
    firstSaidQuote:
      'There has been too much time wasted through the folly of the representative from Earth. Surely, it is only right that on his return he be removed from this council.',
  },
  forgo: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CHEN',
    firstSaidQuote:
      'Take care, Kingdom. I could easily forgo the pleasure of giving you to the Daleks. I could kill you myself.',
  },
  clamp: {
    count: 17,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Turn about. You two, behind it. Steven, take my stick and clamp it down on his gun. Forward!',
  },
  henri: {
    count: 12,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GASTON',
    firstSaidQuote: 'Then drink to Henri of Navarre, our Protestant prince.',
  },
  wines: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GASTON',
    firstSaidQuote:
      'Have you got no decent wine? Where are the Burgundies? Or even the German wines?',
  },
  simon: {
    count: 11,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GASTON',
    firstSaidQuote:
      'Simon Dubar, what a surprise. No doubt you visit this tavern because the air is clearer of rigid Catholic dogma?',
  },
  dubar: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GASTON',
    firstSaidQuote:
      'Simon Dubar, what a surprise. No doubt you visit this tavern because the air is clearer of rigid Catholic dogma?',
  },
  dogma: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GASTON',
    firstSaidQuote:
      'Simon Dubar, what a surprise. No doubt you visit this tavern because the air is clearer of rigid Catholic dogma?',
  },
  mixer: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PRESLIN',
    firstSaidQuote: 'He was merely a mixer of herbs and unguents.',
  },
  herbs: {
    count: 7,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PRESLIN',
    firstSaidQuote: 'He was merely a mixer of herbs and unguents.',
  },
  germs: {
    count: 13,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes. In science, news travels. Yes. And there's a man in Germany at the moment, who's working on optics, trying to make a machine which will enable Preslin to see these small creatures. He calls them germs.",
  },
  wench: {
    count: 11,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GASTON',
    firstSaidQuote:
      "My Lord Cardinal's guard aren't you? What does he want with a wench?",
  },
  abbot: {
    count: 98,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CAPTAIN',
    firstSaidQuote:
      'She is chosen for the staff of the house of the Abbot of Amboise.',
  },
  louis: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GASTON',
    firstSaidQuote: 'Louis, call back the guards.',
  },
  vassy: {
    count: 13,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ANNE',
    firstSaidQuote:
      'Well, you see, I come from Vassy. And when they said it might happen again.',
  },
  leran: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DUVALL',
    firstSaidQuote:
      'Fool! To allow the meddlesome Viscount de Leran to stop you!',
  },
  laran: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DUVALL',
    firstSaidQuote: 'The Viscount de Laran and Nicholas Muss?',
  },
  roger: {
    count: 57,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GASTON',
    firstSaidQuote:
      "Roger Colbert. Recently appointed temporal secretary to the Abbot of Amboise during his stay in Paris. I'll wager he's come to fetch the girl.",
  },
  dutch: {
    count: 13,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DE COLIGNY',
    firstSaidQuote: 'Interested in the Dutch at last, Marshall Tavannes?',
  },
  spain: {
    count: 13,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DE COLIGNY',
    firstSaidQuote:
      'I hope you are looking into the plight of the unfortunate Dutch. The sea beggars as you call them. My fight with Spain is a just one.',
  },
  unify: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DE COLIGNY',
    firstSaidQuote:
      'If we ally ourselves to the Dutch in their conflict with Spain, the common cause will unify the country, and prevent further civil strife.',
  },
  loire: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TOLIGNY',
    firstSaidQuote:
      'But is it not so that under the treaty signed at Loire, the English will come to our assistance?',
  },
  italy: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TAVANNES',
    firstSaidQuote:
      'She has yet to come out into the open and say so. However, if Your Majesty is so eager to fight this war, perhaps we could raise the money by leasing the Alpine hunting grounds to Italy?',
  },
  wield: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DE COLIGNY',
    firstSaidQuote:
      'Kings are recognised only by the power they wield. The Queen Mother seems to claim this power. Take care, Your Majesty, that it does not prove detrimental to yourself, and to France.',
  },
  grasp: {
    count: 29,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CATHERINE',
    firstSaidQuote:
      'We have a Protestant prince in Paris, Henri of Navarre. You think they give a fig for your protection, now that one of their own is within grasp of the throne?',
  },
  evade: {
    count: 9,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TAVANNES',
    firstSaidQuote:
      "He must be found tonight. Tomorrow is Saint Bartholomew's Day and it'll be all too easy for him to evade us in the revelry.",
  },
  rouse: {
    count: 6,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TAVANNES',
    firstSaidQuote:
      'The good people? Madame, if you rouse the mob the innocent will perish with the guilty.',
  },
  pious: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TAVANNES',
    firstSaidQuote:
      'Protestant Europe will merely shed a pious tear over the death of a few thousand Huguenots. The death of a prince will launch a Holy War.',
  },
  bison: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'DODO',
    firstSaidQuote:
      "Yes, it is. I bet if you go down that path there, you'll come to the American Bison and the Tea Bar.",
  },
  zebra: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's terrible, child. Oh, it's most irritating. Well, look at that now. Isn't that extraordinary? Ah, very interesting. It looks like a zebra with two heads.",
  },
  joint: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COMMANDER',
    firstSaidQuote:
      'Like you, we come from the Earth. The origin of the Monoids is obscure. They came to Earth many years ago, apparently from their own planet which was dying. They offered us their invaluable services for being allowed to come on this joint voyage.',
  },
  bleed: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, rubbish, rubbish. With all our imperfections, I can assure you, sir, if you were to cut my skin, I would bleed, the same as you would.',
  },
  virus: {
    count: 95,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'A virus fever which used to be quite common to the human being.',
  },
  trays: {
    count: 6,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COMMANDER',
    firstSaidQuote:
      'They are stored in trays and will re-emerge normally when we land. Each cabinet contains a million people. Oh, yes. There are many things aboard our ship which would interest a traveller.',
  },
  baccu: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ZENTOS',
    firstSaidQuote:
      'A hearing will commence at once. As Deputy Commander, I will preside. Baccu has undertaken to put the charges.',
  },
  fibre: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ZENTOS',
    firstSaidQuote:
      'My instinct, every fibre of my being, tells me differently.',
  },
  voted: {
    count: 17,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ZENTOS',
    firstSaidQuote: 'If that is the voted finding of this hearing, yes!',
  },
  quack: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, I know I'm a bit of a quack, but the combination of these two membrane fluids, a little at a time, should do the trick.",
  },
  dodgy: {
    count: 12,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'DODO',
    firstSaidQuote:
      "Isn't that a bit dodgy? I mean, he was supposed to be the guinea pig, wasn't he?",
  },
  prods: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MONOID 1',
    firstSaidQuote:
      'The main reason was the Guardians themselves. They were a simple people. They actually encouraged the research from which we developed our voice boxes and heat prods. They were totally unprepared for the conflict when it came.',
  },
  infer: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'You infer that my mind is getting weak and old?',
  },
  clown: {
    count: 13,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TOYMAKER',
    firstSaidQuote:
      'Two clown friends of mine. They are the home team. They will play against your friends and win the quest.',
  },
  clara: {
    count: 622,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CLARA',
    firstSaidQuote:
      "His name is Joey. I'm Clara. He will play it too, of course.",
  },
  plank: {
    count: 6,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "It's all right, I can manage it. Rope, five stones, steps, plank, tube. Now I can do it if you can guide me. After all, he can do it. And you remember the directions?",
  },
  booth: {
    count: 10,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "Look, it's a draw. Now let's do it again, this time with him in the booth!",
  },
  cards: {
    count: 49,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DODO',
    firstSaidQuote:
      "They're playing cards. We shall play our next game with a couple of playing cards.",
  },
  cyril: {
    count: 42,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'QUEEN',
    firstSaidQuote:
      "Where's that Knave? Cyril! Cyril! Tormenting the Joker again I'll be bound.",
  },
  joker: {
    count: 7,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'QUEEN',
    firstSaidQuote:
      "Where's that Knave? Cyril! Cyril! Tormenting the Joker again I'll be bound.",
  },
  merry: {
    count: 95,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KING',
    firstSaidQuote: 'Oh, well, then, a riddle then? Or a merry quip?',
  },
  dolls: {
    count: 40,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'STEVEN',
    firstSaidQuote: "It's all right, they're only dolls.",
  },
  picks: {
    count: 13,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KING',
    firstSaidQuote:
      "Oh, no no no, don't fuss yourself, m'dear. The point of the game is to see who picks the chair which isn't dangerous, and whoever does that is the winner. If it's you, you'll get your Tardis back, and if it is us, we get our liberty.",
  },
  teams: {
    count: 13,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TOYMAKER',
    firstSaidQuote:
      'I congratulate you, Doctor, on your choice of friends. A very astute couple. Neither of my teams have been able to beat them yet. I think they have earned a little amusement. Now, what have we here to amuse them?',
  },
  wiggs: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TOYMAKER',
    firstSaidQuote:
      'Ah. Sergeant Rugg and Mrs Wiggs. These then are who Steven will find behind the door.',
  },
  latch: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "Useless. No sign of a door handle, latch, or lock. We're stuck here.",
  },
  riled: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WIGGS',
    firstSaidQuote: "Oh, you're a terrible man when you're riled, Sergeant.",
  },
  plate: {
    count: 41,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WIGGS',
    firstSaidQuote:
      "I'm not worried about. It's my best china! Oooh! Oh! Me best plate!",
  },
  truce: {
    count: 25,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DODO',
    firstSaidQuote:
      "Oh, look! You've thrown just about all the buns there are to throw. Couldn't you both call a truce?",
  },
  trout: {
    count: 7,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RUGG',
    firstSaidQuote:
      'Pay for the ch? Now then, you see why soldiers never apologise? Give the old trout an inch.',
  },
  broom: {
    count: 9,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RUGG',
    firstSaidQuote: 'Now then, careful with that broom, Mrs. Wiggs Careful.',
  },
  ducks: {
    count: 12,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WIGGS',
    firstSaidQuote: 'Make a lovely partner for you, ducks.',
  },
  frank: {
    count: 31,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RUGG',
    firstSaidQuote:
      "Oh, beggin' your pardon, Mrs W, this is man's work. You dance, and I'll run. Well, to be quite frank with you, Mrs W, soldiers don't dance. Well, officers, perhaps. But sergeants, no. Here, why don't you try the floor?",
  },
  hussy: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WIGGS',
    firstSaidQuote:
      "I'm surprised at you, Sergeant Rugg. Put that hussy down and get to the cupboard!",
  },
  wills: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DODO',
    firstSaidQuote:
      "Look, he can bring them to life, but they have wills and minds of their own. I'll never be able to look at a doll or a playing card again with an easy mind. They really do have a secret life of their own.",
  },
  billy: {
    count: 60,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CYRIL',
    firstSaidQuote:
      "Hello, remember me? I'm Cyril, known to my friends as Billy. Had you that time! Scare ya?",
  },
  yaroo: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CYRIL',
    firstSaidQuote:
      "Yaroo! It's right over here. You won't find it so easy this time, you know, because you see, you'll be playing against me!",
  },
  abide: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CYRIL',
    firstSaidQuote:
      "If you don't abide by the rules, you can't possibly win the game.",
  },
  fries: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'PHINEAS',
    firstSaidQuote:
      "Now that ain't so. We're backing you. You make your play and we gun 'im down. Easy as skinnin' summer fries.",
  },
  steve: {
    count: 7,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "Now see here, stranger. I reckon you don't know who I is! Deadeye Steve. The fastest, meanest gun in the West.",
  },
  wyatt: {
    count: 56,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WYATT',
    firstSaidQuote:
      "Marshall of Tombstone's my right and Wyatt Earp's my name.",
  },
  movin: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WYATT',
    firstSaidQuote:
      "Cos of the Clantons are in town, and, boy, that's mighty unhealthy for a stranger that calls himself the fastest gun in town. Now pick up yer pea shooter and let's get movin.",
  },
  rings: {
    count: 32,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BALLAD',
    firstSaidQuote: 'With rings on their fingers',
  },
  outta: {
    count: 16,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KATE',
    firstSaidQuote:
      "You're through with being angry, Doc. All you're gonna do is get outta town.",
  },
  tenor: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, quite, quite so. Allow me, sir, to introduce Miss Dodo Dupont, wizard of the ivory keys, and er Steven Regret, tenor. And lastly sir, your humble servant Doctor Caligari.',
  },
  prime: {
    count: 106,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, is that so? Oh, well, that's no matter, no. You see my prime purpose for visiting your city, sir, was to avail myself the services of a dentist.",
  },
  avail: {
    count: 7,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, is that so? Oh, well, that's no matter, no. You see my prime purpose for visiting your city, sir, was to avail myself the services of a dentist.",
  },
  lunch: {
    count: 44,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "There will be no necessity to have a bash, because tomorrow morning we're going to leave Tombstone and we should be back in the Tardis in for lunch. You know, I don't think that that is a very subtle form of advertising, do you? Yes, come to think of it, my dear, you know I think my toothache's better. Yes, I don't think it's going to be at all necessary",
  },
  hotel: {
    count: 63,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "Come on, Doctor. Straight into the surgery. I'll go to the hotel and book the rooms.",
  },
  liven: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BILLY',
    firstSaidQuote:
      "Maybe it's too quiet for you, barman? Like us to liven it up a little for ya? How about a little fancy shootin', huh?",
  },
  piano: {
    count: 10,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CHARLIE',
    firstSaidQuote: 'Say, are you really a piano player lady?',
  },
  gimme: {
    count: 6,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BILLY',
    firstSaidQuote: 'Gimme that book.',
  },
  afore: {
    count: 9,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BILLY',
    firstSaidQuote:
      'Steven Regret. Now any of you boys ever see a singer carry six guns afore?',
  },
  dunno: {
    count: 37,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'IKE',
    firstSaidQuote:
      "I dunno, but when he comes to collect his key I'll sure have me an itchy feelin' in mah back thinkin' of his friend Regret comin' down those stairs behind me. Phin, go up and fetch him down.",
  },
  itchy: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'IKE',
    firstSaidQuote:
      "I dunno, but when he comes to collect his key I'll sure have me an itchy feelin' in mah back thinkin' of his friend Regret comin' down those stairs behind me. Phin, go up and fetch him down.",
  },
  swell: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KATE',
    firstSaidQuote: 'Swell, cute.',
  },
  katie: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'HOLLIDAY',
    firstSaidQuote:
      'Well, Katie, my girl, five minutes should see the end of the man the Clantons think is Doc Holliday, and then I can start trading again under another name. What name would you fancy, Kate? Kate?',
  },
  bells: {
    count: 20,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "With rings on their fingers and bells on. Look, fellas, please. Come on, please. I've sung this song four times already!",
  },
  fleas: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'IKE',
    firstSaidQuote:
      'Nor me. We heard that you and him were closer than fleas on a porcupine.',
  },
  brand: {
    count: 53,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'HARPER',
    firstSaidQuote: "And your gun's got his brand on it.",
  },
  missy: {
    count: 56,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'HOLLIDAY',
    firstSaidQuote: 'Quiet! Now you just get right back to your room, missy.',
  },
  lined: {
    count: 13,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'IKE',
    firstSaidQuote:
      'Before we could say a word he had us lined up here like a row',
  },
  caged: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'HOLLIDAY',
    firstSaidQuote:
      "I'm sorry to speak sharp, Missy, but I'm gettin' to feel almost as caged up here as you are.",
  },
  posse: {
    count: 4,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'HOLLIDAY',
    firstSaidQuote:
      "You're gettin' clumsy. Do you mind if I turn this lamp up a little? Make sure you haven't got a whole posse with you? Well now, what do you want?",
  },
  blows: {
    count: 28,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WYATT',
    firstSaidQuote:
      "Well, it'll be here when you get back. I mean, don't worry. This is just till this thing blows over.",
  },
  jesse: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KATE',
    firstSaidQuote:
      "Aw honey, I've known them all in my time. Jesse James, Billy the kid, Johnny Ringo. And I'm tellin' you the Doc's the best of the bunch. He's a real gentleman. Just been a mite unlucky, is all.",
  },
  ringo: {
    count: 36,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KATE',
    firstSaidQuote:
      "Aw honey, I've known them all in my time. Jesse James, Billy the kid, Johnny Ringo. And I'm tellin' you the Doc's the best of the bunch. He's a real gentleman. Just been a mite unlucky, is all.",
  },
  lynch: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CHARLIE',
    firstSaidQuote:
      "If you're Doc Holliday, I wouldn't go out there. The whole town's out to lynch you.",
  },
  badge: {
    count: 21,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BILLY',
    firstSaidQuote: "You're wearing a badge, Marshall. If'n you weren't",
  },
  ranch: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WYATT',
    firstSaidQuote:
      "I don't need to answer to you, I'll answer to the committee if need be. Now get back to the ranch while you can still ride.",
  },
  abode: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WYATT',
    firstSaidQuote:
      'And now, friends, shall we take this sinner to the abode of the unrighteous?',
  },
  noose: {
    count: 14,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "Now then, Doctor, it wasn't your neck in the noose just now. I for one am very grateful to Mister Werp, Earp.",
  },
  rides: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BILLY',
    firstSaidQuote:
      "But Pa, Ringo rides alone, you know that. He mightn't wanna join up with us.",
  },
  prowl: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WYATT',
    firstSaidQuote:
      "That's all we needed. Boy, the hosts of Midian are sure on the prowl tonight.",
  },
  sells: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MASTERSON',
    firstSaidQuote:
      'Ringo is a friend of nobody. Professional gunfighter, sells hisself to the highest bidder.',
  },
  mebbe: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'RINGO',
    firstSaidQuote: "You'd better, that's all. I could mebbe change my mind.",
  },
  earps: {
    count: 6,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'PHINEAS',
    firstSaidQuote:
      "Why, this is him, Ike. Don't you recognise one of the fightin' Earps when you see one?",
  },
  alley: {
    count: 8,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WYATT',
    firstSaidQuote:
      "Oh, but they think it was, and boy you had 'em lined up against that piana' like skittles in an alley. Why, you're gonna be a useful man to have around when the shootin' starts.",
  },
  bench: {
    count: 14,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WYATT',
    firstSaidQuote: 'Get him on over to the bench there.',
  },
  timer: {
    count: 12,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MASTERSON',
    firstSaidQuote:
      "T'ain't no use, old timer. He won't listen to me, he won't listen to nobody.",
  },
  fella: {
    count: 35,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VIRGIL',
    firstSaidQuote: "Fella up there with 'em, name of Steven Regret.",
  },
  brung: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'HOLLIDAY',
    firstSaidQuote:
      'Well now, Wyatt, so you did, but the fact is I was brung here at gunpoint by a woman.',
  },
  blush: {
    count: 5,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KATE',
    firstSaidQuote:
      "I blush with shame, Mister Clanton, indeed I do. That was a dad blasted lie. He's right there in Tombstone with the Earps.",
  },
  shady: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'HOLLIDAY',
    firstSaidQuote:
      "Well, it's like I said, Wyatt. I'll be strollin' along real easy behind you on the shady side of the street. Okay?",
  },
  clich: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, my dear Dodo, my dear Dodo. You know you're fast becoming a prey to every cliché-ridden convention in the American West. And it's high time we left. Now, come along.",
  },
  gifts: {
    count: 22,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JANO',
    firstSaidQuote:
      'But our calculations were incomplete. We did not realise that the Doctor would have anyone with him. Nevertheless, although our honours are for him, our gifts are for you.',
  },
  preys: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JANO',
    firstSaidQuote:
      'Life preys on other forms of life, as you know, Doctor. Wild beasts live on other animals. Mankind must have food, water, and oxygen.',
  },
  topic: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'FLOWER',
    firstSaidQuote:
      "Let's forget such a dismal topic. Come, I'll show you the stadium. There's going to be a celebration there tonight especially for you.",
  },
  tours: {
    count: 39,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'DODO',
    firstSaidQuote: 'I hate conducted tours.',
  },
  shone: {
    count: 6,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'DODO',
    firstSaidQuote:
      'He had one of the savages with him. A girl. She seemed to be moving along in a light that shone from one of those guns they carry.',
  },
  queue: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'STEVEN',
    firstSaidQuote:
      "Well, if it isn't allowed, Dodo would be the first in the queue. I'm going to take a look.",
  },
  senta: {
    count: 14,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'TECH 2',
    firstSaidQuote:
      'Something very strange has happened, Senta. We have one of the outsiders, but she does not submit. She is fighting.',
  },
  files: {
    count: 48,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'SENTA',
    firstSaidQuote:
      "Not quite. We've been lucky. Make a record of this for her files. It must be some considerable time before we extract any more life energy from this particular subject.",
  },
  wylda: {
    count: 2,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'TOR',
    firstSaidQuote: 'But we must save Wylda.',
  },
  unite: {
    count: 9,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JANO',
    firstSaidQuote: 'We may need a new leader. Somebody who can unite us.',
  },
  brett: {
    count: 22,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'GREEN',
    firstSaidQuote: 'Professor Brett.',
  },
  polly: {
    count: 211,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'BRETT',
    firstSaidQuote: 'Exciting. Look, this is my secretary, Polly.',
  },
  wotan: {
    count: 37,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'BRETT',
    firstSaidQuote:
      "Now Polly's pretty smart, a cracking typist, right? Also rather a cheeky one at times. Well now this machine, which I call WOTAN.",
  },
  spelt: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'BRETT',
    firstSaidQuote:
      '"Vo tan." Spelt W O T A N. Will Operating Thought ANalogue.',
  },
  kitty: {
    count: 18,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'POLLY',
    firstSaidQuote: 'Hi, Kitty.',
  },
  shore: {
    count: 23,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Well, it's my ship, see. It's gone off to the West Indies and I've got a shore posting. In barracks for six months.",
  },
  palms: {
    count: 1,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      "And you'll miss the swaying palms, the white beaches, the blue sea",
  },
  boats: {
    count: 11,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'FLASH',
    firstSaidQuote: 'Look, go and play with your toy boats, half pint.',
  },
  corps: {
    count: 38,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'BRETT',
    firstSaidQuote:
      'Further instructions from WOTAN. We shall require skilled labour. A labour corps will come into operation immediately. Contact will be made by these people by telephone. When they are on the line, switch them through to thought control. This is the way each person will be enlisted.',
  },
  taxis: {
    count: 3,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'DODO',
    firstSaidQuote:
      'You know, Doctor, those two have gone off in the wrong direction. The taxis are all down there.',
  },
  tramp: {
    count: 6,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'SUMMER',
    firstSaidQuote: 'Tramp found dead in Covent Garden.',
  },
  react: {
    count: 23,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'SUMMER',
    firstSaidQuote: "We don't know how they'll react yet.",
  },
  havoc: {
    count: 16,
    firstSaidSeasonIndex: 3,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'SUMMER',
    firstSaidQuote:
      "Where? Battersea? I see. Well, have you had any reports in yet? Good heavens, it's appalling. Well you stay and get the phone. I'll be back to you. The second machine is approaching the Battersea power station and it's creating absolute havoc. Well, we've tried the army. What else is there?",
  },
  pinch: {
    count: 12,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "I don't know. Maybe he's some kind of hypnotist. Pinch me. Ow! Not that hard. Hey, wait a minute.",
  },
  super: {
    count: 88,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'POLLY',
    firstSaidQuote: "But it's a super place. Whee!",
  },
  nicer: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "It'd be a lot nicer with a few houses and a bus stop. Got any idea where we are?",
  },
  dears: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh yes, yes! You may know where you are, my dears, but not when. Oh, I can foresee oodles of trouble.',
  },
  avery: {
    count: 12,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Avery?',
  },
  afoot: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KEWPER',
    firstSaidQuote:
      "There's business afoot. A message for the Churchwarden tonight.",
  },
  jacob: {
    count: 4,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KEWPER',
    firstSaidQuote: "Aye, Jacob Kewper. And I've no rooms. We're full.",
  },
  crews: {
    count: 17,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'LONGFOOT',
    firstSaidQuote:
      'Who rob great ships on every sea! Who pillage crews without mercy!',
  },
  matey: {
    count: 12,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHERUB',
    firstSaidQuote: 'We miss you, matey. But most of all does the Captain.',
  },
  mates: {
    count: 45,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHERUB',
    firstSaidQuote:
      "You're a fool, Joe Longfoot. But before you goes to join your mates, tell me what I want to know. Speak up.",
  },
  hooks: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHERUB',
    firstSaidQuote:
      "Speak, damn your eyes! It wouldn't be like you to go to Davy Jones' silent, matey. So I reckon we best get on to that old fella and get our hooks into him.",
  },
  burst: {
    count: 53,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'TOM',
    firstSaidQuote: 'The door was burst wide open. No sign of no one though.',
  },
  tizzy: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHERUB',
    firstSaidQuote:
      'Was, you mean. You see, him and me, we had a little bit of a tizzy like, mate.',
  },
  whale: {
    count: 18,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHERUB',
    firstSaidQuote:
      "Don't you talk to me like that. Oh, Captain, give me the word. Just give me one minute. I'll have the words spilling out of him like blubber from a whale.",
  },
  fixes: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BEN',
    firstSaidQuote: "Oh, of all the bloomin' fixes to be in.",
  },
  straw: {
    count: 15,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      "No, but I think I've got a plan. Now wait, look. If we get this straw. Oh no, the rat's in the corner! You get me some straw, will you please?",
  },
  belay: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHERUB',
    firstSaidQuote:
      'Come below, matey. But belay any tricks, ay, Master Kewper?',
  },
  comfy: {
    count: 16,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Yeah, and the Tardis too. In fact, if I know him, I bet he's back in it all comfy.",
  },
  blake: {
    count: 34,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BLAKE',
    firstSaidQuote: "I am Josiah Blake, the King's revenue officer.",
  },
  penny: {
    count: 43,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHERUB',
    firstSaidQuote: 'This would fetch a pretty penny.',
  },
  witty: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SQUIRE',
    firstSaidQuote: "By my favourite mare, that's witty, Business, indeed,",
  },
  birch: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SQUIRE',
    firstSaidQuote:
      'Great Heavens! This is one of the very renegades who slew poor Longfoot. How did you escape? Well done, Birch.',
  },
  vouch: {
    count: 9,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SQUIRE',
    firstSaidQuote:
      'Cease these vile untruths, boy! These gentlemen are goodly merchants. I vouch for them. You are a stranger here, as is your companion, and therefore not to be trusted.',
  },
  babes: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PIKE',
    firstSaidQuote: 'Out of the mouths of babes, ay?',
  },
  twill: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KEWPER',
    firstSaidQuote: "'Twill not be easy without being seen.",
  },
  cache: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SQUIRE',
    firstSaidQuote:
      'Silks, tobacco and brandy, Captain. This is our immediate cache, you understand.',
  },
  aargh: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PIKE',
    firstSaidQuote: 'Aargh, ye black-souled scum! Escaped!',
  },
  liver: {
    count: 13,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PIKE',
    firstSaidQuote:
      "I'll tear your liver out and feed it to the sharks, ye sea slime.",
  },
  spike: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PIKE',
    firstSaidQuote:
      "Jamaica, ye'd have made a fine skipper but you're short on guile. Any dark of the night they'll expect us. We'll spike 'em. We'll land by day. Some will go direct to the church and loot the smuggler's horde. Me and Cherub will seek Avery's gold.",
  },
  crypt: {
    count: 24,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Well, Doctor, in the crypt at the old church there's this secret passage.",
  },
  smack: {
    count: 9,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Yeah, but you don't know where it leads to. Smack down to where the Tardis is. So, all we've got to do is get back to the old church, go down the passage, and we're away, mate.",
  },
  moral: {
    count: 32,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, well I know it's really difficult for both you to understand, but I'm under moral obligation.",
  },
  soppy: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      "That's not old, soppy. Don't forget we're not in the twentieth century. This is sixteen hundred and something.",
  },
  rhyme: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It was some kind of rhyme. Now, let me see. Dead man's secret key. Ringwood, Smallbeer and Gurney.",
  },
  truss: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KEWPER',
    firstSaidQuote: "Don't truss up thy temper, I say.",
  },
  davey: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHERUB',
    firstSaidQuote:
      'Is there any more as fancies a free trip to Davey Jones, ay?',
  },
  jones: {
    count: 168,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHERUB',
    firstSaidQuote:
      'Is there any more as fancies a free trip to Davey Jones, ay?',
  },
  maker: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHERUB',
    firstSaidQuote:
      'Do you fancy these lads of yours meeting their maker so young, ay sawbones?',
  },
  sewed: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHERUB',
    firstSaidQuote:
      "Old Zeb, the ship's chandler. A fellow that sewed many a merchant into a sailcloth nightgown.",
  },
  bilge: {
    count: 10,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GAPTOOTH',
    firstSaidQuote: 'Come on now, you bilge breath. Get on with it.',
  },
  slake: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PIKE',
    firstSaidQuote:
      "When the fever is in the lads' bones, nothing but blood will slake it.",
  },
  parky: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BEN',
    firstSaidQuote: "Yeah, it's getting right parky in here.",
  },
  polar: {
    count: 13,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GENEVA',
    firstSaidQuote:
      'Handing Zeus 4 to Polar base. Will you take control now, please?',
  },
  jimmy: {
    count: 46,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DYSON',
    firstSaidQuote:
      ' Snowcap to Zeus 4. Over to local control channel J for Jimmy.',
  },
  dyson: {
    count: 19,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARCLAY',
    firstSaidQuote:
      'Sir. Dyson, give Texas Tracking the next orbital pattern, will you?',
  },
  texas: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARCLAY',
    firstSaidQuote:
      'Sir. Dyson, give Texas Tracking the next orbital pattern, will you?',
  },
  bluey: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WILLIAMS',
    firstSaidQuote: 'Okay, Bluey, let him have it. Are you receiving it?',
  },
  buddy: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SERGEANT',
    firstSaidQuote: 'Look buddy, I want the truth, and quick.',
  },
  telly: {
    count: 37,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Yeah, but I wonder why there are so few people. I mean it's not like what you see on the telly, is it?",
  },
  probe: {
    count: 116,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SERGEANT',
    firstSaidQuote: 'Oh, this is just a normal atmosphere testing probe.',
  },
  reads: {
    count: 13,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WILLIAMS',
    firstSaidQuote:
      "Yeah, you're right. There is something. I can't see properly but it reads as if it was in orbit between Mars and Venus.",
  },
  tanks: {
    count: 23,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WILLIAMS',
    firstSaidQuote: 'Main tanks are down approximately',
  },
  sarge: {
    count: 27,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TITO',
    firstSaidQuote: "Hey, here it is, Sarge. Hey, sir, what's going on?",
  },
  hotly: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'REPORTER',
    firstSaidQuote:
      'Some observers have reported that its land masses resemble those of Earth, but this is being hotly disputed in top astronomical circles and no general agreement has yet been reached.',
  },
  aeons: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KRAIL',
    firstSaidQuote:
      'Yes. Aeons ago the planets were twins, then we drifted away from you on a journey to the edge of space. Now we have returned.',
  },
  twins: {
    count: 22,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KRAIL',
    firstSaidQuote:
      'Yes. Aeons ago the planets were twins, then we drifted away from you on a journey to the edge of space. Now we have returned.',
  },
  retro: {
    count: 20,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARCLAY',
    firstSaidQuote:
      "Retro rockets to go in 20 seconds. After I give you the time check you'll come in on your own. Right?",
  },
  radar: {
    count: 66,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DYSON',
    firstSaidQuote: "Look at the radar now. They're accelerating!",
  },
  bases: {
    count: 13,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WIGNER',
    firstSaidQuote:
      'Hold on, Cutler. Military bases all round the world must be put on immediate alert. Cutler, could you deal with another attack, with your limited resources?',
  },
  cobra: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CUTLER',
    firstSaidQuote:
      "Security? Major, I want the guard doubled on the main entrance. Use section 1. Yes, and section 2 to the flight exit and tracks. Section 3 to the fuel tanks, check them over, and double the guard on them. What's that? I don't care what sort of a rest they're on! Get them out there, and do it quick! I'll get some action here yet. Missile control? Programme all Cobra anti-missiles for launch imminent. Stand in readiness and await instructions.",
  },
  globe: {
    count: 31,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CUTLER',
    firstSaidQuote:
      "What is it? It's a doomsday weapon, Mister, and rightly primed it could split that planet in half. There are two or three at strategic positions round the globe. We have one of them and the means of delivering it to Mondas.",
  },
  toute: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WIGNER',
    firstSaidQuote:
      "Yes, I know. We've just got reports. They are coming in from all over the world. And to make matters worse, the energy drain is increasing rapidly. Ouvrez les lignes des communications avec toute les de monde. Allez-y.",
  },
  monde: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WIGNER',
    firstSaidQuote:
      "Yes, I know. We've just got reports. They are coming in from all over the world. And to make matters worse, the energy drain is increasing rapidly. Ouvrez les lignes des communications avec toute les de monde. Allez-y.",
  },
  allez: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WIGNER',
    firstSaidQuote:
      "Yes, I know. We've just got reports. They are coming in from all over the world. And to make matters worse, the energy drain is increasing rapidly. Ouvrez les lignes des communications avec toute les de monde. Allez-y.",
  },
  suite: {
    count: 21,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WOMAN',
    firstSaidQuote: 'Toute de suite.',
  },
  poked: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CUTLER',
    firstSaidQuote:
      "Now, look you. Ever since you came into this base you and that old man have poked your noses into things that don't concern you. Well, you've just done it for the last time. You, take them out of here and lock them up with the Doctor.",
  },
  noses: {
    count: 12,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CUTLER',
    firstSaidQuote:
      "Now, look you. Ever since you came into this base you and that old man have poked your noses into things that don't concern you. Well, you've just done it for the last time. You, take them out of here and lock them up with the Doctor.",
  },
  pours: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      'If Mondas turns into a sun and pours out deadly radiation, how much will it affect us?',
  },
  servo: {
    count: 12,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARCLAY',
    firstSaidQuote:
      "Just level with the walkway, there is a panel marked Plug Servo Leads. You'll need a screwdriver.",
  },
  plugs: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARCLAY',
    firstSaidQuote:
      'Good. That will do. Now, unscrew the panel and inside you will see four small plugs. Take out any one of them and snip off a pin and put it back.',
  },
  minus: {
    count: 109,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARCLAY',
    firstSaidQuote:
      'We are starting at T-minus two minutes, starting from now!',
  },
  giros: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARCLAY',
    firstSaidQuote: 'T-minus 1-40 and counting. Clear silo. Booster giros on.',
  },
  krang: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JARL',
    firstSaidQuote: 'Records, Krang.',
  },
  desks: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DYSON',
    firstSaidQuote:
      "Back to your desks all of you. The emergency's not over yet. Philips, there are two reactor rods out in the corridor. See that they're put back at once.",
  },
  wakey: {
    count: 25,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BEN',
    firstSaidQuote: "Hey, come on Doctor, wakey wakey! It's all over now.",
  },
  nails: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Ah. Very good. Nails need growing.',
  },
  tipsy: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Nah, might be just around here. Don't want too many lungfuls of it, I know that. Here, when I was a kid, we used to live opposite a brewery. You could take a walk and get tipsy all in one go.",
  },
  pores: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "No, it's quicksilver. It gets through the pores. Where is the Doctor, or whatever he is, got to?",
  },
  quinn: {
    count: 54,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRAGEN',
    firstSaidQuote:
      'Ah, Quinn, there you are. What have you got there? My people have found two more of them by one of the pools.',
  },
  fumes: {
    count: 14,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRAGEN',
    firstSaidQuote:
      'Yes. The other two have had a rather bad dose of fumes. The girl has, anyway.',
  },
  comic: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'QUINN',
    firstSaidQuote:
      'These comic opera guards of yours do have some uses after all.',
  },
  opera: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'QUINN',
    firstSaidQuote:
      'These comic opera guards of yours do have some uses after all.',
  },
  cheek: {
    count: 15,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Oh, how did he get that thing back again. That was a bit of a cheek, wasn't it, seeing if the Governor was the guy you got the button off?",
  },
  fuses: {
    count: 10,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'LESTERSON',
    firstSaidQuote:
      'Now, my theory is that I can insert a laser ray in this ridge here. The ray spreads, fuses the opening device and gets us in.',
  },
  chuck: {
    count: 11,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Look, they think you're the Examiner, order them to destroy the Daleks. Well, chuck your weight about.",
  },
  aloud: {
    count: 12,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Read this. Aloud!',
  },
  resno: {
    count: 10,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'LESTERSON',
    firstSaidQuote:
      "Will you be quiet! Where do you both think you are? This is a scientific laboratory. Kindly keep your politics out of it. Come on, Resno, man, get on with it. We haven't got all day. We've got to get this working before the Examiner stops us. He's got some phobia about these, these Daleks.",
  },
  stops: {
    count: 55,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'LESTERSON',
    firstSaidQuote:
      "Will you be quiet! Where do you both think you are? This is a scientific laboratory. Kindly keep your politics out of it. Come on, Resno, man, get on with it. We haven't got all day. We've got to get this working before the Examiner stops us. He's got some phobia about these, these Daleks.",
  },
  brows: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Well, the jacket button wasn't. And he was caught red-handed in the Communications room with a pair of pliers. And don't tell me he was plucking his eye-brows either.",
  },
  mines: {
    count: 68,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'LESTERSON',
    firstSaidQuote:
      'Governor, think what it would mean if we were to set it to work in the mines. It could double our production overnight.',
  },
  paces: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'LESTERSON',
    firstSaidQuote:
      "Now, there is no cause for concern, Governor. Just you wait until you see the amount of work it can do. And now, I'm really going to put you through your paces. Follow me, Dalek.",
  },
  ethyl: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'LESTERSON',
    firstSaidQuote:
      'When sodium acts on ethyl alcohol, what is the resulting derivative?',
  },
  versa: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'DALEK',
    firstSaidQuote:
      'When heat is transformed into any other kind of energy or vice versa, the total quantity of energy remains invariable.',
  },
  crush: {
    count: 41,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRAGEN',
    firstSaidQuote:
      "Only to stir them up to create enough trouble to get rid of Hensell, and then, then we crush them. The whole colony will be grateful, and I'll be Governor.",
  },
  hound: {
    count: 4,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'JANLEY',
    firstSaidQuote:
      "Will you both go away. Guard! It's you, badgering him with questions. You've done nothing but hound him ever since you arrived on Vulcan. Bragen's orders were that no one was to be admitted.",
  },
  sheet: {
    count: 9,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VALMAR',
    firstSaidQuote:
      'One of them did kill Resno. And you saw what the Dalek did to that sheet of metal.',
  },
  squad: {
    count: 62,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GUARD',
    firstSaidQuote: "I'm a Squad Leader in Bragen's guard, sir.",
  },
  trips: {
    count: 15,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'HENSELL',
    firstSaidQuote:
      'Well, Bragen, these trips are becoming more and more demanding.',
  },
  brass: {
    count: 12,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Well, I mean I didn't expect the brass bands to be playing, but I wouldn't have thought a thank you would have hurt anybody.",
  },
  whist: {
    count: 11,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KIRSTY',
    firstSaidQuote: 'Whist, father.',
  },
  clans: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ALEXANDER',
    firstSaidQuote:
      "It's done. The clans are broken, shot to pieces by the English guns. Never had the chance to get to within claymore's length of them.",
  },
  dinna: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: 'Dinna fash yourself. He was the first to leave the field.',
  },
  laird: {
    count: 13,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ALEXANDER',
    firstSaidQuote: "You're the Laird himself.",
  },
  canna: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: 'They canna hang us all, can they?',
  },
  piper: {
    count: 20,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ALEXANDER',
    firstSaidQuote: "They'll never hang me, piper. You may be sure of that.",
  },
  jamie: {
    count: 1098,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ALEXANDER',
    firstSaidQuote:
      "Well, I'll find out. Jamie, at the rear. You gang that way. Wait my signal.",
  },
  nobly: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      "It's got words on it. With Charles our brave and merciful Prince Royal, we'll greatly fall or nobly save our country.",
  },
  flank: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'FFINCH',
    firstSaidQuote:
      "Let's hope so. Take a man around the rear, Sergeant. We'll out-flank them.",
  },
  creag: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ALEXANDER',
    firstSaidQuote: 'Creag an tuire!',
  },
  tuire: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ALEXANDER',
    firstSaidQuote: 'Creag an tuire!',
  },
  colin: {
    count: 63,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: "Colin McLaren, the Laird, and I'm his piper.",
  },
  trask: {
    count: 20,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GREY',
    firstSaidQuote:
      'With Mister Trask and his ship at our service, we may expect to clear some measure of profit out of this rebellion, ay Perkins?',
  },
  mourn: {
    count: 17,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KIRSTY',
    firstSaidQuote: 'We can but mourn.',
  },
  whelp: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SERGEANT',
    firstSaidQuote: "That young whelp? Couldn't catch his own grandmother.",
  },
  bairn: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KIRSTY',
    firstSaidQuote:
      "Aye, why do you wear the short skirts of a bairn? You're a grown woman.",
  },
  scots: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      "No we're not! Even your dour Scots lassies must have played piggy-back.",
  },
  piggy: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      "No we're not! Even your dour Scots lassies must have played piggy-back.",
  },
  dairy: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'FFINCH',
    firstSaidQuote:
      " Halt! You dolt. Couldn't catch a couple of wenches, could you? Call yourselves soldiers? The terror of the Highlands? You wouldn't frighten an one-armed dairy maid. Well, I've done enough walking for one day. Go and fetch my horse. If you're not back within one hour, three hundred lashes apiece. Imbeciles! Give the lantern to me. I don't want to be left here in the dark. Right then, march!",
  },
  glens: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KIRSTY',
    firstSaidQuote:
      "Look, you and your kind have robbed our glens. Look, he's got food. Chicken and bread.",
  },
  aries: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Oh, Isis and Osiris, is it meet? Aquarius, Aries, Taurus.',
  },
  dirge: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SENTRY',
    firstSaidQuote: 'Heard a rebel dirge.',
  },
  wasne: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: 'I knew he wasne one of us.',
  },
  finch: {
    count: 31,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      "Oh, we're very brave all of a sudden. Watch him, Kirsty. He must have some form of. Ah-ha, yes. Algernon Thomas Alfred Ffinch. Two 'f's! Lieutenant in the Honourable Colonel Atwood's Rifles. So, I bet the Colonel would be highly interested to hear how his Lieutenant F-finch was captured by two girls.",
  },
  clerk: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GREY',
    firstSaidQuote:
      "Silence, Captain. I will not have my clerk bullied. I have enough evidence on you to send you to the gallows ten times over, and don't you forget it.",
  },
  peril: {
    count: 11,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GREY',
    firstSaidQuote: 'Have a care, Doctor. You waste my time at your peril.',
  },
  richt: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MOLLIE',
    firstSaidQuote: 'All richt, all richt.',
  },
  drown: {
    count: 22,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: "You've not a mind to drown us, have you?",
  },
  firth: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TRASK',
    firstSaidQuote: "Ha! Wouldn't pollute the firth with ye. Get in the boat.",
  },
  broth: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "I've bought a wee drop of broth for Mister Trask.",
  },
  swabs: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TRASK',
    firstSaidQuote:
      "Belay there, you swabs! In case you're thinking of escaping, there's Jim Hughes for you. He didn't find it an happy ship, so I'll find him another berth where he'll be happy!",
  },
  berth: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TRASK',
    firstSaidQuote:
      "Belay there, you swabs! In case you're thinking of escaping, there's Jim Hughes for you. He didn't find it an happy ship, so I'll find him another berth where he'll be happy!",
  },
  havna: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'COLIN',
    firstSaidQuote: "Ye havna been away so long you don't recognise me.",
  },
  shark: {
    count: 17,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'WILLY',
    firstSaidQuote:
      "That shark was my mate. I was running arms from France past the blockade. Trask betrayed me. The Navy boarded the Annabelle and now he's sailing the ship for King George!",
  },
  scalp: {
    count: 4,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KIRSTY',
    firstSaidQuote: "Put your hands off me or I'll scalp the hide off ye!",
  },
  willy: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TRASK',
    firstSaidQuote:
      'Willy MacKay, former master of this vessel. I should have done for him long ago.',
  },
  irons: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GREY',
    firstSaidQuote:
      "Clap him in irons. When I return with new contracts, we'll bind him and drop him from the highest yard-arm.",
  },
  clubs: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh dear, clubs. Would you like to deal, Polly orange wench.',
  },
  saucy: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Oh, you saucy girl.',
  },
  heaps: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "From the English soldiers. Well, they're bound to have heaps of weapons as souvenirs.",
  },
  tease: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'POLLY',
    firstSaidQuote: "Oh look, don't tease us. Look.",
  },
  jetty: {
    count: 4,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Who else would be walking around the jetty at this time of night dressed like a soldier who'd been wounded in battle?",
  },
  foggy: {
    count: 4,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TRASK',
    firstSaidQuote: "Happen it's too foggy to sail, what then?",
  },
  privy: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GREY',
    firstSaidQuote:
      'That will never happen, Trask. There are but three of us privy to this secret. I can answer for myself and Perkins. Ay, Perkins?',
  },
  colic: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      ' Doctor von Wer at your service. Remedies for the ague, the twitch, the colic, the warts and the gout.',
  },
  warts: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      ' Doctor von Wer at your service. Remedies for the ague, the twitch, the colic, the warts and the gout.',
  },
  moors: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'FFINCH',
    firstSaidQuote:
      "Well, I wouldn't linger here if I were you. These moors, you know, they're still scouring them for rebels.",
  },
  fraud: {
    count: 13,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BEN',
    firstSaidQuote: 'You old fraud. Come on, we must go.',
  },
  isles: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: 'The Isles, maybe.',
  },
  dekko: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BEN',
    firstSaidQuote: "No, not me, I'm having a dekko down here.",
  },
  habla: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      'Er, parlez-vous francais? Sprechen Sie deutsch? Habla si espanol?',
  },
  postu: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'GUARD',
    firstSaidQuote: 'Bazumi tampost postu!',
  },
  scoff: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: "Better hurry or he'll scoff the lot.",
  },
  canny: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JAMIE',
    firstSaidQuote:
      "Oh, he's a canny one, yon Doctor. Dinna fash yourself, Polly.",
  },
  damon: {
    count: 24,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ARA',
    firstSaidQuote: 'Well, Damon then.',
  },
  gills: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'DAMON',
    firstSaidQuote: 'We give them plastic gills. Look.',
  },
  depth: {
    count: 35,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Even supposing you could drill to the depth of a hundred miles.',
  },
  jacko: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SEAN',
    firstSaidQuote:
      "By Christopher, you're right. If we disappear now they'll think we're gone to the project work gang. Okay, Jacko?",
  },
  thous: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RAMO',
    firstSaidQuote: 'If I took you to our ruler Thous, could you convince him?',
  },
  cling: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BEN',
    firstSaidQuote: "Don't worry about us. Just cling on.",
  },
  lolem: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RAMO',
    firstSaidQuote: 'Lolem. He is old and superstitious.',
  },
  thugs: {
    count: 17,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You disappoint me, Professor. I didn't think a man of science needed the backing of thugs.",
  },
  bowed: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'LOLEM',
    firstSaidQuote:
      "They were in our midst and we bowed our heads in prayer. When we looked again they'd gone.",
  },
  irish: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'But you are Irish.',
  },
  baggy: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Black coat, baggy trousers and a bow tie?',
  },
  punch: {
    count: 25,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Doctor, look at this! Someone's been having a right punch-up in here.",
  },
  gauge: {
    count: 11,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MAN 2',
    firstSaidQuote:
      'Reading maximum. Gauges four, five and six steady. Gauge three fluctuating and unpredictable.',
  },
  burke: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Yeah, well, look it's all right for you giving me the old chat, mate, but I know nothing about passwords. I've been out chasing this burke all day.",
  },
  oscar: {
    count: 26,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'GUARD',
    firstSaidQuote: "It's Oscar. Get him out of here!",
  },
  betty: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SEAN',
    firstSaidQuote:
      "How would I know, but it certainly isn't closing time at Betty Murphy's pub. It can be only one thing. It's the Doctor, of course. He's started to flood Atlantis. The sea's breaking in.",
  },
  brick: {
    count: 9,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, have I dropped a brick? Oh, I seem to have shaken some of them. Zaroff, I think you ought to know the sea has broken through and is about to overwhelm us here.',
  },
  stink: {
    count: 10,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Yeah, I'm not sorry to be out of that place. Phwoar, Jamie, you don't half stink of fish!",
  },
  sniff: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JAMIE',
    firstSaidQuote:
      "Oh, you want to take a wee sniff of yourself, Benjamin. He's not exactly a bonnie bunch of heather.",
  },
  bumpy: {
    count: 9,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Oh no, no, no. It was just a bumpy landing, that's all.",
  },
  lunar: {
    count: 10,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "It's probably your eyes getting used to the lunar light, hey, Doctor?",
  },
  clogs: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'POLLY',
    firstSaidQuote: 'What do we need these great clogs for?',
  },
  evans: {
    count: 52,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BENOIT',
    firstSaidQuote: 'But Doctor Evans has gone down with it as well.',
  },
  hobby: {
    count: 25,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'NILS',
    firstSaidQuote:
      " Okay, Hobby. Nils speaking. We, er, we've got a bit of a flap on up here.",
  },
  ralph: {
    count: 17,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HOBSON',
    firstSaidQuote:
      "Right, Doctor. You'd better meet them all. We're all scientists here, you see. No room for idle hands, I see to that. Roger Benoit, beside you there, is my assistant. He takes over as Chief Scientist if anything happens to me. He's a physicist like me and Joe Benson there. Nils, our mad Dane, is an astronomer and mathematician as is Charlie here. Ralph, Jules and Franz are geologists. When they're not acting as cooks, looks-outs, general and, you know, handymen.",
  },
  franz: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HOBSON',
    firstSaidQuote:
      "Right, Doctor. You'd better meet them all. We're all scientists here, you see. No room for idle hands, I see to that. Roger Benoit, beside you there, is my assistant. He takes over as Chief Scientist if anything happens to me. He's a physicist like me and Joe Benson there. Nils, our mad Dane, is an astronomer and mathematician as is Charlie here. Ralph, Jules and Franz are geologists. When they're not acting as cooks, looks-outs, general and, you know, handymen.",
  },
  tides: {
    count: 10,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BENOIT',
    firstSaidQuote:
      'The gravitron there controls the tides, the tides controls the weather. And from this console here we plot it all on that map. Simple, eh?',
  },
  chart: {
    count: 13,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Don't get too near, Polly. Have a look on his chart.",
  },
  spout: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HOBSON',
    firstSaidQuote:
      "How can I rest with that thing up the spout. You know the score as well as I do. Five units off centre we lift half London into space. Five more and the Atlantic water level goes up three feet. Rinberg just doesn't understand the pressure we're under. Hey, you! What do you thinking you're doing skulking there?",
  },
  drops: {
    count: 24,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HOBSON',
    firstSaidQuote:
      "Oh, by the way. There were two more of those momentary drops in air pressure while I was on. I've put them in the log.",
  },
  cycle: {
    count: 49,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, it's nothing. It probably just a changeover in the time cycle.",
  },
  broad: {
    count: 16,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Of course along at the control centre it's probably broad daylight. Polly, you wouldn't be making fun of me, would you?",
  },
  dozed: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      "I don't understand what could have happened. I must have dozed off or something. One thing I am sure of. Something went out of that door just as you came in.",
  },
  torus: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BENOIT',
    firstSaidQuote: "You can't do that. The torus will burn out.",
  },
  miami: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RINBERG',
    firstSaidQuote:
      "Well, there's no sign of any improvement here. We've just had a report from Miami, Florida. Thirty minutes ago they were enjoying clear skies and a heat wave. Now Hurricane Lucy is right overhead.",
  },
  autre: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BENOIT',
    firstSaidQuote:
      "Eh lÃ , qu'est-ce que vous fabriquez ici, imbÃ©cile d'idiot ! Vous n'avez rien d'autre Ã faire ? Vous croyez que nous sommes en train de nous amuser ? Oh, come on. Get out of the way.",
  },
  faire: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BENOIT',
    firstSaidQuote:
      "Eh lÃ , qu'est-ce que vous fabriquez ici, imbÃ©cile d'idiot ! Vous n'avez rien d'autre Ã faire ? Vous croyez que nous sommes en train de nous amuser ? Oh, come on. Get out of the way.",
  },
  pumps: {
    count: 23,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HOBSON',
    firstSaidQuote:
      "Something's odd. It's not the pumps, I'm sure of that. Has anyone asked permission to leave the base?",
  },
  hides: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HOBSON',
    firstSaidQuote:
      "If I find anybody's been fooling about in there without permission, I'll tear their hides off.",
  },
  lungs: {
    count: 21,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      'Oh. What about that thing on their chests? You know, the part which replaces their heart and lungs.',
  },
  ether: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'POLLY',
    firstSaidQuote: 'Benzene, ether, alcohol.',
  },
  phoar: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "So, get it? This bottle holds the stuff that puts the fire out and this cylinder pushes gas into the bottle so that stuff squirts out here. Now, all we've got to do is to undo it. Phoar. Empty it and fill it with Polly cocktail.",
  },
  epoxy: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'POLLY',
    firstSaidQuote:
      "Let's think. Benzene, ether, alcohol, acetone and epoxy-propane.",
  },
  medok: {
    count: 33,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'PILOT',
    firstSaidQuote: "What's the matter? Medok!",
  },
  danke: {
    count: 4,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MUSIC',
    firstSaidQuote:
      ' Ra ra ra ra ra-ra ra ra! Danke shone, danke schone. Number one! Tan tan tan tan tana ta tan! Danke schone two, danke schone two',
  },
  baths: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BARNEY',
    firstSaidQuote:
      "Delighted to see you. Delighted to have you with us. Now, you have a complete choice of all our treatments. We have steam baths, beauty treatments, perhaps a massage. You, sir, of course, would like your clothes cleaned. And there's sunlight treatment, moonlight treatment, sparkling and effervescent sprays.",
  },
  suede: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Precisely. Who wants to see their face in a pair of suede shoes? What's this one?",
  },
  macra: {
    count: 16,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MEDOK',
    firstSaidQuote:
      "It's the Macra, Ola! They are real! Ask the Doctor. He'll tell you.",
  },
  gases: {
    count: 14,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'OFFICIA',
    firstSaidQuote:
      'Ah, yes, but here, you see, the rock foundation is a type of salt. Now at depths it generates gases, over the years, and these gases are extremely valuable.',
  },
  screw: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'OFFICIA',
    firstSaidQuote:
      'Now, be careful, Medok. There are other places worse than the Danger Gang, you know. This is a high pressure strike. You are going to need a stronger screw than this.',
  },
  whiff: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: "He's had a wee whiff of the gas.",
  },
  tunic: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'OFFICIA',
    firstSaidQuote: 'My keys. My keys! They were on my tunic.',
  },
  cubic: {
    count: 4,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Ridiculous? Well, that's as may be. But, after all, three times three is nine, and if you divide by half of its own cubic capacity to the formula Pi over four squared, I think you'll have to agree with me.",
  },
  inlet: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'There must be a hidden inlet.',
  },
  draft: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BEN',
    firstSaidQuote:
      "Yeah, I just heard it on the grapevine. They're going to draft us as members of the Colony, and make you the next Pilot.",
  },
  stack: {
    count: 15,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'COMMANDANT',
    firstSaidQuote:
      'A likely story. Tell him to get back into stack and await further instructions.',
  },
  mumbo: {
    count: 16,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Some sort of official mumbo-jumbo. Look! We've just discovered a dead body out there. Did you hear me?",
  },
  jumbo: {
    count: 16,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Some sort of official mumbo-jumbo. Look! We've just discovered a dead body out there. Did you hear me?",
  },
  merge: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's the name of a small animal, a lizard that can change it's colour to merge with it's background. But it's a name that could equally be applied to people as well. People who change their personalities to suit their own ends. Budget Tours. Young people between the ages of eighteen and twenty-five. Oh yes, there's something strange going on here.",
  },
  kiosk: {
    count: 12,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'No, Jamie, I want you to find your way back to the Chameleon kiosk and keep an eye on Polly.',
  },
  brian: {
    count: 33,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'SAMANTHA',
    firstSaidQuote: "It's about my brother, Brian Briggs.",
  },
  frock: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JENKINS',
    firstSaidQuote:
      'One was a scruffy-looking man, medium-height, wearing a frock-coat. the other was a Scots boy dressed in a kilt.',
  },
  swiss: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'SAMANTHA',
    firstSaidQuote:
      'Look, a postcard of Zurich, stamped with a Swiss stamp, all ready to post.',
  },
  atone: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BLADE',
    firstSaidQuote:
      'To atone for your incompetence. The Doctor must die, and you must do it.',
  },
  limit: {
    count: 29,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'COMMANDANT',
    firstSaidQuote:
      'This is the limit. I will not have my control room invaded.',
  },
  epsom: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'HESLINGTON',
    firstSaidQuote:
      "Oh that one, sir. Look, he's turning left at Dunsfold. I shall hold him now over Epsom until I can give him landing clearance.",
  },
  froze: {
    count: 9,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You're right. Well, that's clever. That's very clever. Oh well, makes life simpler for us. Now, the man I froze came from here somewhere.",
  },
  rally: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's a rare tropical disease, Nurse. I'm his doctor. If he if he doesn't rally soon we shall, we shall have to use somnalin.",
  },
  lolly: {
    count: 4,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'SAMANTHA',
    firstSaidQuote:
      "Hey, now you're talking. Do you think you can you raise the lolly?",
  },
  meals: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'PINTO',
    firstSaidQuote:
      "Then no wonder you didn't feel well. Really, Commandant. You must see that your staff have time for regular meals.",
  },
  amber: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'COMMANDANT',
    firstSaidQuote:
      "Oh, good. Hello, old boy. The Chameleon Rome flight's just taken off. They're on Amber one, at flight level 210. Right. Good man.",
  },
  pinto: {
    count: 4,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'That will depend entirely on Nurse Pinto.',
  },
  owing: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BLADE',
    firstSaidQuote:
      'One moment. Owing to the complete success of our operation, living space on our satellite has had to be used for our cargo. Therefore, quarters will be re-allocated. Report to the accommodation centre for instructions.',
  },
  stall: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'COMMANDANT',
    firstSaidQuote: "Right, I'll try and stall them.",
  },
  perry: {
    count: 23,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'PERRY',
    firstSaidQuote: 'Perry, sir.',
  },
  whims: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'WATERFIELD',
    firstSaidQuote:
      'The whims and caprices of our patrons is our line, Mister Perry.',
  },
  dicey: {
    count: 3,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'PERRY',
    firstSaidQuote:
      "No complaints on that score. As long as I'm not asked to do anything dicey.",
  },
  lorry: {
    count: 8,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's between two and three hundred pounds. Yes, it is a lot, at least for what he had to do. Put on a pair of overalls and just hang around. Come to think of it, why hang around? He was obviously planted. Why not just go off in the lorry?",
  },
  rails: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, it's a train. There are carriages and they go on wheels, on rails, and they're drawn by a steam. Hey, come back!",
  },
  bruce: {
    count: 39,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: "Now, don't give up Doctor. Remember Bruce.",
  },
  dazed: {
    count: 5,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'KENNEDY',
    firstSaidQuote:
      "Well, a bit dazed, that's all. He just mumbled something then made a run for it when they weren't looking.",
  },
  keith: {
    count: 42,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'PERRY',
    firstSaidQuote:
      "My name isn't Kenneth, it's Keith. Now look, I don't understand this.",
  },
  agony: {
    count: 20,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, yes, the Tardis. Now, how did he die? His limbs are stiff, his hands clenched. Look, he died in horrible agony. Look at his face. Hello?',
  },
  cigar: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'MAXTIBLE',
    firstSaidQuote:
      'Neither Whitefield nor I were responsible for his death. A cigar?',
  },
  clark: {
    count: 7,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'MAXTIBLE',
    firstSaidQuote:
      'So, you may be standing there, and yet appear to be standing fifty feet away. Well, following the new investigations twelve years ago by J Clark Maxwell into electromagnetism and the experiments by Faraday into static electricity.',
  },
  stark: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: "He's mad. Stark, staring mad.",
  },
  kemel: {
    count: 27,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'MAXTIBLE',
    firstSaidQuote: 'Kemel!',
  },
  quits: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Then we're quits, aren't we?",
  },
  turks: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You'll have to brush up on your history. I can't be around to cover up for you all the time. Now then, in the Crimean War, the English, the French and the Turks fought the Russians.",
  },
  ghost: {
    count: 138,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'JAMIE',
    firstSaidQuote:
      "That was no ghost, Mollie, that's for sure. That was a human voice.",
  },
  edgar: {
    count: 1,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'TERRALL',
    firstSaidQuote: 'You seem to be a devotee of Edgar Allan Poe.',
  },
  allan: {
    count: 4,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'TERRALL',
    firstSaidQuote: 'You seem to be a devotee of Edgar Allan Poe.',
  },
  facet: {
    count: 2,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'MAXTIBLE',
    firstSaidQuote:
      'Then keep your eyes fixed on the jewel. See how the light catches it? Every facet sparkles, does it not?',
  },
  lured: {
    count: 14,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'It was too late when they took away your daughter. It was too late when you stole my Tardus and lured me to this house and this century.',
  },
  omega: {
    count: 123,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'I have given you all names. Alpha, Beta and Omega.',
  },
  wives: {
    count: 6,
    firstSaidSeasonIndex: 4,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'JAMIE',
    firstSaidQuote:
      "Look, it's daft though. Metal into gold's an old wives tale.",
  },
  knobs: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'VICTORIA',
    firstSaidQuote: 'What are all these knobs?',
  },
  viner: {
    count: 14,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PARRY',
    firstSaidQuote:
      "All right. Viner, no need to get excited. Can't you keep your servant under control?",
  },
  telos: {
    count: 31,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PARRY',
    firstSaidQuote:
      'According to the map reference now, that should be the entrance to the city of Telos.',
  },
  klieg: {
    count: 22,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PARRY',
    firstSaidQuote:
      "Of course you have. Mister Klieg, must I remind you again that you do not speak for this expedition? I am it's leader, you and Miss Kaftan are only here on sufferance.",
  },
  neuro: {
    count: 8,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'VINER',
    firstSaidQuote:
      "Yes, that's reasonable. These projectors were probably made to fire in neuro-electric potential. Yes, that's it, I think you're right.",
  },
  meson: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HAYDON',
    firstSaidQuote: 'Alpha-meson phosphor.',
  },
  basis: {
    count: 14,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KLIEG',
    firstSaidQuote:
      'Well, the basis of this code is binary to digital conversion with a intervening step involving a sort of Whitehead logic.',
  },
  basic: {
    count: 92,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You see, if you take any progressive series it can be converted into binary notation. If you take the sum of the integrants, and express the result as a power series, then the indices show the basic binary blocks. Only I wouldn't do it if I were you. Oh no, I really wouldn't do it!",
  },
  wired: {
    count: 30,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's all right. I think. I think it's all right now. Yes. You see, it's just a mock up, a model. No, don't touch that. That gun may be wired up too.",
  },
  roast: {
    count: 13,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KAFTAN',
    firstSaidQuote: 'Roast beef? Roast veal? Chicken?',
  },
  parry: {
    count: 4,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: 'Come on, Mister Parry. Come on, quick! Stand back.',
  },
  cyber: {
    count: 112,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CONTROLLER',
    firstSaidQuote:
      'Release the cyber mats. We will use the power of cybernetics.',
  },
  tying: {
    count: 6,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Jamie, remind me to give you a lesson in tying knots sometime.',
  },
  tibet: {
    count: 17,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, that's it! I knew it, I knew it. It's incredible. Right. Oh no. No, not India. This is Tibet. That's where we are, Tibet. Now, there's no time to be lost. Come along, Jamie, we must find the ghanta.",
  },
  relic: {
    count: 10,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, it's a Tibetan bell, actually. A holy relic. This one is quite small. It has a dragon on it. As a matter of fact, it has rather an interesting history. It was. Oh. Ah ha, yes, I'll have that.",
  },
  scout: {
    count: 34,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, I thought I might. I think I'll go and have a scout around. Now, you two find the bell. It's very important.",
  },
  hairy: {
    count: 12,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: 'A great sort of hairy beastie. Turn the thing back.',
  },
  vague: {
    count: 17,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TRAVERS',
    firstSaidQuote:
      "Yes, but it was dark, remember. All I could see was a vague shape, but I felt its hair. Well it's quite obvious now it's this coat he's wearing.",
  },
  ghana: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THOMNI',
    firstSaidQuote:
      'Ah, that was also a dark period. It was then our holy Ghana was taken from us.',
  },
  sapan: {
    count: 12,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KHRISONG',
    firstSaidQuote:
      'Sapan, I believe that this man is, for some reason, trying to turn the Yeti into savage creatures.',
  },
  kheda: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KHRISONG',
    firstSaidQuote:
      'Rapalchan, watch from the window there. Kheda, you, the other window. Any attempt to rescue you will now be highly dangerous for you.',
  },
  lamas: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TRAVERS',
    firstSaidQuote:
      "Oh yes, he's quite all right. So, you're going to the monastery, are you? Good. I think you'll find those lamas have quite a welcome waiting for you.",
  },
  pletu: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KHRISONG',
    firstSaidQuote:
      'Ralpachan, stand watch at the walls. Pletu, I want two men either side of this base. Thomni, come with me.',
  },
  daffy: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: "Do you not realise the man's a wee bit daffy?",
  },
  shiny: {
    count: 10,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VICTORIA',
    firstSaidQuote: "It's a shiny round thing.",
  },
  focus: {
    count: 82,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'PADMASAMBHAVA',
    firstSaidQuote:
      'Take this pyramid I have prepared. Take it to the caves. Then the Great Intelligence will focus upon this planet. Soon it will begin to grow and at last take on physical form. At last its wanderings in space will be at an end. My work will then be done. Go now, Songsten. Do as I have asked.',
  },
  padma: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VICTORIA',
    firstSaidQuote:
      "Me? I just don't like mysteries. Your Master, for instance, Padma.",
  },
  yetis: {
    count: 7,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, I'm all right. Just a bit puffed, that's all. Jamie, these things are programmed to return to their Yetis. That one that disappeared in the monastery. That wasn't taken.",
  },
  frail: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'PADMASAMBHAVA',
    firstSaidQuote:
      'Oh, Intelligence. You promised to release me, yet still I feel your grasp upon this frail body. Why? What is happening? This was not your plan. But if you continue to expand? I have brought the world to its end.',
  },
  lotus: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Thomni, you'd better teach her the Jewel of the Lotus prayer. It'll give her something to concentrate on.",
  },
  padme: {
    count: 17,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Victoria, Victoria, I can't hold him. The models. Knock over the models! No, Victoria, don't let him. Jewel of the Lotus. Om mane padme hum. Om mane padme hum.",
  },
  phase: {
    count: 137,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ANNOUNCER',
    firstSaidQuote:
      'This is a preliminary warning. Preliminary warning. Prepare phase one base evacuation procedure. Phase one evacuation.',
  },
  clent: {
    count: 44,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GARRETT',
    firstSaidQuote: 'Yes, Leader Clent.',
  },
  arden: {
    count: 48,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CLENT',
    firstSaidQuote:
      "I've had enough of experts and their crazy ideas. Where's Arden?",
  },
  davis: {
    count: 14,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WALTERS',
    firstSaidQuote: 'Sir. Get your drill ready, Davis. Sir!',
  },
  video: {
    count: 60,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GARRETT',
    firstSaidQuote: 'Leader Clent, the video! Arden has made contact.',
  },
  nippy: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ARDEN',
    firstSaidQuote: 'Yes. Cold weather ahead. I thought it felt a bit nippy.',
  },
  vibro: {
    count: 6,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GARRETT',
    firstSaidQuote: 'The vibro-chair.',
  },
  storr: {
    count: 17,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'PENLEY',
    firstSaidQuote: 'Storr, are you alright?',
  },
  valid: {
    count: 13,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CLENT',
    firstSaidQuote: "But you've no valid proof of your qualifications?",
  },
  surge: {
    count: 33,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CLENT',
    firstSaidQuote:
      'How would you halt the ice surge and turn the climate back to normal? Forty five seconds starting from now.',
  },
  label: {
    count: 7,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I've been looking everywhere. Why don't you label your doors?",
  },
  fuzzy: {
    count: 8,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'PENLEY',
    firstSaidQuote:
      "What I like about you is if a polar bear got you you'd give him indigestion. Feeling fuzzy in the head, eh?",
  },
  ripen: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'STORR',
    firstSaidQuote:
      "Ach, you shouldnae have done that. I've been waiting weeks for that to ripen properly.",
  },
  elric: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'PENLEY',
    firstSaidQuote:
      "Twenty four hours and you'll be your old animal-like self again. And while you're undergoing repairs, Storr, old chap, I'm going to do a bit of hunting myself, up on the glacier. Something strange is happening, Elric Penley, honoured sir. That warrior, that girl, that funny, scruffy looking chap. Something strange indeed. Something disturbing. Something to do with the ice. And if what that particular chap has said is true, if they really need me, it may mean the parting of the ways for us.",
  },
  tread: {
    count: 16,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ARDEN',
    firstSaidQuote:
      "Now we don't know how many of them there are, so we'll have to tread carefully.",
  },
  smirk: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'STORR',
    firstSaidQuote:
      "Science! Och, it wasn't science, it was just good plain doctoring. And if you smirk again like that, I'll crack your head open with this.",
  },
  stove: {
    count: 4,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'PENLEY',
    firstSaidQuote:
      "Save the world? Well, that has a fine Clentian ring to it. No thanks, no. It'll take more than me to do that. But don't you worry, you don't get rid of my sort all that easily. Machines corrode and rust, but mankind goes on. You'll find Clent one of these days in a museum, like that ancient stove, with an inscription round him. Robotised human mark two, now extinct. But you'll find others like me still alive.",
  },
  toxic: {
    count: 45,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CLENT',
    firstSaidQuote:
      'What? You mean you intend to use it as a kind of toxic gas?',
  },
  links: {
    count: 25,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CLENT',
    firstSaidQuote:
      'No, our video links are the only communicators available. Pure sound is no longer in use.',
  },
  turoc: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ZONDAL',
    firstSaidQuote: 'Turoc has not yet returned.',
  },
  freed: {
    count: 10,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VARGA',
    firstSaidQuote:
      'If what you say is true, why have you not freed us before?',
  },
  bough: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'PENLEY',
    firstSaidQuote:
      "You're caught on a bough or something. Well, it's not much farther now, lad.",
  },
  grind: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CLENT',
    firstSaidQuote:
      'It is no decision. The computer is playing for time. Now listen, all of you! We risk destruction either by a radioactive explosion or by the slow grind of the glaciers. Now there you see that the ice has advanced one hundred metres today. Now either way',
  },
  isbur: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VARGA',
    firstSaidQuote:
      'Isbur and Rintan, wait for me at the entrance to the cave. Zondal, you will man the sonic gun.',
  },
  anton: {
    count: 4,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ANTON',
    firstSaidQuote: 'This is Anton.',
  },
  giles: {
    count: 30,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ASTRID',
    firstSaidQuote: "Well, if you're that definite, I'll contact Giles.",
  },
  zones: {
    count: 42,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KENT',
    firstSaidQuote:
      "I'm not surprised. I'll show you why. I have a video wire of Salamander addressing the United Zones Conference on World Food.",
  },
  grain: {
    count: 8,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SALAMANDER',
    firstSaidQuote:
      "The progress, Mister President, of the Sun Conservation establishment at Kanowa, in the Australasian Zone, is, I'm delighted to report, highly satisfactory. But we cannot yet guarantee good summer holidays for all. However, we have now in orbit the Mark Seven Sun Catcher, and already we have been able to concentrate the sun's rays into much needed areas. The great Canadian wheat plains are safe. And now, Mister President, Ukraine, the grain field of the planet, that unfortunate area between Bucava and Kirovograd devastated by the elements two short years ago. What have I to say to you about that? I can tell you that on both banks of the Dnieper River the corn is ripening in the sun! And ten-thousand robot harvesters are moving down to gather in fifty million tons of flour!",
  },
  denes: {
    count: 30,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KENT',
    firstSaidQuote:
      "Oh, yes. Elvick believed me. So did Assevski. And they're dead. However there is one other man, a man named Alexander Denes, but none of them will do anything until it's too late.",
  },
  cedar: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BRUCE',
    firstSaidQuote:
      "That's better. You're ex-security, you know the way it's got to go. We might as well be nice and civil about it, mightn't we? That bungalow in Cedar District. In your name, right?",
  },
  visas: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KENT',
    firstSaidQuote:
      'I can arrange three travel warrants and visas. Everything you need.',
  },
  benik: {
    count: 14,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BRUCE',
    firstSaidQuote: 'This is important, Benik.',
  },
  ariel: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BENIK',
    firstSaidQuote:
      "I want a direct channel link to Leader Salamander, Ariel TLXKZ. Notify me as soon as he is able to accept transmission. That's all.",
  },
  tlxkz: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BENIK',
    firstSaidQuote:
      "I want a direct channel link to Leader Salamander, Ariel TLXKZ. Notify me as soon as he is able to accept transmission. That's all.",
  },
  brujo: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'FARIAH',
    firstSaidQuote: 'Brujo.',
  },
  skirt: {
    count: 6,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SALAMANDER',
    firstSaidQuote:
      'What a boy, huh? Fariah, see he gets some proper uniform instead of this skirt. And bring him and his girlfriend to see me.',
  },
  tokaj: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SALAMANDER',
    firstSaidQuote: 'The entire Eperjes-Tokaj ranges are in eruption.',
  },
  lemon: {
    count: 12,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'VICTORIA',
    firstSaidQuote:
      'Er, er. Oh, yes! Yes! We used to have a lovely pudding at home, with lots of almonds, eggs, lemon peel, candied peel, oranges, cream and, oh it was lovely!',
  },
  cream: {
    count: 19,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'VICTORIA',
    firstSaidQuote:
      'Er, er. Oh, yes! Yes! We used to have a lovely pudding at home, with lots of almonds, eggs, lemon peel, candied peel, oranges, cream and, oh it was lovely!',
  },
  spuds: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GRIFFIN',
    firstSaidQuote:
      "Oh that's great, just great. Yes, I've got a job for you, all right. Peel those spuds, yeah, now.",
  },
  ovens: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GRIFFIN',
    firstSaidQuote:
      'Back at school, are we? Well, I suppose there are worse things. The place could be overrun with rats gnawing holes in the gas pipes so the ovens catch fire and burn the building down.',
  },
  griff: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'FARIAH',
    firstSaidQuote: "It isn't that bad, Griff.",
  },
  menus: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GRIFFIN',
    firstSaidQuote:
      "Well sit down and write out the menus. First course interrupted by bomb explosion. Second course affected by earthquakes. Third course ruined by interference in the kitchen. I'm going out for a walk. It'll probably rain.",
  },
  janos: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JANOS',
    firstSaidQuote:
      'Wait! You like wine? My name is Janos. We drink wine together tonight?',
  },
  spoon: {
    count: 7,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'FARIAH',
    firstSaidQuote: 'Try the spoon, Mister Denes.',
  },
  shots: {
    count: 20,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CAPTAIN',
    firstSaidQuote:
      "Three shots have been fired from this gun. It's yours, isn't it?",
  },
  ducts: {
    count: 12,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BENIK',
    firstSaidQuote:
      "The air ducts. They've disappeared through the air conditioning plant. Is there a manhole exit from the plant to the street?",
  },
  swann: {
    count: 22,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MARY',
    firstSaidQuote: "Do you think Salamander's found some more food, Swann?",
  },
  liner: {
    count: 20,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SWANN',
    firstSaidQuote:
      "Holiday Liner Sinks! You say there's a global war, radiation everywhere. How can there be holiday liners? Tell me how! You've lied to us, haven't you? Haven't you!",
  },
  sinks: {
    count: 5,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SWANN',
    firstSaidQuote:
      "Holiday Liner Sinks! You say there's a global war, radiation everywhere. How can there be holiday liners? Tell me how! You've lied to us, haven't you? Haven't you!",
  },
  puppy: {
    count: 7,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SALAMANDER',
    firstSaidQuote:
      'Very well. Bruce and I will take over. You may go. And er, take your little puppy dog with you, hmm?',
  },
  shred: {
    count: 6,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BRUCE',
    firstSaidQuote:
      'Now wait a moment. Are you seriously trying to tell me without a shred of evidence that Salamander is attacking the world with natural disasters?',
  },
  mined: {
    count: 8,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KENT',
    firstSaidQuote:
      'Now wait a minute. The place is mined, we know that. We planned it for years, together. Between us we can destroy them all, and the evidence. Just you and me, Salamander.',
  },
  lurch: {
    count: 4,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "All right, but watch the Tardis doesn't lurch again.",
  },
  tiled: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, it seems to be a large room. Tiled walls, curved ceiling. Come on.',
  },
  weams: {
    count: 14,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ARNOLD',
    firstSaidQuote: " Getting a bit jumpy, aren't you, Weams?",
  },
  brien: {
    count: 13,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'KNIGHT',
    firstSaidQuote: "Take O'Brien and a couple of the others.",
  },
  innit: {
    count: 31,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BLAKE',
    firstSaidQuote: "It's obvious, innit? It's been got at.",
  },
  barge: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'CHORLEY',
    firstSaidQuote:
      "Ah, sorry to barge in. Left my typewriter in here, and I want to knock up a quick piece about this mysterious Doctor chap. Hey, a bit of a turn-up for the book, wasn't it? Any theories?",
  },
  chump: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'WEAMS',
    firstSaidQuote:
      "Well, he's off his chump, ain't he? How'd they get here in the first place?",
  },
  berwi: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'EVANS',
    firstSaidQuote:
      " Sosban fach yn berwi ar y tân, Sosban fawr yn berwi ar y llawr, A'r gath wedi",
  },
  llawr: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'EVANS',
    firstSaidQuote:
      " Sosban fach yn berwi ar y tân, Sosban fawr yn berwi ar y llawr, A'r gath wedi",
  },
  pauls: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: 'Saint Pauls.',
  },
  homed: {
    count: 5,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes. Well presumably, once the sphere started working, the Intelligence just homed in on it.',
  },
  skive: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ARNOLD',
    firstSaidQuote:
      "Yes, you. And when we get in the tunnels, don't you try to skive off, cus if you do I'll have you for breakfast. Do you understand?",
  },
  mesen: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ARNOLD',
    firstSaidQuote:
      "I reckon we shall be all right in these. Oh, all right, Lane. I'll go by mesen.",
  },
  potty: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'EVANS',
    firstSaidQuote: "You're potty, the pair of you.",
  },
  harms: {
    count: 4,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The Intelligence knows that if it harms her, I won't cooperate.",
  },
  megan: {
    count: 14,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ROBSON',
    firstSaidQuote:
      "I didn't ask you to come here. It was Megan Jones and those fools on the board. I said it wouldn't work and it never has.",
  },
  seals: {
    count: 27,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CHIEF',
    firstSaidQuote: "Mister Robson? They're empty. The seals are broken.",
  },
  stung: {
    count: 5,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HARRIS',
    firstSaidQuote: 'You said you were stung or something.',
  },
  wales: {
    count: 14,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PRICE',
    firstSaidQuote: 'And the whole of Wales.',
  },
  quill: {
    count: 4,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'OAK',
    firstSaidQuote:
      'Thank you. My name is Mister Oak and this is my colleague, Mister Quill.',
  },
  geluk: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'VAN LUTYENS',
    firstSaidQuote:
      "Dank uw geluk. I wouldn't have thought you could possibly have done it in the time.",
  },
  hague: {
    count: 4,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ROBSON',
    firstSaidQuote:
      "When you have too much gas in the tube, you release it. Didn't they teach you that much back at evening classes in the Hague, Mister Van Lutyens? Contact Chief Baxter, Control Rig, will you? Tell him the immediate crisis is over. Oh, and contact the other rig chiefs.",
  },
  cabin: {
    count: 57,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'VAN LUTYENS',
    firstSaidQuote: "He's in his cabin.",
  },
  rusty: {
    count: 32,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'You see this rusty stuff here.',
  },
  dwaas: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'VAN LUTYENS',
    firstSaidQuote: "Dwaas. He's cracking up, Harris.",
  },
  vents: {
    count: 21,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HARRIS',
    firstSaidQuote:
      'And order all areas to keep their emergency air vents closed. Understand?',
  },
  spice: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Well, Victoria, it's the spice of life, my dear.",
  },
  feeds: {
    count: 38,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'VICTORIA',
    firstSaidQuote:
      "Yes, but will he? There's so many questions. The weed grows. Feeds off natural gas. But how fast does it grow? What happens to those that touch it? Oh, Jamie. Jamie, I'm frightened!",
  },
  bores: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HARRIS',
    firstSaidQuote:
      'No, no. Anything that comes up through the bores would be cleared by the engineers at the source otherwise it would block the pumps.',
  },
  pedal: {
    count: 3,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PILOT',
    firstSaidQuote:
      'Stick back. Stick back. Nose down a bit. Go on. Right pedal down. Right rudder.',
  },
  dimen: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: 'Well all right, stick your rod dimen',
  },
  float: {
    count: 12,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'JAMIE',
    firstSaidQuote:
      "Aye, stick it back in, and we'll float off somewhere else.",
  },
  salad: {
    count: 9,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'And cabbage. What about a drop of fruit salad?',
  },
  gravy: {
    count: 9,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'There we are. what about the gravy?',
  },
  tanya: {
    count: 22,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'RYAN',
    firstSaidQuote: "Triangulate it, Rico. How's it now. Tanya?",
  },
  gemma: {
    count: 33,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BENNETT',
    firstSaidQuote:
      "It doesn't matter, Gemma, it really doesn't. Don't start looking for mysteries. Now I can't risk that rocket homing on this station.",
  },
  chang: {
    count: 50,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'RYAN',
    firstSaidQuote:
      "Jarvis won't like that. What that on green system three, Chang?",
  },
  flora: {
    count: 16,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ZOE',
    firstSaidQuote:
      'Oh, this is going to be fun. I shall learn a lot from you. Come on, James Robert McCrimmon. Do you know anything about interstellar flora?',
  },
  faked: {
    count: 16,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BENNETT',
    firstSaidQuote: 'On the evidence of one faked-up X-ray shot.',
  },
  crate: {
    count: 17,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VALLANCE',
    firstSaidQuote:
      'We found a whole crate of Bernalium on the rocket. Bringing it over with us. Approval please, Control.',
  },
  fauna: {
    count: 5,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CORWYN',
    firstSaidQuote:
      'Of course not, Bill. After all, you discovered space flora out here. When you found the Cybermat you obviously thought that it was space fauna.',
  },
  snack: {
    count: 8,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'FLANNIGAN',
    firstSaidQuote:
      "Well, if it's all the same with you, sir, we'll just grab a snack and be back in five minutes.",
  },
  shove: {
    count: 11,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'DUGGAN',
    firstSaidQuote: 'Oh, go and shove off, Leo. Chang and I can handle this.',
  },
  freak: {
    count: 50,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ZOE',
    firstSaidQuote:
      "Oh, but I do. I don't want to be thought of as a freak. Leo said I was like a robot, a machine. I think he's right. My head's been pumped full of facts and figures which I reel out automatically when needed, but, well, I want to feel things as well.",
  },
  tends: {
    count: 8,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CORWYN',
    firstSaidQuote:
      'Good. Unfortunately the parapsychology unit at the City tends to ignore this aspect in its pupils. Some of them never fully develop their human emotions.',
  },
  kaput: {
    count: 9,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CASALI',
    firstSaidQuote: "Radar's fine but the radio's kaput.",
  },
  manly: {
    count: 2,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'FLANNIGAN',
    firstSaidQuote:
      'You need a few lessons in the noble and manly arts, me bucko! All right, come on!',
  },
  bucko: {
    count: 1,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'FLANNIGAN',
    firstSaidQuote:
      'You need a few lessons in the noble and manly arts, me bucko! All right, come on!',
  },
  ozone: {
    count: 8,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CYBERMAN',
    firstSaidQuote:
      'Insert one capsule into each section. The oxygen will turn into pure ozone. The humans will die.',
  },
  swarm: {
    count: 42,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CASALI',
    firstSaidQuote:
      'Here comes another swarm. Meteor bearing forty five, thirty six.',
  },
  stare: {
    count: 16,
    firstSaidSeasonIndex: 5,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CYBERMAN',
    firstSaidQuote:
      'Stare into the box. Think of each individual human being at present on the Wheel. Form the image in your eyes.',
  },
  cully: {
    count: 68,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'WAHED',
    firstSaidQuote:
      "You're being melodramatic again, Cully, as usual. You know perfectly well there's a permanent survey unit there to monitor the radiation.",
  },
  wahed: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ETNIN',
    firstSaidQuote: 'Wahed! Over the hill. People.',
  },
  etnin: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'WAHED',
    firstSaidQuote:
      "A work party most probably. Come on Etnin, let's go and seek their assistance in getting us off this dreary island which Cully has so carelessly marooned us on.",
  },
  domin: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'TOBA',
    firstSaidQuote:
      'Quarks. You will set up the drilling site in accordance with the instructions of Domin',
  },
  balan: {
    count: 20,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KANDO',
    firstSaidQuote: " I don't know, Educator Balan.",
  },
  kando: {
    count: 6,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BALAN',
    firstSaidQuote:
      "Oh, come now, Kando. I've taught you how to read a radiation meter. But this is registering negative. Are you sure you've switched it on?",
  },
  malos: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KANDO',
    firstSaidQuote:
      'The Seventh Council under Director Malos initiated research which led to the development of atomic energy. The dest',
  },
  senex: {
    count: 10,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CULLY',
    firstSaidQuote:
      "My father? The great Senex, leader of the Dulcians? He's as bad as the rest of you. Vegetables, the lot of you. You don't live, you exist.",
  },
  arick: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'COUNCILLOR 1',
    firstSaidQuote:
      "Oh I'm sure the Director will approve our decision. After all, he considers the Caves of Arick",
  },
  bovem: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CULLY',
    firstSaidQuote:
      "If you think that I'm going to stay out there for hours on end kicking my heels, you're very much mistaken, Bovem!",
  },
  quark: {
    count: 49,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'RAGO',
    firstSaidQuote:
      'And send a Quark back to the unit. Should any more arrive, I want them alive.',
  },
  steer: {
    count: 19,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, there we are, yes. Yes, I think I've done it. Now then, hold on and I'm going to try and steer this thing.",
  },
  tensa: {
    count: 7,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SENEX',
    firstSaidQuote:
      'Chairman Tensa? Yes, he is able, but can he deal with this crisis?',
  },
  unfit: {
    count: 9,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'TOBA',
    firstSaidQuote:
      'It is not unknown for a leader who is unfit to be replaced.',
  },
  seats: {
    count: 23,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well actually, now I come to think of it, if you were to take out one of the seats, a Quark might fit inside.',
  },
  magma: {
    count: 6,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "But perhaps that's why they've chosen this place! The magma, the molten core of the planet, could that be radioactive?",
  },
  warns: {
    count: 3,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JAMIE',
    firstSaidQuote:
      "There's a wee gadget on here somewhere that warns you to go elsewhere if there's any danger. No, no it's definitely switched off. We've landed.",
  },
  misty: {
    count: 5,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JAMIE',
    firstSaidQuote:
      'No! It was definitely Scotland. Zoe thought she saw something else, her. home city or something, but no, it was very misty and she couldnae have seen right.',
  },
  degul: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GULLIVER',
    firstSaidQuote: 'Heckinah degul.',
  },
  tolgo: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GULLIVER',
    firstSaidQuote: 'Tolgo fonac.',
  },
  fonac: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GULLIVER',
    firstSaidQuote: 'Tolgo fonac.',
  },
  dehul: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GULLIVER',
    firstSaidQuote: 'Langro dehul san? Grildig? Splacknuck?',
  },
  tutis: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GULLIVER',
    firstSaidQuote: 'Recalsitrat undique tutis! Glandack daytan!',
  },
  latin: {
    count: 22,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GULLIVER',
    firstSaidQuote:
      'I spoke in as many languages as I have the least smattering of. High and low Dutch, Latin.',
  },
  moses: {
    count: 5,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DICKY',
    firstSaidQuote: 'Where was Moses when the lights went out?',
  },
  swift: {
    count: 29,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, he can only speak the words that Dean Swift gave him to say.',
  },
  meats: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KARKUS',
    firstSaidQuote: 'You will be minced meats.',
  },
  lodge: {
    count: 15,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GULLIVER',
    firstSaidQuote:
      'If you would take my advice, swear a peace with the Master and his kingdom. Find yourselves a place to lodge, stay quietly with the expectation that things would mend.',
  },
  renew: {
    count: 4,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      'Attention. There are still strangers at large. Renew the search. The strangers must be found.',
  },
  awoke: {
    count: 5,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      "I left England in the summer of nineteen twenty six. It was a very hot day, I remember. I think I must have dozed off over my desk, and when I awoke. Oh, but that' a long story. Did you ever hear of the Adventures of Captain Jack Harkaway?",
  },
  naafi: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'TRACY',
    firstSaidQuote: 'NAAFI break, sir?',
  },
  patty: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Oh thank you, and a patty cake biscuit. Thank you.',
  },
  algol: {
    count: 3,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ZOE',
    firstSaidQuote: "Can't I? A little problem in ALGOL, I think.",
  },
  cushy: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "This is Gordon Jones, lecturer in physics, Churchill College, Cambridge. Next one's a chap I knew at Sandhurst, old Billy Rutlidge. He's got himself a very cushy number at the Ministry of Defence.",
  },
  tunes: {
    count: 7,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: "Aye, but doesn't play tunes like mine.",
  },
  flush: {
    count: 8,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VAUGHN',
    firstSaidQuote:
      "No, Packer. We don't want to frighten them off, do we? Just close off the area and we'll flush them out. Have you dealt with the two young ladies yet?",
  },
  sprat: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VAUGHN',
    firstSaidQuote:
      'How fortunate. We need a sprat to catch our mackerel. Take them down to the warehouse area.',
  },
  tracy: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BENTON',
    firstSaidQuote:
      'Some time ago, sir. Tracy followed them as far as the official boundaries of the railway sidings. They went in about an hour ago.',
  },
  niece: {
    count: 4,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VAUGHN',
    firstSaidQuote:
      "Oh I think you will, Professor. Much as I detest violence, I find it difficult to restrain Packer's er, indisputable talent for persuasion. Your niece is in our custody, and unless you do as I ask, I shall hand her over to Packer. The choice is yours.",
  },
  spied: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ZOE',
    firstSaidQuote:
      "Just try and act as though nothing has happened. Don't look now, but we're being spied on.",
  },
  gauze: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: 'Aye, it was wrapped up in that gauze stuff.',
  },
  canoe: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Brigadier, you don't, by any chance, know where I can find a canoe?",
  },
  fakes: {
    count: 9,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "Nothing. They're very good. I don't want to hurt your professional pride, Miss Watkins, but they do look a little like fakes.",
  },
  wilco: {
    count: 13,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WALTERS',
    firstSaidQuote: 'Wilco. Over.',
  },
  downs: {
    count: 5,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "Right. There's a base near Henlow Downs. Just a minute. Sergeant Walters?",
  },
  yells: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "If he yells for help while I'm away, send in everything we've got to get him out.",
  },
  theta: {
    count: 7,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRANWELL',
    firstSaidQuote: 'Run co-ordinates programme A theta.',
  },
  hover: {
    count: 4,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote: "Yes, hover above them. It'll give us a bearing.",
  },
  roofs: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VAUGHN',
    firstSaidQuote: "Right. Up there. We'll go over the roofs.",
  },
  grade: {
    count: 28,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SELRIS',
    firstSaidQuote:
      'Class three one nine six in the first grade. The names of the first selected candidates are, male, Abu-Gond! The second name is female. Vana-Gond!',
  },
  eelek: {
    count: 22,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SELRIS',
    firstSaidQuote:
      'Abu-Gond and Vana-Gond, alone of your generation you have been chosen to receive the highest honour that can befall a Gond. You are now the companions of the Krotons! Our warmest, our most sincere congratulations to you both. You will now step forward for the investiture of your robes of honour. Eelek.',
  },
  thara: {
    count: 23,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'VANA',
    firstSaidQuote: 'Please, Thara!',
  },
  pwoar: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: "Pwoar, bad eggs. Let's try somewhere else.",
  },
  gonds: {
    count: 18,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'AXUS',
    firstSaidQuote:
      "They're not Gonds! Their clothes, the way they're dressed.",
  },
  soups: {
    count: 3,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, life is supposed to have begun on your planet in the sea. Primeval soup, someone once called it. Well, there are lots of sorts of soups, aren't there? I wonder what this sort is?",
  },
  biped: {
    count: 3,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KROTON',
    firstSaidQuote:
      'There has not been time. It is a similar biped animal, but not from this planet. It is possible that these higher anthropoids have take over the planet.',
  },
  ileal: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KROTON',
    firstSaidQuote: 'Ileal power stat is?',
  },
  tokyo: {
    count: 11,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote:
      'Bombay Tokyo shipment activated. Bombay sending now. Tokyo receiving now. Dispatch completed. New York to Moscow delayed. Moonbase clearance awaited. Stockholm Washington personnel transportation. Stockholm sending now. Washington receiving now. Dispatch completed. Non-arrival shipment of synthetic protein New York to Moscow. Moonbase clearance awaited.',
  },
  brent: {
    count: 10,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'KELLY',
    firstSaidQuote: 'Brent?',
  },
  kelly: {
    count: 39,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BRENT',
    firstSaidQuote: 'Yes, Miss Kelly?',
  },
  funds: {
    count: 12,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ELDRED',
    firstSaidQuote:
      'Yes, but you happened to know which career was going to be financed by government funds.',
  },
  locke: {
    count: 4,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RADNOR',
    firstSaidQuote: 'Locke! Locke!',
  },
  expel: {
    count: 6,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RADNOR',
    firstSaidQuote: 'Switch the air conditioning to expel.',
  },
  parks: {
    count: 31,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote:
      'Information coming in on appearance of vegetable blight now attacking parks and gardens in the metropolises. Many areas',
  },
  fungi: {
    count: 4,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote:
      'Unidentified menace. Foam appears to be byproduct of large fungi which grow and burst, spreading their spores over large areas. Rate of growth of fungi such that acres of ground are covered minutes. Estimated that strong south westerly winds could spread this disease over large areas of Europe and Asia.',
  },
  acres: {
    count: 3,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote:
      'Unidentified menace. Foam appears to be byproduct of large fungi which grow and burst, spreading their spores over large areas. Rate of growth of fungi such that acres of ground are covered minutes. Estimated that strong south westerly winds could spread this disease over large areas of Europe and Asia.',
  },
  grill: {
    count: 7,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ZOE',
    firstSaidQuote: 'How big is this grill?',
  },
  twixt: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "There's many a slip 'twixt the cup and the lip.",
  },
  slaar: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MARSHALL',
    firstSaidQuote:
      "Slaar! We are passing between Earth and moon! The signal has not led us into the moon's gravitational field!",
  },
  sarum: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HERMACK',
    firstSaidQuote:
      "Attention all personnel. This is General Hermack. Your V-ship is now fifty days and many billions of miles out from Earth. You're entering the fourth sector of our galaxy. In this sector for some time now, Earth Government has been aware that a highly organised gang of criminals have been roaming the space ways, and preying upon defenceless cargo ships. The main target of these criminals is argonite, the most valuable mineral known to man and so far only found on the planets of the Fourth Sector. A government space beacon marking the approaches to the planet New Sarum has ceased transmitting its navigation signal. These beacons, as you know, are constructed of argonite. It is my belief that the criminals are attacking the government navigation beacons and plundering the argonite. There can be no other explanation for its failure. This being the case, I have decided to abandon our present mission and to investigate the missing beacon in the New Sarum sector. I want all section commanders on the bridge at twenty hundred hours sector four solar time. Resume normal duties until then.",
  },
  pliny: {
    count: 4,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HERMACK',
    firstSaidQuote:
      "Ah! With our speed, I think we can cut those odds a bit. Now, there are four beacons in the Pliny solar system here. That is where we'll start our patrol.",
  },
  caven: {
    count: 41,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DERVISH',
    firstSaidQuote: "Caven, I don't like this.",
  },
  warne: {
    count: 11,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PENN',
    firstSaidQuote: 'Major Warne.',
  },
  sorba: {
    count: 6,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WARNE',
    firstSaidQuote:
      "I told Lieutenant Sorba we'd be back in about six weeks. sir.",
  },
  nutty: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MILO',
    firstSaidQuote:
      'The last of me nutty sliced bread. Rubbishy new-fangled solar toasters!',
  },
  breed: {
    count: 25,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HERMACK',
    firstSaidQuote:
      "Well, these old mining prospectors like Clancey were the first men to go out into deep space. For a time they had the place to themselves, roaming the spaceways, looking for planets, jumping each other's claims. They were a wild breed, Ian, and they learned to live without the law.",
  },
  sonny: {
    count: 13,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MILO',
    firstSaidQuote:
      "I didn't realise that, sonny, no. Oh dear, oh dear, oh dear. There are so many offences these days.",
  },
  darts: {
    count: 5,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MILO',
    firstSaidQuote:
      "Oh, that may be, sonny, but this marauding band of sharks, you know they're using Beta Darts, one of the latest. You're in the wrong league, boys. Why don't you just go home where you came from.",
  },
  sonar: {
    count: 8,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WARNE',
    firstSaidQuote: 'No, sir. My radar and sonar screens are out of action.',
  },
  brace: {
    count: 16,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MILO',
    firstSaidQuote:
      "Yeah, that's right, argonite. One of the richest strikes we ever found. Took us about ten years to drill that clean. Well, I'd better try to find this old entry shaft then. Now, you'd better brace yourselves. Hang onto something. My landing pad's ain't as good as they used to be.",
  },
  keyed: {
    count: 11,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CAVEN',
    firstSaidQuote:
      "I'm not playing at all. It is a detonator, and it is keyed to a charge right under the atomic drives of the Buccaneer.",
  },
  safes: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, they were used on safes, Jamie. Combination locks became a little too easy to open when burglars took to taking miniature computers with them on their expeditions. Now I have my tuning forks here somewhere.',
  },
  forks: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, they were used on safes, Jamie. Combination locks became a little too easy to open when burglars took to taking miniature computers with them on their expeditions. Now I have my tuning forks here somewhere.',
  },
  chunk: {
    count: 4,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WARNE',
    firstSaidQuote: "Right, sir. I'll bring back a chunk of her.",
  },
  tuner: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CAVEN',
    firstSaidQuote: "Here's the audio-lock tuner key.",
  },
  abort: {
    count: 32,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HERMACK',
    firstSaidQuote:
      "I don't know. Anyway, we'll abort the mission. You'd better return.",
  },
  fiend: {
    count: 5,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MILO',
    firstSaidQuote:
      "Mean to say that you don't know of this fiend Caven? You don't know what kind of villain he is?",
  },
  fraze: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CAVEN',
    firstSaidQuote:
      "I told Fraze to lock them away under the dock complex. Ask him if you don't believe me.",
  },
  wedge: {
    count: 5,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MILO',
    firstSaidQuote:
      'Because he wanted to drive a wedge between Madeleine and me. He wanted to take over the company.',
  },
  hinge: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DOM',
    firstSaidQuote:
      "Leads out to the passage outside. And that steel is three inches thick. I tell you it's hopeless. I spent my first year down here working on that hinge. You can see it's hardly marked.",
  },
  shirt: {
    count: 22,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DOM',
    firstSaidQuote: 'An old shirt and an old aeronautical journal.',
  },
  salvo: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WARNE',
    firstSaidQuote:
      'I could creep the Minnow in, sir, and get a salvo in before they knew what had happened.',
  },
  ypres: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'BUCKINGHAM',
    firstSaidQuote:
      "Between the lines, I think. Not quite sure myself. I'm heading for Ypres, but I seem to have got",
  },
  carts: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'REDCOAT',
    firstSaidQuote:
      "Well, there were these great big guns, bigger than I'd ever seen before, and carts moving along without horses.",
  },
  hoots: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'GORTON',
    firstSaidQuote:
      "I don't care two hoots about the Minister. Besides, I'm not even sure you're from the War Office. Yes, where are your identity papers?",
  },
  fishy: {
    count: 8,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'GORTON',
    firstSaidQuote:
      'I thought so. I thought there was a fishy story all along. Hello, is that',
  },
  shave: {
    count: 3,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ZOE',
    firstSaidQuote: 'That was a close shave. Where are we, Doctor?',
  },
  mills: {
    count: 4,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CARSTAIRS',
    firstSaidQuote:
      "It's a Mills bomb. It's all I could find. I thought we might hang it on the front of the safe and let it off.",
  },
  lucke: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VON WEICH',
    firstSaidQuote: 'Leutnant LUcke!',
  },
  diese: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VON WEICH',
    firstSaidQuote: 'Wer sind diese Leute?',
  },
  leute: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VON WEICH',
    firstSaidQuote: 'Wer sind diese Leute?',
  },
  haben: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LUCKE',
    firstSaidQuote: 'Wir haben hier',
  },
  kapit: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LUCKE',
    firstSaidQuote: 'Wir haben hier drei Englische zivilisten, herr KapitÃ¤n.',
  },
  einem: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LUCKE',
    firstSaidQuote:
      'Er hat mir gesagt, dass er aus einem anderen Zeitalter kam, in annen rontschiff namen Tardis.',
  },
  annen: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LUCKE',
    firstSaidQuote:
      'Er hat mir gesagt, dass er aus einem anderen Zeitalter kam, in annen rontschiff namen Tardis.',
  },
  namen: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LUCKE',
    firstSaidQuote:
      'Er hat mir gesagt, dass er aus einem anderen Zeitalter kam, in annen rontschiff namen Tardis.',
  },
  bitte: {
    count: 2,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VON WEICH',
    firstSaidQuote: 'Leutnant LUcke! Kommen sie bitte mit mir.',
  },
  werde: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VON WEICH',
    firstSaidQuote:
      'Es sind Englische spione! Wir mUssen sie festhalten! Ich werde mit dem General darUber sprechen.',
  },
  weich: {
    count: 3,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LUCKE',
    firstSaidQuote: 'Jawohl herr KapitÃ¤n Von Weich.',
  },
  nests: {
    count: 3,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VON WEICH',
    firstSaidQuote:
      "Along here we shall have pillboxes, machine gun nests, landmines. You'll have no chance, but it will be an excellent test of the morale of your humans. Your entire force will be wiped out.",
  },
  rifle: {
    count: 14,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THOMSON',
    firstSaidQuote:
      "Give me your rifle! Okay, make a break for the woods. I'll stay behind and give you covering fire. Move!",
  },
  blond: {
    count: 3,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'JAMIE',
    firstSaidQuote: "Hey, you with the blond hair. I'm talking to you!",
  },
  shook: {
    count: 5,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SCIENTIST',
    firstSaidQuote:
      'With the majority of human specimens, the process used is both lasting and effective. However, in the case of certain humans of particularly strong character and individuality, the effects of the process have not been permanent. Gradually the processing tended to fade and the specimens developed the ability to pass through the Time Zone Barriers. Some formed themselves into resistance groups which have considerably hampered the progress of our plan. It is to overcome this problem that I have further refined our processing technique. To demonstrate the process I chosen a particularly difficult specimen. A man who finally shook off the effects of the process completely, and allied himself to resistance elements in order to fight us.',
  },
  paths: {
    count: 8,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Yes, this circuit is overloading the neural paths.',
  },
  hoist: {
    count: 6,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Hoist with his own petard. Come along, Lieutenant. Lieutenant?',
  },
  jesus: {
    count: 3,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SMYTHE',
    firstSaidQuote: 'Jesus!',
  },
  passe: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'DU PONT',
    firstSaidQuote: "Qui Ã©tes-vous? Qu'est-ce qui se passe?",
  },
  voyez: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CARSTAIRS',
    firstSaidQuote: 'He seems pretty confused. Est-ce que vous voyez Ã§a?',
  },
  venez: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CARSTAIRS',
    firstSaidQuote: 'Venez ici, monsieur.',
  },
  camps: {
    count: 10,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ZOE',
    firstSaidQuote:
      'And I can remember all the locations of all their camps, too.',
  },
  salut: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VILLAR',
    firstSaidQuote: 'Salut!',
  },
  japan: {
    count: 10,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WAR CHIEF',
    firstSaidQuote:
      'We have soldiers from most of the major wars in the planet Earth. The first World War, the war between Russia and Japan of 1905, Thirty years war.',
  },
  frada: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'There we are. Now then, sit up, sit up! Now then, you are in la Castille de la Cruz de San Antonio de la Frada Forma, in Mexico.',
  },
  forma: {
    count: 1,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'There we are. Now then, sit up, sit up! Now then, you are in la Castille de la Cruz de San Antonio de la Frada Forma, in Mexico.',
  },
  quell: {
    count: 4,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WAR LORD',
    firstSaidQuote:
      "Remove the traitor's carcass. We will return to the home planet and bring back an army to quell this revolt once and for all.",
  },
  evils: {
    count: 3,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, of course, I do. Give me a thought channel and I'll show you some of the evils I've been fighting against.",
  },
  exile: {
    count: 25,
    firstSaidSeasonIndex: 6,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'TIME LORD',
    firstSaidQuote: 'In exile.',
  },
  essex: {
    count: 6,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      'Early this morning a shower of about fifty meteorites landed in Essex.',
  },
  munro: {
    count: 12,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MUNRO',
    firstSaidQuote: "Munro here, sir. I'm in the Ashbridge Cottage Hospital.",
  },
  civvy: {
    count: 1,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MUNRO',
    firstSaidQuote: "No, sir. All we've found is an unconscious civvy.",
  },
  oxley: {
    count: 1,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MUNRO',
    firstSaidQuote:
      'He was lying beside a police box, sir. Abandoned, by the look of it, right in the middle of Oxley Wood.',
  },
  lomax: {
    count: 2,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'LOMAX',
    firstSaidQuote:
      'Doctor Lomax, path lab. You just sent up a blood sample for cross matching.',
  },
  slips: {
    count: 9,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HENDERSON',
    firstSaidQuote:
      'Most of the time. He has brief moments of consciousness and then slips back again.',
  },
  tasty: {
    count: 13,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SEELEY',
    firstSaidQuote:
      "Ain't nothing so tasty as fresh rabbit. A bit of salt and a few onions.",
  },
  sphyg: {
    count: 1,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HENDERSON',
    firstSaidQuote:
      "Fetch the sphyg, would you, nurse? I'll take his blood pressure again while I'm here.",
  },
  tyres: {
    count: 8,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MUNRO',
    firstSaidQuote: 'Shoot the tyres!',
  },
  taped: {
    count: 3,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MUNRO',
    firstSaidQuote: 'How could he with his mouth taped?',
  },
  prank: {
    count: 8,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BEAVIS',
    firstSaidQuote: 'Is this some sort of prank? Where is this patient?',
  },
  auton: {
    count: 3,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CHANNING',
    firstSaidQuote: 'Send an Auton.',
  },
  brook: {
    count: 4,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SEELEY',
    firstSaidQuote: 'Local, sir. Brook cottage.',
  },
  trunk: {
    count: 4,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MUNRO',
    firstSaidQuote: 'In a trunk?',
  },
  toves: {
    count: 3,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      " 'Twas brillig, and the slithy toves, Did gyre and gimble in the wabe",
  },
  mimsy: {
    count: 1,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Come on, Bessie, be more co-operative. All mimsy were the borogroves, And the mome raths',
  },
  raths: {
    count: 1,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Come on, Bessie, be more co-operative. All mimsy were the borogroves, And the mome raths',
  },
  deter: {
    count: 5,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'LAWRENCE',
    firstSaidQuote:
      'We are already very considerably behind in our research programme, and I am deter',
  },
  verge: {
    count: 16,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'LAWRENCE',
    firstSaidQuote:
      'We are on the verge of discovering a way to provide cheap, safe, atomic energy for virtually every kind of use.',
  },
  query: {
    count: 8,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'QUINN',
    firstSaidQuote:
      "Miss Dawson, there's a query here. Perhaps you can help. Do you know who usually keeps this log?",
  },
  pages: {
    count: 8,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "There at the bottom of the page, by the string, the binding? You'll see a tiny shred of paper. Some of those pages have been torn out.",
  },
  doris: {
    count: 12,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SQUIRE',
    firstSaidQuote: 'Doris! Doris!',
  },
  waved: {
    count: 3,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HAWKINS',
    firstSaidQuote: 'Well, apparently he just waved and drove off.',
  },
  cages: {
    count: 3,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SILURIAN',
    firstSaidQuote: 'No. Take him to the cages.',
  },
  ruins: {
    count: 39,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'LAWRENCE',
    firstSaidQuote:
      "Before you people came, I was director of an important research establishment. Now the place is shut down, my career's in ruins, and you are to blame!",
  },
  allen: {
    count: 8,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'LIZ',
    firstSaidQuote: ' Destroy the Van Allen belt.',
  },
  stoke: {
    count: 3,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, well, we'll need to stoke up the reactor. Miss Shaw, I'll need your help, please.",
  },
  bruno: {
    count: 3,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CORNISH',
    firstSaidQuote: 'Frightened your computer grant might be cut, Bruno?',
  },
  lefee: {
    count: 4,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WAKEFIELD',
    firstSaidQuote:
      'In a few minutes we shall know the answer to the question that has been occupying the minds of everyone here at Space Control since Mars Probe 7 took off on its return journey from the red planet nearly eight months ago. What has happened to astronauts Frank Michaels and Joe Lefee? Communications remained perfect on the long outward journey to the red planet and throughout the difficult landing. For a full twelve hours they sent back pictures and reports from the surface of Mars. Both then seemed in perfect health, then silence.',
  },
  lyden: {
    count: 9,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WAKEFIELD',
    firstSaidQuote:
      "Well, as you've just heard, Van Lyden has succeeded in achieving link up. A beautifully smooth",
  },
  nancy: {
    count: 30,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'LIZ',
    firstSaidQuote: 'From where? Nancy? Oui.',
  },
  merci: {
    count: 4,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'LIZ',
    firstSaidQuote: 'Oui. Merci. From France.',
  },
  brake: {
    count: 12,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Ready? I'll let the brake off. Right, push.",
  },
  bogus: {
    count: 6,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, there you are then. A bogus patrol turns up, clears the area, and removes the astronauts at their leisure.',
  },
  doses: {
    count: 1,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'HELDORF',
    firstSaidQuote:
      "General Carrington, these men have received massive doses of radiation. They need total blood transfusions immediately. They need antibiotics, cortisone injections. You don't understand the situation. We must reduce the radiation",
  },
  coded: {
    count: 12,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Does that include sending coded messages to Mars Probe 7? And kidnapping three astronauts?',
  },
  eased: {
    count: 4,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CARRINGTON',
    firstSaidQuote:
      'Good! Well, I hope this explanation has eased your minds, gentlemen.',
  },
  combs: {
    count: 1,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'And hair combs.',
  },
  raids: {
    count: 4,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'TALTALIAN',
    firstSaidQuote:
      'You will use these creatures to carry out a series of raids on carefully chosen targets. You know enough to do your job, but I have further instructions for you.',
  },
  buyer: {
    count: 3,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CORNISH',
    firstSaidQuote: 'Who was the buyer?',
  },
  emits: {
    count: 5,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CORNISH',
    firstSaidQuote:
      'Well, I assume the radio signals that thing emits are affecting the cameras.',
  },
  donna: {
    count: 261,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Ra, ra, rum, rum, da, ra! Ra, ra, da, dum, da ,dah. La Donna e mobile, ra, ra, ra, rum, da, dah. De, dah, da, rum, da, dah, bah ,de, da, dum, da, dah. Da, da, dah, rum, bum.',
  },
  imply: {
    count: 6,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GOLD',
    firstSaidQuote: "I didn't mean to imply otherwise.",
  },
  bingo: {
    count: 18,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SUTTON',
    firstSaidQuote:
      "Getting a respectable tan, bingo! I get snatched off a drill rig in Kuwait just when I'm sure we've made a strike, flown back so fast my stomach's still over the Med and I still haven't the faintest idea what I'm supposed to be doing here.",
  },
  petra: {
    count: 24,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GOLD',
    firstSaidQuote:
      "Petra, this is Mister Sutton, the oil man I told you about. This is Miss Petra Williams, who's been personal assistant to the Professor for some years now.",
  },
  peaks: {
    count: 2,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BROMLEY',
    firstSaidQuote:
      "Yes, yes, that's right. All readings normal, no peaks at all. Yeah. Look, I've done a complete routine check.",
  },
  medal: {
    count: 10,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SUTTON',
    firstSaidQuote:
      "Well done, everyone. I'll have a new medal struck. The Order of the Turkish Bath.",
  },
  cools: {
    count: 2,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'STAHLMAN',
    firstSaidQuote:
      "Then we shall just have to wait till it cools down a bit, won't we.",
  },
  goose: {
    count: 8,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "Stahlman's demanding that I get rid of him. It looks as though he sent you on a wild goose chase.",
  },
  saves: {
    count: 14,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GREG',
    firstSaidQuote: 'How come he saves our skin?',
  },
  bully: {
    count: 5,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'First you try to bully me, and then you switch on the charm. Secret police routine seven stroke four.',
  },
  leeds: {
    count: 7,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'STEWART',
    firstSaidQuote:
      'Massive seismic disturbances reported throughout the country. Earth tremors reported in the Midlands and as far north as Leeds.',
  },
  shuts: {
    count: 4,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'WILLIAMS',
    firstSaidQuote:
      'Well, in an emergency, the master switch automatically shuts down the reactor banks.',
  },
  pique: {
    count: 2,
    firstSaidSeasonIndex: 7,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'STAHLMAN',
    firstSaidQuote:
      "Well then, I imagine he's had his complaints dismissed and has taken himself off in a fit of pique. It doesn't matter. We shall do very well without him.",
  },
  elsie: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GOODGE',
    firstSaidQuote:
      "Elsie. Cut out the hard-boiled eggs, I said. Quite apart from their effects on my digestion, they're aesthetically boring.",
  },
  yates: {
    count: 156,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'JO',
    firstSaidQuote:
      'Thank you, Doctor. Report from one our field sections, sir. Captain Yates. Some kind of sabotage at a radio telescope. Two of their scientists have disappeared.',
  },
  tubby: {
    count: 2,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Who's in charge of you pen pushers these days? Old Tubby Rowlands isn't it?",
  },
  sexes: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BROWNROSE',
    firstSaidQuote:
      "None whatsoever. Different ages, sexes and occupations. Apart from the first two deaths, there's no connection at all.",
  },
  quasi: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The Nestenes change the molecular structure of plastic, Captain Yates. They energise it in some way and turn it into quasi-organic matter, almost like flesh and blood. Well, it's inert at the moment. Something must have activated it.",
  },
  inert: {
    count: 7,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The Nestenes change the molecular structure of plastic, Captain Yates. They energise it in some way and turn it into quasi-organic matter, almost like flesh and blood. Well, it's inert at the moment. Something must have activated it.",
  },
  coach: {
    count: 16,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote: "Farrel's ordered a coach this week. A fifteen-seater.",
  },
  daffs: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'YATES',
    firstSaidQuote:
      "No, they didn't. We've got no idea at all, I'm afraid. We don't even know how long they've been doing it. The thing is, the Brigadier wants to know if the daffs are dangerous.",
  },
  eagle: {
    count: 16,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BENTON',
    firstSaidQuote:
      "Thank you, Eagle. Message confirmed. Over and out. That's it then, sir. Air strike confirmed.",
  },
  slows: {
    count: 5,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'If he slows down, we might be able to jump for it.',
  },
  lowly: {
    count: 4,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KETTERING',
    firstSaidQuote:
      'When the process is completed, the negative impulses that made this man a criminal will have been removed. He will take his place as a useful, if lowly, member of society. Are you ready, Doctor Summers?',
  },
  bites: {
    count: 7,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Bites and scratches? Yes, I know.',
  },
  hoard: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUMMERS',
    firstSaidQuote:
      'Yet all the indications are that he was attacked by a hoard of them, and the shock killed him.',
  },
  tinge: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUMMERS',
    firstSaidQuote: 'From the position of the body, tinge of the skin',
  },
  curry: {
    count: 6,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'YATES',
    firstSaidQuote:
      "Mister Curry, are you still there? Oh good. No, no, for a moment I thought we'd been cut off.",
  },
  noisy: {
    count: 14,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VOSPER',
    firstSaidQuote: "Getting a bit noisy, ain't they, Mister Green?",
  },
  squid: {
    count: 10,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Dried squid and stewed jellyfish, my dear fellow. For our dinner. Beng ahn, my dear Peng-san.',
  },
  naval: {
    count: 28,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "Oh yes, they have. This one's on its way to the naval dockyard. They're going to dump it at the bottom of the ocean.",
  },
  admin: {
    count: 4,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUMMERS',
    firstSaidQuote: "I think you'd better go to the admin block, Miss Grant.",
  },
  bikes: {
    count: 7,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      'Not unless they took the body with them. One of the bikes is missing.',
  },
  lenny: {
    count: 2,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MAILER',
    firstSaidQuote:
      "Look, mate, I don't care how busy you are. I want you back. That machine of yours has broken out. It's wandering around the prison. It's killed Lenny Vosper. It's nearly killed me!",
  },
  booze: {
    count: 4,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "'Ere, wait a minute. I've got a weeks supply of food in there, and booze for the Governor. Am I supposed to go back and tell them you don't want it? They'll think you're barmy.",
  },
  barmy: {
    count: 9,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "'Ere, wait a minute. I've got a weeks supply of food in there, and booze for the Governor. Am I supposed to go back and tell them you don't want it? They'll think you're barmy.",
  },
  wraps: {
    count: 10,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote: 'Well, that about wraps it up, Doctor.',
  },
  coils: {
    count: 5,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JO',
    firstSaidQuote: 'Will you be able to set the coils up again?',
  },
  rider: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "Don't you worry, Doctor. Leave everything to us. I've cancelled the attack and we'll send a dispatch rider to HQ to get your circuit, just in case.",
  },
  comet: {
    count: 16,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'RADAR 2',
    firstSaidQuote:
      "Well, if that's its course, we've discovered a comet. Run another course check.",
  },
  chinn: {
    count: 31,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "Mister Chinn, as head of UNIT, I must remind you, that we're not in the Ministry of Defence.",
  },
  filed: {
    count: 5,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CHINN + BRIGADIER',
    firstSaidQuote: 'And scrupulously filed.',
  },
  errol: {
    count: 2,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'FILER',
    firstSaidQuote: 'Yeah. No, no, that was Errol Flynn.',
  },
  flynn: {
    count: 2,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'FILER',
    firstSaidQuote: 'Yeah. No, no, that was Errol Flynn.',
  },
  filer: {
    count: 22,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'JO',
    firstSaidQuote: 'This is Bill Filer from Washington HQ.',
  },
  niner: {
    count: 11,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'RADAR 2',
    firstSaidQuote:
      'UFO bearing two zero niner. Five hundred miles and closing.',
  },
  astro: {
    count: 7,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BENTON',
    firstSaidQuote: "Negative on astro. We're running ICBM checks, sir.",
  },
  eject: {
    count: 8,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'AXOS',
    firstSaidQuote: 'This specimen is valueless. Absorb, process and eject.',
  },
  foist: {
    count: 2,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Why should they foist this gift onto us? They must want something. Jo, tell me again about that creature that you saw.',
  },
  axons: {
    count: 9,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'JO',
    firstSaidQuote:
      "Look, we must get him out. We'll make the Axons let us search.",
  },
  botch: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      "Oh, no! But what does he think he's doing? What a botch-up!",
  },
  nuton: {
    count: 2,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'AXOS',
    firstSaidQuote:
      'Add the full power output of the Nuton complex to your figures, Doctor.',
  },
  domes: {
    count: 7,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'You set up your main dome here, with all your subsidiary domes around it.',
  },
  bonus: {
    count: 16,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DENT',
    firstSaidQuote:
      "Look at it! It's going to make you rich. This planet has enough duralinium to double the company's profits next year. Your bonus will be big enough to retire on.",
  },
  assay: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MORGAN',
    firstSaidQuote: ' Assay prediction on section four eight.',
  },
  sunny: {
    count: 6,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'WINTON',
    firstSaidQuote:
      "Don't worry, you'll manage. You always do. Must be that sunny nature of yours.",
  },
  aptly: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'WINTON',
    firstSaidQuote:
      'Primitive dwelling. Rather aptly named. Well? What do we do now?',
  },
  miner: {
    count: 8,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CALDWELL',
    firstSaidQuote: "I'm not one of Dent's killers. I'm a miner.",
  },
  buggy: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote: 'Right, Doctor, the buggy is over there.',
  },
  farce: {
    count: 5,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ASHE',
    firstSaidQuote: 'I agree with Winton. This trial is a farce.',
  },
  kilos: {
    count: 22,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MARY',
    firstSaidQuote:
      'By order of Captain Dent, all colonists must be on the ship one hour before blast off. There can be no exceptions. Each of you can bring luggage to weigh not more than seven kilos.',
  },
  runes: {
    count: 2,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HAWTHORNE',
    firstSaidQuote:
      'The signs are there for all to see! I cast the runes only this morning.',
  },
  spine: {
    count: 6,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'FERGUS',
    firstSaidQuote:
      "Devil's End. The very name sends a shiver up the spine. The witches of Devil's End, the famous curse, the notorious cavern underneath the church where the third Lord of Aldbourne played at his eighteen century parody of black magic. Devil's End is part of the dark mythology of our childhood days. And now, for the first time, the cameras of the BBC have been allowed inside the cavern itself. In this cavern, pagan man performed his unspeakable rites. In this cavern, the witches of the seventeenth century hid from the fires of Matthew Hopkins, witch-hunter extraordinary. In this cavern. But I could go on all day.",
  },
  rites: {
    count: 8,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'FERGUS',
    firstSaidQuote:
      "Devil's End. The very name sends a shiver up the spine. The witches of Devil's End, the famous curse, the notorious cavern underneath the church where the third Lord of Aldbourne played at his eighteen century parody of black magic. Devil's End is part of the dark mythology of our childhood days. And now, for the first time, the cameras of the BBC have been allowed inside the cavern itself. In this cavern, pagan man performed his unspeakable rites. In this cavern, the witches of the seventeenth century hid from the fires of Matthew Hopkins, witch-hunter extraordinary. In this cavern. But I could go on all day.",
  },
  apace: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'FERGUS',
    firstSaidQuote:
      "While I was recording that earlier this afternoon, the archaeological dig was proceeding apace. Professor Horner and his team have cut their way into the Devil's Hump, as this barrow is called by the locals, as if it were a giant pie. But now the question is can Professor Horner pull out his plum.",
  },
  raged: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'FERGUS',
    firstSaidQuote:
      "For some two hundred years, the controversy has raged. What is the Devil's Hump. Now, we're not the first to try and find out. But from 1793, when Sir Percival Flint's miners ran back to Cornwall leaving him for dead to the famous Cambridge University fiasco of 1939",
  },
  april: {
    count: 10,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HORNER',
    firstSaidQuote: "Well, it's obvious. April 30th is Beltane, isn't it?",
  },
  gusts: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'WINSTANLEY',
    firstSaidQuote:
      'Well, no, but there have been a lot of queer goings on the last few weeks. Strange sudden noises and gusts of wind, and poor old Jim dropping down in the churchyard.',
  },
  groom: {
    count: 7,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HAWTHORNE',
    firstSaidQuote:
      'Be at peace in thy sleeping. Mister Groom? Mister Groom, are you all right?',
  },
  vicar: {
    count: 17,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HAWTHORNE',
    firstSaidQuote: 'Well, if you must know, I wish to contact the vicar.',
  },
  canon: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HAWTHORNE',
    firstSaidQuote:
      'I mean Canon Smallwood, our old vicar. The one who left in such mysterious circumstances.',
  },
  dated: {
    count: 8,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      'The soul as such is a very dated concept. Viewing the matter existentially, I',
  },
  intro: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HARRY',
    firstSaidQuote:
      "Do my best. Now, you've got everything straight? We start with an intro from Alastair, then I give you a cue to launch into your spiel",
  },
  spiel: {
    count: 2,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HARRY',
    firstSaidQuote:
      "Do my best. Now, you've got everything straight? We start with an intro from Alastair, then I give you a cue to launch into your spiel",
  },
  neary: {
    count: 2,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COMMENTATOR',
    firstSaidQuote:
      'Trying to run out of his own twenty five, then inside to Neary',
  },
  nemah: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COVEN',
    firstSaidQuote: 'Nemah.',
  },
  abara: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      'Hearken to my voice, oh Dark One. Ancient and awful, supreme in artifice, bearer of power, I conjure thee. Be present here at my command and truly do my will. Aba, abara, agarbara, gad, gadoal, galdina!',
  },
  etihw: {
    count: 2,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      'Og ot erus saw bmal eht tnew yram taht, erehwyreve dna, wons sa etihw saw eceelf sti, bmal elttila dah yram!.',
  },
  recce: {
    count: 9,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BENTON',
    firstSaidQuote:
      "Look, sir, if you don't need me here, I'd like to make a quick recce of those tracks.",
  },
  olive: {
    count: 5,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HAWTHORNE',
    firstSaidQuote:
      "Garvin the verger. We must we must get the police at once. Oh, oh, may name's Olive Hawthorne, by the way. How do you do?",
  },
  coven: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HAWTHORNE',
    firstSaidQuote:
      'Oh, I should have realised at once. Magister is the name given to the leader of a black magic coven.',
  },
  satan: {
    count: 38,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HAWTHORNE',
    firstSaidQuote:
      'Yes, dear boy. Satan, Lucifer, the Prince of Darkness, Beelzebub, the Horned Beast. Call him what you like, he was there.',
  },
  khnum: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Top of the class, Jo, top of the class. That's right, that's the Egyptian god Khnum, with horns. There's another one, a Hindu demon.",
  },
  hindu: {
    count: 8,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Top of the class, Jo, top of the class. That's right, that's the Egyptian god Khnum, with horns. There's another one, a Hindu demon.",
  },
  demon: {
    count: 59,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Top of the class, Jo, top of the class. That's right, that's the Egyptian god Khnum, with horns. There's another one, a Hindu demon.",
  },
  myths: {
    count: 15,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Ever since man began? Exactly. But why? All right, Captain Yates, the curtains. Now creatures like those have been seen over and over again throughout the history of man, and man has turned them into myths, gods or devils, but they're neither. They are, in fact, creatures from another world.",
  },
  bills: {
    count: 4,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      "Now, as I've told you, this is not going to be a sermon. But all the same, I do beg of you to listen carefully. Because this could be the most important day in your lives. Now as you know, I am a newcomer among you, and yet already I feel that I know you all. For instance, you, Mister Thorpe. Are you still padding the grocery bills of the local gentry?",
  },
  width: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Right, well tell him to build an EHF wide band width variable phase oscillator, with a negative feedback circuit tunable to the frequency of an air molecule at, er, what is the temperature up at the barrier, Brigadier?',
  },
  volts: {
    count: 11,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "We'll need at least ten thousand volts to get through this lot.",
  },
  cuppa: {
    count: 13,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HAWTHORNE',
    firstSaidQuote:
      "I've bought you a nice cuppa, Sergeant. I hope you like china.",
  },
  piled: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote: "Maybe he's piled up that wretched motorbike.",
  },
  shalt: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BERT',
    firstSaidQuote: 'Thou shalt not suffer a witch to live.',
  },
  nemas: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COVEN',
    firstSaidQuote: 'Nemas.',
  },
  avara: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      'Harken to my voice, oh, Dark One, ancient and awful, supreme in artifice, bearer of power, be present here at my command and truly do my will. Ava, avara, agarbala, gar, gardoal, galdina! As my will, so mote it be.',
  },
  feats: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'All his feats are based on science. Either ours or the secret science of the Daemons.',
  },
  azael: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HAWTHORNE',
    firstSaidQuote: 'Azal? Of course! Azael, the fallen angel.',
  },
  angel: {
    count: 112,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HAWTHORNE',
    firstSaidQuote: 'Azal? Of course! Azael, the fallen angel.',
  },
  atame: {
    count: 1,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      'O mighty Azal, in the name of Atame, I dedicate this offering!',
  },
  adolf: {
    count: 3,
    firstSaidSeasonIndex: 8,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I seem to remember somebody else speaking like that. What was the bounder's name? Hitler. Yes, that's right, Adolf Hitler. Or was it Genghis Khan?",
  },
  paget: {
    count: 4,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "Yes. Yes, I've seen the report from Miss er, Miss Paget. It doesn't seem to be very much to go on.",
  },
  muddy: {
    count: 5,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Did you also make those marks on the floor over there? Muddy feet, Sir Reginald. Someone was in here, you know.',
  },
  canal: {
    count: 8,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Sir Reginald, we've just found a very severely injured man down by the canal tunnel.",
  },
  boney: {
    count: 1,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, quite right. Do you know, I remember saying to old Napoleon. Boney, I said, always remember an army marches on its stomach.',
  },
  shura: {
    count: 8,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ANAT',
    firstSaidQuote: 'It is no concern of yours. Shura.',
  },
  gloss: {
    count: 2,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BOAZ',
    firstSaidQuote: "Don't gloss over it, Anat. We failed.",
  },
  monia: {
    count: 2,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ANAT',
    firstSaidQuote:
      'We did all we could. Monia, our orders were to eliminate Styles, right?',
  },
  fluke: {
    count: 3,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CONTROLLER',
    firstSaidQuote:
      'That was a lucky fluke, I assure you, nothing else. You could just as easily been killed.',
  },
  quota: {
    count: 4,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CONTROLLER',
    firstSaidQuote:
      'What does concern you, however, is the production quota for this factory.',
  },
  aides: {
    count: 1,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MACINTOSH',
    firstSaidQuote:
      'Here in the peaceful heart of England will soon take place what could be described as the most important summit conference of this century. The peaceful atmosphere of this Georgian house gives little indication of the underlying tension of the occasion. A desperate, last minute attempt to stem the rising tide of international tension that seems to be moving the great powers towards the brink of a third world war. Arriving now is Sir Reginald Styles, who with his team of government aides, has been working around the clock to make this meeting possible. Sir Reginald himself, has just returned from an eleventh hour meeting in Peking where his success in persuading the Chinese leaders to reconsider their walk out gave the first real chance of success to these talks. Talks, on which may well depend, the fate of the entire world.',
  },
  doomy: {
    count: 2,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JO',
    firstSaidQuote: 'Oo, looks a bit doomy.',
  },
  omens: {
    count: 8,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HEPESH',
    firstSaidQuote: 'I say again the omens are not good.',
  },
  slain: {
    count: 14,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HEPESH',
    firstSaidQuote:
      'Once before your Majesty saw fit to ignore my warnings, and now your Chancellor, Torbis, lies dead, slain by the wrath of Aggedor.',
  },
  tamed: {
    count: 4,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HEPESH',
    firstSaidQuote:
      'But to them, Peladon, we are merely savages. Savages to be tamed. They despise and distrust us.',
  },
  eenie: {
    count: 4,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Which way indeed? Eenie, meenie, mynie, mo.',
  },
  mynie: {
    count: 1,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Which way indeed? Eenie, meenie, mynie, mo.',
  },
  trims: {
    count: 1,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HEPESH',
    firstSaidQuote:
      'It concerns the royal beast of Peladon, now extinct. It is written, Mighty is Aggedor, fiercest of all the beasts of Peladon. Young men would hunt it to prove their courage. His fur trims our royal garment. His head is our royal emblem. It is also written there will come a day when the spirit of Aggedor will rise again to warn and defend his royal master, King Peladon. For at that day, a stranger will appear in the land, bringing peril to Peladon.',
  },
  izlyr: {
    count: 7,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IZLYR',
    firstSaidQuote:
      'Chairman delegate from Earth, greetings. Delegate Izlyr from Mars. Sub-delegate Ssorg.',
  },
  ssorg: {
    count: 10,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IZLYR',
    firstSaidQuote:
      'Chairman delegate from Earth, greetings. Delegate Izlyr from Mars. Sub-delegate Ssorg.',
  },
  pawns: {
    count: 6,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ARCTURUS',
    firstSaidQuote: 'As pawns in some political game, perhaps?',
  },
  tirra: {
    count: 2,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Klokleda partha mennin kletch. Haroon, haroon, haroon. Klokleda sheena tirra nach. Haroon, haroon, haroon.',
  },
  haran: {
    count: 1,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Tirra nach. Haroon, haran, haroon.',
  },
  lacks: {
    count: 8,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'IZLYR',
    firstSaidQuote:
      'His planet lacks mineral deposits. Peladon has them in abundance.',
  },
  amaze: {
    count: 7,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Grun, you're a brave warrior. What you're going to see now may amaze you, but just you trust me.",
  },
  harun: {
    count: 4,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Haroon, haroon, haroon. Haroon, harun, haroon. Haroon, harun, haroon. Haroon, harun, haroon. Haroon, harun, haroon. There you are, Grun. Yes, he's quite under now. Not such a terrifying creature after all, is he? Right, I think it's about time that King Peladon learned the truth, don't you? Come on, Aggedor. Come on, old chap, that's it. Come on, Aggedor. That's it. Come on, Grun.",
  },
  fiver: {
    count: 2,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CLARK',
    firstSaidQuote: 'A fiver.',
  },
  tango: {
    count: 11,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'JO',
    firstSaidQuote: 'Oscar Bravo Tango Seven Four.',
  },
  audit: {
    count: 3,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote: 'Special audit, Ministry of Defence.',
  },
  lanes: {
    count: 7,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'HART',
    firstSaidQuote:
      "Doctor, those are major shipping lanes. We'd have protests from all over the world.",
  },
  buoys: {
    count: 3,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'HART',
    firstSaidQuote:
      'You know what happens in the English Channel. Trinity House marker buoys are ignored half the time.',
  },
  jaunt: {
    count: 6,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Been out for a little jaunt, have you?',
  },
  gloat: {
    count: 4,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Your usual childish desire to gloat, perhaps?',
  },
  rover: {
    count: 4,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BLYTHE',
    firstSaidQuote:
      "But they didn't bring the Land Rover back, sir. Colonel Trenchard said they took a taxi to the quay.",
  },
  ports: {
    count: 1,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WALKER',
    firstSaidQuote:
      "Your opinion is quite immaterial, Captain Hart. The order's already been given. Ships are converging on this area from ports all over England.",
  },
  myers: {
    count: 1,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'OFFICER',
    firstSaidQuote: 'Myers, check that storeroom!',
  },
  solos: {
    count: 60,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'COTTON',
    firstSaidQuote:
      "Solos. Stinking rotten hole. Can't even breathe. What a planet.",
  },
  varan: {
    count: 63,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KY',
    firstSaidQuote:
      'I knew you would be here, Varan, with your Overlord masters.',
  },
  mutts: {
    count: 20,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MARSHAL',
    firstSaidQuote:
      'There is no proof that my atmospheric experiments have anything at all to do with these mutations. The Mutts are a menace and must be wiped out.',
  },
  swung: {
    count: 3,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'STUBBS',
    firstSaidQuote:
      'You mean His Nibs fixed up the whole thing? Had the Administrator done in and then swung the blame on the natives?',
  },
  forte: {
    count: 5,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JAEGER',
    firstSaidQuote: 'Particle reversal, no doubt. Your little forte?',
  },
  novel: {
    count: 8,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MARSHAL',
    firstSaidQuote:
      "A simple operation. Surveillance reports show they've gone to ground there. Now, Jaeger has devised some novel gas grenades. I want men stationed at every exit. We set off the grenades, flush 'em out. All of them. Ky, Doctor, Varan, Mutts, the lot.",
  },
  stern: {
    count: 3,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MARSHAL',
    firstSaidQuote:
      "Yes, Earth Control has seen fit to have my project investigated. I want my reforms to have their approval. You and your friends here will confirm the necessity of stern measures. Outbreaks of plague and rebellion must be controlled, don't you agree?",
  },
  dilly: {
    count: 3,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Look, for heaven's sake, stop dilly-dallying and let's get on with it. These unstable reactions are dangerous. I shall need some equipment. If we don't come up with an effective control system, we'll particle reverse Skybase and we'll be in a bigger mess than we were before.",
  },
  thera: {
    count: 3,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JO',
    firstSaidQuote:
      "It just shows you don't listen to a word I say, doesn't it. Now, yes, here we are. New eruptions in the Thera group of islands. Somewhere off Greece.",
  },
  bland: {
    count: 2,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RUTH',
    firstSaidQuote:
      "That man. You know, I don't what infuriates me more. His dictatorial manner or that infernal courtesy of his. It's all the same, really. A bland assumption of male superiority.",
  },
  sheep: {
    count: 20,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "You know, if this got out, you'd be the laughing stock of UNIT. A dream. Really, Doctor, you'll be consulting the entrails of a sheep next.",
  },
  naked: {
    count: 24,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "I said, bring some men with you. I feel as naked as a babe in his bath. I'll want light and heavy machine guns. Oh, and Yates? Shove a couple of anti-tank guns in the boot, will you? Over.",
  },
  linen: {
    count: 10,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COOK',
    firstSaidQuote:
      "I can see no alternative to a full Whitehall inquiry. I can only hope that we don't have to parade our dirty linen at Westminster, not to mention Brussels.",
  },
  titan: {
    count: 44,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RUTH',
    firstSaidQuote:
      "But Kronos was a Greek legend. He was the Titan who ate his children, wasn't he?",
  },
  cubed: {
    count: 5,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote: 'E to the power of seven C. E equals MC cubed.',
  },
  afire: {
    count: 3,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'NEOPHITE',
    firstSaidQuote: 'Holiness! Holiness! Come quickly! The crystal is afire!',
  },
  inept: {
    count: 3,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      "I'm not surprised. I've never seen a more inept performance. Look, tell him to ring the Brigadier for confirmation.",
  },
  ladle: {
    count: 1,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BENTON',
    firstSaidQuote:
      "Yes, well, primitive or not, mate, you're still in the soup without a ladle, aren't you.",
  },
  balls: {
    count: 6,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'YATES',
    firstSaidQuote: 'Cannon balls, in fact. Out.',
  },
  heave: {
    count: 9,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'FARMER',
    firstSaidQuote: 'One, two, six, heave! One, two, six, heave! Pull!',
  },
  twits: {
    count: 1,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BENTON',
    firstSaidQuote:
      "Oh, you're suggesting we just sit here and let the Master treat us as a load of twits, I suppose?",
  },
  lovey: {
    count: 2,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HYDE',
    firstSaidQuote:
      "Lovey, I'm not men. I'm Stuart Hyde, registered, card carrying, paid up coward. For Pete's sake, what are you looking at me like that for? All right, I'll come.",
  },
  piles: {
    count: 2,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'DALIOS',
    firstSaidQuote:
      'Brothers, silence! Peace! Peace, I say. I shall speak plainly too. You ask for the blessings of the golden years. Yet there came a time when Atlantis grew to hate them. What would you have, Hippias? If you were master of Kronos, lord of time. Ten crops in one season? A surfeit of fishes? An ocean of wine? Then take the barren soil as well, the stinking piles of rotting meat, an idle drunken people. I tell you Kronos was a curse!',
  },
  lakis: {
    count: 8,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'GALLEIA',
    firstSaidQuote: 'But what did you think of him, Lakis?',
  },
  mouse: {
    count: 15,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JO',
    firstSaidQuote:
      "Well, that's what I'll be as quiet as. An Atlantean mouse, okay?",
  },
  reins: {
    count: 2,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      "Well, purely because of Lord Dalios' great age, it might be well if he were relieved of some of the more onerous duties of kingship. But the reins of power, Lady Queen, should be in stronger hands. Hands such as yours.",
  },
  longs: {
    count: 2,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'DALIOS',
    firstSaidQuote:
      "Well, there's little more to tell. No one else shall suffer as he has suffered. Till the last day of his life, for which he longs so ardently, he will guard the crystal. No one can approach it. To try is certain death.",
  },
  crito: {
    count: 1,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'LAKIS',
    firstSaidQuote: ' Have a care. The Lord Crito is no friend to Hippias.',
  },
  bleak: {
    count: 7,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, I'm coming to that, Jo, in my own time. Ah, I'll never forget what it was like up there. All bleak and cold, it was. A few bare rocks with some weeds sprouting from them and some pathetic little patches of sludgy snow. It was just grey. Grey, grey, grey. Well, the tree the old man sat under, that was ancient and twisted and the old man himself was, he was as brittle and as dry as a leaf in the autumn.",
  },
  weeds: {
    count: 11,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, I'm coming to that, Jo, in my own time. Ah, I'll never forget what it was like up there. All bleak and cold, it was. A few bare rocks with some weeds sprouting from them and some pathetic little patches of sludgy snow. It was just grey. Grey, grey, grey. Well, the tree the old man sat under, that was ancient and twisted and the old man himself was, he was as brittle and as dry as a leaf in the autumn.",
  },
  daisy: {
    count: 22,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "A flower. One of those little weeds. Just like a daisy, it was. Well, I looked at it for a moment and suddenly I saw it through his eyes. It was simply glowing with life, like a perfectly cut jewel. And the colours? Well, the colours were deeper and richer than you could possibly imagine. Yes, that was the daisiest daisy I'd ever seen.",
  },
  brown: {
    count: 42,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, I laughed too when I first heard it. So, later, I got up and I ran down that mountain and I found that the rocks weren't grey at all, but they were red, brown and purple and gold. And those pathetic little patches of sludgy snow, they were shining white. Shining white in the sunlight. You still frightened, Jo?",
  },
  trump: {
    count: 3,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'The trump card. I can stop you whenever I please.',
  },
  crock: {
    count: 2,
    firstSaidSeasonIndex: 9,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote: "Time ram? You couldn't do it in that old crock.",
  },
  ollis: {
    count: 17,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'TYLER',
    firstSaidQuote: 'Mister Ollis! Mister Ollis?',
  },
  yanks: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'TYLER',
    firstSaidQuote:
      "Yeah. Nobody knows what to make of it. Well, they've all seen it. Yanks, and the other lot.",
  },
  flute: {
    count: 5,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'JO',
    firstSaidQuote: 'A flute? No.',
  },
  dandy: {
    count: 3,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DOCTOR 1',
    firstSaidQuote:
      " Ah, there you are. I seem to be stuck up here. Hmm? Hmm? Oh, so you're my replacements. Huh. A dandy and a clown. Have you done anything?",
  },
  jelly: {
    count: 45,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DOCTOR 2',
    firstSaidQuote: 'Oh, we have a think. Care for a jelly baby?',
  },
  lumpy: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'OLLIS',
    firstSaidQuote:
      'Well, there were two others in a daffy old motor car for a start. A man and a girl. They went off after another fellow and all got took by those lumpy creatures.',
  },
  gally: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DOCTOR 2',
    firstSaidQuote:
      "I say, you mean all you've got to do is think of a thing, rub your magic lamp over there and shally me gally me zoop, there it is? That's jolly clever. That's jolly clever.",
  },
  atlas: {
    count: 2,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'OMEGA',
    firstSaidQuote:
      'So long as I control singularity, I can make it do my will. All these things exist because I will them to exist. Without me and the unceasing pressure of my will, the work of thousands of years would collapse into chaos in microseconds. I am, if you like, the Atlas of my world.',
  },
  farmy: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JO',
    firstSaidQuote: 'Sort of farmy.',
  },
  kalik: {
    count: 15,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ORUM',
    firstSaidQuote:
      "Nevertheless, Commissioner Kalik, one has one's duty to perform, no matter how unpleasant.",
  },
  chota: {
    count: 2,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALY',
    firstSaidQuote: ' chota peg',
  },
  deuce: {
    count: 7,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALY',
    firstSaidQuote: 'What the deuce is it?',
  },
  sahib: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALY',
    firstSaidQuote: 'Hang it all, Andrews. The fellow is a sahib, you know.',
  },
  marie: {
    count: 8,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, in its time, the SS Bernice was as famous a sea mystery as the Marie Celeste.',
  },
  ogron: {
    count: 8,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VORG',
    firstSaidQuote:
      "These are the only Tellurians in captivity. Some scientists think that their discovery refutes Valdek's theory that life in the universe is infinitely variable. An even more interesting though less amusing form of life is the Ogron.",
  },
  bally: {
    count: 4,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALY',
    firstSaidQuote:
      "What's that? Well, I never knew them. I've never bally well seen you in all me life before!",
  },
  patel: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ANDREWS',
    firstSaidQuote: "Now we've got them. Patel!",
  },
  demos: {
    count: 3,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VORG',
    firstSaidQuote:
      'A forgery? But your worship, I had no idea. And my assistant and I travelled all the way from Demos believing that we would be welcome on your noble planet.',
  },
  pacts: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'PLETRAC',
    firstSaidQuote:
      'You are an alarmist, Kalik. After all, we have defence pacts with all the neighbouring planets.',
  },
  scary: {
    count: 44,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JO',
    firstSaidQuote: "It's a bit scary, isn't it? What are all those bubbles?",
  },
  marsh: {
    count: 33,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, some sort of marsh gas. Probably highly inflammable. Come on, we'd better take a look around.",
  },
  jingo: {
    count: 4,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Yes. By jingo, I've got it! I know what this is.",
  },
  kicks: {
    count: 6,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JO',
    firstSaidQuote:
      'And outside there are people and creatures just looking at us for kicks?',
  },
  steep: {
    count: 3,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, take our own particular example for a moment, eh? This is our problem. We can't go forward because this shaft is too steep. We can't go back the way we came because of our hungry little friends here.",
  },
  doggo: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ANDREWS',
    firstSaidQuote:
      "All right. Come on out from there. It's no good lying doggo. I can see your foot.",
  },
  chalo: {
    count: 2,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CAPTAIN',
    firstSaidQuote: 'Bosun, chalo, chalo! Tilda caro!',
  },
  tilda: {
    count: 17,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CAPTAIN',
    firstSaidQuote: 'Bosun, chalo, chalo! Tilda caro!',
  },
  umpty: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DALY',
    firstSaidQuote: "Ahh, you feeling a bit umpty? I'm not at all surprised.",
  },
  inter: {
    count: 7,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KALIK',
    firstSaidQuote: 'You are on Inter Minor.',
  },
  lingo: {
    count: 4,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VORG',
    firstSaidQuote: 'The Tellurian carnival lingo. Watch. Palare la carny?',
  },
  carny: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VORG',
    firstSaidQuote: 'The Tellurian carnival lingo. Watch. Palare la carny?',
  },
  varda: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VORG',
    firstSaidQuote: 'Varda the Bona Palone?',
  },
  jills: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VORG',
    firstSaidQuote: "Niente dinari round here, y'jills.",
  },
  magum: {
    count: 3,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SHIRNA',
    firstSaidQuote:
      'You know what gamblers the Wallarians are. Well, Vorg had the magum pod concession.',
  },
  mucky: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VORG',
    firstSaidQuote: "Is this it? A bit mucky, I'm afraid.",
  },
  flaws: {
    count: 6,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ORUM',
    firstSaidQuote: 'Upon reflection, one is conscious of certain flaws.',
  },
  depot: {
    count: 5,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'PLETRAC',
    firstSaidQuote:
      'One understands that the functionaries at the transporter depot are refusing to work double shifts.',
  },
  braid: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'STEWART',
    firstSaidQuote:
      "Gold braid uniform, beautiful stewardesses? Yeah, I'd take that any time.",
  },
  milky: {
    count: 5,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, if this is the period that I think it is, there are two great empires spreading their way through the galaxy of the Milky Way.',
  },
  memos: {
    count: 3,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'HARDY',
    firstSaidQuote:
      "Will they? They're probably still passing memos to each other.",
  },
  riots: {
    count: 7,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WILLIAMS',
    firstSaidQuote:
      'There have been anti-Draconian riots in Tokyo and Belgrade, and the Draconian Consulate in Helsinki has been burnt to the ground. In Los Angeles, demonstrators burnt an effigy of you.',
  },
  duped: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Allow me to congratulate you, sir. You have the most totally closed mind that I've ever encountered. Madam, I beg of you to listen to me. Some third party is trying to provoke war between Earth and Draconia. You are both being duped.",
  },
  sotto: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'DALE',
    firstSaidQuote:
      "(sotto_ When the Peace Party takes over, you'll be given a free pardon. You have my word.",
  },
  merit: {
    count: 4,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'EMPEROR',
    firstSaidQuote:
      'We must respect the customs of our guests, strange though they may be. The suggestion had merit.',
  },
  bodge: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "A bit of a shambles, I'm afraid. Though I'll do my best to bodge something up.",
  },
  vaber: {
    count: 18,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TARON',
    firstSaidQuote: 'This is Vaber.',
  },
  codal: {
    count: 15,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TARON',
    firstSaidQuote: 'No. We wait for Codal.',
  },
  rebec: {
    count: 13,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TARON',
    firstSaidQuote: 'Rebec! Rebec! Rebec, are you all right?',
  },
  maret: {
    count: 2,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'REBEC',
    firstSaidQuote: "No, Maret and Latep, they're following.",
  },
  latep: {
    count: 21,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'REBEC',
    firstSaidQuote: "No, Maret and Latep, they're following.",
  },
  marat: {
    count: 8,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Come on, hurry up. The door's going to close. Come on through. Come on, Marat! Marat, come on! Marat!",
  },
  hyper: {
    count: 11,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, and hyper-cold. Yes, it's an odd phenomena, the water on this planet. It sustains sub-zero temperatures and yet remains semi-liquid.",
  },
  nobel: {
    count: 3,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'STEVENS',
    firstSaidQuote: 'The Nobel prize winner?',
  },
  apple: {
    count: 22,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "There's precious little protein in an apple, you know.",
  },
  stint: {
    count: 3,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JONES',
    firstSaidQuote: "Did my stint in the fields before breakfast, didn't I.",
  },
  goats: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JONES',
    firstSaidQuote:
      'Well, now, what. Shut the blasted door! Of all the silly young goats.',
  },
  orbis: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JONES',
    firstSaidQuote: 'This is really our new hybrid fungus, Saliota Orbis.',
  },
  elgin: {
    count: 8,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'STEVENS',
    firstSaidQuote: 'Yes, of course. Elgin, get an outside line, will you?',
  },
  hinks: {
    count: 3,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'STEVENS',
    firstSaidQuote: 'Hinks. At once.',
  },
  akido: {
    count: 2,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Venusian akido, gentlemen. I do hope I haven't hurt you.",
  },
  lamps: {
    count: 8,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BERT',
    firstSaidQuote:
      "Oh, we have about another hundred feet or so and then we start to go up. If we can do that, we'll find the emergency shaft. Oh, it only goes up for about forty five degrees and it comes out on the hillside. Oh, better save the lamps, eh?",
  },
  basin: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote: 'What, the Amazon basin? Oh surely not.',
  },
  grubs: {
    count: 2,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JONES',
    firstSaidQuote:
      'No, no, I mean the things people eat to get their protein. Grubs, caterpillars, locusts, the blood of their cattle.',
  },
  perky: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JO',
    firstSaidQuote:
      "I know that really. It's just he was, he was such a perky little man. He called me Blodwyn. Cliff, I'm sorry. I don't know why I'm crying. A funny little Welshman that I hardly knew.",
  },
  dicks: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BENTON',
    firstSaidQuote: 'Come on, Dicks, get a move on!',
  },
  carlo: {
    count: 4,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MILKMAN',
    firstSaidQuote:
      "What's going on here? Orders? What do you mean, orders? I suppose if your officer gave you orders to kick the Prince of Wales, old Carlo, up his royal britches, you'd do it, I suppose, would you? What about Miss Cartwright's ginger cat, eh? At death's door, he is, poor devil, not to mention Tom the sea captain.",
  },
  mucus: {
    count: 4,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JONES',
    firstSaidQuote: 'Mine. Mucus membrane cells.',
  },
  arose: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'YATES',
    firstSaidQuote:
      "Well naturally, I have the utmost confidence in the security. In fact, they've, er, doubled it up since the problem arose. So we've no worries there.",
  },
  rosie: {
    count: 2,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Me, oh, I'm his Da. I mean, they told me I was too old to take over, they did, but I've been doing this milk round, oh, fifty-three years, wet or fine, didn't I. Oh, there's life in the old dog yet. Ah, I was only saying to Rosie up at the Red Dragon. A big fine strapping girl she is",
  },
  apron: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JO',
    firstSaidQuote: 'In a frilly cap and an apron?',
  },
  slosh: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: " Do you? Well, watch out I don't slosh you with it!",
  },
  betts: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BENTON',
    firstSaidQuote: "That'll be all, Betts, thank you. Sir.",
  },
  slice: {
    count: 9,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote: 'Rather have a slice of beef. What are you trying to do?',
  },
  elite: {
    count: 28,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BOSS',
    firstSaidQuote:
      'No. No, he will make an interesting experiment. Total processing comes next. He shall be the first of the new slave elite. See to it.',
  },
  amino: {
    count: 6,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Making an aqueous extract of the amino fraction of this fungus.',
  },
  wilde: {
    count: 1,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BOSS',
    firstSaidQuote:
      'Stevens? You are inefficient but you are also a fool. As Oscar Wilde so very nearly said, to lose one prisoner may be accounted a misfortune, to lose two smacks of carelessness.',
  },
  crest: {
    count: 3,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BOSS',
    firstSaidQuote:
      'Stevens, you know, we should have arranged for a symphony orchestra to herald my triumph. To take over the world, to sweep into power on the crest of a wave of Wagnerian sound! You like that idea, of course?',
  },
  sails: {
    count: 9,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BOSS',
    firstSaidQuote:
      "Minutes before the moment of truth sails towards us on time's winged chariot. I love a really juicy mixed metaphor, Stevens. Oh, very well, phase two.",
  },
  telex: {
    count: 3,
    firstSaidSeasonIndex: 10,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "I've got a wedding present for you. It's a telex from Geneva, granting your place here official status as a United Nations Priority One Research Complex.",
  },
  dregs: {
    count: 21,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MEG',
    firstSaidQuote:
      "'Tis the dregs of the barrel, Captain. 'Tis the last there is.",
  },
  swill: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      'And meanwhile our fine neighbours feast their bellies full on fresh meat and swill down flagons of fine wine.',
  },
  smote: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      'Magic weapons? Like that, that smote the sword from my hand?',
  },
  forge: {
    count: 5,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      'An armourer to sharpen weapons, a smith with a forge if these will serve your need.',
  },
  claps: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BLOODAXE',
    firstSaidQuote: 'Oh! Claps the ears!',
  },
  surly: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      'I have a prisoner in the dungeon, a surly fellow who will not speak.',
  },
  flees: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BLOODAXE',
    firstSaidQuote:
      'He flees through the forest. Take him! After him, you dogs! Through the forest!',
  },
  spits: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote: 'Ah, she spits fire, eh, Bloodaxe? Come here, girl.',
  },
  vixen: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      'Ah, that narrow-hipped vixen. Bloodaxe, tomorrow we dine at Wessex Castle.',
  },
  buxom: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      "I've got it! It's one of those tourist places. A medieval castle all restored to its original condition, with jolly banquets and buxom serving wenches. That's it, isn't it? Mind you, I think you've overdoing the sordid realism a bit. I mean, I know things were a bit grotty in the Middle Ages, but, really, you might leave the tourists a bit of glamorous illusion. I've never seen such a scurvy, smelly",
  },
  cluck: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote: 'Linx, you cluck away like a broody old hen.',
  },
  grabs: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      "Oh, she'll not get far before one of my guards grabs her tail. Now, show me. Show me how it fights. Make it walk again.",
  },
  truer: {
    count: 3,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      'Aye. And never was truer word spoken. Are they all so fair of face beyond the stars?',
  },
  rutan: {
    count: 14,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'LINX',
    firstSaidQuote:
      'Emergency landing. I was on a reconnaissance mission when I was attacked by a squadron of Rutan fighters. You have encountered my race before, Doctor?',
  },
  rates: {
    count: 8,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'LINX',
    firstSaidQuote:
      'You will monitor progress rates on the input panel against the programmer. Now I must leave you in charge for a time.',
  },
  crows: {
    count: 6,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote: "By sunset he'll be feeding the crows.",
  },
  shank: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote: 'Is this Doctor a long shank rascal with a mighty nose?',
  },
  bangs: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Gas? Good heavens, what on Earth do you take me for? No, it was some sort of superior stink bomb with a few bangs and flashes thrown in for good measure. No, it's quite harmless, I assure you, but phew.",
  },
  scant: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      'Bring me wine! Wine, I say! To quench the dust from my throat and the stench from my nostrils. More, wench! More! Am I a sparrow to quench my thirst with a few scant drops? Oh, mice! A few loud noises, a few bad smells and you scatter like sheep!',
  },
  taunt: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      "Taunt me not, little toadface, or by the stars I'll see if the colour of your blood is red like mortal man's.",
  },
  dolts: {
    count: 4,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      "Aye, 'tis as well for you dolts that you have me to guide you. Ah, there's more to war than hard strokes, my good Bloodaxe.",
  },
  friar: {
    count: 3,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GUARD',
    firstSaidQuote: 'Hold, friar. What business have you here?',
  },
  osmic: {
    count: 5,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "If I can get these people to respond, I can send them back to their own time with Linx's osmic projector.",
  },
  polka: {
    count: 4,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Polka time!',
  },
  stoat: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      'Fetch me Linx. Fetch me that scabby faced stoat from his burrow.',
  },
  toils: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'My master toils in his workshop to make you more fighting robots. He sent me as proof of his goodwill.',
  },
  ninny: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      'This iron man talks like some Norman ninny. Lift up your visor.',
  },
  lusty: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MEG',
    firstSaidQuote:
      "What, meat for those common creatures? I should say not. They'll have oatmeal the same as the rest of us, and lusty enough they are on that. So you watch yourself if ever you take out that skillet.",
  },
  smite: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      'He does not understand our ways. Tomorrow, Linx, we smite the enemy, hip and thigh. But tonight, we feast.',
  },
  thigh: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'IRONGRON',
    firstSaidQuote:
      'He does not understand our ways. Tomorrow, Linx, we smite the enemy, hip and thigh. But tonight, we feast.',
  },
  waken: {
    count: 8,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BLOODAXE',
    firstSaidQuote:
      'Flee, dogs! Flee for your life! Come on, waken, you dogs! And flee, flee for your lives, you dogs! Waken! Waken up! Now flee!',
  },
  ogden: {
    count: 4,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BENTON',
    firstSaidQuote: 'Thank you, Ogden.',
  },
  deary: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, deary me, that's very antiquated equipment, isn't it? I'll think you'll find that the right is my best side.",
  },
  eater: {
    count: 6,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'The difference, Brigadier, is that the brontosaurus is a placid vegetarian, whereas the Tyrannosaurus is the largest and fiercest flesh eater ever known on your planet.',
  },
  crank: {
    count: 7,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote:
      "Yes, that's right. All the government scientific advisors said the fellow was a crank. What about him?",
  },
  upped: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      'He vanished about six months ago. Just upped and left home.',
  },
  nigel: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      "I interviewed you about that Private Member's Bill of yours against the pollution of rivers. And you're Nigel Castle, the novelist.",
  },
  usury: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'RUTH',
    firstSaidQuote:
      'People on Earth were allowed to choose. And see what kind of a world they made. Moral degradation, permissiveness, usury, cheating, lying, cruelty.',
  },
  oojah: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BENTON',
    firstSaidQuote:
      "You'd better start overpowering me, hadn't you. You know, a bit of your Venusian oojah?",
  },
  purer: {
    count: 3,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GROVER',
    firstSaidQuote:
      'By rolling back time, by taking the Earth back to an earlier, purer age.',
  },
  filth: {
    count: 14,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's not the the oil and the filth and the poisonous chemicals that are the real cause of pollution, Brigadier. It's simply greed.",
  },
  salts: {
    count: 5,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SARAH',
    firstSaidQuote: 'Like swimming in a glass of health salts.',
  },
  mains: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'We seem to have got a mains power',
  },
  click: {
    count: 11,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, exactly. Not a click, not a tick. Nothing. The Tardis is a living thing, thousands of instruments. Its energy sources never stop.',
  },
  genie: {
    count: 3,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      "Ah, don't tell me. You're going to rub it and produce a genie.",
  },
  peter: {
    count: 38,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'RAILTON',
    firstSaidQuote: "It's all right, Peter. He's quite friendly.",
  },
  chums: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, that's pure wishful thinking, Jill. The Daleks won't give us any loyalty and I don't expect too much help from your space chums either.",
  },
  pally: {
    count: 3,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      "Well, they'll be all right. They seemed pretty pally with the Daleks.",
  },
  lance: {
    count: 45,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ECKERSLEY',
    firstSaidQuote:
      "Oh, they'll come round to it. At least they've agreed to use the sonic lance.",
  },
  ettis: {
    count: 26,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ECKERSLEY',
    firstSaidQuote: "What's going on? Hey, Ettis. What's all the panic?",
  },
  gebek: {
    count: 72,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THALIRA',
    firstSaidQuote:
      'And we are grateful for yours, Gebek. Can you persuade your miners to overcome their fears and use the new Federation tools?',
  },
  nexos: {
    count: 3,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ECKERSLEY',
    firstSaidQuote:
      'Nexos? If you will just keep your eyes on that section of the wall over there.',
  },
  preba: {
    count: 4,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ETTIS',
    firstSaidQuote:
      "Alien work. In case we can't break it down, Preba, you go and find an alien to open it for us.",
  },
  musky: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      "Oo, that smell. It's sort of musky, like the lion house at the zoo.",
  },
  tirri: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Klokleda partha mennin klatch. Haroon, haroon, haroon. Klokleda sheena tirri natch. Haroon, haroon, haroon.',
  },
  natch: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Klokleda partha mennin klatch. Haroon, haroon, haroon. Klokleda sheena tirri natch. Haroon, haroon, haroon.',
  },
  tamer: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      'You should have been a lion tamer, Doctor. How did you manage to do that?',
  },
  sskel: {
    count: 11,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'AZAXYR',
    firstSaidQuote:
      'Your Majesty, please accept my apology. This demonstration of our power was forced upon us. I trust another will not be necessary? Sskel, take the Doctor and his companion to the communications room. Ambassador, Engineer Eckersley, will you accompany them?',
  },
  orton: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THALIRA',
    firstSaidQuote:
      'What would you have me do, Orton? Stay here to become a puppet queen for Commander Azaxyr? See my people made slaves?',
  },
  clegg: {
    count: 10,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HOST',
    firstSaidQuote:
      'And now, ladies and gentlemen, a slight contrast. That mind reader extraordinaire, Professor Herbert Clegg!',
  },
  tommy: {
    count: 45,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BARNES',
    firstSaidQuote:
      "Go and get on with your work, Tommy. You're not wanted here.",
  },
  percy: {
    count: 8,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      "Okay, so maybe meditation's the in-thing. Maybe I can sell it to Percy. I still want to know what it's all about. Look, you'd better start at the beginning. I mean, what are you doing here anyway?",
  },
  wiles: {
    count: 3,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MIKE',
    firstSaidQuote: ' A shameless display of feminine wiles. Come on.',
  },
  pepys: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You know, I've always said that next to Mrs Samuel Pepys you make the finest cup of coffee in the world.",
  },
  chips: {
    count: 53,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      'You know, this is barmy. Here am I, calmly discussing fabulous planets with blue moons, giant spiders, magic crystals, as if I was talking about er, pussycats, fish and chips and the Liverpool docks.',
  },
  pushy: {
    count: 1,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Look, Venerable, may we see this man Lupton now? I'm sorry to seem pushy but it is very important.",
  },
  draga: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'GUARD',
    firstSaidQuote:
      'Hear now, Huarth, most noble of the noble ones, Queen of the eight legs, speaks thus. Arak, male two leg, having attacked field guard Draga, leaving him for dead, the same Arak will now surrender himself.',
  },
  sabor: {
    count: 13,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'NESKA',
    firstSaidQuote: "No, Sabor, it's too dangerous.",
  },
  neska: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SABOR',
    firstSaidQuote:
      "Draga is a bad field guard. He's unfair, he's cruel. He struck Neska, Arak's mother, for no good reason.",
  },
  stoic: {
    count: 2,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Look, much as I admire your stoic acceptance of the inevitable, I would appreciate it if you'd shut up for a moment. What I'm trying to do requires the utmost concentration.",
  },
  scarf: {
    count: 21,
    firstSaidSeasonIndex: 11,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'I apologised to the Rinpoche for not bringing him a cotton scarf.',
  },
  spins: {
    count: 2,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'And stupid. If the square on the hypotenuse equals the sum of the square on the other two sides, why is a mouse when it spins? Never did know the answer to that one.',
  },
  props: {
    count: 2,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BENTON',
    firstSaidQuote:
      "Only its not a proper tunnel. I mean, no props or anything. Just the earth been shoved aside. Whoever went through it wouldn't be able to breathe.",
  },
  alice: {
    count: 11,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Said Alice.',
  },
  macro: {
    count: 4,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Judging by the macro-slave drive and that modified version of the Bennett oscillator, I'd say this was built in the early thirtieth Century?",
  },
  nerva: {
    count: 30,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MAN',
    firstSaidQuote:
      "Welcome, sister. Welcome to Nerva. No, do not move. It is dangerous to move from the tranquiller couch. Please remain in contact with the biocryonic vibrations. In five minutes, the final phase of your processing must commence. If you have any personal possessions that you wish to have preserved, please place them in the casket adjacent to your right hand. Shortly you will hear the recorded voice of the High Minister speaking personally to you. At the conclusion of the Minister's message, there will be a two minute interregnum preceding the commencement of irradiation.",
  },
  snail: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Or a snail.',
  },
  mould: {
    count: 3,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HARRY',
    firstSaidQuote: "Perhaps it's some kind of mould.",
  },
  techs: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VIRA',
    firstSaidQuote: 'You claim to be med-techs?',
  },
  monod: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VIRA',
    firstSaidQuote: 'I will inject a monod block.',
  },
  lazar: {
    count: 6,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VIRA',
    firstSaidQuote:
      'It is a name from mythology. His real name is Lazar, but we called him Noah as an amusement.',
  },
  muzzy: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SARAH',
    firstSaidQuote: 'I feel so muzzy.',
  },
  cocky: {
    count: 4,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HARRY',
    firstSaidQuote: "Cocky bunch, aren't they.",
  },
  libri: {
    count: 9,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'NOAH',
    firstSaidQuote: 'Welcome, Libri.',
  },
  genus: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's a genus of wasps that paralyses caterpillars and lays its eggs in their bodies. When the larvae emerge, they have a ready made food supply. Strange how the same life patterns recur throughout the universe.",
  },
  wasps: {
    count: 6,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's a genus of wasps that paralyses caterpillars and lays its eggs in their bodies. When the larvae emerge, they have a ready made food supply. Strange how the same life patterns recur throughout the universe.",
  },
  recur: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's a genus of wasps that paralyses caterpillars and lays its eggs in their bodies. When the larvae emerge, they have a ready made food supply. Strange how the same life patterns recur throughout the universe.",
  },
  stony: {
    count: 2,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WOMAN',
    firstSaidQuote:
      'You have slept longer than the recorded history of mankind, and you stand now at the dawn of a new age. You will return to an Earth purified by flame, a world that we cannot guess at. If it be arid, you must make it flourish. If it be stony, you must make it fertile. The challenge is vast, the task enormous, but let nothing daunt you.',
  },
  daunt: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WOMAN',
    firstSaidQuote:
      'You have slept longer than the recorded history of mankind, and you stand now at the dawn of a new age. You will return to an Earth purified by flame, a world that we cannot guess at. If it be arid, you must make it flourish. If it be stony, you must make it fertile. The challenge is vast, the task enormous, but let nothing daunt you.',
  },
  totem: {
    count: 10,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HARRY',
    firstSaidQuote:
      'Well, I mean, fancy a member of the fair sex being top of the totem pole.',
  },
  wirrn: {
    count: 29,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'NOAH',
    firstSaidQuote:
      'Before the Wirrn. Vira, take command. Now hear me. You take command!',
  },
  rogin: {
    count: 15,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VIRA',
    firstSaidQuote: 'Welcome, Lycett, Rogin. You feel well?',
  },
  imago: {
    count: 2,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Four whole days? At the rate at which the Wirrn are developing, they'll have pupated to imago long before then, and you know what that means.",
  },
  pupal: {
    count: 3,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Between the larval and imago forms, there must be a pupal stage. Now, the Wirrn will be dormant and defenceless. If we can find their weaknesses?',
  },
  fence: {
    count: 10,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SARAH',
    firstSaidQuote: 'Like an electric fence?',
  },
  diode: {
    count: 2,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, it could if it was functioning properly. The signal's faulty. Probably the diode receptors. I'll just beam down and check them.",
  },
  morse: {
    count: 7,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'HARRY',
    firstSaidQuote: 'I feel a bit like a Morse message. Slightly scrambled.',
  },
  krans: {
    count: 4,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ERAK',
    firstSaidQuote: "Krans! Krans! I've seen some guy. A stranger.",
  },
  vural: {
    count: 8,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ERAK',
    firstSaidQuote:
      "Zake's watching him, down by that circle. I thought maybe Vural ought to know.",
  },
  heath: {
    count: 5,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROTH',
    firstSaidQuote: 'He killed Heath and Splier. I got away. Understand?',
  },
  gully: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I'd not kill him. I heard a cry and found him with his neck broken in a gully. An accident, I imagine.",
  },
  rothy: {
    count: 2,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ERAK',
    firstSaidQuote: 'Hey, Rothy! Hey! Hey, Rothy!',
  },
  styre: {
    count: 23,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'STYRE',
    firstSaidQuote:
      'Identical, yes, the same, no. I am Styre. Field Major Styre, as you will address me, of the Sontaran G3 Military Assessment Survey. And your opinion of my looks is of no interest to my programme.',
  },
  moron: {
    count: 16,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'STYRE',
    firstSaidQuote:
      'Silence! The moron was of no further use to me. I had already tested him. You, as a female, are far more interesting. And soon I will have the rest of your companions.',
  },
  swine: {
    count: 8,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ERAK',
    firstSaidQuote:
      'Why you stinking, lousy swine, Vural! You tried to do a deal with this thing?',
  },
  ravon: {
    count: 5,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KALED',
    firstSaidQuote:
      "They don't look like Thals. I wonder? There've been rumours recently that the Thals were developing robots. Anyway, stick them on the transporter. I shall alert Command Headquarters with General Ravon.",
  },
  mutos: {
    count: 15,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'RAVON',
    firstSaidQuote:
      'So, the Thals have come down to recruiting mutos, have they? Turn out your pockets!',
  },
  nyder: {
    count: 23,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'RAVON',
    firstSaidQuote: 'Nyder.',
  },
  kaled: {
    count: 28,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'NYDER',
    firstSaidQuote:
      'We must keep the Kaled race pure. Imperfects are rejected. Some of them survive out there.',
  },
  norms: {
    count: 3,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GERRILL',
    firstSaidQuote:
      "She is a norm. All norms are our enemies. Kill her now for what she's done to our kind.",
  },
  butts: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, good, good. Then perhaps we can talk without interruption from rifle butts.',
  },
  reams: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "They took down reams of notes, every bit of scientific gobbledygook I could think of. Technical jargon that even I didn't understand.",
  },
  trend: {
    count: 2,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'RONSON',
    firstSaidQuote:
      'Now Davros, he believed that there was no way to reverse this trend and so he started experiments to establish our final mutational form. He took living cells, treated them with chemicals and produced the ultimate creature. Come with me.',
  },
  magna: {
    count: 31,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'HARRY',
    firstSaidQuote: 'Magna peloris.',
  },
  waver: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GHARMAN',
    firstSaidQuote:
      ' Spread the word. Convince those who waver how vital it is that the whole Dalek project be ended.',
  },
  caved: {
    count: 2,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SEVRIN',
    firstSaidQuote:
      'Well, the only other way was from the Kaled dome, and your war rocket caved that it. It can never be cleared.',
  },
  pluto: {
    count: 14,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'WARNER',
    firstSaidQuote:
      'This is Nerva Beacon calling Pluto Earth flight One Five. This is Nerva Beacon calling Pluto Earth flight One Five. Pluto Earth flight One Five, are you reading me?',
  },
  fives: {
    count: 3,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COLVILLE',
    firstSaidQuote:
      'Hello Nerva Beacon, we read you fives clear. Our dropover tango oscar alpha estimated at 13.20.',
  },
  vorus: {
    count: 45,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MAGRIK',
    firstSaidQuote:
      'Your plan frightened him, Vorus. Sometimes it frightens me.',
  },
  venom: {
    count: 20,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SARAH',
    firstSaidQuote: 'You mean venom?',
  },
  zerus: {
    count: 1,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MAN',
    firstSaidQuote:
      "Comm. ops magazines which departed from the ship's cell. In the constellation of Zerus X 20, the intensity of radiation caused severe distortion. When the computer dealt with the trouble",
  },
  tyram: {
    count: 13,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VORUS',
    firstSaidQuote: 'Greetings, Councillor Tyram.',
  },
  carat: {
    count: 3,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HARRY',
    firstSaidQuote: 'Twenty four carat, by the looks of it.',
  },
  guild: {
    count: 4,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'VOGAN',
    firstSaidQuote: 'Stay back! No one enters the guild room of the Guardians.',
  },
  vogan: {
    count: 3,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HARRY',
    firstSaidQuote:
      "No, you see, it seems that Kellman, er, he's dead, by the way. Kellman was really working for the Vogan people, and he got the other half, the, what do you call them?",
  },
  dusty: {
    count: 9,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Dusty death. Out, out with',
  },
  irony: {
    count: 8,
    firstSaidSeasonIndex: 12,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Nice sense of irony. I thought for a moment he was going to smile.',
  },
  angus: {
    count: 3,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BENTON',
    firstSaidQuote:
      "Hey, listen to that. That's old Angus at it again. Okay. Take her in.",
  },
  murky: {
    count: 3,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'McRANALD',
    firstSaidQuote:
      "Tullock Moor's a strange, murky sort of place. When the mist comes down, it's like steam frae a witch's cauldron. Nobody from these parts will cross the moor after dark.",
  },
  haunt: {
    count: 7,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'McRANALD',
    firstSaidQuote:
      'It was, let me see, 1870. They went out cutting peat and the mist came down. Donald just disappeared. They found the older brother, Robert, two days later, wandering about, off his head. His eyes, his eyes were terrible to see. For the rest of his life he never spoke again. Take my word for it, my dear. There are ancient mysteries here. Evil spirits haunt Tullock Moor.',
  },
  nevis: {
    count: 5,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MAN',
    firstSaidQuote: 'Hibernian Control. Number three Ben Nevis rig. Over.',
  },
  mcnab: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CORPORAL',
    firstSaidQuote:
      "Sorry, sir. Fletcher's squad have reached McNab Point. They're setting up a listening watch now.",
  },
  zygon: {
    count: 53,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZYGON',
    firstSaidQuote:
      'Selected humans provide us with body prints, a Zygon device that is beyond your understanding.',
  },
  caber: {
    count: 3,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ZYGON',
    firstSaidQuote:
      'See this one? A worthless creature known as the Caber. Now watch.',
  },
  braun: {
    count: 4,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BALDWIN',
    firstSaidQuote: "Right. Professor, that was Braun. We've got to leave.",
  },
  ponti: {
    count: 5,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SALAMAR',
    firstSaidQuote:
      "Crew deck, orbital entry imminent. Ponti and de Haan to command area. Ponti and de Haan to command area. Vishinsky, you'll lead the landing party.",
  },
  elfin: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SARAH',
    firstSaidQuote: 'What was that, an elfin spirit of the forest?',
  },
  motto: {
    count: 4,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DE HAAN',
    firstSaidQuote:
      'Carry them in, carry them out. That ought to be the Space Service motto.',
  },
  horus: {
    count: 21,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SCARMAN',
    firstSaidQuote:
      "Achmed, your lantern, man. Quickly, quickly. It's the Eye of Horus.",
  },
  vicky: {
    count: 3,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Hello, Vicky.',
  },
  namin: {
    count: 5,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'NAMIN',
    firstSaidQuote: 'I am Ibrahim Namin.',
  },
  chalk: {
    count: 9,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WARLOCK',
    firstSaidQuote: 'Oh, no, sir. Not by a long chalk!',
  },
  mummy: {
    count: 193,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "That isn't all must, Sarah. Some of it's mummy. French picklock. Never fails. Belonged to Marie Antoinette. Charming lady. Lost her head, poor thing.",
  },
  cairo: {
    count: 2,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WARLOCK',
    firstSaidQuote:
      "To say that he's not been seen for weeks. That his baggage is lying unclaimed in his hotel. Oh, yes, I've had some enquiries made in Cairo.",
  },
  loops: {
    count: 7,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SCARMAN',
    firstSaidQuote: 'Take up the generator loops.',
  },
  thine: {
    count: 3,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Four men, Sarah. Five, if you include Professor Scarman himself, and they're merely the first of millions unless Sutekh is stopped. Know thine enemy. Admirable advice.",
  },
  sodos: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Serve you, Sutekh? Your name is abominated in every civilised world, whether that name be Set, Satan, Sodos',
  },
  abase: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SUTEKH',
    firstSaidQuote:
      'In my presence, you are an ant, a termite. Abase yourself, you grovelling insect.',
  },
  minie: {
    count: 2,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Eenie, meenie, minie, mo?',
  },
  fleur: {
    count: 3,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SARAH',
    firstSaidQuote: "Er, Fleur de Lys, wasn't it?",
  },
  tweed: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      " The man in the tweed jacket, that's Mister Morgan, the landlord.",
  },
  kraal: {
    count: 6,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'STYGGRON',
    firstSaidQuote:
      'Do as I say. The Doctor may have learned of the Kraal plan. He may be here to spy. It is essential for us to know.',
  },
  edged: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CHEDAKI',
    firstSaidQuote:
      'The androids are a double-edged weapon, Styggron. They are unstoppable, indestructible.',
  },
  agley: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'The best laid schemes of mice and Kraals gang aft agley.',
  },
  masha: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Shush, shush, shush. Once upon a time, there were three sisters, and they lived at the bottom of a treacle well. Their names were Olga, Masha, and Elena. Are you listening, Tilly?',
  },
  elena: {
    count: 4,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Shush, shush, shush. Once upon a time, there were three sisters, and they lived at the bottom of a treacle well. Their names were Olga, Masha, and Elena. Are you listening, Tilly?',
  },
  tilly: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Shush, shush, shush. Once upon a time, there were three sisters, and they lived at the bottom of a treacle well. Their names were Olga, Masha, and Elena. Are you listening, Tilly?',
  },
  tessa: {
    count: 2,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GRIERSON',
    firstSaidQuote: 'Contact confirmed. Well done, Tessa.',
  },
  condo: {
    count: 58,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SOLON',
    firstSaidQuote: 'You were quick, Condo. Were there no survivors?',
  },
  boxed: {
    count: 2,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      "They're probably afraid of getting them boxed, the way you're carrying on.",
  },
  maren: {
    count: 28,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'OHICA',
    firstSaidQuote: 'A male and a female, Maren, in the valley below.',
  },
  ohica: {
    count: 15,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MAREN',
    firstSaidQuote: 'Then how? How, Ohica?',
  },
  solon: {
    count: 52,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SOLON',
    firstSaidQuote: 'Solon.',
  },
  medic: {
    count: 12,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SOLON',
    firstSaidQuote: 'I think just one medic is sufficient to.',
  },
  brood: {
    count: 4,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SOLON',
    firstSaidQuote:
      "Then he must still be unconscious. He can't have moved. That squalid brood of harpies, the Sisterhood. That accursed hag Maren found I was holding a Time Lord and rescued him. May her stinking bones rot! I'll see her die, Condo. I'll see that palsied harridan scream for death before Morbius and I are finished with her.",
  },
  feign: {
    count: 2,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MAREN',
    firstSaidQuote: 'You feign ignorance, Time Lord?',
  },
  optic: {
    count: 9,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yeah, of course it is. The flash probably numbed the optic nerve. It'll wear off in a few hours. Come on.",
  },
  lurks: {
    count: 2,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SOLON',
    firstSaidQuote:
      "Why, I've misjudged you all this time, Condo. Under that brutish exterior there lurks a tender, compassionate nature.",
  },
  organ: {
    count: 10,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SOLON',
    firstSaidQuote:
      "Every part of this, every organ is mine, with my own hands. They'll see. And it's functioning perfectly, exactly to the required standard. It only needs the head and I It's getting dark already. Maren should have sent the Doctor's head by now. Nothing could have gone wrong. Condo saw him go into the Shrine. I don't understand it.",
  },
  kelia: {
    count: 2,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MAREN',
    firstSaidQuote: 'Who is responsible? Who killed Kelia, our sister?',
  },
  garde: {
    count: 3,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'En garde, Morbius.',
  },
  gourd: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WINLETT',
    firstSaidQuote: 'It looks tropical to me, like a gourd.',
  },
  derek: {
    count: 11,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WINLETT',
    firstSaidQuote: 'Derek!',
  },
  ducat: {
    count: 10,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Amelia Ducat.',
  },
  annex: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HARGREAVES',
    firstSaidQuote: 'Would you go to the annex, please?',
  },
  grams: {
    count: 2,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KEELER',
    firstSaidQuote: "Fifteen grams. Careful. I shouldn't get too close.",
  },
  adams: {
    count: 4,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Franklin Adams, 1881 to 1960. American humourist.',
  },
  gobbo: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CHASE',
    firstSaidQuote:
      'Ah yes, the Venezuelan gobbo. I have several of the species.',
  },
  easel: {
    count: 2,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'AMELIA',
    firstSaidQuote:
      'Even so, I think I could set up my easel here to good purpose.',
  },
  panes: {
    count: 1,
    firstSaidSeasonIndex: 13,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      'I was talking to the Doctor, the line went dead and those vines smashed the panes.',
  },
  helix: {
    count: 22,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "It's the Mandragora Helix. I thought we'd avoided it.",
  },
  lambs: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PRIEST',
    firstSaidQuote:
      'It is written that some are conscious of the purpose for which they are chosen. Others are as innocent lambs.',
  },
  adeus: {
    count: 2,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MONK',
    firstSaidQuote: 'Demnos, Demnos, Demnos. Adeus, O Demnos.',
  },
  roost: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'The Mandragora Helix has come home to roost.',
  },
  milan: {
    count: 3,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FEDERICO',
    firstSaidQuote:
      'The King of Naples, Duke of Milan, Duke of Padua, Doge of Venice, Signora of Florence. Very impressive.',
  },
  padua: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FEDERICO',
    firstSaidQuote:
      'The King of Naples, Duke of Milan, Duke of Padua, Doge of Venice, Signora of Florence. Very impressive.',
  },
  focal: {
    count: 2,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Those ruins are the focal point for enormous forces. The Helix energy has penetrated every stone. Is there some way I could get there without being seen?',
  },
  hovel: {
    count: 2,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FEDERICO',
    firstSaidQuote:
      "We must search the city. He's skulking in some stinking hovel. Oh no, I've gone too far now. Before sunrise, I want to see Giuliano's liver fed to the dogs.",
  },
  peers: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MARCO',
    firstSaidQuote:
      'Would you explain to your peers that your accession cannot be celebrated because of a pagan uprising?',
  },
  obarl: {
    count: 4,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ROKON',
    firstSaidQuote:
      'Central Command to Outer Dome Six, report. Module status report immediately, Technic Obarl.',
  },
  spans: {
    count: 7,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ZAZZKA',
    firstSaidQuote:
      'Obliteration module on course and normal function. Now nineteen spans into mission.',
  },
  rokon: {
    count: 9,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ZAZZKA',
    firstSaidQuote:
      'But King Rokon, sire. Total obliteration of the traitor Eldrad was ordered.',
  },
  siren: {
    count: 28,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "What? I can't hear you for the siren.",
  },
  flags: {
    count: 6,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ABBOTT',
    firstSaidQuote:
      "Didn't you see the signs, the flags? Well, you must have heard the hooter. Are you all right?",
  },
  viral: {
    count: 8,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Such as viral infection on this planet.',
  },
  pandy: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CARTER',
    firstSaidQuote:
      "Reception? Doctor Carter here. Now listen. The dark haired young woman wearing some pink-striped overalls. Yes, pink-striped overalls. Yes, just like Andy Pandy. Well, she's on her way out. She's stolen something from my lab. Well, hold her, will you, and call the police. What do you mean, she left an hour ago? Why, it's only just a few. Good grief.",
  },
  susie: {
    count: 7,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WATSON',
    firstSaidQuote:
      "Hello, Susie? Hello, darling. Is mummy there? Oh, did you? Well, your headmistress must have been very pleased. No, no, super. Super. Get mummy for me, would you? Hello, love. Well, it's just to let you know I've got to stay on at the Complex for a while. Yes, it looks like it. No, no, there isn't anything wrong, it's just that, well, I thought I'd let you know where I was.",
  },
  abyss: {
    count: 3,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "It's an abyss.",
  },
  engin: {
    count: 13,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SPANDRELL',
    firstSaidQuote: 'One minute, Engin.',
  },
  usher: {
    count: 2,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SPANDRELL',
    firstSaidQuote:
      'Do you think they will stop Gold Usher? Would you? Get over there and try to find him.',
  },
  solis: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SPANDRELL',
    firstSaidQuote: "Solis, isn't it?",
  },
  andor: {
    count: 21,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CALIB',
    firstSaidQuote:
      'You are the leader, Andor. It is for you to decide. But there can be but one punishment for such a heresy. Banishment.',
  },
  tomas: {
    count: 25,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'LEELA',
    firstSaidQuote: "Don't beg, Tomas. What I said was the truth.",
  },
  leela: {
    count: 202,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ANDOR',
    firstSaidQuote: 'Leela, will you take the test of the Horda?',
  },
  horda: {
    count: 5,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ANDOR',
    firstSaidQuote: 'Leela, will you take the test of the Horda?',
  },
  neeva: {
    count: 39,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'LEELA',
    firstSaidQuote:
      'Andor, please, call them back. What I said, I was wrong. Forgive me, please. Neeva, greatest shaman, Speaker of Law, forgive me, please.',
  },
  spawn: {
    count: 3,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'NEEVA',
    firstSaidQuote: 'Spawn of the evil one, return to your master.',
  },
  hanky: {
    count: 4,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'I think this is not Hyde Park. Could be a nexial discontinuity. Must remember to overhaul those tracers. Put a knot in my hanky.',
  },
  calib: {
    count: 20,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'LEELA',
    firstSaidQuote:
      "No. Go back to the tribe. I'm going now. Goodbye, Tomas. Beware of the devious Calib. One day he'll get so cunning even he won't know what he's planned.",
  },
  colds: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Leela. Leela, either you've got four friends with very bad colds, or we're in danger. Which is it?",
  },
  toads: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh dear, you too. Well then, tread softly, gentlemen, or I'll turn you into toads.",
  },
  smoky: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'If there happens to be a charge in there, you could transform this whole village into a smoky hole in the ground.',
  },
  janis: {
    count: 10,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'LEELA',
    firstSaidQuote: "Janis thorn. It paralyses, then kills. There's no cure.",
  },
  flick: {
    count: 9,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'What, at this range? No, all it needs is a flick of the wrist. Pick her up.',
  },
  korus: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'WARRIOR',
    firstSaidQuote: 'Something killed Korus. I saw it, over there.',
  },
  jabel: {
    count: 11,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JABEL',
    firstSaidQuote: 'I am Jabel, Captain of the people of Tesh.',
  },
  stein: {
    count: 3,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Be thankful you're living, and trust to your luck, and march to your front like a soldier. Gertrude Stein",
  },
  shumf: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'CHUB',
    firstSaidQuote:
      'Its first client wanted treatment for a stiff elbow. The Voc therapist felt carefully all round the joint and then suddenly just twisted his arm off at the shoulder. Shumf! All over in two seconds.',
  },
  zilda: {
    count: 14,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'UVANOV',
    firstSaidQuote:
      "Please, don't worry about my job, Zilda. What's she blowing, Toos?",
  },
  mover: {
    count: 6,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'UVANOV',
    firstSaidQuote:
      'Duty mover, stand by for switch to motive power. Coming right down our throats so we can really suck the pay stream out of this one.',
  },
  scoop: {
    count: 15,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'V32',
    firstSaidQuote: 'Monitors indicate obstruction on forward scoop deck.',
  },
  alibi: {
    count: 6,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ZILDA',
    firstSaidQuote:
      'To give somebody an alibi, Commander. You sent Poul to look for Chub. You could have arranged it all.',
  },
  stirs: {
    count: 2,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes. I have seen a similar sort of thing on Korlano Beta. The mine passes over the surface searching for useful ores. Naturally, the heavier elements tend to sink into the substratas, so a really good sandstorm is a bonus. It stirs things up a bit.',
  },
  scars: {
    count: 4,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'LEELA',
    firstSaidQuote:
      "My tribe has a saying. If you're bleeding, look for a man with scars.",
  },
  dumbs: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Professional interest or morbid curiosity? Which? There are three types of robots aboard this mine. Dumbs, Vocs, a Super Voc, and then there's you. Would you care to explain that? I see. Well then, perhaps I'd better tell SV7 you can talk.",
  },
  taren: {
    count: 12,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'D84',
    firstSaidQuote:
      'A simple precaution. Those letters were signed by Taren Capel.',
  },
  capel: {
    count: 13,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'D84',
    firstSaidQuote:
      'A simple precaution. Those letters were signed by Taren Capel.',
  },
  fixer: {
    count: 3,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'UVANOV',
    firstSaidQuote:
      "Oh good. Somebody's had the sense to hit the robot deactivator switch. Probably Dask. As Chief Fixer he has second line authority on it.",
  },
  dross: {
    count: 2,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'DASK',
    firstSaidQuote:
      'Yes, Doctor. I was brought up a superior being. Brought up to realise my brothers should live as free beings, and not as slaves to human dross.',
  },
  halls: {
    count: 8,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      'Have I ever, in my thirty years in the halls, seen such a dazzling display of lustrous legerdemain? So many feats of superlative, supernatural skill? The answer must be never, sir. Never.',
  },
  coves: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "Courteous coves, these Chinese. I'd have propelled him onto the pavement with a punt up the posterior.",
  },
  casey: {
    count: 27,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "You'd better get your tail pinned on. Linens up in five minutes. Casey, have you got the oopizootics coming on?",
  },
  damme: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "Damme, you don't want to bankrupt me, Casey. Keep your voice down. Threadbare in Carey Street I'll be if people get the notion there's anything wrong with this theatre.",
  },
  carey: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "Damme, you don't want to bankrupt me, Casey. Keep your voice down. Threadbare in Carey Street I'll be if people get the notion there's anything wrong with this theatre.",
  },
  toddy: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SIN',
    firstSaidQuote: 'She been slugging type of toddy.',
  },
  dummy: {
    count: 11,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "Oh, Casey. Don't ever do that to me again. If the celestial Chang caught me trying to pinch his tricks. I had an idea that his dummy was a midget dressed up, but it's just an ordinary vent's doll.",
  },
  hairs: {
    count: 10,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Yes. I think they're rat hairs.",
  },
  clank: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CASEY',
    firstSaidQuote:
      "Shadows don't groan, Mister Jago. Shadows don't clank chains and moan like all the demented souls in hell.",
  },
  sadie: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "There's your ghost. Six-gun Sadie and her Wild West troupe left that behind. All Lombard Street to ninepence, that's what you saw.",
  },
  clang: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      'What you heard was a clang and the rush of water as they closed the sluice gates down on the Thames.',
  },
  spook: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "Yes, a lady's glove, monogrammed EB. Perhaps the ghost dropped it, eh? Come on, we've had enough of your spook.",
  },
  curls: {
    count: 3,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CHANG',
    firstSaidQuote:
      'He is a doctor. Tall with wide pale eyes and hair that curls like the ram. He ask many questions.',
  },
  opium: {
    count: 4,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WENG',
    firstSaidQuote:
      'Your opium-addicted scum are all bunglers, Chang. You should have seen to it yourself.',
  },
  dwarf: {
    count: 14,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LITEFOOT',
    firstSaidQuote:
      "Yes, well, er, put as much in that report as you think will concern the coroner, officer. It's quite clear the man got stupidly drunk and picked a fight with a dwarf.",
  },
  plump: {
    count: 3,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CHANG',
    firstSaidQuote:
      'Tomorrow I bring you two donors. Young, plump, high-spirited girls. The distillation of their life essences will recover your powers, Lord.',
  },
  quail: {
    count: 2,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LITEFOOT',
    firstSaidQuote:
      "Ham, roast beef, chicken, tongue. Those look like quail, unless I'm much mistaken.",
  },
  ching: {
    count: 5,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TERESA',
    firstSaidQuote:
      "Yeah, well, that's how you might see it, Mister Ching-ching, but as far as I'm concerned all I want is a pair of smoked kippers, a cup of rosie and put me plates up for a few hours, savvy?",
  },
  savvy: {
    count: 2,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TERESA',
    firstSaidQuote:
      "Yeah, well, that's how you might see it, Mister Ching-ching, but as far as I'm concerned all I want is a pair of smoked kippers, a cup of rosie and put me plates up for a few hours, savvy?",
  },
  drabs: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CHANG',
    firstSaidQuote: 'Come, you painted drabs. My master must feed.',
  },
  droll: {
    count: 4,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "Ha, ha, very droll. I shall treasure that exceedingly humorous jest, Mister Chang. Oh, Mister Chang? I suppose the little fellow's got a touch of woodworm, what?",
  },
  derby: {
    count: 2,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "Well, he's not going to wear a brown derby and boots, is he, secret investigator like him, a man of a thousand faces.",
  },
  corks: {
    count: 2,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote: 'Oh, corks.',
  },
  nexus: {
    count: 7,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Unsuccessful time travel, Professor. Findicker's discovery of the double nexus particle sent human science up a technological cul-de-sac.",
  },
  zigma: {
    count: 13,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Weng-Chiang is a scientific ignoramus. He doesn't understand the nature of zigma energy.",
  },
  swoon: {
    count: 2,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "Think large, Henry Jago, think large. Shilling a head? I must be crazy. A guinea a head! Conducted tours round the lair of the phantom. I'll lead them myself and modestly mention the part I played in the affair. The ladies will swoon in my arms. Oh, it's a winner. It's a beauty. I'll go bail. I'll clear out all this old junk, call in the electric lighting company.",
  },
  poppy: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Pipe of poppy. It's opium, a narcotic drug.",
  },
  fleck: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "Oh, the trained mind. A fleck of mud here, a speck of paint there. Clues that speak volumes to a trained investigator like him. I'll wager he's on our tracks this very minute.",
  },
  shelf: {
    count: 11,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LITEFOOT',
    firstSaidQuote:
      "My dear man, I'm not thinking of food. I'm thinking that if we take that shelf out and squeeze ourselves in, we can make a surreptitious exit from this establishment via the dining room.",
  },
  betsy: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, the time key. Now heavens to Betsy, where did I last see that?',
  },
  wongs: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "More Wongs for the Tong, I suppose. Do you realise we've been here over an hour?",
  },
  greel: {
    count: 11,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WENG',
    firstSaidQuote: 'I am Magnus Greel!',
  },
  stunt: {
    count: 1,
    firstSaidSeasonIndex: 14,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JAGO',
    firstSaidQuote:
      "I'm not worried, Doctor. I haven't been worried since you turned up. It's just that I'd hate to be gassed before seeing if this stunt works.",
  },
  vince: {
    count: 33,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'REUBEN',
    firstSaidQuote: "Vince here's been seeing stars.",
  },
  frogs: {
    count: 7,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'REUBEN',
    firstSaidQuote:
      "There's the Frogs, the Russkies, Germans too. Can't trust none of them.",
  },
  galli: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Yes, Galli.',
  },
  yacht: {
    count: 7,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'REUBEN',
    firstSaidQuote: "You'm right. Steam yacht, by the look of it.",
  },
  bunks: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'REUBEN',
    firstSaidQuote:
      "Ahoy there. What is it? There's bunks in the sleeping quarters. She's welcome to any of them.",
  },
  bonar: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SKINSALE',
    firstSaidQuote:
      "Some men make me nervous when I'm with them. Salisbury, Bonar Law. With your employer, it's the opposite effect. I get nervous when he's out of my sight.",
  },
  crook: {
    count: 5,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SKINSALE',
    firstSaidQuote:
      'Because your precious employer is a crook and a skunk, my dear, with no scruples about destroying my honour.',
  },
  skunk: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SKINSALE',
    firstSaidQuote:
      'Because your precious employer is a crook and a skunk, my dear, with no scruples about destroying my honour.',
  },
  rigor: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Rigor mortis.',
  },
  blues: {
    count: 7,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "That's the trouble with computers. Always think in black and white. No aquamarines, no blues, no imagination.",
  },
  masts: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes, it causes a sort of halo effect round the masts of ships.',
  },
  lalee: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Hello, Lalee.',
  },
  hives: {
    count: 4,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SAFRAN',
    firstSaidQuote: 'There is no need. We are preparing the hives now.',
  },
  clone: {
    count: 27,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'K9',
    firstSaidQuote: 'Longest recorded clone life, ten mi',
  },
  argon: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'COLBY',
    firstSaidQuote:
      'Of course not. The volcanic sediment is twelve million years old. I accept without reservation the results of your excellent potassium-argon test.',
  },
  colby: {
    count: 12,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'STAEL',
    firstSaidQuote:
      'Colby, Doctor Fendelman is waiting for the corrected coordinates.',
  },
  stael: {
    count: 12,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'FENDELMAN',
    firstSaidQuote: 'Yes. Good, good. Right. Stael, we can begin.',
  },
  leaky: {
    count: 7,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THEA',
    firstSaidQuote: "He's out, exercising Leaky.",
  },
  loony: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MITCHELL',
    firstSaidQuote:
      "My name is Mitchell. I'm the security team leader. And no one is allowed in or out without clearance. This loony old trout seems to think she's an exception.",
  },
  kenya: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'FENDELMAN',
    firstSaidQuote:
      'Oh, this is the ultimate archaeology, Adam. It was data from here which led me to the excavation sites in Kenya. And when we had excavated the skull and assembled it and Thea had dated it, then the real work of this machine could begin.',
  },
  curly: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MOSS',
    firstSaidQuote:
      "Well, there's this bloke calls himself a doctor. Tall, curly hair. He's got a girl working with him. And I told him where to find this place. Well, I didn't realise. I tried to stop him after. They know all about us.",
  },
  rayed: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'FENDELMAN',
    firstSaidQuote:
      'It is the only logical explanation, Adam. Man did not evolve on Earth, of this I am sure. There is something else that I have not told you. With the scanner, I have traced what I now believe to be the moment of death of this alien traveller. At that moment, there is an enormous surge of power the like of which I have not seen before. It was this that first attracted my attention. It is an inpouring of energy. A concentration of power as though to store. Now I ask myself, where would this power be stored? And why? These questions I could not answer until I had x-rayed the skull.',
  },
  maxie: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'COLBY',
    firstSaidQuote:
      "Oh no, Max isn't famous for his sense of humour, are you, Maxie?",
  },
  cores: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Throw in the apple cores very hard, put the lot in a shallow tin and bake in a high oven for two weeks. It's too late. She's slipping away. Come on.",
  },
  jiffy: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MARTHA',
    firstSaidQuote:
      "Here, well, if you'm going to stay, you may as well sit yourselves down. I'll have the tea ready in a jiffy.",
  },
  twere: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MARTHA',
    firstSaidQuote:
      "I seed that figure he spoke of in a dream. 'Twere a woman.",
  },
  hiker: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, it wasn't. It was a Fendahleen. It was the same think that killed the hiker and Mitchell. It can only have been created out of pure energy while the skull was restructuring Thea's brain.",
  },
  peaky: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MARTHA',
    firstSaidQuote: 'You all right, Professor? You look a bit peaky.',
  },
  swede: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'COLBY',
    firstSaidQuote: "Look, don't you threaten me, you swede-bashing cretin.",
  },
  cordo: {
    count: 28,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'WOMAN',
    firstSaidQuote: 'Citizen Cordo, District Four?',
  },
  humid: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Quite warm. Around twenty degrees. Very humid.',
  },
  wiley: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, the taxes. My dear old thing, all you need is a wiley accountant. Would you care for a jelly baby? Hmm? Try one.',
  },
  vibes: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MARN',
    firstSaidQuote: 'The data vibes also indicate illegal landing.',
  },
  flout: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MARN',
    firstSaidQuote:
      "Your Honour, it's inconceivable. To flout so many regulations.",
  },
  acorn: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'HADE',
    firstSaidQuote:
      "It exists, Marn. It exists. Despite the screening and the Preparation Centres and the air conditioning, criminal deviants occur in every generation. Enemies of the Company. On old Earth they had a saying. There's one rotten acorn in every barrel. We must find this filth, Marn. Find it and crush it.",
  },
  axial: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Not if the sidereal and axial rotation periods are the same, or if there's more than one sun.",
  },
  ajack: {
    count: 9,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MANDRELL',
    firstSaidQuote: 'Where are they from? He looks like an Ajack.',
  },
  pearl: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'HADE',
    firstSaidQuote:
      'Ah, what a great truth, your Sublimity. A pearl of wisdom.',
  },
  scabs: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MANDRELL',
    firstSaidQuote: 'Take her, you cowardly scabs! Must I do it myself?',
  },
  wurgs: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'HADE',
    firstSaidQuote:
      'Indeed. There are so many Wurgs and Keeks in Megropolis Three I sometimes wonder how my distinguished colleague, Gatherer Pile, manages to keep track of you all.',
  },
  keeks: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'HADE',
    firstSaidQuote:
      'Indeed. There are so many Wurgs and Keeks in Megropolis Three I sometimes wonder how my distinguished colleague, Gatherer Pile, manages to keep track of you all.',
  },
  rubus: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Rubus idaeus?',
  },
  synge: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MANDRELL',
    firstSaidQuote: "That's right, Synge. What's your answer, B grade? Right.",
  },
  sired: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CORDO',
    firstSaidQuote:
      "We've sired a revolution, Leela. Down with the Company, eh, fellas!",
  },
  taxed: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'And then taxed the life out of them. I mean, to recover your capital costs.',
  },
  leech: {
    count: 7,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You blood-sucking leech! You won't stop until you own the entire galaxy, will you. Don't you think commercial imperialism is as bad as military conquest?",
  },
  index: {
    count: 19,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "He got a bit of a shock. You see, I fed two percent growth tax into the computers. Index linked. Blew the economy and he couldn't take it.",
  },
  ident: {
    count: 9,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JACKSON',
    firstSaidQuote: 'Run it through ident.',
  },
  cubit: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ORFE',
    firstSaidQuote: 'Two four zero and cubit.',
  },
  regen: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JACKSON',
    firstSaidQuote: 'Herrick, take Tala to regen now.',
  },
  grins: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'LEELA',
    firstSaidQuote:
      "You're all laughing at me. I'll smash your stupid grins off your stupid faces.",
  },
  carbo: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JACKSON',
    firstSaidQuote: 'Herrick, carbo-magnetic seat lock.',
  },
  trogs: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TARN',
    firstSaidQuote:
      'Not enough. There were two more bursts yesterday. What we need is a good sacrifice. Trogs always work harder after a good sacrifice.',
  },
  seers: {
    count: 7,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IDMON',
    firstSaidQuote:
      "We all know we're slaves to the guards as the guards are slaves to the Seers.",
  },
  idmon: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RASK',
    firstSaidQuote: 'You know the penalty, Idmon.',
  },
  klimt: {
    count: 9,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'KLIMT',
    firstSaidQuote: 'Klimt here. Possible suspect on nine.',
  },
  realm: {
    count: 20,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ANKH',
    firstSaidQuote: 'The servants of the Oracle. Seers of the realm of Hedas.',
  },
  hedas: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ANKH',
    firstSaidQuote: 'The servants of the Oracle. Seers of the realm of Hedas.',
  },
  jason: {
    count: 12,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "No, no, no time. I'm very busy. Goodbye, Jason.",
  },
  rodan: {
    count: 17,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ANDRED',
    firstSaidQuote:
      'Speak. Where? When? Relative time, please, Rodan. Thank you.',
  },
  gomer: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SAVAR',
    firstSaidQuote:
      'Unsettled times, eh, Gomer? Though still the time will throw up the man.',
  },
  savar: {
    count: 1,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'GOMER',
    firstSaidQuote: 'Just so, Lord Savar. Cyclic burst.',
  },
  vivid: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BORUSA',
    firstSaidQuote:
      "Isn't that a little melodramatic, even for your vivid imagination?",
  },
  rated: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RODAN',
    firstSaidQuote:
      "There's a forcefield between you and me. Between me and everyone. Don't you know this is one of the highest security rated rooms in the Citadel?",
  },
  jasko: {
    count: 3,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ABLIF',
    firstSaidQuote:
      'Thought they were game at first. Jasko nearly put a spear through them.',
  },
  ablif: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'NESBIN',
    firstSaidQuote:
      'And this is Ablif. But what is more to the point, what do you want with us?',
  },
  essay: {
    count: 4,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'If you wanted to hide a tree, where would you hide it? In a forest. I read your essay on reason.',
  },
  widen: {
    count: 6,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'STOR',
    firstSaidQuote:
      'You must widen the gap in the forcefield to allow my battle fleet to enter.',
  },
  metre: {
    count: 2,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'K9',
    firstSaidQuote: 'One rod of type three iridium alloy, one metre in length.',
  },
  demat: {
    count: 4,
    firstSaidSeasonIndex: 15,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "It's the ultimate weapon. The Demat gun.",
  },
  ribos: {
    count: 10,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "One hundred and sixteen parsecs. Must be the planet of Ribos. If it changes again while we're in the vortex, we could lose it. On the other hand",
  },
  graff: {
    count: 21,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GARRON',
    firstSaidQuote:
      "The Graff Vynda-K is arriving. I've got to go and meet him.",
  },
  vynda: {
    count: 6,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GARRON',
    firstSaidQuote:
      "The Graff Vynda-K is arriving. I've got to go and meet him.",
  },
  opeks: {
    count: 8,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GRAFF',
    firstSaidQuote:
      "A great deal less than the ten million opeks you're asking.",
  },
  jests: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GRAFF',
    firstSaidQuote: ' No one jests with me, Sholakh. You know that.',
  },
  taffy: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I wonder if old Taffy knows the real value of it. Scringe stone found in a dead man's pocket? A lost mine? A phony map. Are people still falling for that old guff? I mean, are they?",
  },
  binro: {
    count: 19,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SHRIEVE',
    firstSaidQuote:
      "Of course. Binro. Binro the Heretic. So you're down to this, are you?",
  },
  blunt: {
    count: 6,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GARRON',
    firstSaidQuote: "Oh no, that's a very blunt word, isn't it?",
  },
  chink: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GARRON',
    firstSaidQuote: "Ah, do I hear the chink of the Graff's gold?",
  },
  tibia: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SEEKER',
    firstSaidQuote: 'Deeper, fibula and tibia. Lead us deeper, deeper yet.',
  },
  kimus: {
    count: 14,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MULA',
    firstSaidQuote: "Kimus! Thank goodness it's only you.",
  },
  vigil: {
    count: 6,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MENTIAD',
    firstSaidQuote:
      'Brothers, the Vigil of Evil is accomplished. The one called Pralix must be harvested. The Time of Knowing shall be soon, and fast upon that shall follow the Time of Vengeance. Vengeance for the crimes of Zanak!',
  },
  zanak: {
    count: 22,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MENTIAD',
    firstSaidQuote:
      'Brothers, the Vigil of Evil is accomplished. The one called Pralix must be harvested. The Time of Knowing shall be soon, and fast upon that shall follow the Time of Vengeance. Vengeance for the crimes of Zanak!',
  },
  balag: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CAPTAIN',
    firstSaidQuote: 'By the horns of the prophet Balag, speak!',
  },
  whizz: {
    count: 2,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Macromat field integrator. Has the whizz-bang gone wrong?',
  },
  locus: {
    count: 3,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'And the amblicyclic photon? Would you mind if I examined its locus?',
  },
  fangs: {
    count: 2,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CAPTAIN',
    firstSaidQuote:
      "And so are you. We need not delay your death any longer. By the curl-ed fangs of the sky demon, I've looked forward to this moment.",
  },
  isaac: {
    count: 18,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Old Isaac? Friend of mine on Earth. He discovered gravity. Well, I say he discovered gravity. I had to give him a bit of a prod.',
  },
  remat: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "They'll both peak when Zanak goes into demat and remat mode. Then brace yourself.",
  },
  harpy: {
    count: 2,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Yes, that's her, the old harpy.",
  },
  flung: {
    count: 5,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, naturally, Calufrax is flung off into the space time vortex and we pick it up later in the Tardis.',
  },
  vries: {
    count: 8,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'EMILIA',
    firstSaidQuote:
      'Well, their leader, Mister De Vries, is a very unpleasant man.',
  },
  senor: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Hmm. Was there a Senor Camara?',
  },
  druid: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, it's just a key. It's been mislaid. Tell me, you're not really a Druid, are you.",
  },
  raven: {
    count: 8,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'DE VRIES',
    firstSaidQuote:
      'Goddess of war, death and magic. Beware the raven or the crow, Doctor. They are her eyes.',
  },
  triad: {
    count: 4,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'EMILIA',
    firstSaidQuote:
      "There's an ancient Welsh triad that says, it's a three line poem, umpity, bumpity. Oh, you'll find them in the notes.",
  },
  idwal: {
    count: 2,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'EMILIA',
    firstSaidQuote:
      "If I knew that I'd be professor of megalithic archaeology at Bangor instead of that fool, Idwal Morgan.",
  },
  ogros: {
    count: 3,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, from Ogros, their home planet. That's in Tau Ceti. Repulsive place covered in great swamps full of amino acids, primitive proteins which they feed on by absorption. Hence their need of globulin",
  },
  acids: {
    count: 6,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, from Ogros, their home planet. That's in Tau Ceti. Repulsive place covered in great swamps full of amino acids, primitive proteins which they feed on by absorption. Hence their need of globulin",
  },
  magog: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Gog, Magog, Ogres. They can't be far away. Anyway, you and I have got work to do. Listen. Do you by any chance have any tritium crystals?",
  },
  ogres: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Gog, Magog, Ogres. They can't be far away. Anyway, you and I have got work to do. Listen. Do you by any chance have any tritium crystals?",
  },
  fluff: {
    count: 3,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "How do you know? You've been locked in that capsule for four thousand years! Even the finest piece of machinery deteriorates after that time. Rust, dust, pieces of fluff. Think how you'd feel if you condemn an innocent humanoid to death just because you got a bit of fluff stuck in your sprocket wheel or whatever it is you've got in there.",
  },
  lager: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'EMILIA',
    firstSaidQuote: "Yes. She wouldn't touch lemon tea or lager and lime",
  },
  goody: {
    count: 2,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Aha! Aha! Goody. Gosh, that takes me back.',
  },
  isaak: {
    count: 2,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Last time I used this, I was with Isaak Walton. Yes. Yes, it's all here.",
  },
  lamia: {
    count: 15,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GRENDEL',
    firstSaidQuote: 'Fetch Madame Lamia.',
  },
  zadek: {
    count: 19,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'REYNART',
    firstSaidQuote:
      "No, we won't, Zadek. This man is obviously a gentleman. If he can mend our android, we shall reward him. If he cannot, you have my word, Doctor, you will come to no harm. You may go free.",
  },
  eerie: {
    count: 3,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'REYNART',
    firstSaidQuote:
      "Excellent! Farrah, bring wine. Do you know, it's quite eerie seeing oneself walk and talk like that. I never thought I'd see that thing going again.",
  },
  taran: {
    count: 4,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ROMANA',
    firstSaidQuote: "I'm not even Taran. What possible use can I be to you?",
  },
  freya: {
    count: 2,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GRENDEL',
    firstSaidQuote:
      "Good heavens, no, my dear. That's the Princess Strella. First Lady of Tara, a descendant of the Royal House, Mistress of the domains of Thorvald, Mortgarde and Freya. In fact, Tara's most eligible spinster, shortly to become, in rapid succession, my fiancée, my bride, and then deceased. Yes, it will be a tragic accident. A flower blighted in its prime. And naturally, as her husband, I shall claim her estates and her position as second in line to the throne, as provided for under Taran law.",
  },
  choke: {
    count: 10,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GRENDEL',
    firstSaidQuote:
      "Don't be so tediously heroic, my dear fellow. Not too tight, Lamia. We don't want to choke her.",
  },
  spark: {
    count: 13,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'A circuit must have been faulty. I heard it spark.',
  },
  widow: {
    count: 4,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'REYNART',
    firstSaidQuote:
      'To become legal, rightful King of Tara. You see, if you marry me you will automatically become Queen, but five minutes after the wedding you would almost certainly be a widow.',
  },
  knell: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Hear that, K9? Wedding bells or a funeral knell? Do hurry up. A hamster with a blunt penknife would do it quicker.',
  },
  thawn: {
    count: 12,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'FENNER',
    firstSaidQuote:
      'Thawn, I saw your landing. How did things go on Delta Magna?',
  },
  reeds: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Something must have happened to her. Look at the way those reeds are crushed.',
  },
  kroll: {
    count: 145,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RANQUIN',
    firstSaidQuote: 'The mark of Kroll is sacred to my people.',
  },
  skart: {
    count: 6,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RANQUIN',
    firstSaidQuote: 'Skart.',
  },
  deity: {
    count: 3,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, they've told you about their local water deity, have they?",
  },
  lover: {
    count: 10,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THAWN',
    firstSaidQuote:
      "Because he's a Swampie-lover! I've told you, he's in with them.",
  },
  hajes: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Hmm? Let me see. And Kroll. When Kroll awakened, he saw that the people were fat and indolent, and then Kroll became angry and he struck them down, swallowing into him the symbol of his power and killing all who were in the temple, even Hajes the priest. Great was the lamentation of the people but Kroll returned to the water and slept.',
  },
  snaps: {
    count: 4,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Ah! And snaps our spines. How ingenious. Now I know the purpose of the window.',
  },
  beads: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ROMANA',
    firstSaidQuote:
      "It's not my muscles I can't relax, it's my vertebrae. They feel like beads on a piece of, ow, elastic.",
  },
  hunts: {
    count: 10,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, I told him not to move. It hunts by surface vibrations. Primarily a vegetarian, of course, but over the years it's learnt that anything that moves is wholesome.",
  },
  zeons: {
    count: 27,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SHAPP',
    firstSaidQuote:
      "The navigation systems are being blocked, sir. The Zeons must be using a new device. The whole fleet's flying blind.",
  },
  shapp: {
    count: 39,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MARSHAL',
    firstSaidQuote:
      'Or have they all turned cowards? I want this attack pressed home, Shapp, before the Zeons smash us to pieces. Is that clear?',
  },
  wards: {
    count: 4,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MAN',
    firstSaidQuote:
      'Direct hit reported on hospital complex. Wards seven to ten destroyed.',
  },
  merak: {
    count: 49,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MARSHAL',
    firstSaidQuote:
      'Very well, your Highness. One of my guards will accompany you to the hospital. Where, no doubt, Surgeon Merak anxiously awaits you.',
  },
  opted: {
    count: 2,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ROMANA',
    firstSaidQuote: 'It opted out.',
  },
  theet: {
    count: 5,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DRAX',
    firstSaidQuote: 'Hello, Theet. How you been, boy?',
  },
  sigma: {
    count: 20,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DRAX',
    firstSaidQuote:
      "It is Theet, innit? Theta Sigma? Yeah, 'course it is. Remember me, ay?",
  },
  mutes: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DRAX',
    firstSaidQuote: 'Upper level. Watch out for the mutes.',
  },
  putty: {
    count: 1,
    firstSaidSeasonIndex: 16,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Like putty.',
  },
  bleep: {
    count: 2,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Anti-radiation pills. The levels are quite high out here. Here's a bleeper that'll bleep when you need the next dose.",
  },
  tutor: {
    count: 6,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'You know the most important thing my cybernetics tutor ever taught me?',
  },
  navvy: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You know something? You've got all the makings of a first class navvy. Concrete. Manufactured.",
  },
  magla: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The conditions existing on the planet Magla make it incapable of supporting any lifeform. Huh. Huh. Huh. He obviously doesn't realise the planet Magla's an eight thousand mile wide amoeba that has grown a crusty shell. I wonder what he does know?",
  },
  equip: {
    count: 4,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DAVROS',
    firstSaidQuote:
      "Errors of the past will be rectified. I will add new design elements to the Dalek's circuitry. They will be armed with new weaponry. Weaponry so devastating that all matter will succumb to its power. I will equip them with all the knowledge of the universe",
  },
  vying: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DAVROS',
    firstSaidQuote:
      'No. Two gigantic computerised battle fleets locked together in deep space, hundreds of galactic battle cruisers vying with each other for centuries, and not a shot fired?',
  },
  ethos: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'What Paris has, it has an ethos, a life. It has',
  },
  bible: {
    count: 4,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HERMANN',
    firstSaidQuote: 'Discreetly, sir? Sell a Gutenberg Bible discreetly?',
  },
  thump: {
    count: 2,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DUGGAN',
    firstSaidQuote: "Exactly. I'm about ready to thump somebody.",
  },
  lisas: {
    count: 5,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Every one. What I don't understand is why a man who's got six Mona Lisas wants to go to all the trouble of stealing a seventh.",
  },
  hells: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DUGGAN',
    firstSaidQuote: 'Hells bells!',
  },
  roped: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Ah, Count. Hello. I wonder if you could spare me a moment of your time. Romana, hello, how are you? I see the Count's roped you in as a lab assistant. What are you making for him? A model railway? Gallifreyan egg timer? I hope you're not making a time machine. I shall be very angry.",
  },
  exert: {
    count: 5,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'K9',
    firstSaidQuote:
      'Peter gave himself for lost and shed big tears, but his sobs were overheard by some friendly sparrows who flew to him in great excitement and implored him to exert himself.',
  },
  doran: {
    count: 10,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ADRASTA',
    firstSaidQuote: 'Engineers. Doran and Tollund.',
  },
  patus: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ORGANON',
    firstSaidQuote:
      "Oh, don't mention it, sir. As my dear mother always used to say. Born under the sign of Patus, middle cusp she was. If you can help anybody, like preventing them from being eaten by a monster, then do so. They might be grateful. So I did.",
  },
  serfs: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ORGANON',
    firstSaidQuote:
      "Oh, I've lost count. Many moon flows. I've survived on scraps of food that the serfs throw down. I think they're intended for the Thing.",
  },
  erato: {
    count: 22,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ERATO',
    firstSaidQuote: 'My name is Erato.',
  },
  skulk: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ERATO',
    firstSaidQuote:
      'To skulk about in pits, as you so crudely put it, is not my normal habit. I most emphatically do not eat people. I live by ingesting chlorophyll and mineral salts. I would have you know that I am the Tythonian High Ambassador.',
  },
  azure: {
    count: 16,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote:
      'This is your flight computer speaking. We are about to go into orbit around the planet Azure. Passengers may leave their seats when the blue light comes on, but are requested not to remove their protective coveralls until instructed. Will passengers please remember that the Empress will be at seven tenths G, so please be careful when you first start to move around. Thank you.',
  },
  tryst: {
    count: 32,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'RIGG',
    firstSaidQuote: 'Tryst.',
  },
  algae: {
    count: 4,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TRYST',
    firstSaidQuote:
      'The second planet supports life in a very early stage of evolution. The molluscs, the algae, the primitive insects. I can show you.',
  },
  toyed: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'And you invented this marvellous machine to collect your specimens? You know, I knew a man once who toyed with an idea like this. What was his name? Professor Stein?',
  },
  della: {
    count: 20,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'RIGG',
    firstSaidQuote: 'Ah, Della.',
  },
  stott: {
    count: 17,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TRYST',
    firstSaidQuote:
      "Well, Della, I've been thinking about Stott, our sadly lamented crewman and your close friend, and his strange behaviour on Eden. Might it be him who discovered a new source of Vrax? But he died, of course, didn't he.",
  },
  costa: {
    count: 3,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DYMOND',
    firstSaidQuote:
      "Ah, Doctor. This is Waterguard Fisk and Landing Officer Costa of the Azurian Excise. I've been telling them",
  },
  aneth: {
    count: 24,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PILOT',
    firstSaidQuote:
      "We're twelve hours out from Aneth. Only another twelve to Skonnos.",
  },
  nimon: {
    count: 73,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PILOT',
    firstSaidQuote: 'Nimon will soon fulfil his great promise to us.',
  },
  sorak: {
    count: 15,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SOLDEED',
    firstSaidQuote:
      'I believe we are, Sorak. I do believe we are. The Second Skonnon Empire will be born.',
  },
  hodge: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, the sooner the better. It's a right hodge-podge up there. Very old engines patched up with new equipment, a lot of it not really compatible.",
  },
  podge: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, the sooner the better. It's a right hodge-podge up there. Very old engines patched up with new equipment, a lot of it not really compatible.",
  },
  sezom: {
    count: 3,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SEZOM',
    firstSaidQuote: 'I am Sezom.',
  },
  knick: {
    count: 2,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CHRONOTIS',
    firstSaidQuote:
      'Well, just a few knick-knacks. You know how I love my books, Doctor.',
  },
  clare: {
    count: 14,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PARSONS',
    firstSaidQuote:
      "Clare, hi. Yes, it's me. What? Yes, I'm fine. Listen, the most amazing... Well, just stop being busy. This is important. There's this book, and it's got a molecular structure unlike anything I've ever seen before. Yes, I said book. It's like nothing on Earth. Extraterrestrial. No, I'm not mad. Listen, I've done everything. X-rays, microscope, you name it. Look, you don't have to believe everything till you've seen it yourself. Yeah, come on over. No, not in two hours. Now. Great.",
  },
  flair: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, a criminal, yes, but he had such style, such flair, such',
  },
  shada: {
    count: 18,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ROMANA',
    firstSaidQuote:
      'Beware. The. Sphere. Beware. Skagra. Beware. Shada. The. Secret. Is. In. The',
  },
  johns: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PARSONS',
    firstSaidQuote: 'Chris Parsons, Bristol Grammar School and Johns.',
  },
  thira: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CALDERA',
    firstSaidQuote:
      "There's A S T Thira, the psychologist. G V Centauri, the parametricist. L D Ia, the biologist. R A F Akrotiri.",
  },
  spasm: {
    count: 3,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CHRONOTIS',
    firstSaidQuote:
      "Oh, a spasm, a mere spasm. I just hope it wasn't a dying spasm, because it has left us jammed between two irrational time interfaces. Time is moving away from us. If we do manage to disentangle ourselves, I'll just have to be careful, otherwise I shall cease to exist again.",
  },
  gleam: {
    count: 3,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You want to take over the universe, don't you. I've met your sort before. Any moment now a mad gleam will come into one of your eyes and you'll start shouting, the universe shall be mine.",
  },
  inane: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SKAGRA',
    firstSaidQuote:
      'Doctor, your inane whitterings do not interest me. This will happen. It will start within hours. And once it has started, nothing you or anyone else can do will stop it. Take them away. They bore me.',
  },
  jinks: {
    count: 1,
    firstSaidSeasonIndex: 17,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'CONSTABLE',
    firstSaidQuote:
      "Be normal high jinks that would be then, sir, would it? Students roaming the streets stealing policeman's helmets, bollards, and",
  },
  brock: {
    count: 29,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PANGOL',
    firstSaidQuote: "You won't believe this. Brock looks like backing out.",
  },
  klout: {
    count: 2,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BROCK',
    firstSaidQuote: 'Oh. Klout, my lawyer.',
  },
  morix: {
    count: 3,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BROCK',
    firstSaidQuote:
      'Morix! Morix! Where is everyone? For goodness sake, get somebody!',
  },
  loman: {
    count: 3,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PANGOL',
    firstSaidQuote:
      "As I demonstrated earlier myself. Visitor Loman thinks the demonstration might have been an edited recording. Perhaps you'd care to try for yourself, Mister Loman?",
  },
  morik: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BROCK',
    firstSaidQuote: 'Morik sent you all the way to Earth just for this?',
  },
  warik: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ARGOLIN',
    firstSaidQuote: 'Warik.',
  },
  rerun: {
    count: 2,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "All right, but we'd better rerun the experiment, don't you think, Mister Hardin?",
  },
  radon: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Yes. Radon 222 decays rapidly.',
  },
  wafer: {
    count: 4,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ROMANA',
    firstSaidQuote: 'Now, this is a wafer wave inducer, is it?',
  },
  aging: {
    count: 7,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HARDIN',
    firstSaidQuote: 'Yes, it produced this rapid aging effect.',
  },
  scaly: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Back to the boardroom. Our scaly friend's seen someone he wants to talk to.",
  },
  venue: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FOAMASI',
    firstSaidQuote:
      'Since our last government clamp-down, the West Lodge has been looking for a new venue for its illegal activities. Argolis would have been ideal.',
  },
  eigen: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HARDIN',
    firstSaidQuote: 'I must work out some new eigen functions.',
  },
  jolts: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You'd better stop the Tardis. We don't want any nasty jolts. Prion, did you say?",
  },
  prion: {
    count: 3,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You'd better stop the Tardis. We don't want any nasty jolts. Prion, did you say?",
  },
  zolfa: {
    count: 14,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ROMANA',
    firstSaidQuote:
      "Well, there's one called Zolfa-Thura. That's in the history books.",
  },
  thura: {
    count: 12,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ROMANA',
    firstSaidQuote:
      "Well, there's one called Zolfa-Thura. That's in the history books.",
  },
  deons: {
    count: 8,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DEEDRIX',
    firstSaidQuote:
      'For thousands of years our lives have been dominated by a mystery. The Dodecahedron belongs to all of us, not just the Deons.',
  },
  caris: {
    count: 4,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DEEDRIX',
    firstSaidQuote:
      'Thank you, Caris. Understood. All this rather proves her point.',
  },
  mends: {
    count: 4,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ZASTOR',
    firstSaidQuote:
      'Some fifty years ago, I knew a man who solved the insoluble by the strangest means. He sees the threads that join the universe together and mends them when they break.',
  },
  creed: {
    count: 5,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DEEDRIX',
    firstSaidQuote:
      'Well, how can there be any respect for a creed that practices primitive sacrifice. Are you making sacrifices now in the name of your monstrous myth?',
  },
  varsh: {
    count: 8,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'TYLOS',
    firstSaidQuote: 'Easy, Varsh. You said it would be easy.',
  },
  tylos: {
    count: 7,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VARSH',
    firstSaidQuote: 'All right, Tylos',
  },
  adric: {
    count: 248,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VARSH',
    firstSaidQuote: 'You belong in the Starliner, Adric.',
  },
  login: {
    count: 17,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'NEFRED',
    firstSaidQuote: 'Citizen Login. What is it?',
  },
  keara: {
    count: 6,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'LOGIN',
    firstSaidQuote: "But Keara, she's so young.",
  },
  garif: {
    count: 9,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'NEFRED',
    firstSaidQuote: 'Garif, I have seen the System Files.',
  },
  maths: {
    count: 29,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROMANA',
    firstSaidQuote:
      "Well, I'd explain but I don't think even your maths is good enough. I'm shutting the door.",
  },
  toxin: {
    count: 3,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, it's not a toxin. It must be something in those spider bites, some kind of psychochemical.",
  },
  vowed: {
    count: 4,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'NEFRED',
    firstSaidQuote:
      'When the Starliner crashed upon this planet, our ancestors vowed that their one endeavour would be to repair the ship and to return to Terradon.',
  },
  rivet: {
    count: 2,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GARIF',
    firstSaidQuote: 'Everything is listed, down to the smallest rivet.',
  },
  serum: {
    count: 5,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'You understand? Avoid all contact. Avoid all contact. Adric! Adric, the serum!',
  },
  leaps: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, evolution goes in quantum leaps, but doesn't go that fast.",
  },
  rural: {
    count: 5,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "On the other hand, they may have opted deliberately for a semi-rural culture. It's a mistake to judge by appearances. Hello.",
  },
  aukon: {
    count: 16,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ZARGO',
    firstSaidQuote: 'But strangers, Aukon.',
  },
  zargo: {
    count: 9,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TARAK',
    firstSaidQuote:
      'Years ago. Some of us were on the run from Zargo and his men. We escaped into the wasteland and discovered this, all kinds of wonderful things just thrown about, half hidden. There was even food, mountains of it.',
  },
  grimm: {
    count: 2,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "That's very good. Have you ever heard of the Brothers Grimm?",
  },
  clods: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'AUKON',
    firstSaidQuote:
      'We have bred dullness, conformity, obedience into those clods for twenty generations. Unfortunately, we have also bred out just those qualities we need for other purposes.',
  },
  stalk: {
    count: 4,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yes. Creatures that stalk in the night and feast on the blood of the living. Creatures that fear sunlight and running water and certain herbs. Creatures that are so strong they can only be killed by beheading, or a stake through the heart.',
  },
  tarak: {
    count: 17,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GUARD',
    firstSaidQuote:
      "I know you. You're Tarak. Tarak the traitor. You ran out to join the rebels.",
  },
  veros: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KALMAR',
    firstSaidQuote:
      "Not history, Veros, the present. We're scanning the surrounding countryside.",
  },
  husks: {
    count: 5,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'AUKON',
    firstSaidQuote:
      'We shall leave this miserable space trap for the real universe. Rich, fat worlds teeming with life. We shall suck their life blood until they are empty husks, and pass on to more worlds, and yet still more.',
  },
  infra: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes. The spectrum's a bit weak at the moment. Infra-red. Picking up sleeping life forms. Now we're going into x-ray. Watch the area below the Tower.",
  },
  biroc: {
    count: 20,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RORVIK',
    firstSaidQuote: "Now we'll have to see, Biroc. Show us where we're going.",
  },
  casts: {
    count: 3,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'K9',
    firstSaidQuote:
      'One traditional method is tossing of coins. The I-Ching methodology casts doubt on the value of normal causalistic procedures.',
  },
  sagan: {
    count: 4,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RORVIK',
    firstSaidQuote: 'Sagan, Kilroy. Take him below and get him fixed up.',
  },
  hsiao: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'K9',
    firstSaidQuote:
      "Hexagram nine. Hsiao Ch'u. The taming power of the small. Quote, if you are sincere, blood vanishes and fear gives way.",
  },
  royce: {
    count: 3,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PACKARD',
    firstSaidQuote:
      'Portable Mass Detector. Aldo, Royce! Break it out from the stores, will you.',
  },
  moths: {
    count: 9,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KEEPER',
    firstSaidQuote:
      'Yes, we have indeed been visited by evil many times. Our compassion for these poor distorted creatures seems to attract them like moths to a flame. Sometimes they are redeemed.',
  },
  grove: {
    count: 28,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KEEPER',
    firstSaidQuote:
      "It's baleful influence will not extend beyond the grove, and even here it will only produce a few weeds. Like others before it, the creature will calcify and pass harmlessly into the soil. But the demise of any living thing is painful to us.",
  },
  heady: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TREMAS',
    firstSaidQuote:
      "Enough, Trakens. Enough! Applause is heady, and I've already drunk more wine than a man of my responsibilities should. To be a consul and a father I thought were duties enough, but now once again to be a husband, and to Kassia.",
  },
  nyssa: {
    count: 233,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KEEPER',
    firstSaidQuote:
      'The Fosters, perhaps. Since you drove them from the grove, it has become neglected. Fruit trees need some little tending too, you know. No, Nyssa shall watch over your Melkur. And she must share in the blessing, too.',
  },
  prose: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Ah, yes. Well, I suppose it is a bit above your head. Mind you, they did say I had a very sophisticated prose style.',
  },
  neman: {
    count: 28,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SERON',
    firstSaidQuote: 'Send for Proctor Neman.',
  },
  seron: {
    count: 18,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KATURA',
    firstSaidQuote:
      "We can't afford to stand on ceremony, Consul Seron. I propose we put it to the vote.",
  },
  shirk: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KASSIA',
    firstSaidQuote:
      'It will, Consuls, but only if we demonstrate our intention to oppose it. And to do that, we need a Keeper Nominate who will not shirk what must be done.',
  },
  luvic: {
    count: 4,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KATURA',
    firstSaidQuote: "That's certainly true, but I'm far too old and, Luvic.",
  },
  texts: {
    count: 10,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LUVIC',
    firstSaidQuote: 'The texts say it is an agonising death, Katura.',
  },
  loath: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MELKUR',
    firstSaidQuote:
      'Yes, death. I had not forgotten. I am loath to begin my regime with bloodshed, but in this case.',
  },
  aunty: {
    count: 8,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'TEGAN',
    firstSaidQuote:
      "Okay, Aunty Vanessa, let's go. More choke. Easy on the throttle as you turn her over.",
  },
  tegan: {
    count: 310,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'VANESSA',
    firstSaidQuote:
      "Now calm now, Tegan, dear. Look, we've got plenty of time. You get yourself so excited.",
  },
  keree: {
    count: 3,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MONITOR',
    firstSaidQuote:
      'Keree gorok gorok, keree gorok per denesta zel octa zarel gorok gorok keree',
  },
  gorok: {
    count: 5,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MONITOR',
    firstSaidQuote:
      'Keree gorok gorok, keree gorok per denesta zel octa zarel gorok gorok keree',
  },
  zarel: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MONITOR',
    firstSaidQuote:
      'Keree gorok gorok, keree gorok per denesta zel octa zarel gorok gorok keree',
  },
  wring: {
    count: 1,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote: 'I will wring the truth out of it.',
  },
  voids: {
    count: 3,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MONITOR',
    firstSaidQuote:
      'Yes. We opened the system by creating voids into other universes.',
  },
  topsy: {
    count: 2,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'TEGAN',
    firstSaidQuote:
      "Listen. Here, you fellows, you've got this all topsy turvy.",
  },
  turvy: {
    count: 2,
    firstSaidSeasonIndex: 18,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'TEGAN',
    firstSaidQuote:
      "Listen. Here, you fellows, you've got this all topsy turvy.",
  },
  wilds: {
    count: 3,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MERGRAVE',
    firstSaidQuote:
      'Well, sirs, today has been a good adventure in the wilds beyond the walls. And a quarry worth the name.',
  },
  vista: {
    count: 4,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'RUTHER',
    firstSaidQuote: 'Ah, there is an exemplary vista from here.',
  },
  corfu: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEGAN',
    firstSaidQuote: 'But Heathrow is on the M4, not Corfu.',
  },
  bossy: {
    count: 3,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ADRIC',
    firstSaidQuote:
      "That's the trouble with women. Mindless, impatient and bossy.",
  },
  bigon: {
    count: 19,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BIGON',
    firstSaidQuote: 'Welcome. My name is Bigon.',
  },
  pears: {
    count: 4,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BIGON',
    firstSaidQuote:
      'Will it please you to eat and drink? A simple meal. Vegetarian. Citrus fruits, apples, nut, avocado pears and grape juice.',
  },
  mayan: {
    count: 2,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BIGON',
    firstSaidQuote: 'The Mayan people of the Americas.',
  },
  yikes: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TEGAN',
    firstSaidQuote: 'Yikes.',
  },
  drake: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'I knew a sailor once, friend of mine, chap named Drake.',
  },
  gland: {
    count: 3,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BIGON',
    firstSaidQuote:
      "Don't be too sure. In the Mobiliary there is a deadly poison. The deadliest in the known universe. The Urbankans secreted it in a gland. It causes organic matter to shrink in on itself. One trillionth of a gram would reduce you to the size of a grain of salt. With this he will conquer Earth.",
  },
  posed: {
    count: 2,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, perhaps if we could define the exact nature of the threat posed by the trees',
  },
  panna: {
    count: 9,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'KARUNA',
    firstSaidQuote: 'Aris is a male. Panna will explain.',
  },
  jhana: {
    count: 2,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'PANNA',
    firstSaidQuote:
      "What's he babbling about? No male can open the Box of Jhana without being driven out of his mind. It is well known. Unless. Is he an idiot?",
  },
  shawl: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'RALPH',
    firstSaidQuote: 'Me, sir? No. Would you like me to fetch your shawl?',
  },
  cones: {
    count: 3,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Must be the lateral balance cones again. You know, I must do some maintenance after we've delivered Tegan.",
  },
  barns: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MACE',
    firstSaidQuote:
      "Ah, then you must know, sir, that the nobility will not take kindly to being knocked up and questioned about the contents of their barns. It's a sure way of us all being horse-whipped. And I have a particularly sensitive skin, sir.",
  },
  wreak: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, if I'm right, the comet that actor saw was their ship burning up in the atmosphere. They're probably stranded here, desperate. They could wreak havoc.",
  },
  gloom: {
    count: 2,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MACE',
    firstSaidQuote:
      'I feel my mind slipping into a bottomless pit of gloom and despair.',
  },
  raaga: {
    count: 2,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "There's only one place in the universe a Terileptil can acquire such scaring. The tinclavic mines on Raaga.",
  },
  slate: {
    count: 4,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TANNER',
    firstSaidQuote:
      "Please, sir, if you don't mind. The game's already started. His lordship won the toss and decided to bat first to give you time to get here. That train's always slate.",
  },
  stump: {
    count: 2,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Middle stump!',
  },
  mater: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'CHARLES',
    firstSaidQuote:
      'Ripping performance, old boy. Come over to the house and meet the mater.',
  },
  esher: {
    count: 5,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MUIR',
    firstSaidQuote: "Near Esher, isn't it?",
  },
  digby: {
    count: 9,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'LADY C',
    firstSaidQuote: 'Where was Digby?',
  },
  beaut: {
    count: 2,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TEGAN',
    firstSaidQuote: "But you're a beaut dancer, Sir Robert.",
  },
  madge: {
    count: 23,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MUIR',
    firstSaidQuote: 'No, Madge. Wait until the Sergeant gets here.',
  },
  newer: {
    count: 2,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WALTERS',
    firstSaidQuote: 'A lead screen. Some of the newer alloys.',
  },
  drone: {
    count: 11,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Magnetic drone.',
  },
  vance: {
    count: 4,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RINGWAY',
    firstSaidQuote: 'Ringway to Vance. Report, please.',
  },
  snide: {
    count: 3,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RINGWAY',
    firstSaidQuote:
      "Shut up! I'm tired of your snide remarks and bullying ways.",
  },
  silos: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ADRIC',
    firstSaidQuote: 'How many of these silos are you carrying?',
  },
  warps: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "The freighter's jumped time warps.",
  },
  overs: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'How about opening day? Pass the time of day with the foreign royals. We could even drop in at Lords, see a few overs from Wisden and Pilch. I wonder if the Lion will be bowling?',
  },
  pilch: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'How about opening day? Pass the time of day with the foreign royals. We could even drop in at Lords, see a few overs from Wisden and Pilch. I wonder if the Lion will be bowling?',
  },
  tumal: {
    count: 5,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote:
      'Sharaz, sharaz tumal. Balor, balor. Sharaz, sharaz tumal balor balor.',
  },
  balor: {
    count: 4,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote:
      'Sharaz, sharaz tumal. Balor, balor. Sharaz, sharaz tumal balor balor.',
  },
  visan: {
    count: 6,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'Visan, visan.',
  },
  fakir: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SCOBIE',
    firstSaidQuote:
      'So, this fakir throws the rope up in the air and he and his assistant climb up it. Hey presto, disappeared.',
  },
  snare: {
    count: 3,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SCOBIE',
    firstSaidQuote:
      'Look, old chap, this is all a bit of a snare and a delusion.',
  },
  showa: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'Showa shirah sharah sharum.',
  },
  blobs: {
    count: 8,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'TEGAN',
    firstSaidQuote: 'Those blobs.',
  },
  veram: {
    count: 2,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'Veram veram. Zarak naman.',
  },
  zarak: {
    count: 8,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'Veram veram. Zarak naman.',
  },
  naman: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'Veram veram. Zarak naman.',
  },
  kalid: {
    count: 17,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'I am Kalid.',
  },
  zanor: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote:
      'Visan, visan, zanor minaz. You see your friend? Visan, visan.',
  },
  minaz: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote:
      'Visan, visan, zanor minaz. You see your friend? Visan, visan.',
  },
  shara: {
    count: 4,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'Shara, shara, kazan.',
  },
  kazan: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'Shara, shara, kazan.',
  },
  nagim: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'Vraa nagim!',
  },
  sator: {
    count: 2,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'Sator sobal sotos mondoro.',
  },
  sobal: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'Sator sobal sotos mondoro.',
  },
  sotos: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KALID',
    firstSaidQuote: 'Sator sobal sotos mondoro.',
  },
  binds: {
    count: 3,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ZARAK',
    firstSaidQuote:
      'Herein the new power, the force that binds and shapes us, shall be feared and adored. Nations shall prostrate themselves before us. We shall be divinity.',
  },
  yearn: {
    count: 1,
    firstSaidSeasonIndex: 19,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ANITHON',
    firstSaidQuote:
      'Zarak, do you not yearn for shape and touch and feeling? My brother, our true destiny is the becoming of ourselves. All our power must be combined to work with the Doctor against the rebel Time Lord.',
  },
  talor: {
    count: 5,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DAMON',
    firstSaidQuote: "I don't believe this. Talor, look.",
  },
  robin: {
    count: 30,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FRAZER',
    firstSaidQuote:
      "Robin! Come on, wake up. There's something going on inside.",
  },
  zorac: {
    count: 3,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BORUSA',
    firstSaidQuote:
      'The Matrix confirms what we already know, Cardinal Zorac. The creature is intelligent, immensely powerful, and formed from antimatter.',
  },
  maxil: {
    count: 11,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DAMON',
    firstSaidQuote:
      'Commander Maxil, why are you treating the Doctor like a criminal?',
  },
  hedin: {
    count: 20,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'And you, Hedin. Nyssa, my old friend, Councillor Hedin. Councillors, my companion, Nyssa of Traken.',
  },
  ergon: {
    count: 2,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'OMEGA',
    firstSaidQuote:
      'He serves me in here. If you are capable of doing the same, you will not find me ungrateful. The Ergon will scan you for possible future use. Step forward, girl. It would be unwise to resist.',
  },
  dotty: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TANHA',
    firstSaidQuote:
      "I agree Ambril can be rather trying. On the whole, you know, I preferred his predecessor. Now what was the man's name? Oh, he was completely dotty, but much more fun.",
  },
  tanha: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'AMBRIL',
    firstSaidQuote: 'Good morning, my Lady Tanha.',
  },
  chela: {
    count: 7,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'AMBRIL',
    firstSaidQuote: 'Yes, Chela, what is it?',
  },
  wishy: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'AMBRIL',
    firstSaidQuote: 'How indeed. Wishy mystical mumbo-jumbo.',
  },
  pokes: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'LON',
    firstSaidQuote:
      "Well, you know how it is. With time on one's hands, one pokes around.",
  },
  litre: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'IBBOTSON',
    firstSaidQuote:
      'A 1929 Humber 16/50 open tourer, Imperial model. Do you realise this car has the same chassis as the three and a half litre Humber Super Snipe?',
  },
  snipe: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'IBBOTSON',
    firstSaidQuote:
      'A 1929 Humber 16/50 open tourer, Imperial model. Do you realise this car has the same chassis as the three and a half litre Humber Super Snipe?',
  },
  hippo: {
    count: 5,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'TURLOUGH',
    firstSaidQuote: "It's dull and fat and ugly. Just like you, Hippo.",
  },
  modes: {
    count: 2,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, he couldn't. The Mara during the process of its becoming. It had to be trapped between modes of its being.",
  },
  decor: {
    count: 2,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, well, some people have the strangest ideas about decor. Come on, let's get back to the Tardis.",
  },
  decks: {
    count: 10,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TANNOY',
    firstSaidQuote:
      'All decks stand by. All decks stand by. This is a special announcement from Terminus Incorporated.',
  },
  olvir: {
    count: 15,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KARI',
    firstSaidQuote: 'Olvir?',
  },
  leper: {
    count: 3,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'OLVIR',
    firstSaidQuote: "We're on a leper ship! We're all going to die!",
  },
  eirak: {
    count: 7,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'VALGARD',
    firstSaidQuote: 'Eirak, Bor has just entered the Forbidden Zone.',
  },
  vanir: {
    count: 4,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'VALGARD',
    firstSaidQuote:
      'One of the Vanir has entered the Forbidden Zone. If he has died, we must have his body back. You understand?',
  },
  slush: {
    count: 2,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JACKSON',
    firstSaidQuote:
      "More than expecting you, slush, we've been waiting for you. Where you been, eh? I mean, we've been living on nothing but hard tack since we come aboard, haven't we, lads?",
  },
  wages: {
    count: 6,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COLLIER',
    firstSaidQuote:
      "Yeah. And we got a month's wages in advance. Not likely to forget that, now, would we?",
  },
  flier: {
    count: 2,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COLLIER',
    firstSaidQuote:
      'Ah, that was a race, now. Regular flier she was, the old America.',
  },
  splat: {
    count: 2,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COLLIER',
    firstSaidQuote:
      "Yeah, and strong arms. Otherwise you're down on the deck from the height of the crosstree, splat.",
  },
  aloft: {
    count: 12,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COLLIER',
    firstSaidQuote:
      "Here, know why a pig can never become a sailor? Cos he can't look aloft!",
  },
  deals: {
    count: 5,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'STRIKER',
    firstSaidQuote:
      "Good. Well, here's to an eventful passage, gentlemen, and a stormy one. My first mate Mister Marriner. You've met, I believe, Miss Tegan. The Doctor. Mister Marriner is my right hand man. He deals with the crew. Everything in order?",
  },
  scuba: {
    count: 2,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TEGAN',
    firstSaidQuote: 'Underwater gear, like scuba divers wear.',
  },
  wrack: {
    count: 22,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MARRINER',
    firstSaidQuote: "It's surprising of Wrack.",
  },
  tiara: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TEGAN',
    firstSaidQuote:
      'It was there, like a ruby, right in the centre of the tiara.',
  },
  liege: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'GILLES',
    firstSaidQuote: 'My liege, I have no need of aid from Lucifer.',
  },
  carta: {
    count: 7,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, you could put it like that. This particular shirt turned out to be the Crown Jewels, but that's next year. We're still three months away from Magna Carta.",
  },
  heals: {
    count: 2,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RANULF',
    firstSaidQuote:
      'Time heals. But at the present, my concern is for the King. Why is he so changed? And who are these beings he calls demons?',
  },
  cider: {
    count: 3,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'GILLES',
    firstSaidQuote:
      'Be not rash, my Lord. The King is resting. He sends word to not preserve pitchers. A new cider will be provided when he dines.',
  },
  dines: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'GILLES',
    firstSaidQuote:
      'Be not rash, my Lord. The King is resting. He sends word to not preserve pitchers. A new cider will be provided when he dines.',
  },
  lutes: {
    count: 2,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JOHN',
    firstSaidQuote: 'The lutes. Let us have the lutes.',
  },
  abhor: {
    count: 3,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JOHN',
    firstSaidQuote:
      " We sing in praise of total war, against the Saracen we abhor. To free the tomb of Christ our lord, we'll put the known world to the sword. There is no glory greater than to serve with gold the Son of Man. No riches here on Earth shall see, no scutage in eternity.",
  },
  sooth: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JOHN',
    firstSaidQuote:
      'Not for us. In sooth, this is but a puny demon that has no stomach for it. So be it. Let the Maiden embrace the vanquished.',
  },
  aided: {
    count: 3,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      'Aided and abetted by you, his demon, and your blue engine.',
  },
  orion: {
    count: 10,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'The Eye of Orion.',
  },
  angst: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'DOCTOR 5',
    firstSaidQuote: 'Just a twinge of cosmic angst.',
  },
  zodin: {
    count: 4,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'DOCTOR 2',
    firstSaidQuote: 'And the terrible Zodin.',
  },
  bares: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      'And if you cannot? The cosmos without the Doctor scarcely bares thinking about. What makes you think his other selves are in the Zone?',
  },
  coder: {
    count: 1,
    firstSaidSeasonIndex: 20,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'TEGAN',
    firstSaidQuote: "It's an entry coder.",
  },
  myrka: {
    count: 15,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ICHTAR',
    firstSaidQuote: 'The Myrka can deal with it.',
  },
  solow: {
    count: 8,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'NILSON',
    firstSaidQuote: "It's time to move, Solow. We've got our man.",
  },
  bleat: {
    count: 3,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'NILSON',
    firstSaidQuote:
      "Don't bleat, Solow. We've waited long enough for an opportunity like this.",
  },
  navel: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'TEGAN',
    firstSaidQuote:
      "Please hurry, Doctor. That thing isn't going to lie there contemplating its navel forever.",
  },
  bulic: {
    count: 7,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'VORSHAK',
    firstSaidQuote: 'Your assessment, Bulic?',
  },
  blocs: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Absolutely nothing, Tegan. There are still two power blocs, fingers poised to annihilate each other. Hexachromite.',
  },
  feuds: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "There isn't time for your petty feuds.",
  },
  theme: {
    count: 7,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Then admire the craftsmanship. Seventeenth century. Probably on a theme of a man being chased by the devil. Must admit I've never seen anything quite like it before.",
  },
  malus: {
    count: 31,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CHANDLER',
    firstSaidQuote:
      "Malus come. Malus's got to war, ain't he? He makes fighting worse. He makes them hate more.",
  },
  ragga: {
    count: 2,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "The planet Ragga. Let's get back to the church.",
  },
  hakol: {
    count: 5,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Precisely what I said. The Tereleptils mine tinclavic for more or less the exclusive use of the people of Hakol. That's in the star system Rifta, you know.",
  },
  rifta: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Precisely what I said. The Tereleptils mine tinclavic for more or less the exclusive use of the people of Hakol. That's in the star system Rifta, you know.",
  },
  norna: {
    count: 8,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'RANGE',
    firstSaidQuote: 'This is my daughter, Norna. And you',
  },
  cowed: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'PLANTAGENET',
    firstSaidQuote:
      'Who are you to give me advice! I am the son of Captain Revere. The people of Frontios will not be cowed by these mewling words of defeat, Doctor. We may lack the outward appurtenances of might, but we carry our strength within us. We will win the war with the invisible aggressors whose missiles batter on our planet, and we will win the greater battle, the struggle for the future of our race.',
  },
  soils: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'PLANTAGENET',
    firstSaidQuote:
      'No, wait. Why do you ask when the reason is well known? My father sought the precious minerals beneath the soils.',
  },
  froms: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "This rock analysis. You've been investigating the whyfors. I think you should be looking into the where froms. Mister Range tells me you have a research room.",
  },
  crass: {
    count: 2,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRAZEN',
    firstSaidQuote:
      "What's the meaning of this crass behaviour? Cockerill, what's going on?",
  },
  glean: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRAZEN',
    firstSaidQuote: "Where'd you glean all this information?",
  },
  goals: {
    count: 3,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GRAVIS',
    firstSaidQuote:
      'You do not know our goals. I have described our means. Once we have full control of Frontios, our plans are only just beginning.',
  },
  spick: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'STYLES',
    firstSaidQuote:
      "Huh. And you're seeing it on a good day. If you wanted to see everything spick and span, you shouldn't have asked for a transfer to a prison. Come on!",
  },
  flats: {
    count: 2,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CALDER',
    firstSaidQuote:
      "Builders. They're converting the warehouse into flats. Thought they were unexploded bombs.",
  },
  stien: {
    count: 5,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Hmm. But Stien was more effective. A living, thinking being, not some tin-pot machine.',
  },
  logar: {
    count: 53,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TIMANOV',
    firstSaidQuote:
      'Malkon, for our people to survive we must have faith, and never more so than at this moment. Logar is testing us. We must not seem to be wanting.',
  },
  trion: {
    count: 27,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TURLOUGH',
    firstSaidQuote: 'A Trion ship.',
  },
  elton: {
    count: 17,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PERI',
    firstSaidQuote:
      "No, she's taken up with that Mrs van Geysingham from the hotel, and I'm not spending all afternoon exploring a Cro-Magnon cave with some octogenarian from Miami Beach. Hey, what's this? Looks like Elton John.",
  },
  vamos: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'FOSTER',
    firstSaidQuote:
      "Vamos. Sorry, Peri. You'll have to wait for the next trip.",
  },
  misos: {
    count: 4,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TURLOUGH',
    firstSaidQuote: 'The Misos Triangle.',
  },
  sarns: {
    count: 6,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TIMANOV',
    firstSaidQuote:
      "Timanov, chief elder of the Sarns. I've been struggling to keep the faith.",
  },
  erupt: {
    count: 4,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Look, be a good fellow. We're trying to help. The volcano could erupt at any moment.",
  },
  laden: {
    count: 2,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'No, no, no. You can see where the light track sometimes crosses the heavy one. So, someone came here with a heavily laden monoskid, unloaded it somewhere and then returned to the ship.',
  },
  lapel: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PERI',
    firstSaidQuote: 'Doctor, why do you wear a stick of celery in your lapel?',
  },
  stotz: {
    count: 19,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KRELPER',
    firstSaidQuote:
      "Chacaws. I don't pick chacaws, Stotz. I've never been confined, and you know why? Cos I'm smart.",
  },
  rones: {
    count: 4,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SALATEEN',
    firstSaidQuote:
      'A message from Captain Rones, sir. His men have just taken two gun runners.',
  },
  stews: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MORGUS',
    firstSaidQuote:
      'They were merely ignorant handlers, Excellency. The stews of the city are full of such unemployed riff-raff.',
  },
  cramp: {
    count: 8,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PERI',
    firstSaidQuote: 'Cramp.',
  },
  lures: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JEK',
    firstSaidQuote:
      'No, you were led by your own cupidity. Greed, heedless of caution, lures many a man to his death.',
  },
  offal: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JEK',
    firstSaidQuote:
      'Do you think bullets could stop me now? You stinking offal, Morgus!',
  },
  remus: {
    count: 4,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SYLVEST',
    firstSaidQuote:
      'Look, Romulus, I wish you would be kinder to your mother. You too, Remus.',
  },
  vesta: {
    count: 2,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Vesta Ninety Five.',
  },
  manic: {
    count: 5,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'I told you, manic moments of no consequence. They become less dramatic and less and less frequent.',
  },
  swims: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Titan Three. Thou craggy knob, which swims upon the oceans of the firmament. Receive this weary penitent.',
  },
  sober: {
    count: 4,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, forgive me, old friend. Of course you don't recognise me. I've regenerated twice since our last meeting. Look, the twin hearts that beat as one? I'm a Time Lord, just as you are, and in case you still pretend not to know who I am, let me remind you. The last night I stayed, that last night, when you drank like twenty giants and I had to push you in the fountain to sober you up.",
  },
  shrug: {
    count: 1,
    firstSaidSeasonIndex: 21,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Don't be smug with me. Now, I've already explained my condition. I may be behaving like a manic barometer, but don't shrug off help when it's offered. You can't afford to.",
  },
  hoary: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BILL',
    firstSaidQuote: 'This is a hoary old one. Talk about neglect.',
  },
  payne: {
    count: 6,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'LYTTON',
    firstSaidQuote:
      "If he lets me down, he'll have reason not to. You, Payne, will kill him.",
  },
  scuff: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'You saw the signs and scuff marks on the bricks.',
  },
  bates: {
    count: 6,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CYBERMAN',
    firstSaidQuote: 'Stratton and Bates.',
  },
  odour: {
    count: 2,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'LYTTON',
    firstSaidQuote: 'The sour, rank odour of death is unmistakable.',
  },
  uncut: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'LYTTON',
    firstSaidQuote: 'The equivalent of two million pounds in uncut diamonds.',
  },
  flast: {
    count: 2,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FLAST',
    firstSaidQuote: 'My name is Flast.',
  },
  varne: {
    count: 2,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ROST',
    firstSaidQuote: 'My name is Rost. This is Varne.',
  },
  teddy: {
    count: 3,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'PERI',
    firstSaidQuote:
      "Before each and every unfortunate accident, you've said in a loud, confident voice, that's it. And to be honest, Doc, I am getting tired of clearing up the mess and being thrown around the Tardis like the teddy bear of some psychotic baby.",
  },
  tapes: {
    count: 5,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GOVERNOR',
    firstSaidQuote: 'The Punishment Dome. We sell tapes of what happens there.',
  },
  varos: {
    count: 38,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GOVERNOR',
    firstSaidQuote:
      'They show what befalls those who refuse to obey the orders by which the people of Varos must live.',
  },
  votes: {
    count: 4,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SIL',
    firstSaidQuote:
      'But tonight you must place yourself at the mercy of the votes of your people. Should they not agree with your stubborn stance, you may be obliterated.',
  },
  cetes: {
    count: 2,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Midway between Cetes and Sculptor. Materialised into actual and temporal void.',
  },
  rebos: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ARAK',
    firstSaidQuote: "Nah, they'll be all right. This batch of rebos are good.",
  },
  amorb: {
    count: 6,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SIL',
    firstSaidQuote:
      'They do not seem or act like Varosians. They could be from a rival company! The Amorb-Prospect Division. I would want the strangers removed for questioning.',
  },
  areta: {
    count: 9,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'JONDAR',
    firstSaidQuote: 'Areta is my wife. They condemned her, too.',
  },
  pargh: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SIL',
    firstSaidQuote: 'Pargh!',
  },
  clump: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'The best we can. Do you think you could attach this string to that clump of vines without killing yourself?',
  },
  tobys: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BASS',
    firstSaidQuote:
      "Hey, we're not last, grandma. T'others'll be along when they've emptied tobys.",
  },
  louts: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'PERI',
    firstSaidQuote:
      "But you're in danger. That attack wasn't random. Those louts tried to kill you.",
  },
  goria: {
    count: 2,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      'Ah, now I understand. You need it for your aliens on Miasimia Goria. I dropped in on your little domain before following you here. Chaos. Complete mayhem. What went wrong?',
  },
  crisp: {
    count: 2,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'To see? Not exactly. He was burnt to a crisp the last time I saw him.',
  },
  snuff: {
    count: 4,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      "As you observe, I'm very much alive. Your erstwhile mentor, on the other hand, is about to, I believe your modern expression is, snuff the candle.",
  },
  bonny: {
    count: 3,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GUARD',
    firstSaidQuote:
      'No sign of that Doctor, my lord, but I met his bonny lass.',
  },
  chefs: {
    count: 3,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DOCTOR 2',
    firstSaidQuote: 'Yes, with a high opinion of himself. Chefs usually have.',
  },
  kartz: {
    count: 14,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CHESSENE',
    firstSaidQuote:
      'Not to me. I still have the Kartz-Reimer module. But it shows the Gallifreyans are suspicious, so I was right to lay the plans I did.',
  },
  stike: {
    count: 22,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CHESSENE',
    firstSaidQuote: 'Not for long. Stike is moving.',
  },
  chide: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DOCTOR 2',
    firstSaidQuote:
      "Don't chide me, Dastari. I'm simply a messenger. Officially, I'm here quite unofficially.",
  },
  baton: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DASTARI',
    firstSaidQuote:
      "Doctor, our races have become tired and effete. Our seed is thin. We must hand the baton of progress to others. If I can raise the Androgums to a higher plane of consciousness, there's no limit to what that boiling energy might achieve.",
  },
  prate: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DOCTOR 2',
    firstSaidQuote:
      "And I've never heard such specious claptrap! Oh, don't you prate to me about ethics! The balance of the space-time continuum could be destroyed by your ham-fisted numbskulls.",
  },
  conga: {
    count: 2,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Hm? Oh, you've never seen such fish. And as for the Pandatorean conga, it's longer than your railway trains.",
  },
  karam: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SHOCKEYE',
    firstSaidQuote:
      "These days, you no longer use your karam name, do you, Chessene o' the Franzine Grig?",
  },
  dante: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Now, then. Archimedes. Fascinating chap, bit wet. Brunel. Christopher Columbus. He had a lot to answer for. Dante, Da Vinci, Dastari! Joinson Dastari, HP One. Head of Projects, Space Station Chimera, Third Zone. That's him!",
  },
  voila: {
    count: 4,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Voila! You know, I don't know much about art, but I know what I like.",
  },
  arana: {
    count: 9,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CHESSENE',
    firstSaidQuote:
      'Doña Arana had little interest in food. Her mind was full of her religion.',
  },
  anita: {
    count: 17,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'OSCAR',
    firstSaidQuote: 'What does that say, Anita?',
  },
  adore: {
    count: 4,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'OSCAR',
    firstSaidQuote: 'Oh, I adore them.',
  },
  vorum: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Vorum gas. An ordinary person would have been unconscious for hours.',
  },
  boing: {
    count: 3,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Boing! Boing!',
  },
  fogey: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Your Doctor is an antediluvian fogey. Allowing himself to be captured by the Sontarans. If anything happens to myself as a result of it I will never forgive himself.',
  },
  polic: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ANITA',
    firstSaidQuote: "Oscar, it doesn't say Policía.",
  },
  naiad: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'OSCAR',
    firstSaidQuote:
      'Botcherby. Oscar Botcherby at your service, sir, and this dark-eyed naiad is named Anita.',
  },
  roles: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'OSCAR',
    firstSaidQuote:
      "I'm between roles at the moment, so I'm managing a restaurant for a friend of mine. Las Cadanas in the Bario Santa Cruz.",
  },
  bario: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'OSCAR',
    firstSaidQuote:
      "I'm between roles at the moment, so I'm managing a restaurant for a friend of mine. Las Cadanas in the Bario Santa Cruz.",
  },
  domni: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DOCTOR 2',
    firstSaidQuote:
      "Do you expect me to cooperate in my own murder? I'm domni oik parl.",
  },
  pussy: {
    count: 3,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, they say there's more than one way to cook a cat. Here, pussy, pussy, puss-puss! Here, little puss.",
  },
  clams: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ANITA',
    firstSaidQuote:
      "What? Let me see. They've had lobsters, clams, and squid, brains in white sauce, two whole suckling pigs, a ham with figs, eight steaks, and an entire family paella!",
  },
  jacks: {
    count: 10,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CHESSENE',
    firstSaidQuote:
      "Well, if it would please you. Take the one in the skirt. He's the youngest of the jacks.",
  },
  pared: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Pared the interface.',
  },
  fatty: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SHOCKEYE',
    firstSaidQuote:
      "Tenderising the meat. Oh, see how the flesh is marbling. That's the fatty tissue breaking up.",
  },
  borad: {
    count: 50,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TYHEER',
    firstSaidQuote:
      "Fat chance. There's got to be another way to defeat the Borad from within the Citadel.",
  },
  gazak: {
    count: 3,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ARAM',
    firstSaidQuote: "You please yourself, Tyheer, but I'm getting out. Gazak?",
  },
  renis: {
    count: 3,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'TEKKER',
    firstSaidQuote: 'Maylin Renis.',
  },
  sezon: {
    count: 7,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PERI',
    firstSaidQuote: ' Sezon at the Falchian Rocks.',
  },
  dumbo: {
    count: 6,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PERI',
    firstSaidQuote:
      "At last. Why am I being kept here? And why have I had this contraption fitted to me? Well, can't you speak, dumbo?",
  },
  rolls: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PERI',
    firstSaidQuote:
      "That was my lunch. Well, it's the last time I eat any more of your nut roast rolls. What else is here?",
  },
  takis: {
    count: 13,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JOBEL',
    firstSaidQuote:
      "Lovely, lovely, lovely. Absolutely lovely. You've excelled yourself, Mister Takis. You really have.",
  },
  jobel: {
    count: 26,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TAKIS',
    firstSaidQuote: 'Thank you, Mister Jobel.',
  },
  froth: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'JOBEL',
    firstSaidQuote:
      "Oh! I hope they're on time. She's already started to froth. We know what that leads to. Thank goodness that the casket is lead-lined. I want to see you all in fresh tunic and full funerary make-up before the president arrives. Don't want the poor thing uncertain who the corpse is, do we.",
  },
  vitae: {
    count: 2,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Herbabaculum vitae.',
  },
  rabid: {
    count: 7,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PERI',
    firstSaidQuote: 'With sharp teeth and rabid saliva?',
  },
  vogel: {
    count: 3,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KARA',
    firstSaidQuote:
      "I'm well aware of that, Great Healer. I would willingly sell the bones of Vogel here if it would help your cause.",
  },
  spree: {
    count: 2,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, how do you think I feel? I'm a nine hundred year old Time Lord. Not much dignity in scrambling over a wall like a small boy into an orchard on a scrumping spree.",
  },
  porky: {
    count: 2,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PERI',
    firstSaidQuote: 'Oh, watch it, porky.',
  },
  plops: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'GRIGORY',
    firstSaidQuote:
      "Instant death doesn't bother me. It's the long lingering kind I'm worried about. You forget I'm a doctor. When they slice me open, I'll know the name and function of each organ that plops out.",
  },
  tacky: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PERI',
    firstSaidQuote:
      "I know that. It's just the way you talked about your friend. I didn't expect to find him in a place with such a tacky name.",
  },
  digit: {
    count: 3,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KARA',
    firstSaidQuote:
      "Even with Davros dead, he's not without his followers. And like the disciples of any fanatic, they will not give up without a struggle. As you can see, the box has a series of buttons. I will give you a simple five digit sequence which will activate the transmitter. This you must do the moment you enter Davros' laboratory. The moment you strike the final button, a prerecorded signal will be transmitted. I will then mobilise my forces to eliminate Davros' agents here and to take over his entire base.",
  },
  taint: {
    count: 1,
    firstSaidSeasonIndex: 22,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ORCINI',
    firstSaidQuote:
      'You must understand that this mission must be an honourable one. Nothing must taint or spoil it.',
  },
  glitz: {
    count: 94,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DIBBER',
    firstSaidQuote: "Well, they're not from round here, Mister Glitz.",
  },
  candy: {
    count: 4,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PERI',
    firstSaidQuote:
      "No. I've seen enough. I'll wait you at the entrance. Where they used to sell candy bars and newspapers.",
  },
  grell: {
    count: 6,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MERDEEN',
    firstSaidQuote: "I don't know, but the Immortal is never wrong, Grell.",
  },
  swats: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "About which you continually boast. That's the trouble with pallid little swats like you, Balazar, You can't even organise an efficient stoning.",
  },
  endow: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GLITZ',
    firstSaidQuote:
      'A small expediency if I am to endow a library on my home planet of Salostophus.',
  },
  goner: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GLITZ',
    firstSaidQuote: "He's a goner. You can tell by his colour.",
  },
  stati: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BROKEN TOOTH',
    firstSaidQuote:
      "I know a tunnel that passes Marb Stati on and leads straight to the Immortal's castle.",
  },
  rebut: {
    count: 3,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'INQUISITOR',
    firstSaidQuote:
      "You will have the opportunity in due course to rebut any or all of the Valeyard's charges.",
  },
  botty: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DIBBER',
    firstSaidQuote:
      "Yeah, but the most important of all is, what if I'm right? If we blast our way through there, well, he's not going to sit there on his iron botty, is he.",
  },
  neons: {
    count: 2,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'All of them! Merdeen, flick up all the switches with red neons on them.',
  },
  clash: {
    count: 2,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Are you frightened it might clash with what you're wearing?",
  },
  fuels: {
    count: 2,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "As I suspected, a device for extracting energy from the sea. Something your planet had the technology to do long before its fossil fuels ran out, but they didn't bother. This is just an auxiliary console, though. The main control room must be somewhere else.",
  },
  loans: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KIV',
    firstSaidQuote:
      'This Thordon world. The Krontep warriors have succeeded in subduing the massed hordes of the Tonkonp Empire. We must negotiate with the Krontep king. Usual contracts, development loans, some limited scientific advance. What is the position regarding King Yrcanos?',
  },
  lease: {
    count: 2,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KIV',
    firstSaidQuote:
      'In the event of a major discovery, their lease from the Thordonians will be for thirty years at a royalty rate of forty percent to us.',
  },
  morgo: {
    count: 3,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SIL',
    firstSaidQuote:
      'I will pray to the Great Morgo for your immediate recovery, Magnificence.',
  },
  donor: {
    count: 6,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SIL',
    firstSaidQuote:
      "If the Lord Kiv dies, his bodyguards have instructions to destroy us. You must operate to save his life and ours. There's no more time for research. I will find a donor and you must operate.",
  },
  eases: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'KIV',
    firstSaidQuote:
      'That is better. The pain eases. Stay near me. You I trust.',
  },
  toady: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VALEYARD',
    firstSaidQuote:
      'Just like that, my dear Doctor. A toady, a coward, a turncoat. You were afraid that Crozier wanted to transplant the brain of the alien Kiv into your head. You said as much yourself. The thought of that made you panic.',
  },
  slang: {
    count: 4,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VALEYARD',
    firstSaidQuote:
      'A rather imprecise Earth slang word, Sagacity, implying psychiatric instability.',
  },
  strop: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, thought I'd strop the odd scalpel, mop a brow or two.",
  },
  verne: {
    count: 4,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TUZA',
    firstSaidQuote:
      "Find Verne and his men. He'll know where to meet us. Tell him the day of reckoning has come. Now hurry!",
  },
  linna: {
    count: 3,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TUZA',
    firstSaidQuote: 'Linna?',
  },
  ragna: {
    count: 2,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'YRCANOS',
    firstSaidQuote:
      'Ragna! Look on this and see Yrcanos, a great warlord, and also Yrcanos, the even greater liberator!',
  },
  mildu: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'YRCANOS',
    firstSaidQuote:
      'Ah. You sense the presence of Mildu, the great god of war. That is good. It seems that I shall make a warrior out of you yet. Come!',
  },
  mogar: {
    count: 7,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Mogar, a planet on the Perseus arm of the Milky Way.',
  },
  janet: {
    count: 6,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'RUDGE',
    firstSaidQuote: 'Problems, Janet? Let me help.',
  },
  rudge: {
    count: 23,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'RUDGE',
    firstSaidQuote:
      'Security Officer Rudge, Professor. Now, which cabin did you go to?',
  },
  stora: {
    count: 2,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'KIMBER',
    firstSaidQuote:
      'Oh, surely not. We met three years ago on Stella Stora. You came to investigate shortages in the granary.',
  },
  neddy: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MEL',
    firstSaidQuote:
      'Listen, when I start to call you Neddy, then you can worry. Drink up.',
  },
  shika: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I've got a better idea. Let's go to Pyro Shika, a fascinating planet",
  },
  pease: {
    count: 2,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Far cry from the carefree life of Pease Pottage, eh, Mel?',
  },
  nooks: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MEL',
    firstSaidQuote:
      'Meanwhile, I wander around, poke my nose into a few nooks and crannie and see if anyone tries to make contact. Remember, we were restricted to the passenger quarters. This is only the lounge.',
  },
  judas: {
    count: 4,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Now, before you go rushing off, Mel, do you know what a Judas goat is?',
  },
  lasky: {
    count: 16,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRUCHNER',
    firstSaidQuote: "Professor Lasky! The Demeter seeds, they're gone.",
  },
  prone: {
    count: 4,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MEL',
    firstSaidQuote:
      'Oh, come on, you know me. Am I prone to that sort of imagination?',
  },
  lofty: {
    count: 12,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRUCHNER',
    firstSaidQuote: 'I lack your lofty detachment.',
  },
  towel: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Don't throw the towel in, Mel.",
  },
  farms: {
    count: 5,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'DOLAND',
    firstSaidQuote:
      'Oh, but I shall, no matter what the cost. Then robots can be dumped on the scrap heap. Vervoids will run the factories and farms at practically no cost. All they need is sunlight and water.',
  },
  vesti: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Vesti la guibba e la faccia',
  },
  baron: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, my lady, but I would point out that much of the Railyard's so-called evidence was a farrago of distortion which would have had Ananias, Baron Munchhausen and every other famous liar blushing down to their very toe nails. Much of the evidence was not as I remembered.",
  },
  magno: {
    count: 5,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GLITZ',
    firstSaidQuote:
      'Well, eventually the Time Lords did suss out the leak, so they wanted to wipe out all the Sleepers, and they used this er, magno. Magno',
  },
  bourn: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'VALEYARD',
    firstSaidQuote:
      'The undiscovered country from whose bourn no traveller returns.',
  },
  urges: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'VALEYARD',
    firstSaidQuote:
      "I really must curb these urges. I've no wish to be contaminated by your whims and idiosyncrasies.",
  },
  croak: {
    count: 1,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GLITZ',
    firstSaidQuote:
      'Hang on. You told me this fleshy fair-haired personage was the one you wanted to croak.',
  },
  modem: {
    count: 2,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MEL',
    firstSaidQuote: 'A megabyte modem.',
  },
  maser: {
    count: 2,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'A maser.',
  },
  edict: {
    count: 2,
    firstSaidSeasonIndex: 23,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      "Thank you, Keeper. That is the news I'd been awaiting. Listen carefully. I have an edict to deliver. Somewhere the Valeyard and the Doctor are engaged in their squalid duel. With luck, they'll kill each other, but that is a mere coincidental occurrence. What I have to impart is of vital importance to all of you. Now that Gallifrey is collapsing into chaos, none of you will be needed. Your office will be abolished. Only I can impose order. I have control of the Matrix. To disregard my commands will be to invite summary execution.",
  },
  beyus: {
    count: 29,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE RANI',
    firstSaidQuote: 'Insolence could cost your people dearly, Beyus.',
  },
  refit: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I'm a bit worried about the temporal flicker in sector thirteen. There's a bicentennial refit of the Tardis to book in. I must just pop over to Centauri Seven and then perhaps a quick holiday. Right, that all seems quite clear. Just three small points. Where am I? Who am I? And who are you? The Rani! Stay back!",
  },
  sulky: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Perhaps this is my new persona. Sulky, bad-tempered. I mean, think how I spoke to you earlier.',
  },
  haute: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Ah, thank goodness in this regeneration I've regained my impeccable sense of haute couture.",
  },
  hasta: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Afraid so. More hasta less vista.',
  },
  ikona: {
    count: 17,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MEL',
    firstSaidQuote: 'Hurry, Ikona! Hurry!',
  },
  adept: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE RANI',
    firstSaidQuote: "Quite adept at manoeuvring, aren't you, Doctor?",
  },
  manip: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I don't believe it. A time manip. This monstrosity will give you the ability to change the order of creation.",
  },
  elvis: {
    count: 13,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'That means Shakespeare, Michelangelo, Louis Pasteur, Elvis, even Mrs Malaprop will never have existed.',
  },
  snore: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'As you snore, so shall you sleep.',
  },
  kangs: {
    count: 69,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BIN LINER',
    firstSaidQuote: "We're the Kangs.",
  },
  raita: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BIN LINER',
    firstSaidQuote: 'Raita!',
  },
  cooee: {
    count: 2,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TILDA',
    firstSaidQuote: 'Cooee. Cooooeeee. Would you care for a cup of tea?',
  },
  cakes: {
    count: 8,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TILDA',
    firstSaidQuote: 'I said, would you like a cup of tea and some cakes?',
  },
  tabby: {
    count: 20,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TILDA',
    firstSaidQuote:
      "Shush, shush. Oh, she's nearly here, dear. Oh, my goodness, Tabby. Look at that table. Quick.",
  },
  maddy: {
    count: 3,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TILDA',
    firstSaidQuote: 'Oh, Maddy, dear, how nice to see you.',
  },
  basil: {
    count: 4,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TILDA',
    firstSaidQuote: 'See if you can spot the basil.',
  },
  yawny: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BLUE KANG',
    firstSaidQuote: 'Not a yawny Oldster.',
  },
  messy: {
    count: 9,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CARETAKER',
    firstSaidQuote:
      "One hundred and seventy. All the messy creatures will be moving up to the swimming pool zone on floor three oh four. Luckily they won't have time to make it too untidy before I destroy them! I have nothing to fear. Nobody knows my Paradise Towers better than I do.",
  },
  chima: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'DELTA',
    firstSaidQuote: "You saved my life, Chima. I'm sorry.",
  },
  squat: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Navarinos from the tribe on Navarro? Squat, wrinkly, purply creatures? Won't they be a little conspicuous on Earth?",
  },
  tharl: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Nostalgia Trips, the most notorious travel firm in the five galaxies. It was a Nostalgia Trip cruiser that got stuck with the glass eaters of Tharl.',
  },
  mitts: {
    count: 2,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WEISMULLER',
    firstSaidQuote:
      "Bad news. That satellite has gone haywire, and the scientists think it's going to fall to Earth somewhere around here. And the President wants us to find it before certain enemy powers get their mitts on it.",
  },
  quarb: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Now, inside this box is the only Quarb crystal this side of Softel nebula.',
  },
  vinny: {
    count: 2,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BURTON',
    firstSaidQuote:
      'Thank you, Vinny, but you will all have to go, and that is an order. Look sharp now. Off you go.',
  },
  dinky: {
    count: 3,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WEISMULLER',
    firstSaidQuote:
      "Oh, gee. It's no use, lady. They've got a special kind of wrench. It's sort of like a dinky Allen key.",
  },
  mccoy: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GLITZ',
    firstSaidQuote:
      'Do you mind? This is the real McCoy, this is. It comes from an unimpeachable source.',
  },
  brill: {
    count: 6,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ACE',
    firstSaidQuote: 'Cor, this sounds brill.',
  },
  nitro: {
    count: 19,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ACE',
    firstSaidQuote:
      "They're just old cans. They've got home made Nitro Nine in them now.",
  },
  gooey: {
    count: 2,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ACE',
    firstSaidQuote:
      "Nitro Nine. We've got eight seconds. Last one back's a gooey mess.",
  },
  fugit: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Possibly. Come on, Glitz. Tempus fugit. I want to be back in time for tea.',
  },
  plato: {
    count: 2,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "So, what you're saying is that before Plato existed, someone had to have the idea of Plato.",
  },
  erect: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KANE',
    firstSaidQuote:
      'One day, when we return home, I shall erect colossal statues in your honour.',
  },
  sprog: {
    count: 3,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GLITZ',
    firstSaidQuote:
      "Just for once, sprog, do as I say, and stay here. Don't go wandering off.",
  },
  ached: {
    count: 1,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KANE',
    firstSaidQuote:
      'There were times when I ached for death. I considered journeying round from the cold dark side of Svartos to the sun blistered surface on the other side, where I would quickly die. Now, with the Dragonfire, I have the power to return to Proamon and exact my revenge. You, girl. Bring me the Dragonfire.',
  },
  quirk: {
    count: 3,
    firstSaidSeasonIndex: 24,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Time? Funny old business, time. It delights in frustrating your plans. All Kane's bitterness and hatred thwarted by a quirk of time.",
  },
  aegis: {
    count: 1,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GILMORE',
    firstSaidQuote:
      'They felt, Miss Williams, that the initial stages could be carried out under the aegis of the Counter-Intrusion Measures, United Kingdom. The D-notice office has of course been informed and a cover story prepared.',
  },
  diced: {
    count: 1,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'My problem is trying to stop Group Captain Gilmore and his men getting diced in the crossfire.',
  },
  wimps: {
    count: 2,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ACE',
    firstSaidQuote: "They're retreating, all of them. Wimps!",
  },
  silas: {
    count: 7,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DAPHNE',
    firstSaidQuote: 'Silas P.',
  },
  nudge: {
    count: 4,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Ah. Hold the two bananas and nudge. Never fails.',
  },
  poems: {
    count: 2,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HAROLD',
    firstSaidQuote:
      "Public grief, she calls it. It also covers listening to slow music, and reading poems, unless they're limericks, of course.",
  },
  forum: {
    count: 9,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HAROLD',
    firstSaidQuote:
      'One of the ones. There are three ways of disappearing on Terra Alpha. The Late Show at the Forum, a visit to the Kandy Kitchen, and something else.',
  },
  kandy: {
    count: 6,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'HAROLD',
    firstSaidQuote:
      'One of the ones. There are three ways of disappearing on Terra Alpha. The Late Show at the Forum, a visit to the Kandy Kitchen, and something else.',
  },
  furry: {
    count: 2,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SUSAN',
    firstSaidQuote: 'Happy songs, Ace. Songs about sunshine and furry animals.',
  },
  syrup: {
    count: 3,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's crystallised sugar. This pipe must have carried some sort of syrup. What do you think?",
  },
  muzak: {
    count: 1,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'EARL',
    firstSaidQuote:
      'And thanks to this lady and her fun gun, she can take out a loudspeaker playing muzak at a hundred paces.',
  },
  reich: {
    count: 3,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'DE FLORES',
    firstSaidQuote:
      "Gentlemen. I wonder if even you can fully appreciate what this moment means. You're standing now at the turning point of history. The day of fulfillment of our mighty destiny is about to dawn. Fifty years ago, I stood at the side of the Fuehrer himself when he ordered the first giant step to greatness, just as now the moment approaches for the second and final one. It will be decisive, for this time, this time we must not fail. Gentlemen, I give you the Fourth Reich.",
  },
  aisle: {
    count: 5,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, that's exactly what we've got to do, look at all this stuff. You take that aisle.",
  },
  tudor: {
    count: 1,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GUIDE',
    firstSaidQuote:
      'Tower, and also further over there is the Mary Tudor Tower. Those gargoyles have been there for about five hundred years. They were built in 1509 originally, and the',
  },
  sleds: {
    count: 1,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'LEADER',
    firstSaidQuote:
      'The Doctor must not lead the statue back to the rocket sleds. We will stop him.',
  },
  kites: {
    count: 8,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'BELLBOY',
    firstSaidQuote: 'Flowerchild, look. Your kites, your beautiful kites.',
  },
  lelex: {
    count: 1,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'STALLHOLDER',
    firstSaidQuote:
      'The Psychic Circus. All the riff-raff go there. All the infernal extraterrestrials like him. Monopods from Lelex, Doctors.',
  },
  nacks: {
    count: 1,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'CAPTAIN',
    firstSaidQuote:
      'Not really. I got a whole set of these silly little nick-nacks from some bug-eyed monster when I was on the planet Leophantos.',
  },
  pasty: {
    count: 1,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ACE',
    firstSaidQuote: 'Pasty face.',
  },
  hippy: {
    count: 3,
    firstSaidSeasonIndex: 25,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'And a friendly hippy circus was turned into a trap for killing people.',
  },
  waltz: {
    count: 3,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BAMBERA',
    firstSaidQuote:
      'Well done, Zbrigniev. Two civilians waltz up with a pair of antiquated pass cards and you let them in. Why?',
  },
  camra: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'PAT',
    firstSaidQuote: "It's in the CAMRA guide. We call it Arthur's Ale.",
  },
  vodka: {
    count: 3,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SHOU',
    firstSaidQuote: 'Vodka and coke, Pat.',
  },
  baden: {
    count: 2,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ANCELYN',
    firstSaidQuote:
      'Beware your tongue, Mordred. Have you so easily forgotten Baden, hmm? The way he cast down your mother with his mighty arts.',
  },
  czech: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'LAVEL',
    firstSaidQuote:
      'The Czech engineering group. Flood relief in the low countries. They can be at the site by tomorrow.',
  },
  lavel: {
    count: 2,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote: 'Oh, and Lavel?',
  },
  yuing: {
    count: 4,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'WARMSLY',
    firstSaidQuote: 'And I did have some help from Shou Yuing.',
  },
  husak: {
    count: 5,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote: 'Has Major Husak reported in yet?',
  },
  seest: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'WARMSLY',
    firstSaidQuote:
      'Did you know that it takes one year to uncover one centimetre on a site this big? But now, delay not. Take the sword and fling him far into the middle mere. Watch what thou seest and lightly bring me word.',
  },
  bosom: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'WARMSLY',
    firstSaidQuote:
      "Thou rememberest how, in those old days, one summer noon, an arm rose up from out the bosom of the lake clothed in white samite, mystic, wonderful, holding the sword. And how I rode across and took it, and have worn it, like a king. It's all a myth, really. Honestly, women in water holding swords?",
  },
  vexed: {
    count: 2,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ANCELYN',
    firstSaidQuote: 'My lady is vexed.',
  },
  blimp: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ACE',
    firstSaidQuote: 'Looks like Colonel Blimp has a fancy taste in hardware.',
  },
  slant: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ACE',
    firstSaidQuote: 'Shut up, you yellow, slant-eyed',
  },
  drama: {
    count: 3,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Correct. And you. Now, high drama is very similar to comedy. It's all a matter of",
  },
  mower: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BRIGADIER',
    firstSaidQuote: 'Yeah. Are you any good with a lawn mower, Ancelyn?',
  },
  borax: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ACE',
    firstSaidQuote: 'Nothing much in here. Alum, borax, carbon tetrachloride.',
  },
  clime: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Excuse my young friend. She comes from a less civilised clime.',
  },
  eluti: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'REDVERS',
    firstSaidQuote:
      "Redvers had some stories. The pigmies from the Eluti forest lead him blind fold for three whole days through uncharted jungle. They took him to a swamp full of giant lizards like giant dinosaurs. Do you know, young Conan Doyle just laughed at him. Huh. Well, there's Doctor's for you.",
  },
  conan: {
    count: 2,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'REDVERS',
    firstSaidQuote:
      "Redvers had some stories. The pigmies from the Eluti forest lead him blind fold for three whole days through uncharted jungle. They took him to a swamp full of giant lizards like giant dinosaurs. Do you know, young Conan Doyle just laughed at him. Huh. Well, there's Doctor's for you.",
  },
  doyle: {
    count: 3,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'REDVERS',
    firstSaidQuote:
      "Redvers had some stories. The pigmies from the Eluti forest lead him blind fold for three whole days through uncharted jungle. They took him to a swamp full of giant lizards like giant dinosaurs. Do you know, young Conan Doyle just laughed at him. Huh. Well, there's Doctor's for you.",
  },
  congo: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'REDVERS',
    firstSaidQuote:
      'Once, when Redvers was in the Congo, he faced a herd of stampeding buffalo head on. He raised his gun and with one single bullet',
  },
  eliza: {
    count: 10,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No such luck. Quiet, Eliza. Now be a good girl. I'm making some small talk.",
  },
  phine: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Good night, sleep tight. Up the wooden hill to Bedfordshire, otherwise known as Java. Well, not tonight, Josiah-phine!',
  },
  husky: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'He sounded a little husky.',
  },
  grose: {
    count: 2,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GROSE',
    firstSaidQuote:
      "It's high time they were called. I've said as much to my husband, Mister Grose.",
  },
  gypsy: {
    count: 2,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MACKENZIE',
    firstSaidQuote:
      "Ah, gypsy blood. I can see it in him. Lazy workers. What's this one playing up over? Oh, beg your pardon.",
  },
  comma: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Subject for catalogue. File under Imagination comma lack of.',
  },
  rungs: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'There go the rungs in his evolutionary ladder.',
  },
  nukes: {
    count: 2,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ACE',
    firstSaidQuote: "No nukes, then? Isn't it going to explode?",
  },
  disco: {
    count: 7,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ACE',
    firstSaidQuote:
      "I've had more trouble getting into Greenford disco without a ticket.",
  },
  gayev: {
    count: 3,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SORIN',
    firstSaidQuote:
      "Gayev, listen to me. Where are the sealed orders? You had them. Gayev, what's happened to them? Gayev! Let's take him to the camp. Move out! Move, move, move!",
  },
  carve: {
    count: 2,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'I carve these stones in memory of Asmund, Grimvald, Torkal, Halfdan, brave Viking warriors slain by the curse.',
  },
  sorin: {
    count: 3,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'PROZOROV',
    firstSaidQuote: 'No, we take them back to Captain Sorin.',
  },
  spake: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WAINWRIGHT',
    firstSaidQuote:
      'When I was a child, I spake as a child, I understood as a child, I thought as a child. When I became a man, I put away childish things. Now abideth faith, hope, love. These three. And the greatest of these is. And the greatest of these is.',
  },
  nazis: {
    count: 3,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MILLINGTON',
    firstSaidQuote:
      'Once the Nazis see what our planes are dropping on their cities',
  },
  norse: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Norse mythology. It seems that I've persuaded him that I'm on his side.",
  },
  annie: {
    count: 2,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WAINWRIGHT',
    firstSaidQuote:
      "There's your Vikings, or descendants of them at any rate. Joseph Sundvik, Florence Sundvik, wife. Daughters Sarah, Martha, Jane, Clara, Annie.",
  },
  leaks: {
    count: 4,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WAINWRIGHT',
    firstSaidQuote:
      "Oh, it's the roof. It leaks. It always seeps in like that when it's raining and there's an east wind.",
  },
  aryan: {
    count: 2,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'JUDSON',
    firstSaidQuote:
      'I was hoping for something a little more, well, Aryan. However, let the Ancient One approach. Where is the Ancient One?',
  },
  emily: {
    count: 3,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'JUDSON',
    firstSaidQuote:
      'Emily Wilson, granddaughter of Joseph Sundvik. You are touched by the Curse of Fenric. I selected you. You are one of the Wolves of Fenric.',
  },
  pence: {
    count: 4,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PATERSON',
    firstSaidQuote:
      "Your mum had you listed as a missing person. You don't give a toss, do you? I dunno. Four kids gone missing just this month. Vanished into thin air. It's the parents I feel sorry for. Doesn't cost much to phone, luv. Ten pence, that's all.",
  },
  darth: {
    count: 2,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ANGE',
    firstSaidQuote: 'Married Darth.',
  },
  vader: {
    count: 1,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ACE',
    firstSaidQuote: 'Darth Vader, the brain-dead plumber? Flo?',
  },
  midge: {
    count: 21,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ACE',
    firstSaidQuote: 'Midge?',
  },
  karra: {
    count: 3,
    firstSaidSeasonIndex: 26,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KARRA',
    firstSaidQuote: "I'm not a cat. I'm Karra. I'm your sister.",
  },
  sauna: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'PETE',
    firstSaidQuote:
      "John Doe on the toe. We've got to nice autopsy booked for you tomorrow morning, Mister, followed by a sauna or a Swedish herbal wrap. What would be your pleasure? One a.m. Hey, it's December thirty first 1999. Party on!",
  },
  asian: {
    count: 3,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote: 'The Asian child.',
  },
  bucks: {
    count: 3,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'LEE',
    firstSaidQuote: "I don't know. A million bucks.",
  },
  freud: {
    count: 4,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'GRACE',
    firstSaidQuote: 'You know, Freud had name for that.',
  },
  curie: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'GRACE',
    firstSaidQuote: 'Did you know Madame Curie, too?',
  },
  rinse: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ROSE',
    firstSaidQuote:
      "Yeah, only if you wash the mug. And I don't mean rinse, I mean wash. Can I use your computer?",
  },
  clive: {
    count: 7,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ROSE',
    firstSaidQuote: "Hello, I've come to see Clive? We've been emailing.",
  },
  pizza: {
    count: 17,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ROSE',
    firstSaidQuote:
      "All right, he's a nutter. Off his head. Complete online conspiracy freak. You win! What are we going to do tonight? I fancy a pizza.",
  },
  ajobs: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ROSE',
    firstSaidQuote:
      "Do you think I should try the hospital? Suki said they had ajobs going in the canteen. Is that it then, dishing out chips. I could do A Levels. I don't know. It's all Jimmy Stone's fault. I only left school because of him. Look where he ended up. What do you think?",
  },
  shunt: {
    count: 3,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Am I addressing the Consciousness? Thank you. If I might observe, you infiltrated this civilisation by means of warp shunt technology. So, may I suggest, with the greatest respect, that you shunt off?',
  },
  slash: {
    count: 24,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You lot, you spend all your time thinking about dying, like you're going to get killed by eggs or beef or global warming or asteroids. But you never take time to imagine the impossible, that maybe you survive. This is the year five point five slash apple slash twenty six. Five billion years in your future, and this is the day",
  },
  cheam: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'STEWARD',
    firstSaidQuote:
      'Hurry, now, thank you. Quick as we can. Come along, come along. And now, might I introduce the next honoured guest? Representing the Forest of Cheam, we have trees, namely, Jabe, Lute and Coffa.',
  },
  coffa: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'STEWARD',
    firstSaidQuote:
      'Hurry, now, thank you. Quick as we can. Come along, come along. And now, might I introduce the next honoured guest? Representing the Forest of Cheam, we have trees, namely, Jabe, Lute and Coffa.',
  },
  jolco: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'STEWARD',
    firstSaidQuote:
      'There will be an exchange of gifts representing peace. If you could keep the room circulating, thank you. Next, from the solicitors Jolco and Jolco, we have the Moxx of Balhoon.',
  },
  pakoo: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'STEWARD',
    firstSaidQuote:
      'Cal Spark Plug. Mister and Mrs Pakoo. The Ambassadors from the City State of Binding Light.',
  },
  texan: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CASSANDRA',
    firstSaidQuote:
      "Truly, I am the last Human. My father was a Texan, my mother was from the Arctic Desert. They were born on the Earth and were the last to be buried in its soil. I have come to honour them and say goodbye. Oh, no tears, no tears. I'm sorry. But behold, I bring gifts. From Earth itself, the last remaining ostrich egg. Legend says it had a wingspan of fifty feet and blew fire from its nostrils. Or was that my third husband? Oh, no. Oh, don't laugh. I'll get laughter lines. And here, another rarity.",
  },
  hertz: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "That wasn't a gravity pocket. I know gravity pockets and they don't feel like that. What do you think, Jabe? Listened to the engines. They've pitched up about thirty Hertz. That dodgy or what?",
  },
  proto: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CASSANDRA',
    firstSaidQuote:
      "Oh, they call themselves New humans and Proto-humans and Digi-humans, even 'Humanish, but you know what I call them? Mongrels.",
  },
  liana: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Hey, nice liana.',
  },
  ticks: {
    count: 7,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Hold on. Give us two ticks.',
  },
  jimbo: {
    count: 3,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Remote controlled Droids. Nice little cover for the real troublemaker. Go on, Jimbo. Go home.',
  },
  pixie: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CASSANDRA',
    firstSaidQuote: "Oh, shut it, pixie. I've still got my final option.",
  },
  creak: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'And creak?',
  },
  sneed: {
    count: 9,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SNEED',
    firstSaidQuote:
      'Sneed and Company offer their sincerest condolences, sir, in this most trying hour.',
  },
  gelth: {
    count: 14,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GELTH',
    firstSaidQuote:
      'Pity us. Pity the Gelth. There is so little time. Help us.',
  },
  edwin: {
    count: 7,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'DICKENS',
    firstSaidQuote:
      "I shall be subtle at first. The Mystery of Edwin Drood still lacks an ending. Perhaps the killer was not the boy's uncle. Perhaps he was not of this Earth. The Mystery of Edwin Drood and the Blue Elementals. I can spread the word, tell the truth.",
  },
  drood: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'DICKENS',
    firstSaidQuote:
      "I shall be subtle at first. The Mystery of Edwin Drood still lacks an ending. Perhaps the killer was not the boy's uncle. Perhaps he was not of this Earth. The Mystery of Edwin Drood and the Blue Elementals. I can spread the word, tell the truth.",
  },
  crewe: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JACKIE',
    firstSaidQuote: 'Oh, guess who asked me out. Billy Crewe.',
  },
  indra: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'GANESH',
    firstSaidQuote:
      "Indra Ganesh, sir. Junior secretary with the MOD. I'll be your liaison.",
  },
  terry: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SOLDIER',
    firstSaidQuote: 'Mick, Terry, side rooms. Now!',
  },
  ricky: {
    count: 24,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Ricky.',
  },
  sling: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "That's the spaceship on its way to Earth, see? Except. Hold on. See? The spaceship did a sling shot round the Earth before it landed.",
  },
  moore: {
    count: 11,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ROSE',
    firstSaidQuote: 'Patrick Moore?',
  },
  lloyd: {
    count: 3,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I'm telling you. Lloyd George, he used to drink me under the table. Who's the Prime Minister now?",
  },
  whoof: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'One more move and my sonic device will triplicate the flammability of this alcohol. Whoof, we all go up. So back off.',
  },
  fotch: {
    count: 5,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'GREEN',
    firstSaidQuote:
      'Slitheen is not our species. Slitheen is our surname. Jocrassa Fel Fotch Pasameer-Day-Slitheen at your service.',
  },
  nuked: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You get the codes, release the missiles, but not into space because there's nothing there. You attack every other country on Earth. They retaliate, fight back. World War Three. Whole planet gets nuked.",
  },
  dooms: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HARRIET',
    firstSaidQuote: 'Voicemail dooms us all.',
  },
  diana: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'GODDARD',
    firstSaidQuote: 'Goddard, sir. Diana Goddard.',
  },
  wipes: {
    count: 5,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ADAM',
    firstSaidQuote:
      'Mister Van Statten tends to dispose of his staff, and when he does he wipes their memory. I kept this stuff in case I needed to fight my way out one day.',
  },
  diego: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'GODDARD',
    firstSaidQuote:
      'And by tonight, Henry van Statten will be a homeless, brainless junkie living on the streets of San Diego, Seattle, Sacramento. Someplace beginning with S.',
  },
  verbs: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Go and find out. Stop nagging me. The thing is, Adam, time travel's like visiting Paris. You can't just read the guide book, you've got to throw yourself in. Eat the food, use the wrong verbs, get charged double and end up kissing complete strangers. Or is that just me? Stop asking questions, go and do it. Off you go, then. Your first date.",
  },
  graft: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'EDITOR',
    firstSaidQuote:
      "Ah, hidden behind a genetic graft, but that's still you. Eva Saint Julienne, last surviving member of the Freedom Fifteen. Hmm, self declared anarchist, is that right?",
  },
  danny: {
    count: 139,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'NURSE',
    firstSaidQuote:
      "It's a personal choice. Some people whistle. I know one man who triggers it with O, Danny Boy. But you're set on default for now. That's a click of the fingers.",
  },
  geoff: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MUM',
    firstSaidQuote: "Who's that? Geoff, is that you?",
  },
  wight: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The past is another country. 1987's just the Isle of Wight. Are you sure about this?",
  },
  vitex: {
    count: 4,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'ROSE',
    firstSaidQuote:
      "All the stuff mum kept. His stuff. She kept it all packed away in boxes in the cupboard. She used to show me when she'd had a bit to drink. Here it is, on display. Where it should be. Third prize at the bowling. First two got to go to Didcot. Health drinks. Tonics, mum used to call them. He made his money selling this Vitex stuff. He had all sorts of jobs. He was so clever. Solar power. Mum said he was going to do this. Now he can. Okay, look I'll tell him you're not my boyfriend.",
  },
  genes: {
    count: 5,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'PETE',
    firstSaidQuote:
      "I'm a dad. I mean, I'm already a dad, but Rose grows up and she's you. That's wonderful. I mean, I suppose I thought that you'd be a bit useless, what with my useless genes and all, but. Well, I mean, how did you get here?",
  },
  mauve: {
    count: 3,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "It's mauve.",
  },
  spock: {
    count: 6,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'ROSE',
    firstSaidQuote: 'Not very Spock, is it, just asking.',
  },
  ernie: {
    count: 5,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'NANCY',
    firstSaidQuote:
      'Ernie, how many times? We are guests in this house. We will not make comments of that kind. Washing up.',
  },
  glenn: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'JACK',
    firstSaidQuote: 'Do you like Glenn Miller?',
  },
  blitz: {
    count: 7,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'JACK',
    firstSaidQuote:
      "It's 1941, the height of the London Blitz, the height of the German bombing campaign, and something else has fallen on London. A fully equipped Chula warship. The last one in existence, armed to the teeth. And I know where it is, because I parked it. If the Agency can name the right price, I can get it for you. But in two hours, a German bomb is going to fall on it and destroy it forever. That's your deadline. That's the deal. Now, shall we discuss payment?",
  },
  chula: {
    count: 7,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'JACK',
    firstSaidQuote:
      "It's 1941, the height of the London Blitz, the height of the German bombing campaign, and something else has fallen on London. A fully equipped Chula warship. The last one in existence, armed to the teeth. And I know where it is, because I parked it. If the Agency can name the right price, I can get it for you. But in two hours, a German bomb is going to fall on it and destroy it forever. That's your deadline. That's the deal. Now, shall we discuss payment?",
  },
  ruddy: {
    count: 9,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'LLOYD',
    firstSaidQuote: 'Ruddy kids!',
  },
  mmmmm: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'JENKINS',
    firstSaidQuote: 'What do you mmmmm. Mummy.',
  },
  email: {
    count: 4,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Software patch. Going to email the upgrade. You want moves, Rose? I'll give you moves.",
  },
  ditto: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'The nanogenes will clean up the mess and switch themselves off, because I just told them to. Nancy and Jamie will go to Doctor Constantine for help, ditto. All in all, all things considered, fantastic!',
  },
  mayor: {
    count: 15,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'MARGARET',
    firstSaidQuote:
      "This nuclear power station right in the heart of Cardiff city will bring jobs for all. As you can see, as Lord Mayor, I've had to sanction some radical redevelopments. No photographs! What did I say? Take pictures of the project by all means, but not me, thank you. So, Cardiff Castle will be demolished allowing the Blaidd Drwg Project to rise up, tall and proud. A monument to Welsh industry. And yes, some of you might shiver. The words nuclear power station and major population centre aren't exactly the happiest of bedfellows. But I give you my personal guarantee that as long as I walk upon this Earth, no harm will come to any of my citizens. Now, drink up. A toast. To the future!",
  },
  cathy: {
    count: 5,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'CATHY',
    firstSaidQuote:
      "Excuse me, Mrs Blaine? My name's Cathy Salt, I represent the Cardiff Gazette.",
  },
  tusks: {
    count: 3,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'JACK',
    firstSaidQuote: 'I swear, six feet tall and with big tusks',
  },
  roars: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'JACK',
    firstSaidQuote:
      "And I'm like, oh, no, no, it's got nothing to do with me. And then it roars, and we are running. Oh my God, we are running! And Brakovitch falls, so I turn to him and I say",
  },
  heist: {
    count: 6,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'JACK',
    firstSaidQuote: "Must've been a great big heist. It's stacked with power.",
  },
  droid: {
    count: 12,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'ROSE',
    firstSaidQuote: 'Oh, my God, the android. The Anne droid.',
  },
  denim: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'ZU-ZANA',
    firstSaidQuote:
      "It's all very twentieth century. Where did you get that denim?",
  },
  lynda: {
    count: 15,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'LYNDA',
    firstSaidQuote:
      "I know you're not supposed to talk about the outside world, but you must've been watching. Do people like me? Lynda. Lynda with a Y, not Linda with an I. She got forcibly evicted because she damaged the camera. Am I popular?",
  },
  linda: {
    count: 13,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'LYNDA',
    firstSaidQuote:
      "I know you're not supposed to talk about the outside world, but you must've been watching. Do people like me? Lynda. Lynda with a Y, not Linda with an I. She got forcibly evicted because she damaged the camera. Am I popular?",
  },
  kyoto: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "We'd just left Raxacoriofallapatorius. Then we went to Kyoto. That's right, Japan in 1336, and we only just escaped.",
  },
  fitch: {
    count: 5,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'ANNE DROID',
    firstSaidQuote:
      'Correct. Fitch in the Pan Traffic Calendar, which month comes after Hoob?',
  },
  broff: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'ANNE DROID',
    firstSaidQuote:
      'Correct. Broff, the Great Cobalt Pyramid is built on the remains of which famous Old Earth Institute?',
  },
  tweak: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'TRINE-E',
    firstSaidQuote:
      "It's the buccaneer look. Little dash of pirate and just a tweak of President Schwarzenegger.",
  },
  waist: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'ZU-ZANA',
    firstSaidQuote:
      "No, that's a bit too much Hell's Angel. I think I like the shorter one. Look, waist length, nice and slimming, shows off the bum.",
  },
  evict: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'DAVINA',
    firstSaidQuote:
      "The Doctor, you've broken the House Rules. Big Brother has no choice but to evict you. You have ten seconds to make your farewells, and then we're going to get you!",
  },
  frane: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'RODRICK',
    firstSaidQuote: 'Hoshbin Frane.',
  },
  baint: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'ANNE DROID',
    firstSaidQuote:
      'No, the correct answer is a paab. Rose, in fashion, Stella Pok Baint is famous for what?',
  },
  hydra: {
    count: 2,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "You can't. it's made of Hydra combination.",
  },
  minto: {
    count: 1,
    firstSaidSeasonIndex: 27,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'MICKEY',
    firstSaidQuote: 'Have you tried that new pizza place down Minto Road?',
  },
  stevo: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'MICKEY',
    firstSaidQuote:
      'Hey, turn that down. Turn it off, Stevo. Turn that off! John, shut up!',
  },
  synch: {
    count: 3,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'ROSE',
    firstSaidQuote:
      "God, I'm all out of synch. You just forget about Christmas and things in the Tardis. They don't exist. You get sort of timeless.",
  },
  pepto: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'JACKIE',
    firstSaidQuote: "Codeine? Paracetamol? Oh, I don't know, Pepto-Bismol?",
  },
  array: {
    count: 2,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'SALLY',
    firstSaidQuote:
      "And they're moving. The ship's still in flight now. We've got it on the Hubble array.",
  },
  sally: {
    count: 44,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'SALLY',
    firstSaidQuote: 'Sally.',
  },
  chord: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, that struck a chord. Am I right that the sanctified rules of combat still apply?',
  },
  disin: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "The disin. Oh, you'll find out.",
  },
  winch: {
    count: 2,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DUKE',
    firstSaidQuote: 'Winch me up. Up! Look at me. No sign of infection.',
  },
  samba: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CASS-DOCTOR',
    firstSaidQuote:
      "Goodness me, I'm a man. Yum. So many parts. And hardly used. Oh, oh, two hearts! Oh, baby, I'm beating out a samba!",
  },
  nnypd: {
    count: 2,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'LOUDSPEAKER',
    firstSaidQuote: 'This is the NNYPD. Please step away from the shuttles.',
  },
  bient: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CASSANDRA',
    firstSaidQuote:
      "And if you actually see them, you're shocked. But don't quote me on that. Oh, naughty. À bientôt!",
  },
  aboot: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ROSE',
    firstSaidQuote: "Och, aye! I've been oot and aboot.",
  },
  feral: {
    count: 2,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "She's a feral child. I bought her for sixpence in old London Town. It's was her or the Elephant Man, so",
  },
  eaves: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VICTORIA',
    firstSaidQuote:
      "Very much. Oh, completely. And that's the charm of a ghost story, isn't it? Not the scares and chills, that's just for children, but the hope of some contact with the great beyond. We all want some message from that place. It's the Creator's greatest mystery that we're allowed no such consolation. The dead stay silent, and we must wait. Come. Begin your tale, Sir Robert. There's a chill in the air. The wind is howling through the eaves. Tell us of monsters.",
  },
  lupus: {
    count: 2,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ANGELO',
    firstSaidQuote: 'Lupus deus est. Lupus deus est.',
  },
  album: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Viscum album, the oil of the mistletoe. It's been worked into the wood like a varnish. How clever was your dad? I love him. Powerful stuff, mistletoe. Bursting with lectins and viscotoxins.",
  },
  carew: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'VICTORIA',
    firstSaidQuote:
      "My annual pilgrimage. I'm taking it to Helier and Carew, the Royal Jewellers at Hazelhead. The stone needs recutting.",
  },
  asbos: {
    count: 2,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I thought there'd be happy slapping hoodies. Happy slapping hoodies with ASBOs. Happy slapping hoodies with ASBOs and ringtones. Huh? Huh? Oh, yeah. Don't tell me I don't fit in.",
  },
  kenny: {
    count: 8,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WAGNER',
    firstSaidQuote:
      "Melissa. You'll be joining my class for the next period. Milo's failed me, so it's time we moved you up to the top class. Kenny, not eating the chips?",
  },
  metro: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      "Well, it's not like getting parts for a Mini Metro, Beside, the technology inside him could rewrite human science. I couldn't show him to anyone.",
  },
  lassa: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'FINCH',
    firstSaidQuote: 'My name is Brother Lassa. And you?',
  },
  lumic: {
    count: 29,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'CYBERMAN',
    firstSaidQuote: 'You are John Lumic.',
  },
  films: {
    count: 6,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MICKEY',
    firstSaidQuote:
      "Oh, come on. You've seen it on films. Like an alternative to our world where everything's the same but a little bit different, like, I don't know, traffic lights are blue, Tony Blair never got elected.",
  },
  blair: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MICKEY',
    firstSaidQuote:
      "Oh, come on. You've seen it on films. Like an alternative to our world where everything's the same but a little bit different, like, I don't know, traffic lights are blue, Tony Blair never got elected.",
  },
  modal: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JACKIE',
    firstSaidQuote:
      'Birthday present from Mister Lumic. Latest modal. Diamond studded. Pick up signals from Venezuela.',
  },
  cybus: {
    count: 12,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'NEWSREADER',
    firstSaidQuote:
      'With shares in Cybus Industries doubling in price, Mister Lumic is',
  },
  toffs: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'SOLDIER',
    firstSaidQuote:
      'Course there is. Where you been living, mate? Up there with the toffs?',
  },
  jakey: {
    count: 2,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Tell you what. We can take the ear pods at the same time. Give people their minds back so they don't walk into that place like sheep. Jakey-boy? Lumic's transmitting the control signal. It must be from over there.",
  },
  lnows: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Knows how to get past firewalls and passwords. Lnows how to find something encrypted in the Lumic Family Database, under er. What was it, Pete? Binary what?',
  },
  chats: {
    count: 3,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yeah, talk too much, that's my problem. Lucky I got you that cheap tariff, Rose, for all our long chats.",
  },
  vegas: {
    count: 4,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ROSE',
    firstSaidQuote:
      "I thought we'd be going for the Vegas era, you know the white flares and the, grr, chest hair.",
  },
  eddie: {
    count: 6,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'RITA',
    firstSaidQuote:
      'But her face, Eddie. What happened to her? That awful face.',
  },
  twerp: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'EDDIE',
    firstSaidQuote:
      "Shut your face, you, whoever you are. We can handle this ourselves. Listen, you little twerp. You're hardly out of the blooming' cradle, so I don't expect you to understand. But I've got a position to maintain. People round here respect me. It matters what people think.",
  },
  glued: {
    count: 2,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WIRE',
    firstSaidQuote:
      "What a clever thing you are! But why fret about it? Why not just relax? Kick off your shoes and enjoy the Coronation. Believe me, you'll be glued to the screen.",
  },
  kylie: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's never too late, as a wise person once said. Kylie, I think. The Wire's got big plans. It'll need. Yes, yes, yes, it's got to harvest half the population. Millions and millions of people and where are we?",
  },
  soles: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Rubber soles, swear by them!',
  },
  satin: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'DIMBLEBY',
    firstSaidQuote:
      'Or coat of Chivalry of Cloth of Gold, lined with crimson satin.',
  },
  quake: {
    count: 3,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'SCOOTI',
    firstSaidQuote:
      "Stand by, everyone. Buckle down. We have incoming. And it's a big one. Quake point five on its way.",
  },
  olden: {
    count: 4,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'IDA',
    firstSaidQuote:
      "You're not joking. You really don't know. Well introductions. F Y I, as they said in the olden days. I'm Ida Scott, science officer. Zachary Cross Flane, acting Captain, sir. You've met Mister Jefferson, he's Head of Security. Danny Bartock, Ethics committee.",
  },
  flane: {
    count: 2,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'IDA',
    firstSaidQuote:
      "You're not joking. You really don't know. Well introductions. F Y I, as they said in the olden days. I'm Ida Scott, science officer. Zachary Cross Flane, acting Captain, sir. You've met Mister Jefferson, he's Head of Security. Danny Bartock, Ethics committee.",
  },
  sixes: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'ROSE',
    firstSaidQuote: "That's a lot of sixes.",
  },
  stats: {
    count: 5,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'ZACH',
    firstSaidQuote:
      "It's giving off readings of over ninety stats on the Blazon scale.",
  },
  comms: {
    count: 21,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'ZACH',
    firstSaidQuote: 'Comms are down.',
  },
  lynne: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'ELTON',
    firstSaidQuote:
      "I should say, this isn't, you know, my whole life. It's not all spaceships and stuff, because I'm into all sorts of things. I like football. I like a drink. I like Spain. And if there's one thing I really, really love, Jeff Lynne and the Electric Light Orchestra. Because you can't beat a bit of ELO.",
  },
  chaka: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'ELTON',
    firstSaidQuote: "Fish 'n' Chips, Rock 'n' Roll. Chaka Demus 'n' Pliers.",
  },
  demus: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'ELTON',
    firstSaidQuote: "Fish 'n' Chips, Rock 'n' Roll. Chaka Demus 'n' Pliers.",
  },
  scour: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'ELTON',
    firstSaidQuote:
      'So it began. The impossible task. To scour the mean streets, to search a major capital city for an unknown girl. To hunt down that face in a seething metropolis of lost souls. To find that one girl in ten million.',
  },
  pervy: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'ELTON',
    firstSaidQuote:
      "I wasn't being pervy or anything. I wasn't after her. I was looking for the Doctor.",
  },
  maeve: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'TRISH',
    firstSaidQuote: 'Maeve? Are you okay?',
  },
  trish: {
    count: 5,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'MAEVE',
    firstSaidQuote: "Doctor can't help. Can't you, can't you feel it, Trish?",
  },
  beady: {
    count: 2,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 11,
    firstSaidBy: "TOM'S DAD",
    firstSaidQuote: "It's all right. I've got my beady eyes on them. Come on.",
  },
  lewis: {
    count: 7,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "See, look. I've got a colleague. Lewis.",
  },
  hicks: {
    count: 3,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'MAEVE',
    firstSaidQuote:
      "Saw it with me own eyes. Dale Hicks in your garden, playing with your Tommy, and then pfft! Right in front of me, like he was never there. There's no need to look any further than this street. It's right here amongst us.",
  },
  chloe: {
    count: 52,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'TRISH',
    firstSaidQuote: 'You have to come down some time, Chloe.',
  },
  dokey: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Okey dokey?',
  },
  probs: {
    count: 2,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No probs. I'll give you a fiver if you can tell me what the hell it is, because I haven't got the foggiest.",
  },
  choir: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'TRISH',
    firstSaidQuote:
      "She's in the choir. She's singing in an old folks home. Any mum would be proud. You know I want you to know these things before you see her, Doctor, because right now, she's not herself.",
  },
  brunt: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'TRISH',
    firstSaidQuote:
      "Chloe usually got the brunt of his temper when he'd had a drink. The day he crashed the car, I thought we were free. I thought it was over.",
  },
  papua: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, I will tell you this. Papua New Guinea surprises everyone in the shot put.',
  },
  watts: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'PEGGY',
    firstSaidQuote:
      "Listen to me, Den Watts. I don't care if you have come back from the grave. Get out of my pub! The only spirits I'm serving in this place are gin, whisky and vodka. So, you heard me. Get out!",
  },
  peggy: {
    count: 27,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'JACKIE',
    firstSaidQuote:
      'Well, first of all, Peggy heard this noise in the cellar, so she goes down',
  },
  singh: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'RAJESH',
    firstSaidQuote:
      "You must be the Doctor. Rajesh Singh. It's an honour, sir.",
  },
  wharf: {
    count: 8,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'JACKIE',
    firstSaidQuote:
      "Hold on a minute. We're in Canary Wharf. Must be. This building, it's Canary Wharf.",
  },
  rells: {
    count: 1,
    firstSaidSeasonIndex: 28,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'DALEK 3',
    firstSaidQuote:
      'Rewind image by nine rells. Identify grid seven gamma frame. This male registers as enemy.',
  },
  nerys: {
    count: 6,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'DONNA',
    firstSaidQuote:
      "Well, obviously, when you kidnapped me. Who was it? Who's paying you? Is it Nerys? Oh my God, she's finally got me back. This has got Nerys written all over it.",
  },
  nosed: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'NODDY',
    firstSaidQuote:
      'Does he ride a red nosed reindeer, does he turn up on his sleigh? Do the fairies keep him sober for a day? So here it',
  },
  dosed: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Somehow you've been dosed with Huon energy. And that's a problem, because Huon energy hasn't existed since the Dark Times. The only place you'd find a Huon particle now is a remnant in the heart of the Tardis. See? That's what happened. Say, that's the Tardis.",
  },
  snuck: {
    count: 5,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Thames flood barrier right on top of us. Torchwood snuck in and built this place underneath.',
  },
  huons: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Particle extrusion. Hold on. Brilliant. They've been manufacturing Huon particles. Course, my people got rid of Huons. They unravel the atomic structure.",
  },
  spats: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'DONNA',
    firstSaidQuote:
      'He did. We used to laugh. We used to call him the fat cat in spats.',
  },
  molto: {
    count: 10,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, do you know what I said before about time machines? Well, I lied. And now we're going to use it. We need to find out what the Empress of the Racnoss is digging up. If something's buried at the planet's core, it must've been there since the beginning. That's just brilliant. Molto bene. I've always wanted to see this. Donna, we're going further back than I've ever been before.",
  },
  snows: {
    count: 3,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Even if it snows?',
  },
  onset: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'MORGENSTERN',
    firstSaidQuote: 'Dizziness can be a sign of early onset diabetes.',
  },
  slabs: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's just a Slab. They're called Slabs. Basic slave drones. See? Solid leather, all the way through. Someone has got one hell of a fetish.",
  },
  mimic: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "If she can assimilate Mister Stoker's blood, mimic the biology, she'll register as human. We've got to find her and show the Judoon. Come on!",
  },
  biggs: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Hiding. On the run. Like Ronald Biggs in Rio de Janeiro. What's she doing now? She's still not safe. The Judoon could execute us all. Come on.",
  },
  rhino: {
    count: 4,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Have you seen them? There are these things. These great big space rhino things. I mean, rhinos from space. And we're on the moon! Great big space rhinos with guns on the moon. And I only came in for my bunions, look. I mean, all fixed now. Perfectly good treatment. The nurses were lovely. I said to my wife, I said I'd recommend this place to anyone, but then we end up on the moon. And did I mention the rhinos?",
  },
  tesla: {
    count: 44,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FLORENCE',
    firstSaidQuote:
      'The magnetic setting now increased to fifty thousand Tesla.',
  },
  stems: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FLORENCE',
    firstSaidQuote:
      "It'll send out a magnetic pulse that'll fry the brain stems of every living thing within two hundred and fifty thousand miles. Except for me, safe in this room.",
  },
  bloom: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WIGGINS',
    firstSaidQuote:
      " Her face was like a winter's moon that lights the traveller's way. Her smile was like a summer bloom that bursts then fades away. My love is night, my love is day. My love she is my world.",
  },
  fades: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'WIGGINS',
    firstSaidQuote:
      " Her face was like a winter's moon that lights the traveller's way. Her smile was like a summer bloom that bursts then fades away. My love is night, my love is day. My love she is my world.",
  },
  nonny: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SHAKESPEARE',
    firstSaidQuote:
      'Hey, nonny nonny. Sit right down here next to me. You two get sewing on them costumes. Off you go.',
  },
  egads: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MARTHA',
    firstSaidQuote: 'Er, verily, forsooth, egads.',
  },
  afric: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SHAKESPEARE',
    firstSaidQuote:
      "Oops. Isn't that a word we use nowadays? An Ethiop girl? A swarth? A Queen of Afric?",
  },
  chant: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'LILITH',
    firstSaidQuote: 'Fear not. Chant with me. Water damps the fiercest flame.',
  },
  damps: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'LILITH',
    firstSaidQuote: 'Fear not. Chant with me. Water damps the fiercest flame.',
  },
  trite: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SHAKESPEARE',
    firstSaidQuote:
      "A trite reply. Yeah, that's what I'd do. And you? You look at him like you're surprised he exists. He's as much of a puzzle to you as he is to me.",
  },
  bouts: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SHAKESPEARE',
    firstSaidQuote:
      'Oh, sweet Dolly Bailey. She sat out three bouts of the plague in this place when we all ran like rats. But what could have scared her so? She had such enormous spirit.',
  },
  nelly: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MARTHA',
    firstSaidQuote:
      "Whoa, Nelly. I know for a fact you've got a wife in the country.",
  },
  flirt: {
    count: 7,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Come on. We can all have a good flirt later.',
  },
  rexel: {
    count: 3,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BURBAGE',
    firstSaidQuote: 'and strikes the fulsome grove of Rexel Four.',
  },
  marty: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'No, the novelisation. Yes, the film. Marty McFly goes back and changes history.',
  },
  mcfly: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'No, the novelisation. Yes, the film. Marty McFly goes back and changes history.',
  },
  badda: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You're making a habit of this. Ah! I've only got one heart working. How do you people cope? I've got to get the other one started. Hit me! Hit me on the chest! Dah! Other side. Now, on the back, on the back. Left a bit. Dah, lovely. There we go. Badda booma! Well, what are you standing there for? Come one! The Globe!",
  },
  booma: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You're making a habit of this. Ah! I've only got one heart working. How do you people cope? I've got to get the other one started. Hit me! Hit me on the chest! Dah! Other side. Now, on the back, on the back. Left a bit. Dah, lovely. There we go. Badda booma! Well, what are you standing there for? Come one! The Globe!",
  },
  attic: {
    count: 4,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Anyway, time we were off. I've got a nice attic in the Tardis where this lot can scream for all eternity, and I've got to take Martha back to Freedonia.",
  },
  verse: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SHAKESPEARE',
    firstSaidQuote:
      "We're alike in many ways, Doctor. Martha, let me say goodbye to you in a new verse. A sonnet for my Dark Lady. Shall I compare thee to a summer's day? Thou art more lovely and more temperate.",
  },
  spate: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SALLY',
    firstSaidQuote:
      "Salutations! This is Sally Calypso with the traffic news at ten fifteen. We've got reports of a multiple stackpile at junction five zero nine, with a spate of carjackings reported on New Fifth Avenue. So you take care now, and drive safely.",
  },
  slums: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MARTHA',
    firstSaidQuote: "You've brought me to the slums?",
  },
  bendy: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'PHARMACIST 3',
    firstSaidQuote:
      'Get some Mellow. Makes you feel all bendy and soft all day long.',
  },
  gravs: {
    count: 3,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MILO',
    firstSaidQuote: 'Engaging anti-gravs. Hold on.',
  },
  cheen: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CHEEN',
    firstSaidQuote:
      "Well, I'm Cheen, and this is Milo. And I swear we're sorry. We're really, really sorry. We just needed access to the fast line, but I promise, as soon as we arrive, we'll drop you off and you can go back and find your friend.",
  },
  strut: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BRANNIGAN',
    firstSaidQuote:
      'Hey! You daft little street strut. What are you doing standing there? Either get out or get in. Come on!',
  },
  hymns: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MARTHA',
    firstSaidQuote:
      "It is, though, because you haven't seen the things he can do. Honestly, just trust me, both of you. You've got your faith, you've got your songs and your hymns, and I've got the Doctor.",
  },
  lazlo: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TALLULAH',
    firstSaidQuote: 'Wish me luck, Lazlo!',
  },
  spire: {
    count: 3,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'FOREMAN 2',
    firstSaidQuote:
      "It's a beautiful thing, sir, and every single one of us is proud of it. My wife says it's like a, like a spire reaching into Heaven.",
  },
  revue: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TALLULAH',
    firstSaidQuote:
      "Oh, honey, I got one song in a back street revue and that's only because Heidi Chicane broke her ankle. Which had nothing to do with me whatever anybody says. I can't afford to make a fuss. If I don't make this month's rent, then before you know it, I'm in Hooverville.",
  },
  heidi: {
    count: 4,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TALLULAH',
    firstSaidQuote:
      "Oh, honey, I got one song in a back street revue and that's only because Heidi Chicane broke her ankle. Which had nothing to do with me whatever anybody says. I can't afford to make a fuss. If I don't make this month's rent, then before you know it, I'm in Hooverville.",
  },
  myrna: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'LOIS',
    firstSaidQuote:
      'Aw, quick complaining, Myrna. Go buy yourself some glasses.',
  },
  piped: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'FRANK',
    firstSaidQuote: "I've got it all piped up to the scaffolding outside.",
  },
  marth: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LEO',
    firstSaidQuote:
      'Hey, you all right, Marth? I think Mum wants to talk to you.',
  },
  eliot: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LAZARUS',
    firstSaidQuote: "So the mysterious Doctor knows his Eliot. I'm impressed.",
  },
  whuff: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MARTHA',
    firstSaidQuote: "Whuff, it's like a sauna in here.",
  },
  riley: {
    count: 6,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'RILEY',
    firstSaidQuote:
      "They're randomly generated. Reckon I know most of them. Sorry. Riley Vashti.",
  },
  atles: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'RILEY',
    firstSaidQuote:
      'Oh, this is a nightmare. Classical music. Who had the most pre-download number ones, Elvis Presley or The Be-atles? How are we supposed to know that?',
  },
  remix: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No! Wait! Er, er. Oh, what was that remix? Er, I don't know. I am a bit busy.",
  },
  erina: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ASHTON',
    firstSaidQuote:
      'Understood, Captain. Erina? Get back here with that equipment.',
  },
  wicks: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Ah, Pemberton, Smythe, Wicks, take post.',
  },
  spion: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JOAN',
    firstSaidQuote:
      'His name was Oliver. He died in the battle of Spion Cop. We were childhood sweethearts. But you see, I was angry with the army for such a long time.',
  },
  poole: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MARTHA',
    firstSaidQuote:
      "There you are. Come and look what I've got. Mister Poole didn't want his afternoon tea so Cook said I could have it. And there's enough for two. What are you standing there for?",
  },
  snell: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'ROCASTLE',
    firstSaidQuote:
      'Very well. You boys, remain on guard. Mister Snell, telephone for the police. Mister Philips, with me. We shall investigate.',
  },
  trent: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, it lies on the River Leen, its southern boundary following the course of the River Trent which flows from Stoke to the Humber.',
  },
  aglow: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'VICAR',
    firstSaidQuote:
      'They were young, straight of limb, true of eye, steady and aglow.',
  },
  kathy: {
    count: 12,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'SALLY',
    firstSaidQuote: 'Kathy?',
  },
  timey: {
    count: 12,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "People assume that time is a strict progression of cause to effect, but actually from a non-linear, non-subjective viewpoint, it's more like a big ball of wibbly-wobbly, timey-wimey stuff.",
  },
  wimey: {
    count: 10,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "People assume that time is a strict progression of cause to effect, but actually from a non-linear, non-subjective viewpoint, it's more like a big ball of wibbly-wobbly, timey-wimey stuff.",
  },
  padra: {
    count: 3,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'PADRA',
    firstSaidQuote:
      'My name is Padra Toc Shafe Cane. Tell me. Just tell me, can you take me to Utopia?',
  },
  shafe: {
    count: 12,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'PADRA',
    firstSaidQuote:
      'My name is Padra Toc Shafe Cane. Tell me. Just tell me, can you take me to Utopia?',
  },
  creet: {
    count: 3,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'ATILLO',
    firstSaidQuote:
      'The computers are down but you can check the paperwork. Creet! Passenger needs help.',
  },
  canes: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'PADRA',
    firstSaidQuote:
      "The Shafe Canes, anyone? Kistane from Red Force Five? My name's Padra.",
  },
  reefs: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'YANA',
    firstSaidQuote:
      "Oh, it's far beyond the Condensate Wilderness, out towards the Wildlands and the Dark Matter reefs, calling us in. The last of the humans scattered across the night.",
  },
  ellis: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'JACK',
    firstSaidQuote:
      "Earth, 1892. Got in a fight in Ellis Island. A man shot me through the heart. Then I woke up. Thought it was kind of strange. But then it never stopped. Fell off a cliff, trampled by horses, World War One, World War Two, poison, starvation, a stray javelin. In the end, I got the message. I'm the man who can never die. And all that time you knew.",
  },
  rugby: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'MARTHA',
    firstSaidQuote:
      "But he goes back years. He's famous. Everyone knows his story. Look. Cambridge University, Rugby blue. Won the Athletics thing. Wrote a novel, went into business, marriage, everything. He's got a whole life.",
  },
  boxer: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'LEO',
    firstSaidQuote:
      "I'm in Brighton. Yeah, we came down with Boxer. Did you see that Saxon thing on telly?",
  },
  grits: {
    count: 2,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      "Anything I can do? I could make the tea, or isn't that American enough? I don't know, I could make grits. What are grits, anyway?",
  },
  sheba: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'DOCHERTY',
    firstSaidQuote:
      "She can be the Queen of Sheba for all I care. I'm still busy.",
  },
  deses: {
    count: 1,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'DOCHERTY',
    firstSaidQuote:
      "Oh God, I miss Countdown. Never been the same since Des took over. Both Deses. What's the plural for Des? Desi? Deseen? But we've been told there's going to be a transmission from the man himself.",
  },
  cuffs: {
    count: 3,
    firstSaidSeasonIndex: 29,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'JACK',
    firstSaidQuote:
      "Whoa, big fella! You don't want to miss the party. Cuffs. So, what do we do with this one?",
  },
  diner: {
    count: 4,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'ASTRID',
    firstSaidQuote:
      "Doesn't feel that different. I spent three years working at the spaceport diner, travelled all the way here and I'm still waiting on tables.",
  },
  lifeb: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Everyone, listen to me! This is an emergency! Get to the lifeb',
  },
  slade: {
    count: 11,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'SLADE',
    firstSaidQuote: 'Rickston Slade.',
  },
  banna: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "That's the attitude. Rickston, Mister Copper, and you, Bannakaffalatta. Look, can I just call you Banna? It's going to save a lot of time.",
  },
  fatso: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'SLADE',
    firstSaidQuote:
      'Thing is, how are Mister and Mrs Fatso going to get through that gap?',
  },
  spiky: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Oi! Don't get spiky with me. Keep going.",
  },
  erica: {
    count: 5,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'COPPER',
    firstSaidQuote:
      "Oh, and they're all at war with the continent of Ham Erica.",
  },
  grail: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FOSTER',
    firstSaidQuote:
      'Adipose Industries, the twenty first century way to lose weight. No exercise, no diet, no pain. Just lifelong freedom from fat. The Holy Grail of the modern age. And here it is. You just take one capsule. One capsule, once a day for three weeks, and the fat, as they say.',
  },
  rakes: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FOSTER',
    firstSaidQuote:
      "Oh, Penny, if cynicism burnt up calories, we'd all be as thin as rakes. But if you want the science, I can oblige.",
  },
  stacy: {
    count: 7,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DONNA',
    firstSaidQuote: 'Stacy Campbell?',
  },
  beeps: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'STACY',
    firstSaidQuote:
      "I'm doing the opposite. I'm dumping him. I can do better than him now. Right, I won't be long. If the taxi beeps, give me a shout.",
  },
  flaps: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, thing about cat flaps is, they don't just let things in, they let things out as well.",
  },
  sleek: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, yes, I've still got your sonic pen. Nice. I like it. Sleek. It's kind of sleek.",
  },
  nanny: {
    count: 14,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DONNA',
    firstSaidQuote: 'What, like an outer space super nanny?',
  },
  veena: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DONNA',
    firstSaidQuote:
      "Planet of the Hats, I'm ready. I don't need injections, do I? You know, like when you go to Cambodia. Is there any of that? Because my friend Veena went to Bahrain, and she. You're not saying much.",
  },
  epcot: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'DONNA',
    firstSaidQuote: 'Are you having me on? Are we in Epcot?',
  },
  sybil: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THALINA',
    firstSaidQuote:
      'We have found it, Sister Spurrina, in the thirteenth book of the Sibylline Oracles. The blue box. A temple made of wood. And yet the Sybil foretold that the box would appear at the time of storms, and fire, and betrayal.',
  },
  lopus: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CAECILIUS',
    firstSaidQuote:
      "Marble. Lopus Caecilius. Mining, polishing and design thereof. If you want marble, I'm your man.",
  },
  augur: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'ROMBUS',
    firstSaidQuote:
      'Announcing Lucius Petrus Dextrus, Chief Augur of the City Government.',
  },
  facto: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Ipso facto.',
  },
  sibyl: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SPURRINA',
    firstSaidQuote: 'No man is allowed to enter the Temple of Sibyl.',
  },
  welds: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "See? The energy converter takes the lava, uses the power to create a fusion matrix, which welds Pyrovile to human. Now it's complete, they can convert millions.",
  },
  ryder: {
    count: 4,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'RYDER',
    firstSaidQuote:
      'Mister Halpen, sir. Doctor Ryder, new head of Ood Management.',
  },
  atmos: {
    count: 41,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JO',
    firstSaidQuote:
      "Oh, this goes way beyond the newspapers. This thing's worldwide. I'm telling you, ATMOS is dangerous.",
  },
  prawn: {
    count: 2,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DONNA',
    firstSaidQuote: "She's engaged, you prawn.",
  },
  staal: {
    count: 13,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SKREE',
    firstSaidQuote: 'General Staal? They are close.',
  },
  duper: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yeah, but if there is a danger of hostile aliens, I think it's best to keep a super-duper time machine away from the front lines.",
  },
  coral: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, if that's what you want. I mean, it's a bit soon. I had so many places I had wanted to take you. The Fifteenth Broken Moon of the Medusa Cascade, the Lightning Skies of Cotter Palluni's World, Diamond Coral Reefs of Kataa Flo Ko. Thank you. Thank you, Donna Noble, it's been brilliant. You've, you've saved my life in so many ways. You're, you're just popping home for a visit, that's what you mean.",
  },
  kataa: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, if that's what you want. I mean, it's a bit soon. I had so many places I had wanted to take you. The Fifteenth Broken Moon of the Medusa Cascade, the Lightning Skies of Cotter Palluni's World, Diamond Coral Reefs of Kataa Flo Ko. Thank you. Thank you, Donna Noble, it's been brilliant. You've, you've saved my life in so many ways. You're, you're just popping home for a visit, that's what you mean.",
  },
  dunce: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'DONNA',
    firstSaidQuote: 'Know what you are? A great big outer space dunce.',
  },
  palin: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SYLVIA',
    firstSaidQuote:
      "Oh, hark at her, Michael Palin. Are you staying for tea, because I haven't got anything in. I've been trying to keep your granddad on that macrobiotic diet, but he sneaks off and gets pork pies at the petrol station. Don't deny it, I've seen the wrappers in the car. Oh, I don't miss a trick. Now then, what were you going to tell me? What don't I know?",
  },
  diets: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JENKINS',
    firstSaidQuote:
      "UNIT's been watching Rattigan Academy for ages. It's all a bit Hitler Youth. Exercise at dawn and classes and special diets.",
  },
  jeeps: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'JENKINS',
    firstSaidQuote:
      "How come we've got it in the jeeps? Yeah, tell me about it. They're fitted as standard on all government vehicles. We can't get rid of them till we can prove there's something wrong.",
  },
  grunt: {
    count: 6,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "He called you a grunt. Don't call Ross a grunt. He's nice. We like Ross. Look at this place.",
  },
  skorr: {
    count: 5,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'STAAL',
    firstSaidQuote: "Then you'll see it completed, Commander Skorr. Get to it.",
  },
  nobis: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'As they say in Latin, Donna nobis pacem.',
  },
  pacem: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'As they say in Latin, Donna nobis pacem.',
  },
  urban: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'NEWS 24',
    firstSaidQuote:
      "The United Nations has issued a directive worldwide, telling urban populations to stay indoors. Those in rural areas are being ordered to stay away from all major cities. There are reports from every country in Europe of thousands of people walking across country to escape. And on the Eastern seaboard of America it's said to be reminiscent of Dunkirk, with boats taking refugees out into the Atlantic.",
  },
  korea: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PRICE',
    firstSaidQuote:
      'North America, online. United Kingdom, online. France, online. India, online. Pakistan, online. China, online. North Korea, online. All systems locked and coordinated. Launching in ten, nine, eight, seven, six, five',
  },
  mondo: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'You were building equipment, ready to terraform El Mondo Luko so that humans could live there and breathe the air with this. An atmospheric converter.',
  },
  embed: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The machine must embed military history and tactics, but no name. She's a generated anomaly.",
  },
  cline: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'COBB',
    firstSaidQuote:
      "And you're the one who showed us the path to victory. But you can consider the irony from your prison cell. Cline, at arms.",
  },
  rambo: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DONNA',
    firstSaidQuote: 'Oi, oi, oi. All right. Cool the beans, Rambo.',
  },
  dewey: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DONNA',
    firstSaidQuote:
      "No, no, no, no. But listen, I spent six months working as a temp in Hounslow Library, and I mastered the Dewey Decimal System in two days flat. I'm good with numbers. It's staring us in the face.",
  },
  peach: {
    count: 11,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'GREEVES',
    firstSaidQuote: 'Good afternoon, Professor Peach.',
  },
  noddy: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'DONNA',
    firstSaidQuote:
      "Oh, come on! It's not like we could drive across country and find Enid Blyton having tea with Noddy. Could we? Noddy's not real. Is he? Tell me there's no Noddy.",
  },
  butle: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'DONNA',
    firstSaidQuote:
      'Why would she seal it off? All right, I need to investigate. You just butle off.',
  },
  mammy: {
    count: 9,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'DONNA',
    firstSaidQuote:
      "What is it? What else? It's a song? Mammy? I don't know. Camptown Races?",
  },
  detox: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Detox. Oh my. I must do that more often. I mean, the detox.',
  },
  spicy: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CURBISHLEY',
    firstSaidQuote: 'Ah, I thought it was jolly spicy.',
  },
  delhi: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CLEMENCY',
    firstSaidQuote:
      "It was forty years ago, in the heat of Delhi, late one night. I was alone, and that's when I saw it. A dazzling light in the sky. The next day, he came to the house. Christopher, the most handsome man I'd ever seen. Our love blazed like a wildfire. I held nothing back. And in return he showed me the incredible truth about himself. He'd made himself human, to learn about us. This was his true shape.",
  },
  jumna: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CLEMENCY',
    firstSaidQuote:
      "I loved him so much, it didn't matter. But he was stolen from me. 1885, the year of the great monsoon. The river Jumna rose up and broke its banks. He was Taken At The Flood. But Christopher left me a parting gift. A jewel like no other. I wore it always. Part of me never forgot. I kept it close, always.",
  },
  thozz: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'GOLIGHTLY',
    firstSaidQuote: "Put thozz thingzz back where you found them. It'zzzz",
  },
  godzz: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'GOLIGHTLY',
    firstSaidQuote:
      "Damn it, you humanzz, worshipping your tribal sky godzz. I am so much more. That night, the universe exploded in my mind. I wanted to take what wazz mine. And you, Agatha Christie, with your railway station bookstall romancezz, what'z to stop me killing you?",
  },
  monty: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's a world. Literally, a world. The whole core of the planet is the index computer. Biggest hard drive ever. And up here, every book ever written. Whole continents of Jeffrey Archer, Bridget Jones, Monty Python's Big Red Book. Brand new editions, specially printed.",
  },
  zippo: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Scanning for life forms. If I do a scan looking for your basic humanoids. You know, your book readers, few limbs and a face, apart from us, I get nothing. Zippo, nada. See? Nobody home. But if I widen the parameters to any kind of life.',
  },
  taboo: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'NODE',
    firstSaidQuote:
      'I am Courtesy Node seven one zero slash aqua. Please enjoy the Library and respect the personal access codes of all your fellow readers, regardless of species or hygiene taboo.',
  },
  slarg: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'NODE',
    firstSaidQuote:
      "Additional. There follows a brief message from the Head Librarian for your urgent attention. It has been edited for tone and content by a Felman Lux Automated Decency Filter. Message follows. Run. For God's sake, run. No way is safe. The library has sealed itself, we can't. Oh, they're here. Argh. Slarg. Snick. Message ends. Please switch off your mobile comm. units for the comfort of other readers.",
  },
  snick: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'NODE',
    firstSaidQuote:
      "Additional. There follows a brief message from the Head Librarian for your urgent attention. It has been edited for tone and content by a Felman Lux Automated Decency Filter. Message follows. Run. For God's sake, run. No way is safe. The library has sealed itself, we can't. Oh, they're here. Argh. Slarg. Snick. Message ends. Please switch off your mobile comm. units for the comfort of other readers.",
  },
  vowel: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'DONNA',
    firstSaidQuote: "Oh, skip to a vowel. They're easy.",
  },
  oxide: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'HOBBES',
    firstSaidQuote:
      "They call it the Sapphire Waterfall, but it's no such thing. Sapphire's an aluminium oxide, but the glacier is just compound silica with iron pigmentation.",
  },
  kliks: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'JOE',
    firstSaidQuote:
      "Driver Joe at the wheel. There's been a diamondfall at the Winter Witch Canyon, so we'll be taking a slight detour, as you'll see on the map. The journey covers five hundred kliks to the Multifaceted Coast. Duration is estimated at four hours. Thank you for travelling with us, and as they used to say in the olden days, wagons roll.",
  },
  klein: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'HOSTESS',
    firstSaidQuote:
      'Also, the latest artistic installation from Ludovico Klein.',
  },
  poosh: {
    count: 6,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'DEE DEE',
    firstSaidQuote:
      "I'm just a second-year student, but I wrote a paper on the Lost Moon of Poosh, Professor Hobbes read it, liked it, took me on as researcher, just for the holidays. Well, I say researcher. Most of the time he's got me fetching and carrying. But it's all good experience.",
  },
  jival: {
    count: 4,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'SYLVIA',
    firstSaidQuote:
      "Jival, he's called. Jival Chowdry? He runs that little photocopy business and he needs a secretary.",
  },
  temps: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'SYLVIA',
    firstSaidQuote:
      "Oh, I know why you want a job at HC Clements, lady. Because you think you'll meet a man with lots of money and your whole life will change. Well let me tell you, sweetheart. City executives don't need temps, except for practice.",
  },
  mooky: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'VEENA',
    firstSaidQuote:
      "Mooky says let's go to the Boardwalk. It's two for the price of one.",
  },
  annum: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'DONNA',
    firstSaidQuote:
      "I can afford it. Promotion. You are talking to Jival Chowdry's Personal Assistant, I'll have you know. Capital P, capital A, twenty three thousand pound per annum, merci beaucoup.",
  },
  typed: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'DONNA',
    firstSaidQuote:
      "Who typed this? I'm your PA. Did you get somebody else to type this? Beatrice?",
  },
  clyde: {
    count: 2,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'NEWS 24',
    firstSaidQuote:
      'Also had been inside the Royal Hope, along with his teenage friends Maria Jackson and Clyde Langer. It is feared that they also perished.',
  },
  emerg: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'NEWS 24',
    firstSaidQuote: 'The Royal Air Force has declared an emerg',
  },
  obego: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'SOLDIER',
    firstSaidQuote:
      "The Daniels Family, billeted at number fifteen. Mister and Mrs Obego, billeted at number thirty one. Miss Coltrane, you're in number eight. The Noble family, billeted at number twenty nine.",
  },
  rocco: {
    count: 2,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'ROCCO',
    firstSaidQuote:
      "We've been here for eight weeks already. I had a nice little paper shop in Shepherd's Bush. All gone now. So, upstairs, we have Merchandani family. Seven of them. Good family. Good kids. Except that one. You be careful of him. I's a joking! Where's that smile, eh? Rocco Colasanto. I'm here with my wife and her sister and her husband and their kids and their daughter's kids. We've got the front room. My mother, she's got the back room. She's old. You forgive, eh?. And this? This is you. This is your palazzo.",
  },
  mamma: {
    count: 2,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'ROCCO',
    firstSaidQuote:
      'Is pot-luck! Is fun. I go wake Mamma. She likes new people. Mamma! Is people! Nice people!',
  },
  ianto: {
    count: 4,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'ROSE',
    firstSaidQuote:
      "That was the Torchwood team. Gwen Cooper, Ianto Jones, they gave their lives. And Captain Jack Harkness has transported to the Sontaran home world. There's no one left.",
  },
  firey: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'ROCCO',
    firstSaidQuote:
      "And you! I'm going to miss you most of all. All flame-haired and firey.",
  },
  erisa: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'MAGAMBO',
    firstSaidQuote: 'Captain Erisa Magambo. Thank you for this.',
  },
  jahoo: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Callufrax Minorr. Jahoo. Shallacatop. Woman Wept. Clom. Clom's gone? Who'd want Clom?",
  },
  laura: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'MAN',
    firstSaidQuote:
      "We're not going. Do you hear me? Laura, get back inside the house. Simon, get inside. Go!",
  },
  exter: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'DALEK',
    firstSaidQuote:
      'Hostility will not be tolerated. Exterminate. Exterminate. Exter',
  },
  sonst: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'Halt! Sonst werden wir Sie exterminieren! Sie sind jetzt ein Gefangener der Daleks!',
  },
  jetzt: {
    count: 2,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'DALEK 2',
    firstSaidQuote:
      'Halt! Sonst werden wir Sie exterminieren! Sie sind jetzt ein Gefangener der Daleks!',
  },
  immer: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'GERMAN WOMAN',
    firstSaidQuote:
      'Hier ist niemand. Was immer Sie wollen, gehen Sie fort. Lassen Sie mich in Ruhe!',
  },
  gehen: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'GERMAN WOMAN',
    firstSaidQuote:
      'Hier ist niemand. Was immer Sie wollen, gehen Sie fort. Lassen Sie mich in Ruhe!',
  },
  komme: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'MARTHA',
    firstSaidQuote:
      'Ich heisse Martha Jones. Ich komme von UNIT. Agentin fuenf sechs sechs sieben eins, von der medizinishen Abteilung.',
  },
  fuenf: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'MARTHA',
    firstSaidQuote:
      'Ich heisse Martha Jones. Ich komme von UNIT. Agentin fuenf sechs sechs sieben eins, von der medizinishen Abteilung.',
  },
  sechs: {
    count: 2,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'MARTHA',
    firstSaidQuote:
      'Ich heisse Martha Jones. Ich komme von UNIT. Agentin fuenf sechs sechs sieben eins, von der medizinishen Abteilung.',
  },
  hiess: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'GERMAN WOMAN',
    firstSaidQuote:
      'Es hiess Sie kaemen vorbei. That accent. That is London, ja? I went to London. Long time ago.',
  },
  nicht: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'GERMAN WOMAN',
    firstSaidQuote:
      'I know the Key. What it does. Sie sind der Albtraum, nicht die anderen, Sie! Ich sollte Sie umbringen, am besten gleich jetzt!',
  },
  goons: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'JACK',
    firstSaidQuote: "Don't send in your goons, or I'll set this thing off.",
  },
  phwor: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'DONNA',
    firstSaidQuote:
      'Phwor. Macrotransmission of a K-filter wavelength blocking Dalek weaponry in a self-replicating energy blindfold matrix.',
  },
  cyclo: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 14,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Infostamp with a Cyclo-Steinham core. You ripped open the core and broke the safety. Zap! Only the Doctor would think of that.',
  },
  fugue: {
    count: 2,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 14,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Sorry. Really, I am so sorry, but that's an awful lot of luggage for one man. Because an infostamp is plain technology. It's not enough to make a man lose his mind. What you suffered is called a fugue. A fugue state, where the mind just runs away because it can't bear to look back. You wanted to become someone else, because Jackson Lake had lost so much.",
  },
  hazel: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 14,
    firstSaidBy: 'ROSITA',
    firstSaidQuote:
      "What is it? What's happening? That's Mister Cole. He's Master of the Hazel Street Workhouse. Maybe he's taking them to prayers.",
  },
  riven: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 14,
    firstSaidBy: 'CYBERLEADER',
    firstSaidQuote:
      'Your mind is riven with anger and abuse and revenge. These have no place in a Cybermind. Activate. Emotions have tormented you all of your life. Now you will be set free. This is your liberation.',
  },
  kevin: {
    count: 18,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 15,
    firstSaidBy: 'MACMILLAN',
    firstSaidQuote:
      "She's on the bus! She's on the. Kevin, get the car. It's definitely her. Come on. Move it. Jackson, follow that bus.",
  },
  buses: {
    count: 10,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 15,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, humans on buses, always blaming me. Look, look, if you must know, I was tracking a hole in the fabric of reality. Call it a hobby. But it was a tiny little hole. No danger to anyone. Suddenly it gets big, and we drive right through it.',
  },
  chops: {
    count: 5,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 15,
    firstSaidBy: 'LOU',
    firstSaidQuote: 'Chops. Nice couple of chops and gravy. Nothing special.',
  },
  media: {
    count: 6,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 15,
    firstSaidBy: 'MAGAMBO',
    firstSaidQuote:
      'Establish an exclusion zone. Any media, move them back. Any trouble, arrest them,',
  },
  souza: {
    count: 4,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 15,
    firstSaidBy: 'CHRISTINA',
    firstSaidQuote:
      "That must be nice. It's Christina de Souza. To be precise, Lady Christina de Souza.",
  },
  hywel: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 15,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's the Cup of Athelstan, given to the first King of Britain as a coronation gift from Hywel, King of the Welsh. But it's been held in the International Gallery for two hundred years, which makes you, Lady Christina, a thief.",
  },
  bowie: {
    count: 2,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'BOTH',
    firstSaidQuote: 'Bowie Base One.',
  },
  gusev: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Number one. Founded July 1st, 2058. Established Bowie Base One in the Gusev Crater. You've been here how long?",
  },
  georg: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'YURI',
    firstSaidQuote:
      "Let's save money. Georg says fine, okay. His birthday comes around, turns out Georg has bought him a car. Top of the range. And the thing is, he's used Mikhail's credit stamp. So Mik's saying, that means I bought it myself. Georg says it's the thought that counts.",
  },
  mutti: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'ULRIKA',
    firstSaidQuote: 'Hallo, Mutti. Hallo, Mars! Sag hallo.',
  },
  mints: {
    count: 2,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Think-a think-a think-a think. What have we got? Not enough oxygen. Protein packs, useless. Glacier, glacier mints, minty, Monty, molto bene, bunny, bonny, bish bash bosh. Argh. The room, the room, look at the room. Section F. What's in Section F? Anyone!",
  },
  minty: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Think-a think-a think-a think. What have we got? Not enough oxygen. Protein packs, useless. Glacier, glacier mints, minty, Monty, molto bene, bunny, bonny, bish bash bosh. Argh. The room, the room, look at the room. Section F. What's in Section F? Anyone!",
  },
  bunny: {
    count: 4,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Think-a think-a think-a think. What have we got? Not enough oxygen. Protein packs, useless. Glacier, glacier mints, minty, Monty, molto bene, bunny, bonny, bish bash bosh. Argh. The room, the room, look at the room. Section F. What's in Section F? Anyone!",
  },
  bobby: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 17,
    firstSaidBy: 'WILF',
    firstSaidQuote:
      "Yeah, all right, all right. Now listen, this is important. We have got to find it, right? So phone around. Phone everybody. Sally, will you get onto the Bridge club? Right. Winston, you try the old boys. Bobby, want you to ring the skiffle band, right? Between us, we've got the city covered.",
  },
  obama: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 17,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      "Well, you look after him. And don't forget tomorrow night. The Christmas broadcast. President Obama.",
  },
  netty: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 17,
    firstSaidBy: 'MINNIE',
    firstSaidQuote:
      'The Silver Cloak. It worked. Because Wilf phoned Netty, who phoned June, and her sister lives opposite Broadfell, and she saw the police box, and her neighbour saw this man heading east.',
  },
  cafes: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 17,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "What's so special about this place? We passed fifteen cafes on the way.",
  },
  shaun: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 17,
    firstSaidBy: 'WILF',
    firstSaidQuote:
      "Shaun Temple. They're engaged. Getting married in the spring.",
  },
  danes: {
    count: 3,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 17,
    firstSaidBy: 'NAISMITH',
    firstSaidQuote: 'If you would, Mister Danes.',
  },
  cords: {
    count: 2,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 17,
    firstSaidBy: 'ROSSITER',
    firstSaidQuote:
      "Er, excuse me, sir. If I could check the basement? We're getting fluctuation on the power cords.",
  },
  zocci: {
    count: 2,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 17,
    firstSaidBy: 'ADDAMS',
    firstSaidQuote: "No, that's a Zocci.",
  },
  cacti: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 18,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "That's cacti.",
  },
  weres: {
    count: 1,
    firstSaidSeasonIndex: 30,
    firstSaidStoryIndex: 18,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You weren't there in the final days of the War. You never saw what was born. But if the Timelock's broken, then everything's coming through. Not just the Daleks, but the Skaro Degradations, the Horde of Travesties, the Nightmare Child, the Could-have-been King with his army of Meanwhiles and Never-weres. The War turned into hell. And that's what you've opened, right above the Earth. Hell is descending.",
  },
  whack: {
    count: 3,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, that's much better. Brand new me. Whack on the head, just what I needed.",
  },
  comas: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, they're all the multiform. Eight comas, eight disguises for Prisoner Zero.",
  },
  oldie: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Fermat's Theorem, the proof. And I mean the real one. Never been seen before. Poor old Fermat, got killed in a duel before he could write it down. My fault. I slept in. Oh, and here's an oldie but a goodie. Why electrons have mass. And a personal favourite of mine, faster than light travel with two diagrams and a joke. Look at your screens. Whoever I am, I'm a genius. Look at the sun. You need all the help you can get. Fellas, pay attention.",
  },
  mabel: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote:
      'Well done, Mabel. Well done, Alfie. Good girl, Tabitha. Very well done, Ranjit. Good girl, Chloe. Well done, Ben. Well done, Mandy.',
  },
  alfie: {
    count: 35,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote:
      'Well done, Mabel. Well done, Alfie. Good girl, Tabitha. Very well done, Ranjit. Good girl, Chloe. Well done, Ben. Well done, Mandy.',
  },
  mandy: {
    count: 5,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote:
      'Well done, Mabel. Well done, Alfie. Good girl, Tabitha. Very well done, Ranjit. Good girl, Chloe. Well done, Ben. Well done, Mandy.',
  },
  timmy: {
    count: 2,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote: 'Bad boy, Timmy.',
  },
  vator: {
    count: 3,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MANDY',
    firstSaidQuote:
      "You can't ride a Vator with a zero. You know what happens. You'll get sent below.",
  },
  wheee: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Say wheee!',
  },
  roomy: {
    count: 3,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Yes, yes, yes. But on the plus side, roomy.',
  },
  chemo: {
    count: 3,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "I'm vibrating the chemo-receptors.",
  },
  gizmo: {
    count: 3,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'LIZ',
    firstSaidQuote:
      "Stuck my gizmo on you. Been listening in. Nice moves on the hurl escape. So, what's the big fella doing here?",
  },
  breen: {
    count: 3,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CHURCHILL',
    firstSaidQuote:
      'Something the matter, Breen? You look a little down in the dumps.',
  },
  dumps: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CHURCHILL',
    firstSaidQuote:
      'Something the matter, Breen? You look a little down in the dumps.',
  },
  swish: {
    count: 2,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I'd be feeling pretty swish if I looked like you. Pretty supreme.",
  },
  jammy: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "All right, it's a Jammy Dodger, but I was promised tea.",
  },
  adieu: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Oh, shall we say adieu?',
  },
  aplan: {
    count: 2,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'RIVER',
    firstSaidQuote:
      'Well, at least the building was empty. Aplan temple. Unoccupied for centuries.',
  },
  woolf: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "So is Virginia Woolf. I'm on her bowling team. Very relaxed, sort of cheerful. Well, that's having two heads, of course. You're never short of a snog with an extra head.",
  },
  pedro: {
    count: 7,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'AMY',
    firstSaidQuote:
      "No, I heard you. Before you sent Pedro, you sent Crispin and Phillip, and now you can't even remember them. Something happened. I don't know what, and you don't even remember.",
  },
  rouge: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Anywhere you want. Any time you want. One condition. It has to be amazing. The Moulin Rouge in 1890. The first Olympic Games. Think of it as a wedding present, because it's either this or tokens. It's a lot to take in, isn't it? Tiny box, huge room inside. What's that about? Let me explain.",
  },
  byron: {
    count: 11,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Venezia. La Serenissima. Impossible city. Preposterous city. Founded by refugees running from Attila the Hun. It was just a collection of little wooden huts in the middle of the marsh, but became one of the most powerful cities in the world. Constantly being invaded, constantly flooding, constantly just beautiful. Ah, you got to love Venice. So many people did. Byron, Napoleon, Casanova. Ooo, that reminds me. 1580. That's all right. Casanova doesn't get born for a hundred and forty five years. Don't want to run into him. I owe him a chicken.",
  },
  veils: {
    count: 2,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WOMAN',
    firstSaidQuote: 'Veils down, girls.',
  },
  blots: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RORY',
    firstSaidQuote: 'He was right. It blots out everything else.',
  },
  salsa: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'RORY',
    firstSaidQuote:
      'If we cancel now, we lose the deposit on the village hall. The salsa band. Oh.',
  },
  rages: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ROSANNA',
    firstSaidQuote:
      "This is how it works. First, we drink you until you're dry. Then we fill you with our blood. It rages through you like a fire, changing you, until one morning you awake and your humanity is a dream now faded.",
  },
  guido: {
    count: 2,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'No. Guido, What are you doing?',
  },
  stave: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Yeah, bit of a mistake. But look, what a result. Look at this bench. What a nice bench. What will they think of next? So. What do you do around here to stave off the, you know',
  },
  lordy: {
    count: 2,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'AMY',
    firstSaidQuote:
      "Is this because of you? Is this some Time Lordy thing because you've shown up again?",
  },
  chubs: {
    count: 2,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'RORY',
    firstSaidQuote: "I'll deal with this one, Chubs. Now",
  },
  sofas: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, no, no. Ice can burn. Sofas can read. It's a big universe. We have to agree which battle to lose. All of us, now.",
  },
  slava: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'A speck of psychic pollen from the candle meadows of Karass don Slava. Must have been hanging around for ages. Fell in the time rotor, heated up and induced a dream state for all of us.',
  },
  alaya: {
    count: 8,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'ALAYA',
    firstSaidQuote: 'Alaya.',
  },
  liens: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "They're not aliens. They're Earth-liens. Once known as the Silurian race, or, some would argue, Eocenes, or Homo Reptilia. Not monsters, not evil. Well, only as evil as you are. The previous owners of the planet, that's all. Look, from their point of view, you're the invaders. Your drill was threatening their settlement. Now, the creature in the crypt. Her name's Alaya. She's one of their warriors, and she's my best bargaining chip. I need her alive. If she lives, so do Elliot and Mo and Amy, because I will find them. While I'm gone, you four people, in this church, in this corner of planet Earth, you have to be the best of humanity.",
  },
  amend: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "But maybe it should be. So, here's a deal. Everybody listening. Eldane, you activate shutdown. I'll amend the system, set your alarm for a thousand years time. A thousand years to sort the planet out. To be ready. Pass it on. As legend, or prophesy, or religion, but somehow make it known. This planet is to be shared.",
  },
  peasy: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'AMY',
    firstSaidQuote: 'Easy peasy.',
  },
  whats: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'VINCENT',
    firstSaidQuote:
      "One of my favourite whats? You've never seen my work before.",
  },
  orsay: {
    count: 2,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, think about it. This is the middle of Vincent Van Gogh's greatest year of painting. If we're not careful, the net result of our pleasant little trip will be the brutal murder of the greatest artist who ever lived. Half the pictures on the wall of the Museé D'Orsay will disappear. And it will be our fault.",
  },
  pablo: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "And Picasso. What a ghastly old goat. I kept telling him, concentrate, Pablo. It's one eye, either side of the face.",
  },
  tonto: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Oh, a huge variety of things. This one here, for instance, plays soothing music. While this one makes a huge amount of noise. And this one makes everything go absolutely tonto.',
  },
  ginge: {
    count: 2,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'AMY',
    firstSaidQuote: 'The ultimate ginge. Brighter than sunflowers.',
  },
  craig: {
    count: 81,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'SOPHIE',
    firstSaidQuote: "Craig, what's that on the ceiling?",
  },
  dylan: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'SOPHIE',
    firstSaidQuote:
      "Sorry. You know what I mean. Okay, I'll talk to Craig. Okay. Now she's having a Dylan crisis on top of the Clare crisis. It could be another all-nighter. I'm sorry, but I really should go. Do you mind if I go?",
  },
  owens: {
    count: 3,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'CRAIG',
    firstSaidQuote: 'Craig Owens. The Doctor?',
  },
  fines: {
    count: 2,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You've got everything I need for an omelette fines herbes, pour deux. So, who's the girl on the fridge?",
  },
  malta: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'CRAIG',
    firstSaidQuote:
      "No, Dom's in Malta. There's nobody around. Hang on a sec. We've got a match today, pub league. We're one down if you fancy it?",
  },
  nines: {
    count: 5,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'AMY',
    firstSaidQuote:
      "A lot of nines. Is it good that they're nines? Tell me it's good that they're all nines.",
  },
  thems: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Come on, Craig, breathe. Thems are healthy footballer's lungs.",
  },
  zeros: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'AMY',
    firstSaidQuote:
      "You've done it. Oh, now the screen's just zeros. Now it's minus ones, minus twos, minus threes.",
  },
  cults: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'SHARON',
    firstSaidQuote:
      "I just don't want her growing up and joining one of those Star Cults. I don't trust that Richard Dawkins.",
  },
  ponds: {
    count: 9,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Come along, Ponds.',
  },
  fezes: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "It's a fez. I wear a fez now. Fezes are cool.",
  },
  mezon: {
    count: 1,
    firstSaidSeasonIndex: 31,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'RIVER',
    firstSaidQuote:
      'Not yet. Your systems are still restoring, which means your shield density is compromised. One Alpha Mezon burst through your eyestalk would kill you stone dead.',
  },
  petal: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'SARDICK',
    firstSaidQuote:
      "Look, petal, we already have a surplus population. No more people allowed on this planet. I don't make the rules.",
  },
  claus: {
    count: 7,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Father Christmas, Santa Claus or, as I've always known him, Jeff.",
  },
  shoal: {
    count: 14,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'KAZRAN',
    firstSaidQuote:
      'My school. During the last fog belt, the nets broke and there was an attack. Loads of them. A whole shoal. No one was hurt, but it was the most fish ever seen below the mountains.',
  },
  lends: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'KAZRAN',
    firstSaidQuote:
      'My dad lends money. He always takes a family member as, he calls it security.',
  },
  achoo: {
    count: 2,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Achoo!',
  },
  salud: {
    count: 4,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Salud!',
  },
  wumpy: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Time isn't a straight line. It's all bumpy wumpy. There's loads of boring stuff like Sundays and Tuesdays and Thursday afternoons. But now and then there are Saturdays. Big temporal tipping points when anything's possible. The Tardis can't resist them, like a moth to a flame. She loves a party, so I give her 1969 and NASA, because that's space in the sixties, and Canton Everett Delaware the third, and this is where she's pointing.",
  },
  nixon: {
    count: 6,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CANTON',
    firstSaidQuote: 'You were my second choice for President, Mister Nixon.',
  },
  dicky: {
    count: 2,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, Dicky. Tricky Dicky. They're never going to forget you. Say hi to David Frost for me.",
  },
  frost: {
    count: 13,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh, Dicky. Tricky Dicky. They're never going to forget you. Say hi to David Frost for me.",
  },
  bagsy: {
    count: 2,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Okay. Groovy. So not just pirates today. We've managed to bagsy a ship where there's a demon popping in. Very efficient. I mean, if something's going to kill you, it's nice that it drops you a note to remind you.",
  },
  mogul: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'AVERY',
    firstSaidQuote: 'No! No. This is the treasure of the Mogul of India.',
  },
  towed: {
    count: 2,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "It's been towed.",
  },
  avast: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'AVERY',
    firstSaidQuote:
      'To the rigging, you dogs! Let go the sails. Avast ye! Put the bunt into the slack of the clews.',
  },
  clews: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'AVERY',
    firstSaidQuote:
      'To the rigging, you dogs! Let go the sails. Avast ye! Put the bunt into the slack of the clews.',
  },
  idris: {
    count: 6,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'UNCLE',
    firstSaidQuote:
      "Yes, it's going to be you. I only wish I could go in your place, Idris. Nah, I don't, because it's really going to hurt.",
  },
  welly: {
    count: 4,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "With enormous difficulty. Right now I'm burning up Tardis rooms to give us some welly. Goodbye, swimming pool. Goodbye, scullery. Sayonara, squash court seven.",
  },
  oogly: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes. So you're like a sea urchin. Hard outer surface, that's the planet we're walking on. Big, squashy, oogly thing inside, that's you.",
  },
  bitey: {
    count: 6,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, you're not. You're a bitey, mad lady. The Tardis is up and downy stuff in a big blue box.",
  },
  downy: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, you're not. You're a bitey, mad lady. The Tardis is up and downy stuff in a big blue box.",
  },
  wacey: {
    count: 2,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'AMY',
    firstSaidQuote: "Spacey wacey, isn't it?",
  },
  lucas: {
    count: 6,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote: 'ID confirmed. Jennifer Lucas.',
  },
  gunge: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BUZZER',
    firstSaidQuote: "No need to get poncey. It's just gunge.",
  },
  lefts: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'JENNIFER',
    firstSaidQuote: 'Three lefts, a right and a left. Third door on your left.',
  },
  pints: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'G-JIMMY',
    firstSaidQuote:
      'Yeah. I drank about eight pints of tea, then they told me I had a wee boy and I just burst out laughing. No idea why. I miss home, as much as you.',
  },
  aorta: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'You stopped his heart. He had a heart. Aorta, valves, a real human heart. And you stopped it.',
  },
  yowza: {
    count: 3,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Yowza. An escape route.',
  },
  recon: {
    count: 5,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'BUZZER',
    firstSaidQuote: 'The army will send a recon team our.',
  },
  hoper: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Because, Amy, I am and always will be the optimist. The hoper of far-flung hopes and the dreamer of improbable dreams. The wheels are in motion. Done.',
  },
  plumb: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'G-DOCTOR',
    firstSaidQuote:
      'Well, you did want to plumb your brain into the core of an entire planet just to halt its orbit and win a bet.',
  },
  hoods: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'FAT ONE',
    firstSaidQuote:
      "You're not supposed to stare at them. And if they think you're trying to see under their hoods, they'll kill you on the spot.",
  },
  lorna: {
    count: 4,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THIN ONE',
    firstSaidQuote: "You're Lorna Bucket, aren't you?",
  },
  strax: {
    count: 33,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'HARCOURT',
    firstSaidQuote: 'Commander Strax. I just have to ask. A Sontaran nurse?',
  },
  fairs: {
    count: 2,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'RIVER',
    firstSaidQuote:
      "It's my birthday. The Doctor took me ice skating on the River Thames in 1814, the last of the great Frost Fairs. He got Stevie Wonder to sing for me under London Bridge.",
  },
  debts: {
    count: 2,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'DORIUM',
    firstSaidQuote:
      "You think he isn't? If that man is finally collecting on his debts, God help you, and God help his debtors.",
  },
  slump: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'STRAX',
    firstSaidQuote: "Don't slump. It's bad for your spine.",
  },
  mikes: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Oh blimey, okay, you probably leave a message at the tone or something. Sorry, I wasn't really trying to do this. I was looking for the mikes.",
  },
  award: {
    count: 3,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JIM',
    firstSaidQuote: "We're in a hurry. We're not trying to win an award.",
  },
  tenza: {
    count: 5,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'George is a Tenza. Of course he is.',
  },
  syncs: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, because that Red Waterfall time is compressed. That's the point. The Time Glass syncs up the",
  },
  shill: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'INTERFACE',
    firstSaidQuote:
      "The perfect replica of a Shill Governor's Mansion on Shallanna.",
  },
  shins: {
    count: 2,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'AMY',
    firstSaidQuote: 'Go for the shins.',
  },
  ravan: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'AMY',
    firstSaidQuote:
      "Let's go to Ravan-Skala, he says. The people are six hundred feet tall. You have to talk to them in hot air balloons and the Tourist Information Centre is made of one of their hats, he says. I'm sorry, but I don't see any huge hats.",
  },
  skala: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'AMY',
    firstSaidQuote:
      "Let's go to Ravan-Skala, he says. The people are six hundred feet tall. You have to talk to them in hot air balloons and the Tourist Information Centre is made of one of their hats, he says. I'm sorry, but I don't see any huge hats.",
  },
  beaky: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Amy, Beaky, this could be the most exciting thing I have ever seen.',
  },
  halke: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'RORY',
    firstSaidQuote: 'Commander Halke, defeat.',
  },
  paige: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'AMY',
    firstSaidQuote:
      "Paige Barnes, other people's socks. Tim Nelson, balloons. Novice Prin, sabrewolves. Royston Luke Gold, Plymouth? Lucy Hayward, that brutal gorilla. Doctor, what does it mean?",
  },
  socks: {
    count: 3,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'AMY',
    firstSaidQuote:
      "Paige Barnes, other people's socks. Tim Nelson, balloons. Novice Prin, sabrewolves. Royston Luke Gold, Plymouth? Lucy Hayward, that brutal gorilla. Doctor, what does it mean?",
  },
  howie: {
    count: 10,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'You with the face, Howie, you said you were surprised to be back in reception.',
  },
  woors: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "They're not doors, they're walls. Walls that look like doors. Door-walls, if you like, or dwalls. Woors even, though you'd probably got it when you said they're not doors. I mean, the windows are",
  },
  shona: {
    count: 15,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'KELLY',
    firstSaidQuote: 'Oh, thanks, Shona.',
  },
  nappy: {
    count: 2,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'CRAIG',
    firstSaidQuote:
      "Of course you do. I don't even know when his nappy needs changing, and I'm the one supposed to be his dad. Oh.",
  },
  yappy: {
    count: 3,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, I was on my way, you know. Saw a shop, got a job. You got to live in the moment. Craig, mind Yappy.',
  },
  ghosh: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Sheila Clark went missing Tuesday. Atif Ghosh last seen Friday. Tom Luker last seen Sunday.',
  },
  luker: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Sheila Clark went missing Tuesday. Atif Ghosh last seen Friday. Tom Luker last seen Sunday.',
  },
  trait: {
    count: 2,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, that's impossible. And also grossly sentimental and over simplistic. You destroyed them because of the deeply ingrained hereditary human trait to protect one's own genes, which in turn triggered a, a, a. Yeah. Love. You blew them up with love.",
  },
  arriv: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'CRAIG',
    firstSaidQuote: 'Doctor, that will be Sophie arriv',
  },
  sighs: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'KOVARIAN',
    firstSaidQuote:
      'By Silencio Lake, on the Plain of Sighs, an Impossible Astronaut will rise from the deep and strike the Time Lord dead.',
  },
  envoy: {
    count: 1,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Father Gideon Vandaleur, former envoy of the Silence. My condolences.',
  },
  glade: {
    count: 2,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Been knocking about. A bit of a farewell tour. Things to do, people to see. There's always more. I could invent a new colour, save the Dodo, join the Beatles. Hello, it's me. Get him. Tell him, we're going out and it's all on me, except for the money and driving. I have got a time machine, Dorium. It's all still going on. For me, it never stops. Liz the First is still waiting in a glade to elope with me. I could help Rose Tyler with her homework. I could go on all of Jack's stag parties in one night.",
  },
  elope: {
    count: 3,
    firstSaidSeasonIndex: 32,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Been knocking about. A bit of a farewell tour. Things to do, people to see. There's always more. I could invent a new colour, save the Dodo, join the Beatles. Hello, it's me. Get him. Tell him, we're going out and it's all on me, except for the money and driving. I have got a time machine, Dorium. It's all still going on. For me, it never stops. Liz the First is still waiting in a glade to elope with me. I could help Rose Tyler with her homework. I could go on all of Jack's stag parties in one night.",
  },
  duvet: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Oh, he's good. The old bear and duvet, eh? Classic.",
  },
  cheem: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 0,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Never underestimate a tree, Lily. I met the Forest of Cheem once. She fancied me.',
  },
  darla: {
    count: 2,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'FIGURE',
    firstSaidQuote: 'Darla von Karlsen.',
  },
  oswin: {
    count: 39,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'OSWIN',
    firstSaidQuote: 'Oswin Oswald, junior entertainment officer, starship',
  },
  combo: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'OSWIN',
    firstSaidQuote: 'Bad combo. No sense of humour in that chin.',
  },
  neffy: {
    count: 7,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Crikey, Charlie, look at that. Ooo, I know someone who'd love to have a look at that. And the Ponds. Mustn't forget the Ponds, Neffy. Haven't seen them in ages. I'm riffing. People usually stop me when I'm riffing or carry on without me. That's also an option.",
  },
  cutie: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Roar yourself. Hello, cutie. Good boy. Who's a lovely Tricy then? Yes, you are. Yes, you are.",
  },
  tricy: {
    count: 6,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Roar yourself. Hello, cutie. Good boy. Who's a lovely Tricy then? Yes, you are. Yes, you are.",
  },
  spank: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'RIDDELL',
    firstSaidQuote:
      'Egyptian Queen or not, I shall put you across my knee and spank you.',
  },
  argos: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Ah, the purple light. That's what it was. An IV system, identifying value. The database of everything across space and time allocated a market value. Argos for the universe. You were trying to find out how much I'm worth.",
  },
  livid: {
    count: 2,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Course you are. Sit down, both of you, licketty split. The ship does all the engineering. The controls are straight forward. Even a monkey use them. Oh look, they're going to. Guys, come on. Comedy gold. Where's a Silurian audience when you need one. Anyway, two eye line screens. Velocity and trajectories. Steer away from the Earth. Try not to bump into the moon otherwise the races who live there will be livid.",
  },
  cubes: {
    count: 37,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Invasion of the very small cubes. That's new.",
  },
  ipads: {
    count: 3,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'KATE',
    firstSaidQuote:
      'Like iPads have dropped out of the sky. Taking them to work, taking pictures, making films, posting them on Flickr and YouTube. Within three hours, the cubes had a thousand separate Twitter accounts.',
  },
  saver: {
    count: 4,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'RANJIT',
    firstSaidQuote:
      "Everyone here loves you. The nurses, the doctors. You're a life-saver, mate, literally.",
  },
  hirst: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'AMY',
    firstSaidQuote:
      "Hey! Doctor, it's me. Hello. So, the UN classified the cubes as provisionally safe, whatever that means, and Banksy and Damien Hirst put out statements saying the cubes are nothing to do with them. And the cubes, well, they're just here. Still. What's it been, nine months? People are just taking them for granted. Maybe we'll never know why they came. But anyway. I got to Laura's wedding. It was great. She's here tonight, being as it's our wedding anniversary. We thought you might have dropped by. I left you messages.",
  },
  savoy: {
    count: 2,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "26th of June, 1890. The recently opened Savoy Hotel. Dinner, bed and breakfast for two. Bonjour, bonjour. Merci, Auguste. You'll be back before the party's over. They won't even notice you went. No complications, I promise.",
  },
  lefty: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Whoo! Ooo. Ooo! Welcome back, lefty! Whoa-ho! Two hearts! Woo! Back in the game. Ah. Never do that to me again.',
  },
  seams: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      ' New York growled at my window, but I was ready for it. My stocking seams were straight, my lipstick was combat ready, and I was packing cleavage that could fell an ox at twenty feet.',
  },
  liney: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I don't like them. They make your eyes look all liney. No, actually, sorry. They're fine. Carry on.",
  },
  bulky: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RIVER',
    firstSaidQuote:
      'Vortex manipulator. Less bulky than a Tardis. A motorbike through traffic. You?',
  },
  flock: {
    count: 2,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Shut up, I'm making deductions. It's very exciting. Now, what are you, eh? A flock of space crystals? A swarm? The snowmen are foot soldiers, mindless predators. But you, you're the clever one. You're Moriarty. So, you turn up on a planet, you generate a telepathic field to learn what you can, and when you've learnt enough, what do you do? You can't conquer the world using snowmen. Snowmen are rubbish in July. You'll have to be better than that. You'll have to evolve.",
  },
  expla: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'LATIMER',
    firstSaidQuote:
      'Children, what is the expla. Who the devil are you? What are you doing in my house?',
  },
  angie: {
    count: 17,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CLARA',
    firstSaidQuote:
      "Angie? Is the internet working? Trying to phone the helpline, they won't answer.",
  },
  artie: {
    count: 12,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'GEORGE',
    firstSaidQuote: 'Good. Right, come along, Artie. Time to go.',
  },
  alexi: {
    count: 3,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KIZLET',
    firstSaidQuote: 'Alexi, we call them servers, not spoonheads.',
  },
  showy: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Whoo! Would a victory roll be too showy offy?',
  },
  shard: {
    count: 3,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'CLARA',
    firstSaidQuote: "The Shard. They're in the Shard. Floor sixty five.",
  },
  gents: {
    count: 2,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'MAHLER',
    firstSaidQuote:
      "I'm here to fix the toilets, the gents. How long have I been here?",
  },
  bryan: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'DAVE',
    firstSaidQuote: "Mate, I'm so sorry. She wants to be Bryan Robson.",
  },
  akhat: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The Pyramid of the Rings of Akhaten. It's a holy site for the Sun Singers of Akhat.",
  },
  lugal: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, let's see. Ah! There go some Panbabylonians. A Lugal-Irra-Kush. Some Lucanians. A Hooloovoo. Ah! Qom VoTivig.",
  },
  moped: {
    count: 3,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Loose translation. She sounds a bit grumpy but she's a total love actually, aren't you? Yes, you are. No, actually, she's just asking if we fancy renting a moped.",
  },
  sabre: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'ZHUKOV',
    firstSaidQuote: 'Sabre rattling.',
  },
  duran: {
    count: 2,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'GRISENKO',
    firstSaidQuote: 'Duran Duran. One of my favourites. Come on.',
  },
  kinks: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Gadget. Health and safety. Classified, I'm afraid. You know, while the back room boffins work out a few kinks.",
  },
  ghast: {
    count: 3,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'PALMER',
    firstSaidQuote:
      'Caliburn House is over four hundred years old, but she has been here much longer. The Caliburn Ghast.',
  },
  notch: {
    count: 3,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Oh, that is good. That is top-notch.',
  },
  huffy: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Don't touch a thing. The Tardis will get huffy if you mess.",
  },
  snarl: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "We're not going to die here. This isn't real! It's a snarl.",
  },
  effie: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'EDMUND',
    firstSaidQuote:
      "Don't fret, Effie, my dear. All will be well, but we must get to the bottom of this dark and queer business no matter what the cost.",
  },
  snowy: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'AMOS',
    firstSaidQuote:
      "Them new manufacturers can do horrible things to a person. Horrible. I've pickled things in here that'd fair turn your hair snowy as top of Buckden Pike.",
  },
  gobby: {
    count: 3,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Sorry. It's much better than it used to be. Ooo, I once spent a hell of a long time trying to get a gobby Australian to Heathrow Airport.",
  },
  manky: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'AMOS',
    firstSaidQuote:
      "Like something manky in a coal cellar. They keep turning up in t'canal. The Crimson Horror.",
  },
  maids: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'GILLYFLOWER',
    firstSaidQuote:
      'Like pretty maids all in a row. The process improves with every attempt. Mister Sweet is such a clever old thing. Oh, into the canal with the rejects, Ada.',
  },
  yucky: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yeah, yeah, yeah, yeah, yeah. Way past that now. Yucky red parasite from the time of the dinosaurs pitches up in Victorian Yorkshire. Didn't see that one coming.",
  },
  natty: {
    count: 2,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'CAPTAIN',
    firstSaidQuote:
      "The beach, the Giant's Cauldron, Natty Longshoe's Comical Castle.",
  },
  mahal: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 14,
    firstSaidBy: 'VASTRA',
    firstSaidQuote:
      "I was getting a little bored of the Taj Mahal. The tea should be superb. It's drawn from one of my favourite memories. Strax, good of you to join us.",
  },
  coped: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 14,
    firstSaidBy: 'RIVER',
    firstSaidQuote: 'I believe I could have coped.',
  },
  atten: {
    count: 3,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 15,
    firstSaidBy: 'SOLDIER',
    firstSaidQuote: 'Atten - shun!',
  },
  papal: {
    count: 8,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Papal Mainframe. It's like a great big flying church. The first ship to arrive. They are the ones who shielded the planet. They can get us down there.",
  },
  tasha: {
    count: 10,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Tasha Lem, the Mother Superious.',
  },
  twirl: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'TASHA',
    firstSaidQuote: 'Is that a new body? Give us a twirl.',
  },
  quiff: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'The old key in the quiff routine. Classic.',
  },
  skarr: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'SONTARAN',
    firstSaidQuote:
      "Commander Skarr. That's the detection warning. Our invisibility cloak is compromised.",
  },
  rainy: {
    count: 1,
    firstSaidSeasonIndex: 33,
    firstSaidStoryIndex: 16,
    firstSaidBy: 'GRAN',
    firstSaidQuote: 'I saw him on a pier on a rainy day.',
  },
  dopey: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Bashful? Sneezy? Dopey? Grumpy.',
  },
  needy: {
    count: 2,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Well, I would say that that person would be an egomaniac, needy, game-player sort of person.',
  },
  clung: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "No, it isn't. It's just far away. Everything looks too small. I prefer it down there. Everything is huge. Everything is so important. Every detail, every moment, every life clung to.",
  },
  carer: {
    count: 4,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CLARA',
    firstSaidQuote: "I'm his carer.",
  },
  bulbs: {
    count: 3,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'CLARA',
    firstSaidQuote:
      "Yeah. Well, maybe. It's either that or the bulbs need changing.",
  },
  fayre: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROBIN',
    firstSaidQuote:
      'You called? Very, very nicely done with the box, sir. I saw a Turk perform something very similar at Nottingham Fayre.',
  },
  lardy: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'SHERIFF',
    firstSaidQuote:
      "Take you? A lardy lack-wit like you? It's labour we require up at the castle. Labour and gold. Not old men and their worthless baubles. This will be a great help, Master Quayle, believe me. Newcomer to Sherwood, are we?",
  },
  tucks: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROBIN',
    firstSaidQuote:
      'And this is Friar Tuck. Aptly named for the amount of grub he tucks into.',
  },
  cocks: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROBIN',
    firstSaidQuote: 'Trussed up like turkey-cocks. Thanks to your friend.',
  },
  crone: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'ROBIN',
    firstSaidQuote:
      "Well, I'll tell you one thing. I'd last a lot longer than this desiccated man-crone.",
  },
  wally: {
    count: 3,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Wally.',
  },
  orson: {
    count: 6,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'This is Colonel Orson Pink, from about a hundred years in your future.',
  },
  gamer: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PSI',
    firstSaidQuote: "I'm a gamer. Sorry, who put you in charge?",
  },
  intru: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote: 'Intru',
  },
  mucho: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Gioffre Borgia, mucho scary hombre, says to me, what do you think of our Leaning Tower of Pisa? I say, it looks okay to me.',
  },
  kiddo: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'MATTHEW',
    firstSaidQuote:
      "Hello? I'm a police officer. There's no point hiding. Do you hear me? Come on, kiddo.",
  },
  lydia: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KELVIN',
    firstSaidQuote:
      'Though unheard by Lydia, was caught by Elizabeth, and as it assured her that Darcy was not',
  },
  darcy: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KELVIN',
    firstSaidQuote:
      'Though unheard by Lydia, was caught by Elizabeth, and as it assured her that Darcy was not',
  },
  ozzie: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'COURTNEY',
    firstSaidQuote: 'Ozzie loves the Squaddie.',
  },
  hidey: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Sooner or later it will creep from its hidey-hole and some military idiot will try to attack it.',
  },
  frown: {
    count: 3,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DANNY',
    firstSaidQuote:
      "Are you still on for tonight? Cos you had your I'm about to cancel frown on.",
  },
  pffff: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Pffff.',
  },
  panky: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Good. Because I don't like people being sick in my Tardis. No being sick. And no hanky-panky.",
  },
  elina: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LUNDVIK',
    firstSaidQuote:
      "He'd just had a grand-daughter. Elina. She was his first. He was my teacher. He taught me how to fly. We were both given the sack on the same day.",
  },
  louse: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'LUNDVIK',
    firstSaidQuote: 'Like a flea. Or a head louse.',
  },
  chick: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's feeling the sun on itself. It's getting warm. The chick flies away and the eggshell disintegrates. Harmless.",
  },
  nosey: {
    count: 2,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'The Doctor. Nosey Parker.',
  },
  rigsy: {
    count: 30,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'FENTON',
    firstSaidQuote: "It's your filth, Rigsy, start with your signature.",
  },
  mural: {
    count: 6,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'RIGSY',
    firstSaidQuote:
      "I've lost someone, too. My Aunt Karina. Deaf as a post. Didn't really know her that well but she's still gone. Is your one in the mural?",
  },
  leone: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'ACCRA REPORTER',
    firstSaidQuote:
      " In three hours' time, the Ghana Black Stars are due to play Sierra Leone in the African Cup of Nations.",
  },
  ville: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'PARIS REPORTER',
    firstSaidQuote:
      "Est-ce que c'est bien le Bois de Boulogne? Non, c'est le centre-ville.",
  },
  maebh: {
    count: 50,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'MAEBH',
    firstSaidQuote: "Maebh. My name's Maebh.",
  },
  melon: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'SAMSON',
    firstSaidQuote:
      "Nuts. That's unfortunate for you, isn't it, Bradley? You have an allergy, don't you? What if one of them falls on your head? Do you die, or swell up like a massive melon?",
  },
  madly: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'RUBY',
    firstSaidQuote:
      "Miss. You let her go off with some randomer into the forest. You're supposed to be madly in love with her.",
  },
  ipods: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'CLARA',
    firstSaidQuote:
      'It was ordinary. People just kept walking with their iPods and their shopping bags. He was alive, and then he was dead and it was nothing. Like stepping off a bus.',
  },
  mopey: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You won't. Look at you. I need sceptical, clever, critical. I don't need mopey. It put years on your face. And what if people see us together? It looks like you've been melted.",
  },
  wombs: {
    count: 2,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'SEB',
    firstSaidQuote:
      'Go with me. Go with me. Imagine babies in wombs could talk to other babies in other wombs. What would they say? What would they think life was like if they could talk among themselves?',
  },
  ahmed: {
    count: 2,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'AHMED',
    firstSaidQuote: 'Colonel Ahmed, sir. Privileged to meet you.',
  },
  yummy: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'MISSY',
    firstSaidQuote: 'Ah. Thanks for being yummy.',
  },
  elves: {
    count: 2,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'CLARA',
    firstSaidQuote: 'An invasion of, of what, elves?',
  },
  crabs: {
    count: 5,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Colloquially known as the Dream Crabs.',
  },
  mince: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'DANNY',
    firstSaidQuote: 'Mince pie, anyone?',
  },
  feely: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Look. No. Look, we don't need all this touchy-feely stuff.",
  },
  weamy: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'SANTA',
    firstSaidQuote:
      "All right. As the Doctor might say, Oh, it's all a bit dreamy-weamy.",
  },
  holdy: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "I'm not very good with this holdy-hand thing.",
  },
  rarer: {
    count: 1,
    firstSaidSeasonIndex: 34,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Do you know what's rarer? Second chances. I never get a second chance, so what happened this time? Don't even know who to thank.",
  },
  kanzo: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SOLDIER',
    firstSaidQuote: 'Kanzo?',
  },
  sarff: {
    count: 11,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'COLONY SARFF',
    firstSaidQuote: 'We are Colony Sarff. We bring harm.',
  },
  bezzy: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'CLARA',
    firstSaidQuote:
      "So the Doctor is your bezzy mate and I'm supposed to believe that you've turned good?",
  },
  dudes: {
    count: 3,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ALL',
    firstSaidQuote: 'Dudes!',
  },
  bitch: {
    count: 2,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'MISSY',
    firstSaidQuote:
      'Time Lady, thank you. Some of us can afford the upgrade. Is it still the same old Supreme Dalek these days? I fought him once on the slopes of the Never Vault. Tell him the bitch is back.',
  },
  moran: {
    count: 13,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MORAN',
    firstSaidQuote:
      'Private journal of Captain Jonathan Moran, 21st November 2119. We have located a craft of unknown origin on the lake floor. Visual scans in situ revealed nothing, so we have brought the craft on board and myself and the crew will now investigate.',
  },
  moley: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CASS via LUNN',
    firstSaidQuote:
      "One of the ghosts is our previous commanding officer. The other, um moley guy, we don't know what he is.",
  },
  raved: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'CLARA',
    firstSaidQuote:
      'Wait, wait a second. You just raved about ghosts like a kid who had too much sherbet.',
  },
  andre: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "And because whatever song I heard first thing in the morning, I was stuck with. Two weeks of Mysterious Girl by Peter Andre. I was begging for the brush of Death's merciful hand. Don't you see? These words are an earworm. A song you can't stop humming, even after you die.",
  },
  albar: {
    count: 4,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'PRENTIS',
    firstSaidQuote:
      'Remarkable. Oh, and humans, too.  Albar Prentis, Funeral Director.',
  },
  limpy: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Yes, perhaps you'd like to field this one, Limpy?",
  },
  tongs: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You're the blacksmith and you've got a baby too? He's been at it hammer and tongs.",
  },
  doozy: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'And it is a doozy!',
  },
  anvil: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Then we deploy the anvil. Now, at this stage, getting me one of their helmets is key. We get a helmet, and this is over. Then we can mop up the rest using Ashildr's monstrosity.",
  },
  benny: {
    count: 2,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'CLARA',
    firstSaidQuote: 'See, all it needed was the Benny Hill theme.',
  },
  zorro: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'No, you bungled mine, Zorro!',
  },
  lucie: {
    count: 5,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ASHILDR',
    firstSaidQuote:
      "I wasn't just robbing Lucie Fanshawe for her loot. She's bragged about having the rarest gem in the land, an ancient amulet from foreign parts. Could it be we are looking for the same prize?",
  },
  farts: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'SAM',
    firstSaidQuote: "He's so old, he farts dust!",
  },
  walsh: {
    count: 4,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KATE',
    firstSaidQuote:
      'Get me Colonel Walsh. And I need you to coordinate the Operation Double locations.',
  },
  polyp: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The Zygon command centre. That's the control polyp for all Zygons on Earth.",
  },
  holed: {
    count: 2,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'KATE',
    firstSaidQuote:
      "They're holed up in this settlement in Turmezistan. It's where they've taken Osgood. I'm going to order Colonel Walsh to bomb it.",
  },
  brits: {
    count: 5,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'NORLANDER',
    firstSaidQuote:
      "The Brits came two years ago. We didn't want them. They just They just turned up. No jobs. Nowhere to live. No money. And they were, they were odd. They started getting into fights. Couple of them got killed.",
  },
  motel: {
    count: 2,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'NORLANDER',
    firstSaidQuote:
      'Yeah, she was here. She was at the motel, asking questions. Before.',
  },
  intel: {
    count: 7,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'WALSH',
    firstSaidQuote:
      "We all know what a rabbit warren this place is, but we've got intel they're holed up inside the church. Hitchley, you take the front, storm it, draw their fire. The Doctor and I will take the back.",
  },
  specs: {
    count: 5,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Yes, we're in Britain. Oh, your specs are broken. I'll fix them. You can wear mine, they're sonic.",
  },
  beget: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "These things have happened, Zygella. They are facts. You just want cruelty to beget cruelty. You're not superior to people who were cruel to you. you're just a whole bunch of new cruel people. A whole bunch of new cruel people being cruel to some other people, who'll end up being cruel to you. The only way anyone can live in peace is if they're prepared to forgive. Why don't you break the cycle?",
  },
  unsee: {
    count: 2,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'RASSMUSSEN',
    firstSaidQuote:
      "I'm warning you. You can never unsee it.  But if you do watch. Gagan Rassmussen. I'm Gagan Rassmussen. This is Le Verrier lab in orbit around Neptune.",
  },
  gagan: {
    count: 4,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'RASSMUSSEN',
    firstSaidQuote:
      "I'm warning you. You can never unsee it.  But if you do watch. Gagan Rassmussen. I'm Gagan Rassmussen. This is Le Verrier lab in orbit around Neptune.",
  },
  winks: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Semi-sentient. It thinks it knows what's good for you. You obviously needed forty winks. Clever little sleep pod. You said it was something more than that, though.",
  },
  knits: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Are they now? Sleep, that knits up the ravelled sleeve of care. The death of each day's life, sore labour's bath. Balm of hurt minds, chief nourisher in life's great feast. Congratulations, Professor. You've revolutionised the labour market. You've conquered nature.",
  },
  poets: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Shakespeare. He really knew his stuff. They all did. The Ancients. The poets. All those sad songs. All those lullabies. Sleep is essential to every sentient being in the universe. But to humans. Greedy, filthy, stupid humans. It's an inconvenience to be bartered away. Well, now we know the truth. Sleep isn't just a function. It's blessed. Every night we dive deep into that inky pool, deep into the arms of Morpheus. Every morning, we wake up and wipe the sleep from our eyes, and that keeps us safe. Safe from the monsters inside.",
  },
  skate: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Whatever they're using, it only hides the street itself. It prevents you from noticing there's even something missing. They're somehow making our eyes skate right over it. Let's call it a misdirection circuit.",
  },
  kabel: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'ASHILDR',
    firstSaidQuote:
      "Fine, I'll show you. Mister Kabel, Mister Rump. Permit them entry.",
  },
  janus: {
    count: 3,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "She's a Janus.",
  },
  ember: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "The universe is over! It doesn't have a say any more! We're standing on the last ember, the last fragment of everything that ever was. As of this moment, I'm answerable to no-one!",
  },
  unzip: {
    count: 2,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'HYDROFLAX',
    firstSaidQuote:
      'Prepare to die in agony and submit to my supremacy! Unzip this bag!',
  },
  ooooo: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'NARDOLE',
    firstSaidQuote: 'Ooooo!',
  },
  bowel: {
    count: 1,
    firstSaidSeasonIndex: 35,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Sorry. It was my stomach. I have an irritable bowel.',
  },
  potts: {
    count: 31,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Potts?',
  },
  vegan: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Tutorial's over, take the night off. It's all cancelled. Go and be a proper student. Texts, snogging, a vegan wrap.",
  },
  barry: {
    count: 3,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'BILL',
    firstSaidQuote:
      "Hello? Is someone in there? Is that Barry? Because she's with Neville, and it's not my fault.",
  },
  vardy: {
    count: 12,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GOODTHING',
    firstSaidQuote:
      "Kezzia, please don't come in. We're having a little tiny Vardy problem.",
  },
  emoji: {
    count: 2,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BILL',
    firstSaidQuote: 'Emoji. It speaks emoji!',
  },
  teens: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Emojis. Wearable communications. We're in the utopia of vacuous teens.",
  },
  flyer: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You're not stepping on a butterfly, you're just taking a flyer.",
  },
  pavel: {
    count: 7,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'SHIREEN',
    firstSaidQuote: 'Pavel',
  },
  klarj: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Reminds me of Quincy Jones. I stepped in for him once. The bassist he'd hired turned out to be a Klarj Neon Death Voc-Bot. What was worse, he couldn't play. This is very interesting.",
  },
  noooo: {
    count: 2,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IVAN',
    firstSaidQuote: 'No! Noooo!',
  },
  trots: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BILL',
    firstSaidQuote:
      'You know, like for restaurants. Waiter was a bit handsy, lasagne gave me the trots. Two stars.',
  },
  velma: {
    count: 7,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'NARDOLE',
    firstSaidQuote: 'Velma! That was her name!',
  },
  dorms: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ABBY',
    firstSaidQuote:
      "Forty breaths to the dorms, one twenty to the core. That's where we're headed. It's the safest place.",
  },
  pesky: {
    count: 2,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'But can they learn? Evolve? Grow? Maybe get tired of carrying pesky humans around? Know the feeling?',
  },
  latte: {
    count: 3,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Didn't I send you out to get me a latte?",
  },
  fined: {
    count: 2,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'BILL',
    firstSaidQuote: "Oh, great. I'll get fined for dying!",
  },
  ellie: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'IVAN',
    firstSaidQuote: 'Ellie.',
  },
  moira: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PENNY',
    firstSaidQuote: 'Oh, hello. Are you Moira?',
  },
  senza: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'POPE',
    firstSaidQuote:
      'Que deve proseguire senza di me. Il Cardinale Angelo vi condurra alla biblioteca.',
  },
  possa: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'POPE',
    firstSaidQuote: 'Possa il Signore illuminare il vostro cammino.',
  },
  mario: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I know. So did I. The trouble is, when simulants develop enough independent intelligence to realise what they are, there's a risk they'll rebel. Those deaths, they weren't suicide. Those were people escaping. It's like, er, Super Mario figuring out what's going on, deleting himself from the game because he's sick of dying.",
  },
  shuck: {
    count: 2,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'NARDOLE',
    firstSaidQuote: 'Shuck-shuck, obviously.',
  },
  krone: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'NARDOLE',
    firstSaidQuote:
      'Found it in the Tardis. Yeah, it was in one of the drawers with some old takeaway menus and fifty Danish krone. Anyway, this is them.',
  },
  hulks: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'NARDOLE',
    firstSaidQuote:
      'Mmm hmm. Yeah. Yeah. The Monks have got him on one of the old prison boats. Hulks, they used call them.',
  },
  seine: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BILL',
    firstSaidQuote:
      "Okay. Yeah, yeah, I get it. It's like that time we discovered that huge fish creature in the, in the Seine in Paris.",
  },
  humph: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MISSY',
    firstSaidQuote: 'Humph!',
  },
  veldt: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'GODSACRE',
    firstSaidQuote:
      'Oh, er, well, yes, I was stationed out there. South Africa. One day, I, I came across something in the veldt. Something that was clearly not of this earth. An interplanetary vessel. I found Friday here on board, in a sort of coma, half dead.',
  },
  fanny: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'JACKDAW',
    firstSaidQuote:
      "Months we've been digging 'ere and what have we got to show for it? Sweet Fanny Adams, that's what.",
  },
  nilly: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'CATCHLOVE',
    firstSaidQuote:
      'The deuce she is. And you think you can just go about slaughtering my men willy-nilly, do you, madam?',
  },
  cairn: {
    count: 2,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Look, a stone cairn. Pictish civilisation.',
  },
  picts: {
    count: 2,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Picts, early Celts, loved stone cairns. They built them under the ground but close to the sky. They think they're doors between worlds. Iron age churches. What do you always find near churches?",
  },
  celts: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Picts, early Celts, loved stone cairns. They built them under the ground but close to the sky. They think they're doors between worlds. Iron age churches. What do you always find near churches?",
  },
  rodeo: {
    count: 3,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, if she's there, we're saving her. If she's not, she's safe already. Trust me, this is not my first rodeo.",
  },
  kiddy: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "You'll hold them back? What, with your lollipop and your kiddy face paint and your crazy novelty monster killing tool? Are you holding that thing the right way up, by the way?",
  },
  vitus: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'LUCIUS',
    firstSaidQuote: "Oh. All right. Yeah, I got it. You're like Vitus, then.",
  },
  douse: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'No! Wait! Douse the fire, quickly!',
  },
  rents: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Not you. Okay, kids, pay attention. She slaughtered your legion. You slaughtered everything that she loves. Now, you all have a choice. You can carry on slaughtering each other till no one is left standing, or you grow the hell up! Because there's a new war now. I think these creatures are light-eating locusts, looking for rents and cracks between worlds to let themselves into dimensions of light. Once they break through, they eat. They will eat the sun, and then they will eat the stars. And they will keep eating until there are no stars left. So, whose side are you on now? Because as far as I can see, there's only one side left.",
  },
  graze: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Ah. We just take the Tardis for a spin and we graze for distress calls. We pick a good one. Our usual Saturday.',
  },
  smurf: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'MISSY',
    firstSaidQuote:
      "What do you care, Smurf? They're not even interested in you.",
  },
  alamo: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 12,
    firstSaidBy: 'NARDOLE',
    firstSaidQuote:
      'Come on you lot, put your backs into it. Remember the Alamo! Oh, maybe not.',
  },
  tummy: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Well, it's all those years of bigger on the inside, You try sucking your tummy in that long. Why are you trying not to regenerate?",
  },
  toten: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'GERMAN SOLDIER',
    firstSaidQuote:
      'Lass mich einfach hier. Ich will dich nicht toten. Bitte geh.',
  },
  mocks: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "My friend Bill Potts was turned into a Cyberman. She gave her life so that people she barely knew could live. So, let's be clear. Nobody imitates Bill Potts. Nobody mocks Bill Potts.",
  },
  berry: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "They've got my Tardis. Over to you, Mary Berry.",
  },
  nacht: {
    count: 2,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'GERMANS',
    firstSaidQuote: 'Stille Nacht, heilige Nacht. Alles schlaft, einsam wacht.',
  },
  alles: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'GERMANS',
    firstSaidQuote: 'Stille Nacht, heilige Nacht. Alles schlaft, einsam wacht.',
  },
  wacht: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'GERMANS',
    firstSaidQuote: 'Stille Nacht, heilige Nacht. Alles schlaft, einsam wacht.',
  },
  knabe: {
    count: 1,
    firstSaidSeasonIndex: 36,
    firstSaidStoryIndex: 13,
    firstSaidBy: 'GERMANS',
    firstSaidQuote: 'Stille Nacht, heilige Nacht. Alles schlaft, einsam wacht.',
  },
  rahul: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'ANDY',
    firstSaidQuote:
      "Rahul, if you're right about that, should we not tell someone?",
  },
  dakar: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'So, what, like a race? Like Paris-Dakar, in space? Are you two space-racing each other?',
  },
  scuse: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'GRAHAM',
    firstSaidQuote: "'Scuse me, we are human beings. Show a bit of solidarity.",
  },
  mappy: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "There. That's more like it. Angstrom, bring me that route mappy thing. If we sync it, this shows us the whole network of tunnels. Your friend Ilin warned us not to travel at night. We could use the tunnels to keep moving while it's dark, avoiding whatever's on the surface.",
  },
  mason: {
    count: 3,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MASON',
    firstSaidQuote: 'Mason. Montgomery Police.',
  },
  negro: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'MASON',
    firstSaidQuote:
      "Y'all happen to know a couple of... mongrels, hmm? Negro boy, Mexican girl?",
  },
  creek: {
    count: 5,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BLAKE',
    firstSaidQuote: 'Nope. Going fishing at Mill Creek.',
  },
  elias: {
    count: 2,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GRAHAM',
    firstSaidQuote:
      "That's what I said. Strangely, he didn't listen. Your mate is interfering. He's reassigned Blake's route to a driver called Elias Griffin Junior.",
  },
  najia: {
    count: 9,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'NAJIA',
    firstSaidQuote:
      "I'm Najia. I didn't realise that you were in here. Or here at all. Wow.",
  },
  sonya: {
    count: 7,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'HAKIM',
    firstSaidQuote:
      "You've brought friends back. Sonya? Yaz has brought friends back. I'm getting food.",
  },
  nadia: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ROBERTSON',
    firstSaidQuote:
      "I knew it. And I'm going to litigate you until your last breath, Nadia.",
  },
  stash: {
    count: 4,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'ROBERTSON',
    firstSaidQuote:
      "Food, water, entertainment system, a book. I could survive in here for six months if I needed to. And I've got a huge stash of weapons, enough for all of us. Enough for two guns apiece.",
  },
  grime: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'RYAN',
    firstSaidQuote: "Sheffield's sickest grime station!",
  },
  tryna: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'MUSIC',
    firstSaidQuote:
      "Where do you know me from? Out here like the Roll Deep song Man, I'm tryna put my Co-Ds on I do not know this don Where do you know me from? Where do you know me from? Where do you know me from? Where do you know me from?",
  },
  deffo: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'RYAN',
    firstSaidQuote: 'Deffo.',
  },
  mabli: {
    count: 14,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'ASTOS',
    firstSaidQuote:
      "Mabli, stop beating yourself up. I'm sure there's a simple explanation.",
  },
  ronan: {
    count: 9,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'DURKAS',
    firstSaidQuote:
      'I understand your responsibilities, Ronan, okay? I hear about them endlessly.',
  },
  keeba: {
    count: 3,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'General Cicero? Not Eve Cicero? Keeba galaxy? Neuro pilot?',
  },
  resus: {
    count: 22,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'YOSS',
    firstSaidQuote:
      "Yeah, it feels like forever. I'm a day overdue. They're thinking they might induce me at Resus One, otherwise... Well, it wouldn't be good for either of us.",
  },
  astos: {
    count: 20,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'MABLI',
    firstSaidQuote:
      "You're here! Look, you can't keep disturbing all the other patients. Astos, found them. They're here in Pod Two.",
  },
  pting: {
    count: 26,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'COMPUTER',
    firstSaidQuote: 'Item Seven Alpha Cubed. Pting.',
  },
  sadhu: {
    count: 2,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PREM',
    firstSaidQuote: 'Want to ride with us, Sadhu? I can take one more.',
  },
  bakti: {
    count: 4,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PREM',
    firstSaidQuote: 'Bakti? They killed him.',
  },
  hasna: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PREM',
    firstSaidQuote:
      "They don't have to know. Hasna already thinks the marriage is cursed. Umbreen doesn't need anything else to worry about. And Manish? Who knows what he thinks these days. I was away from him for too long, fighting in the war. By the time I got back, Manish wasn't my baby brother any more.",
  },
  kunal: {
    count: 6,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'PREM',
    firstSaidQuote:
      "In Singapore. Our section had found a boat to escape on. But I'd signed up with Kunal. I wasn't going to leave without him at my side.",
  },
  bheti: {
    count: 3,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'HASNA',
    firstSaidQuote: 'They are, bheti.',
  },
  ninja: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SYSTEM',
    firstSaidQuote: "Product incoming. You're a ninja at this, Ryan.",
  },
  jarva: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SLADE',
    firstSaidQuote: 'Jarva Slade, Warehouse Executive. Your boss.',
  },
  erode: {
    count: 2,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Even if it costs people's lives. You kill a load of customers at Kerblam, let the systems take the fall for it, erode people's trust in automation, make people angry.",
  },
  cragg: {
    count: 4,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BECKA',
    firstSaidQuote:
      'People of Bilehurst Cragg, we are forced to meet here once again. Satan stalks this land. We must continue to root him out, and do whatever it takes to save the soul of our village. Let us put the accused to the test.',
  },
  willa: {
    count: 22,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'GRANNY',
    firstSaidQuote: 'Hush, Willa.',
  },
  becka: {
    count: 25,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BECKA',
    firstSaidQuote:
      "I am Becka Savage, landowner of Bilehurst Cragg. It belonged to my late husband, passed to me when he died. I've tried to be a benevolent leader but it's very difficult in these times, especially for a woman.",
  },
  pense: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'JAMES',
    firstSaidQuote: 'Honi soit qui mal y pense.',
  },
  morax: {
    count: 22,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MORAX',
    firstSaidQuote: 'Morax.',
  },
  fjord: {
    count: 3,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'GRAHAM',
    firstSaidQuote:
      'Ah, nice fjord. That is a fjord, innit? Got your bearings yet, Doc?',
  },
  leapt: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's fine. It's only 2018. I thought we'd leapt into the Woolly Rebellion.",
  },
  hanne: {
    count: 20,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'HANNE',
    firstSaidQuote: 'Hanne.',
  },
  porch: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'RYAN',
    firstSaidQuote: 'Er, the conservatory. I mean, I mean the porch.',
  },
  trine: {
    count: 9,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'TRINE',
    firstSaidQuote: "Hi. I'm Trine, Erik's wife.",
  },
  delph: {
    count: 8,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'ANDINIO',
    firstSaidQuote: "It's time. You're ready, Delph.",
  },
  kolos: {
    count: 4,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Nine cries for help, nine distress signals, all coming from the same planet. Not just the same planet, the same area of the same planet. Now listen, planet of Ranskoor Av Kolos.',
  },
  mitch: {
    count: 11,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'LIN',
    firstSaidQuote: 'Talk about what, Mitch?',
  },
  kissy: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'MITCH',
    firstSaidQuote: "No. It was more kissy than that, I'd say.",
  },
  aaron: {
    count: 7,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'AARON',
    firstSaidQuote: 'Aaron.',
  },
  pasta: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'MUM',
    firstSaidQuote: "I'm making pasta. Do you want some?",
  },
  gofer: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'GRAHAM',
    firstSaidQuote: "I'm just the gofer.",
  },
  whoop: {
    count: 1,
    firstSaidSeasonIndex: 37,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Right. Okay. Well, whoop-de-doo. You've got a weapon after all. Lot of good it's going to do you.",
  },
  alexa: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'HAKIM',
    firstSaidQuote: 'Alexa, play Rubber Soul.',
  },
  bling: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'GRAHAM',
    firstSaidQuote: 'Yeah, bring on the bling.',
  },
  stegs: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Steganography. There's another image hidden within the pixels of that photo. It's basic spycraft in your time. Easy way to smuggle out information because there's no pattern to look for. No two stegs are the same.",
  },
  logan: {
    count: 9,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'RYAN',
    firstSaidQuote:
      "I decided my spy name would be Logan, and now I'm worried I don't look anything like Hugh Jackman.",
  },
  snafu: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'AIDE',
    firstSaidQuote:
      "I am so sorry about the diary snafu, sir. Oh, dear, this must be them. Hi! I'm sure you recognise Mister Barton.",
  },
  sofia: {
    count: 3,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'AIDE',
    firstSaidQuote: 'This is Sofia Afzal.',
  },
  afzal: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'AIDE',
    firstSaidQuote: 'This is Sofia Afzal.',
  },
  mails: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'BARTON',
    firstSaidQuote:
      "Hello, friends. Or should I say plane thieves? What, did you think I wouldn't be able to track you? We have your numbers, e-mails, GPS. I even know how many more stamps you need for a free coffee. So close, Ryan. Or should I say Logan? Look up.",
  },
  stomp: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'RYAN',
    firstSaidQuote: 'Just stomp your foot, or something!',
  },
  bonne: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Bonne chance.',
  },
  mardy: {
    count: 2,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'YASMIN',
    firstSaidQuote:
      "Me too. So long as there's plenty of sun and absolutely no deep-space squid. Might get you out of your mardy mood.",
  },
  vilma: {
    count: 10,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BENNI',
    firstSaidQuote: 'Look at that, Vilma. Can you believe it?',
  },
  benni: {
    count: 19,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'VILMA',
    firstSaidQuote: "Oh, it's perfect, Benni. Thank you.",
  },
  bella: {
    count: 11,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BELLA',
    firstSaidQuote: "Shame. I'm Bella.",
  },
  sylas: {
    count: 16,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'NEVI',
    firstSaidQuote:
      "Yeah, nothing's working, mate, sorry. Where's my snap hammer? Sylas?",
  },
  debug: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      " This debug script should neutralise the hopper viruses, but they'll need time to work. More urgently, I need to build a new ionic membrane to banish whatever is killing your guests.",
  },
  bonce: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'GRAHAM',
    firstSaidQuote: 'Done that bit. Look, feel the lump on my bonce. Do that.',
  },
  brady: {
    count: 2,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TESLA',
    firstSaidQuote:
      'Mister Brady, sir, please. My work is not a fairy tale. I promise you, within about a year, my Wardenclyffe project will be as real and functioning as this very generator.',
  },
  cents: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'TESLA',
    firstSaidQuote:
      'Yeah. I... I thought... I thought things would be different. You know, when I first arrived in America, I had four cents to my name. I was robbed on the journey. But still I thought, this is the beginning. Here I would prosper, my ideas would live.',
  },
  wonky: {
    count: 2,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "I knew I had one in my tool box. Braxium Bouncer, Mark III. Found it at a bazaar. Bit wonky, but I can't take the Tardis. This should give us enough power to transport me, Yaz and Tesla back here. But once I'm there, I can't jump back until it recharges itself. Which, you know, I'm not worried about. Definitely. And you shouldn't be worried about it either. Not in the least.",
  },
  pooch: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'RUTH',
    firstSaidQuote:
      'Whoa. You all right, love? Hello. Hello. Hello, pooch. Have a leaflet. All right. Thanks. Morning. Have one of these. Thanks. Hi. You all right? Morning, Reggie.',
  },
  zonal: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Dangerous intergalactic police for hire. Notice of a zonal enforcement field on Earth. No one can get in or out. What? They're preparing to beam down there. A platoon of Judoon, near the moon. They can't do that. They've got no jurisdiction there. Right in the centre of Gloucester. I am not having that. If I can match the Tardis's rotation to the frequency of the enforcement field's refresh rate, I might just might be able to slip us in before anyone gets killed.",
  },
  ibiza: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'HARKNESS',
    firstSaidQuote:
      'Ha! Which is why the scoop read the wrong signal. Ho, ho. Using the old Quanticum Scoop I got from a fourple on Ibiza 13. Whoo, that was a night. Actually, that was a month.',
  },
  soyuz: {
    count: 2,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ADAM',
    firstSaidQuote: 'Soyuz to Control. We have automatic system failure.',
  },
  trawl: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'TV',
    firstSaidQuote:
      "A statement just issued by the European Space Agency says they're still unable to confirm whether the British astronaut Adam Lang managed to evacuate his descent module safely after it veered off course and crashed into the Indian Ocean earlier today. Although search and rescue teams continue to trawl the waters, the agencies say they are now treating Adam Lang as missing, presumed dead. There are tributes for Mister Lang on social media and his family have asked for privacy at what they say is a difficult time.",
  },
  fists: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'GRAHAM',
    firstSaidQuote:
      "Come on, son. Fists down, There's a good lad. Now, perhaps you'd like to tell us why you're so interested in that door.",
  },
  aramu: {
    count: 4,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ARAMU',
    firstSaidQuote: 'Aramu and Suki.',
  },
  olson: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'ZACH',
    firstSaidQuote:
      'Zach Olson. There was an impact. Our captain tried to raise the sub, but it was too late. It was already inside.',
  },
  amiga: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'GABRIELA',
    firstSaidQuote: 'Melhor amiga.',
  },
  drips: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'GRAHAM',
    firstSaidQuote:
      "I'll give you a hand. I've seen a few intravenous drips in my time. Finally, it comes in handy.",
  },
  sympa: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "That's what I was thinking. We're so sympa.",
  },
  gyres: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "It's a naturally occurring hot spot where ocean currents trap pollution. There are five major gyres on Earth right now. Praxeus is attracted to plastic. It's built a whole environment here from the plastic. A world of pure Praxeus! This is where it all started. Seabirds infected with Praxeus transporting the bacteria around the world, transferring it to humans when they attack.",
  },
  petri: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "To use Earth as a petri dish, destroying one race to save the remnants of your own. But this down here, this environment, it wasn't deliberate.",
  },
  gorge: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'ZELLIN',
    firstSaidQuote: 'Billions in one go. Gorge on their fears.',
  },
  canto: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BYRON',
    firstSaidQuote:
      "My third canto. Of Childe Harold's Pilgrimage, my work in progress.",
  },
  khazi: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'GRAHAM',
    firstSaidQuote:
      "Splendid. Very convenient. Ryan, not a khazi for love nor money, and a Frenchwoman who's got a right hump about something.",
  },
  umami: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Hmm. 14th. No... 15th century. Touch more umami.',
  },
  squiz: {
    count: 2,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'Right. You keep an eye on Trigger Happy. Me and you need to take a squiz at your skeleton.',
  },
  plume: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: 'Waterloo. Oh, I love a good plume. What do you think?',
  },
  morat: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'BYRON',
    firstSaidQuote:
      'A 15th-century soldier from the Battle of Morat. His final remains.',
  },
  elise: {
    count: 3,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'MARY',
    firstSaidQuote: 'Elise? Can you hear me? Do you have William?',
  },
  valet: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'FLETCHER',
    firstSaidQuote: 'No, sir. I am the valet.',
  },
  stabs: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'CYBERMAN',
    firstSaidQuote: 'The sword that stabs his peace...',
  },
  ashad: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 8,
    firstSaidBy: 'CYBERMAN',
    firstSaidQuote:
      "My name was Ashad. I did spare your son... because he's a useless runt, sickly and weak. And I did have children. I slit their throats when they joined the resistance.",
  },
  ravio: {
    count: 5,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'FEEKAT',
    firstSaidQuote:
      "We're not soldiers. I was a teacher. Ravio was a nurse. We've got a childminder, a driver, a builder. We're just ordinary humans, refugees, and we've all lost everything... and everyone. All to the Cybermen. And nobody cares.",
  },
  ethan: {
    count: 5,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 9,
    firstSaidBy: 'FEEKAT',
    firstSaidQuote:
      "Come on. Let's go. You and Ravio get the Gravraft started. Ethan and I will grab the supplies.",
  },
  miney: {
    count: 2,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      "Fine. You really want me to show you I'm serious? Eenie, meenie, miney... Miney.",
  },
  cybes: {
    count: 2,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      "Ah! The Citadel, the heart of Gallifrey. Recognise the old place? I was thinking I might knock through there, put a wet room there, screening room there. Torture room in the cellar, naturally. Oh. And see through there? The Panopticon. Well, what's left, which, er... which isn't much. We had some fun there, didn't we, hey? Graduated. Assassinated presidents. The best of times! But I thought here would be a fitting place to end this. Oh. Oop. Excuse me. Check my notifications. Oh, goodie! The Cybermen are here, at the Boundary. Better extend the hand of friendship. Breaker 1-2 calling all Cybes.",
  },
  loins: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'KO SHARMUS',
    firstSaidQuote: 'Here they come. Gird your loins, gentlemen.',
  },
  doosh: {
    count: 3,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 10,
    firstSaidBy: 'THE MASTER',
    firstSaidQuote:
      "Yeah! Doosh, doosh, doosh. Line up. Attention! Yeah, that's it. Well, let's test it out. Shoot him. Shoot him!",
  },
  turbo: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'LEO',
    firstSaidQuote:
      'Oh, pretty much. Er, once Mister Robertson became involved, he really helped us turbo-boost the whole project. Actually, talking about...',
  },
  firms: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'ROBERTSON',
    firstSaidQuote:
      "Yes, yes, as discussed. When those car firms deserted you, I bought up all the plants. I own them now. So we repurpose, New infrastructure, new jobs. This is going to be a big win for you, Jo. A flagship policy from our dynamic new Technology Secretary, and it looks like, er, your party's going to need a new leader soon.",
  },
  intra: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'LEO',
    firstSaidQuote:
      "What? It's intelligent. I hooked it into the intra-neural network and... and there were flickers of activity. It understood our systems immediately.",
  },
  osaka: {
    count: 7,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Dalek DNA trace, Japan. Osaka. Well, sort of. Not an exact match. Ah, it's corrupted. I can't quite make sense of it.",
  },
  troll: {
    count: 1,
    firstSaidSeasonIndex: 38,
    firstSaidStoryIndex: 11,
    firstSaidBy: 'RYAN',
    firstSaidQuote:
      'I was looking online earlier. Some weird stuff going on in a village in Finland. Troll invasion, so the locals are saying.',
  },
  disks: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KARVANISTA',
    firstSaidQuote:
      "Is that right? Cos from where I'm hovering, you seem to be handcuffed and footlocked to a gravity bar, which in 79 seconds will release you into the boiling acid ocean directly below, where your bodies will instantly disintegrate. Even if you survive that - which you won't - in four minutes' time the entire planet will be engulfed by a nearby giant red star. Oh, and if you try and escape, my Kill Disks will blast you to pieces.",
  },
  psych: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'K-TOSCS',
    firstSaidQuote:
      'I mean, obviously. I havedone my psych-resistance training.',
  },
  aaaah: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'SWARM',
    firstSaidQuote: 'Aaaah. Renewed at last.',
  },
  wilma: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DAN',
    firstSaidQuote: 'Wilma, who likes soup, really?',
  },
  klopp: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      "Liverpool. Anfield. Klopp era. Classic. Ooh, Yaz, maybe we could take in a game. I've seen the Barcelona match nine times. I was a ball boy for Trent, once. Hmm. Number 37. Non-terrestrial weapon dispersal traces.",
  },
  fussy: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'YASMIN',
    firstSaidQuote: 'Why, fussy about who you get rescued by?',
  },
  lupar: {
    count: 5,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'KARVANISTA',
    firstSaidQuote:
      "The Lupari are species-bonded to humanity. For every human, there's a paired guardian Lupar. The bond is our genetic obligation, and our honour, only ever to come into effect in the ultimate crisis.",
  },
  kasto: {
    count: 3,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'VINDER',
    firstSaidQuote:
      'You hear that system advice? This is Serving Commander Inston-Vee Vinder of Kasto-Winfer-Foxfell, doing the unthinkable and leaving his post.',
  },
  diane: {
    count: 4,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 1,
    firstSaidBy: 'DAN',
    firstSaidQuote: "Mine, too. And Di. I'm late to meet Diane.",
  },
  mouri: {
    count: 26,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'TRIANGLE',
    firstSaidQuote:
      'The Temple is compromised. The Mouri must never be compromised. Do you see? Do you see the Mouri?',
  },
  skaak: {
    count: 2,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SVILD',
    firstSaidQuote:
      'I bring information, Commander Skaak. The sworn enemy of Sontar, the Doctor, is here on Earth.',
  },
  wwtdd: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 2,
    firstSaidBy: 'SWARM',
    firstSaidQuote:
      'Such linear creatures. And that message in pen on the palm of your hand, that no one knows about. WWTDD. What Would The Doctor Do?',
  },
  mites: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'WILLIAMSON',
    firstSaidQuote:
      'No. Those mites, I have seen them remove people and objects from this mortal plane. Wait, wait, they return!',
  },
  tigmi: {
    count: 7,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 3,
    firstSaidBy: 'BEL',
    firstSaidQuote:
      'And I can still hear you telling me that. So I am. We are. Me and Tigmi, moving forward.',
  },
  devon: {
    count: 2,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 4,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote: "Er, Earth, coastal... Devon? I'd say 19... 49.",
  },
  kebab: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'DAN',
    firstSaidQuote: 'I was nearly a kebab!',
  },
  entre: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'FARQUHAR',
    firstSaidQuote:
      "Of course, yes. No need to explain. So, what's your field of expertise, Prentis? Can you say, entre nous?",
  },
  havea: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'AWSOK',
    firstSaidQuote:
      'Of course, you havea lot of questions. It must be hard to know where to start.',
  },
  deign: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'THE DOCTOR',
    firstSaidQuote:
      'No, not hard at all. The hard bit is getting you to deign to answer.',
  },
  spore: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 5,
    firstSaidBy: 'PRENTIS',
    firstSaidQuote:
      'Yes. It does look... special. Its purpose is to detect non-terrestrial life forms. Turn it on, Jennings, and get that sample spore everyone keeps telling me is not of this Earth. Here we go.',
  },
  dally: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'WILLIAMSON',
    firstSaidQuote: 'Do not dally!',
  },
  amped: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KARVANISTA',
    firstSaidQuote: 'You just amped everything past maximum!',
  },
  cerro: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KATE',
    firstSaidQuote:
      'Sontaran Command is at the Cerro Tololo Observatory in Chile, site of the Dark Energy Camera.',
  },
  chile: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'KATE',
    firstSaidQuote:
      'Sontaran Command is at the Cerro Tololo Observatory in Chile, site of the Dark Energy Camera.',
  },
  nepal: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 6,
    firstSaidBy: 'DAN',
    firstSaidQuote:
      'Fetch your dog, and I have. Wow, that Nepal fella was good after all.',
  },
  mancs: {
    count: 2,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'DAN',
    firstSaidQuote: "Mancs. New Year, Mancs. Doesn't she understand?",
  },
  bongs: {
    count: 2,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      "Oh. Listen, Mam, I have to go. I've got a customer. So, yeah, just call me at the bongs, will you?",
  },
  beefy: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'YASMIN',
    firstSaidQuote:
      'Urgh. Who eats beans and then thinks these could just do with being a bit beefy?',
  },
  rasta: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'NICK',
    firstSaidQuote:
      "I'm not dead. I can make it to midnight. I can make it out! Woo! You think you can kill a Rasta?",
  },
  macho: {
    count: 1,
    firstSaidSeasonIndex: 39,
    firstSaidStoryIndex: 7,
    firstSaidBy: 'SARAH',
    firstSaidQuote:
      "Oh my God, this is the most silliest type of macho-ness I've ever seen. Oh. Hiya, Mammy. Yeah, we're just about to get in a taxi to the airport.",
  },
}

export const doctorWhoWords = Object.keys(doctorWhoValidGuesses)
